import React, {
  useState,
  useMemo,
  useEffect,
  useLayoutEffect,
  useContext,
  useCallback,
  useRef,
} from 'react';
import ReactMapGL, { Marker, Popup, Source, Layer } from 'react-map-gl';
// import mapboxgl from '!mapbox-gl';
// @ts-ignore
// eslint-disable-next-line import/no-webpack-loader-syntax
// import mapboxgl from '!mapbox-gl';
import { AuthContext } from '../../context/AuthContext';
import axiosConn from '../../axiosConn';
import TopbarPlayerMap from '../../components/topbarPlayerMap/TopbarPlayerMap';
import { Link, useHistory } from 'react-router-dom';
import secureLocalStorage from 'react-secure-storage';
import { getLocationAndSave } from '../../utils/locationUtil';
import { useGetPosts } from '../../hooks/useGetPosts';
import getDistance from '../../utils/getDistance';
import preciseFormat from '../../utils/preciseFormat';
import useMobileView from '../../hooks/useMobileView';
import JGLocalOpsMark from '../../components/common/JGLocalOpsMark';
import { useLocation } from 'react-router-dom';
import { WebMercatorViewport } from 'viewport-mercator-project';
import { SocketContext } from '../../context/socket';
import { usePresence } from '../../context/PresenceContext';
import { useLocalOpsLive } from '../../context/LocalOpsLiveContext';
import { formatCoarseLocationLabel } from '../../utils/localOpsLocation';
import PlayerMarkers from '../../components/playerMarkers/PlayerMarkers';
import getDistanceFromLatLonInMeters from '../../utils/getDistanceFromLatLonInMeters';
import getShareUrl from '../../utils/getShareUrl';
import {
  getMediaThumbnail,
  normalizeMediaList,
} from '../../utils/postMediaUtils';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import LayersOutlinedIcon from '@mui/icons-material/LayersOutlined';
import LocalOpsLayersSheet from '../../components/localops/LocalOpsLayersSheet';
import LocalOpsCreateSheet from '../../components/localops/LocalOpsCreateSheet';
import LocalOpsOfferingDetailSheet from '../../components/localops/LocalOpsOfferingDetailSheet';
import LocalOpsTaskDetailSheet from '../../components/localops/LocalOpsTaskDetailSheet';
import LocalOpsPublicDetailsEditSheet from '../../components/localops/LocalOpsPublicDetailsEditSheet';
import LocalOpsShareSheet from '../../components/localops/LocalOpsShareSheet';
import LocalOpsStarterTaskIdeas, {
  STARTER_TASK_TEMPLATES,
  buildStarterTaskPreset,
} from '../../components/localops/LocalOpsStarterTaskIdeas';
import LocalOpsTopUpSheet from '../../components/localops/LocalOpsTopUpSheet';
import BuyerPendingConfirmationGateModal from '../../components/localops/BuyerPendingConfirmationGateModal';
import LocalOpsFeed from '../../components/localops/LocalOpsFeed';
import LocalOpsFeedTicker from '../../components/localops/LocalOpsFeedTicker';
import PostCompletionScreen from '../../components/localops/PostCompletionScreen';
import AuthChooser from '../../components/auth/AuthChooser';
import {
  LANDING_INTENT_TYPES,
  LOCALOPS_ACTIVE_ORDER_STATUSES,
  COLLISION_SPECIALIST_RIDE_TEMPLATE,
  buildClientLaunchAttribution,
  buildCollisionSpecialistRidePreset,
  buildGenericAssistanceTaskPreset,
  buildOfferingDraftPreset,
  buildCreateTaskPresetFromOffering,
  buildOrderBackedOfferingTarget,
  GENERIC_OFFERING_DRAFT_INTAKE_TYPE,
  GENERIC_ASSISTANCE_TASK_INTAKE_TYPE,
  getOfferingIntentId,
  getOrderIntentOfferingId,
  getOrderIntentStatus,
  getLandingEarnHeadline,
  getLandingEarnTaskLabel,
  hasUsableLandingAmountLabel,
  getOwnerTaskLandingIntentType,
  getOwnerTaskLandingLabel,
  getDurableLocalOpsTaskId,
  getPersistedCompletionAction,
  getTaskIntentId,
  getTrustGateRetryAction,
  isGenericAssistanceTaskRequest,
  isOfferingDraftReviewRequest,
  isCollisionSpecialistRideRequest,
  isOpenPaidLandingTaskForViewer,
  isReleasedOrReopenedPaidLandingTask,
  isRequesterLandingIntent,
  resolveLandingIntent,
  resolveLandingPrimaryAction,
  selectOwnerLandingTask,
  shouldAutoInjectCheckoutSuccess,
  shouldShowLandingSheet,
} from './localOpsCriticalPathUtils';
import { CAMDEN_LIVE_ROUTES } from '../../utils/galaxyRegionHub';
import {
  SHARE_FUNNEL_EVENT_NAMES,
  buildShareFunnelContext,
  readShareFunnelContextFromSearch,
  recordShareFunnelEvent,
} from '../../utils/localOpsShareFunnel';
import {
  LAUNCH_VISIT_EVENTS,
  trackLocalOpsLaunchEvent,
} from '../../utils/localOpsLaunchEvents';
import {
  LOCALOPS_FUNNEL_EVENTS,
  recordLocalOpsFunnelEvent,
} from '../../utils/localOpsFunnelTelemetry';
import {
  attachProofAttributionHintToPendingCreate,
  readProofAttributionHintFromSearch,
  sanitizeProofAttributionHint,
} from '../../utils/localOpsProofAttribution';
import { buildLocalOpsAcceptFeedback } from '../../utils/localOpsTaskAcceptPresentation';

import './playermap.css';

const minZoom = 3; // Allow for a more zoomed-out view
const maxZoom = 17; // Allow for a closer view
const DEFAULT_MAP_CENTER = Object.freeze({
  lat: 25.774772,
  lon: -80.185942,
  zoom: 4,
});
const INITIAL_VIEWPORT_ZOOM_MOBILE = 12;
const INITIAL_VIEWPORT_ZOOM_DESKTOP = 13;
const FETCH_REFRESH_THRESHOLD_METERS = 25;
const LOCALOPS_MAX_MARKERS_MOBILE = 36;
const LOCALOPS_MAX_MARKERS_DESKTOP = 120;
const LOCALOPS_ROUTE_COLOR = '#1f7a8c';
const LOCALOPS_ROUTE_OUTLINE = '#10424d';
const LOCALOPS_LAYER_STORAGE_KEY = 'playerMapLayers';
const LOCALOPS_OFFERINGS_CACHE_KEY = 'localopsOfferingsCache';
const LOCALOPS_TASKS_CACHE_KEY = 'localopsTasksCache';
const AUTH_BASE = process.env.REACT_APP_AUTH_BASE_URL || '';
const LOCALOPS_TRAVEL_STORAGE_KEY = 'playerMapTravelMode';
const LOCALOPS_TRAVEL_RADIUS_MULTIPLIER = 2;
const LOCALOPS_TRAVEL_MIN_RADIUS_MI = 50;
const LOCALOPS_TRAVEL_MIN_RADIUS_KM = 80;
const LOCALOPS_LIVE_FEED_CAP = 100;
const LOCALOPS_STILL_AVAILABLE_OFFER_MS = 90 * 24 * 60 * 60 * 1000;
const LOCALOPS_PENDING_ACTION_KEY = 'localopsPendingAction';
const LOCALOPS_LOCATION_PRIMER_DISMISSED_KEY =
  'localopsLocationConsentPrimerDismissed';
const LOCALOPS_LOCATION_GATE_CODE = 'LOCALOPS_LOCATION_GATE_OPENED';
const LOCALOPS_USER_LOCATION_COPY =
  'JG LocalOps uses your current location to keep tasks and offerings local. Your exact location is not posted publicly.';
const LOCALOPS_ENTITY_LOCATION_COPY =
  'This task or offering location does not look local. Update the task/offering address or pin so it is inside this LocalOps area.';
const LOCALOPS_LOCATION_DENIED_COPY =
  'Location access is blocked or was denied in your browser. Use the site permission control to set Location to Ask or Allow, then try again.';
const LOCALOPS_LOCATION_UNAVAILABLE_COPY =
  'We could not access your location. Use your browser permission control, then try again.';
const LOCALOPS_REGION_BROWSE_CENTERS = Object.freeze({
  camden: Object.freeze({
    lat: 36.05895,
    lon: -88.09782,
    zoom: 12,
    label: 'Camden',
  }),
});
const PLAYERMAP_LANDING_ROUTE_KIND = 'playermap_landing';
const PLAYERMAP_LANDING_CTA_IDS = Object.freeze({
  POST_TASK: 'playermap_post_task_clicked',
  OFFER_LOCALLY: 'playermap_offer_locally_clicked',
  HELP_COMMUNITY_TASK: 'playermap_help_community_task_clicked',
  ENTER_CAMDEN_LIVE: 'playermap_enter_camden_live_clicked',
  STARTER_IDEAS_OPENED: 'playermap_starter_ideas_opened',
  STARTER_IDEA_SELECTED: 'playermap_starter_idea_selected',
  STARTER_IDEA_SELECTED_RIDE_HELP:
    'playermap_starter_idea_selected_ride_help',
});
const LOCALOPS_LANDING_DURABLE_EVENT_MAP = Object.freeze({
  localops_landing_requester_mode_shown:
    LAUNCH_VISIT_EVENTS.PLAYERMAP_REQUESTER_MODE_SHOWN,
  localops_landing_primary_action_shown:
    LAUNCH_VISIT_EVENTS.PLAYERMAP_PRIMARY_ACTION_SHOWN,
});
const LOCALOPS_LANDING_DURABLE_CTA_MAP = Object.freeze({
  localops_landing_post_task_clicked: PLAYERMAP_LANDING_CTA_IDS.POST_TASK,
  localops_landing_post_offering_clicked:
    PLAYERMAP_LANDING_CTA_IDS.OFFER_LOCALLY,
  localops_landing_help_community_task_clicked:
    PLAYERMAP_LANDING_CTA_IDS.HELP_COMMUNITY_TASK,
  localops_landing_camden_live_clicked:
    PLAYERMAP_LANDING_CTA_IDS.ENTER_CAMDEN_LIVE,
  localops_landing_starter_ideas_opened:
    PLAYERMAP_LANDING_CTA_IDS.STARTER_IDEAS_OPENED,
});
const BUYER_PENDING_CONFIRMATION_CODE =
  'BUYER_PENDING_CONFIRMATION_REQUIRED';
const MAGIC_LINK_RETURN_TO_ALLOWED_PARAMS = [
  'src',
  'source',
  'utm_source',
  'utm_campaign',
  'intent',
  'region',
  'regionSlug',
  'market',
  'marketSlug',
  'routeKind',
  'partnerAction',
  'partnerSource',
  'partnerIntent',
  'firestarter',
  'firestarterCreate',
  'firestarterSurface',
  'isCold',
  'taskType',
  'starter',
  'proofId',
  'refPlayerId',
  'originSurface',
  'attributionVersion',
];
const SHARE_FUNNEL_CONTEXT_STATE_KEYS = [
  'shareFunnelId',
  'src',
  'source',
  'utm_source',
  'utm_campaign',
  'intent',
  'regionSlug',
  'marketSlug',
];

const normalizeSafeReturnToValue = (value) =>
  String(value || '')
    .replace(/[\r\n\t]+/g, ' ')
    .trim()
    .slice(0, 160);

const getPlayerMapLandingTaskAmountLabel = (task) => {
  if (!task) return '$—';
  const amount = [
    task.price,
    task.amount,
    task.amountUsd,
    task.priceUsd,
    task.payoutUsd,
    task.money?.price,
    task.money?.amount,
    task.money?.amountUsd,
    task.money?.priceUsd,
  ].find((value) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) && parsed > 0;
  });
  const parsed = Number(amount);
  if (!Number.isFinite(parsed) || parsed <= 0) return '$—';
  return `$${parsed.toFixed(2)}`;
};

export const buildSafePlayerMapMagicLinkReturnTo = ({
  pathname = '/playermap',
  search = '',
} = {}) => {
  if (pathname !== '/playermap') return '/playermap';
  const params = new URLSearchParams(String(search || '').replace(/^\?/, ''));
  const safeParams = new URLSearchParams();
  MAGIC_LINK_RETURN_TO_ALLOWED_PARAMS.forEach((key) => {
    const value = normalizeSafeReturnToValue(params.get(key));
    if (value) safeParams.set(key, value);
  });
  const intakeType = normalizeSafeReturnToValue(params.get('intakeType'));
  const draft = normalizeSafeReturnToValue(params.get('draft'));
  if (intakeType === GENERIC_ASSISTANCE_TASK_INTAKE_TYPE && draft) {
    safeParams.set('intakeType', intakeType);
    safeParams.set('draft', draft);
    const useCase = normalizeSafeReturnToValue(params.get('useCase'));
    if (useCase) safeParams.set('useCase', useCase);
  }
  const rideTemplate = normalizeSafeReturnToValue(params.get('rideTemplate'));
  if (rideTemplate === COLLISION_SPECIALIST_RIDE_TEMPLATE) {
    safeParams.set('rideTemplate', rideTemplate);
  }
  const query = safeParams.toString();
  return query ? `/playermap?${query}` : '/playermap';
};

const buildShareFunnelContextFromState = (state = {}) => {
  if (!state?.shareFunnelId || !state?.share) return null;
  const params = new URLSearchParams();
  SHARE_FUNNEL_CONTEXT_STATE_KEYS.forEach((key) => {
    if (state[key]) params.set(key, state[key]);
  });
  return buildShareFunnelContext({
    share: state.share,
    queryParams: params,
  });
};

const JGK_DEBUG =
  process.env.REACT_APP_JGK_DEBUG === '1' ||
  (typeof window !== 'undefined' &&
    window.localStorage?.getItem('jgk:debug') === '1');

const jgkLog = (...args) => {
  if (JGK_DEBUG) console.log(...args);
};
const jgkWarn = (...args) => {
  if (JGK_DEBUG) console.warn(...args);
};

const normalizeLocalOpsSlug = (value) =>
  String(value || '')
    .trim()
    .toLowerCase();

const parseFiniteQueryNumber = (queryParams, keys = []) => {
  for (const key of keys) {
    const raw = queryParams?.get?.(key);
    if (raw === null || raw === undefined || raw === '') continue;
    const value = Number(raw);
    if (Number.isFinite(value)) return value;
  }
  return null;
};

const getLocalOpsBrowseCenterFromParams = (queryParams) => {
  if (!queryParams?.get) return null;
  const regionSlug = normalizeLocalOpsSlug(
    queryParams.get('regionSlug') || queryParams.get('region'),
  );
  const marketSlug = normalizeLocalOpsSlug(
    queryParams.get('marketSlug') || queryParams.get('market'),
  );
  const queryLat = parseFiniteQueryNumber(queryParams, [
    'browseLat',
    'regionLat',
    'centerLat',
  ]);
  const queryLon = parseFiniteQueryNumber(queryParams, [
    'browseLon',
    'browseLng',
    'regionLon',
    'regionLng',
    'centerLon',
    'centerLng',
  ]);
  if (Number.isFinite(queryLat) && Number.isFinite(queryLon)) {
    const label =
      queryParams.get('regionLabel') ||
      queryParams.get('marketLabel') ||
      regionSlug ||
      marketSlug ||
      'LocalOps';
    return {
      lat: queryLat,
      lon: queryLon,
      zoom:
        parseFiniteQueryNumber(queryParams, ['browseZoom', 'regionZoom']) ||
        12,
      label,
    };
  }
  return (
    LOCALOPS_REGION_BROWSE_CENTERS[regionSlug] ||
    LOCALOPS_REGION_BROWSE_CENTERS[marketSlug] ||
    null
  );
};

const createLocationConsentGateError = () => {
  const err = new Error('Location required for LocalOps.');
  err.code = LOCALOPS_LOCATION_GATE_CODE;
  return err;
};

const LOCALOPS_ACTION_LABELS = {
  create_offering: 'publish this offering',
  create_task: 'publish this task',
  reserve_offering: 'reserve this offering',
  accept_task: 'accept this task',
  start_task: 'start this task',
};

const getLocationConsentActionLabel = (actionType) =>
  LOCALOPS_ACTION_LABELS[actionType] || 'continue with this LocalOps action';

const getBrowserGeolocationPermissionState = async () => {
  if (typeof navigator === 'undefined' || !navigator.permissions?.query) {
    return null;
  }
  try {
    const status = await navigator.permissions.query({ name: 'geolocation' });
    return status?.state || null;
  } catch (err) {
    return null;
  }
};

const isBrowserGeolocationDenied = (err) =>
  err?.code === 1 ||
  err?.code === err?.PERMISSION_DENIED ||
  /denied|blocked/i.test(String(err?.message || ''));

const getSafeLocationTelemetryErrorCode = (err) => {
  const rawCode = err?.code;
  if (
    rawCode === 1 ||
    rawCode === err?.PERMISSION_DENIED ||
    /denied|blocked/i.test(String(err?.message || ''))
  ) {
    return 'permission_denied';
  }
  if (rawCode === 2 || rawCode === err?.POSITION_UNAVAILABLE) {
    return 'permission_unavailable';
  }
  if (rawCode === 3 || rawCode === err?.TIMEOUT) {
    return 'timeout';
  }
  if (rawCode === 'unsupported') return 'unsupported';
  if (rawCode === 'save_failed') return 'save_failed';
  return 'unknown';
};

const getLocationConsentErrorCopy = (err) =>
  isBrowserGeolocationDenied(err)
    ? LOCALOPS_LOCATION_DENIED_COPY
    : LOCALOPS_LOCATION_UNAVAILABLE_COPY;

const isLocalOpsLocationCode = (code) =>
  typeof code === 'string' && code.startsWith('LOCALOPS_LOCATION_');

const isLocalOpsEntityLocationError = (err) => {
  const code =
    err?.response?.data?.code ||
    err?.code ||
    err?.cause?.code ||
    '';
  return isLocalOpsLocationCode(code);
};
const maskCredentialValue = (value) => {
  const raw = String(value || '');
  if (!raw) return '';
  if (raw.length <= 8) return '***';
  return `${raw.slice(0, 4)}...${raw.slice(-4)}`;
};
const maskSensitiveLocalOpsPayload = (value) => {
  if (Array.isArray(value)) return value.map(maskSensitiveLocalOpsPayload);
  if (!value || typeof value !== 'object') return value;
  return Object.entries(value).reduce((next, [key, entry]) => {
    next[key] =
      key === 'intakeDraftToken'
        ? maskCredentialValue(entry)
        : maskSensitiveLocalOpsPayload(entry);
    return next;
  }, {});
};
const JGK_PENDING_INTENT_KEY = 'jgkPendingIntent';
const TOPUP_STARTED_KEY = 'jgkTopUpStartedAt';
const TOPUP_RETURN_KEY = 'jgkTopUpReturnTo';
const LAST_COMPLETION_TASK_KEY = 'localops:lastCompletionTaskId';
const LAST_COMPLETION_SEEN_KEY = 'localops:lastCompletionSeenAt';
const LAST_COMPLETION_TS_KEY = 'localops:lastCompletionAt';
const TRUST_GATE_RETRY_KEY = 'localops:trustGateRetry';
const RESUME_LOCK_MS = 60000;
const RESUME_STALE_LOCK_MS = 10000;
const OFFERING_NEARBY_DEBOUNCE_MS = 260;
const LOCALOPS_REALTIME_SNAPSHOT_DEBOUNCE_MS = 1200;
const LOCALOPS_REALTIME_SNAPSHOT_COOLDOWN_MS = 15000;
const ASSISTANCE_TASK_TYPES = new Set([
  'assistance',
  'assisted_transport',
  'transport',
  'ride',
  'pickup',
  'dropoff',
]);
const TASK_TYPE_BADGES = {
  delivery: 'DEL',
  errand: 'ERR',
  home_help: 'HOME',
  offering_product: 'PRD',
  offering_service: 'SRV',
  service: 'SRV',
  assistance: 'AID',
  assisted_transport: 'AID',
  transport: 'AID',
  ride: 'AID',
  pickup: 'AID',
  dropoff: 'AID',
};
const OFFERING_BADGES = {
  product: 'PRD',
  service: 'SRV',
  assistance: 'AID',
};
const FIRESTARTER_MODE = 'task-first-firestarter-v1';
const FIRESTARTER_CREATE_DEFAULT = 'task_errand';
const LANDING_FALLBACK_TASK_PRESET = 'task_errand';
const LANDING_FALLBACK_OFFERING_PRESET = 'offering_product';
const LOCAL_EMPTY_IGNITION_SOURCE = 'player_map_local_empty_fallback';
const REQUESTER_TASK_TYPE_PRESETS = Object.freeze({
  delivery: Object.freeze({ type: 'task_delivery', taskType: 'delivery' }),
  errand: Object.freeze({ type: 'task_errand', taskType: 'errand' }),
  home_help: Object.freeze({ type: 'task_home_help', taskType: 'home_help' }),
  assisted_transport: Object.freeze({
    type: 'task_assistance',
    taskType: 'assisted_transport',
  }),
  assistance: Object.freeze({
    type: 'task_assistance',
    taskType: 'assisted_transport',
  }),
});
const LOCALOPS_CREATE_DRAFT_PREFIX = 'localopsDraft';

const normalizeRequesterLandingParam = (value) =>
  String(value || '').trim().toLowerCase();
// Phase-2 rollout kill switch: creator intents stay OFF unless explicitly enabled.
const ENABLE_CREATOR_LANDING_INTENT = false;
const ACTIVE_CREATE_TASK_PENDING_STATES = new Set([
  'pending',
  'checkout_starting',
  'checkout_started',
  'resuming',
  'replaying',
]);

const coerceFlag = (value, fallback = false) => {
  if (value === undefined || value === null || value === '') return fallback;
  if (typeof value === 'boolean') return value;
  const normalized = String(value).trim().toLowerCase();
  if (['0', 'false', 'off', 'no'].includes(normalized)) return false;
  if (['1', 'true', 'on', 'yes'].includes(normalized)) return true;
  return fallback;
};

const isMongoId = (value) =>
  typeof value === 'string' && /^[a-f0-9]{24}$/i.test(value);

const makePendingIntentId = () =>
  `pi_${Date.now()}_${Math.floor(Math.random() * 1e6)}`;

const RAISE_PAY_PENDING_INTENT_TYPE = 'raise_pay_and_renotify';

const RAISE_PAY_HANDLED_TERMINAL_STATUSES = new Set([
  'sent',
  'success',
  'no_eligible_helpers',
  'fanout_failed',
  'stale',
  'stale_state',
  'ineligible',
  'ineligible_task',
  'invalid_amount',
]);

const normalizeRaisePayStatus = (value, fallback = '') =>
  String(value || fallback || '').trim().toLowerCase();

const getRaisePayTerminalMessage = (status, fallback = '') => {
  if (fallback) return fallback;
  const normalized = normalizeRaisePayStatus(status);
  if (normalized === 'no_eligible_helpers') {
    return 'Task pay was raised. No eligible local helpers were available to notify right now.';
  }
  if (normalized === 'fanout_failed') {
    return 'Task pay was raised, but helpers could not be notified right now.';
  }
  if (
    normalized === 'stale' ||
    normalized === 'stale_state' ||
    normalized === 'ineligible' ||
    normalized === 'ineligible_task'
  ) {
    return 'This task changed before the pay raise completed. No pay change was applied.';
  }
  if (normalized === 'invalid_amount') {
    return 'Enter a valid higher task pay.';
  }
  return 'Task pay was raised and local helpers were notified.';
};

const normalizePendingIntent = (value) => {
  if (!value || typeof value !== 'object') return null;
  const {
    id,
    type,
    payload,
    requiredJGK = 0,
    createdAt = Date.now(),
    state = 'pending',
    uiContext = {},
    resumeLockId = null,
    lastAttemptAt = null,
    startedAt = null,
  } = value;
  if (!type || !payload) return null;
  return {
    id: id || makePendingIntentId(),
    type,
    payload,
    requiredJGK: Number(requiredJGK) || 0,
    createdAt,
    state,
    uiContext,
    resumeLockId,
    lastAttemptAt,
    startedAt,
  };
};

const readPendingIntent = () => {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(JGK_PENDING_INTENT_KEY);
    if (raw) return normalizePendingIntent(JSON.parse(raw));
    // migrate legacy
    const legacyRaw = window.localStorage.getItem(LOCALOPS_PENDING_ACTION_KEY);
    return legacyRaw ? normalizePendingIntent(JSON.parse(legacyRaw)) : null;
  } catch (err) {
    return null;
  }
};

const writePendingIntent = (value) => {
  if (typeof window === 'undefined') return;
  if (!value) {
    window.localStorage.removeItem(JGK_PENDING_INTENT_KEY);
    window.localStorage.removeItem(LOCALOPS_PENDING_ACTION_KEY);
    return;
  }
  try {
    window.localStorage.setItem(JGK_PENDING_INTENT_KEY, JSON.stringify(value));
    window.localStorage.removeItem(LOCALOPS_PENDING_ACTION_KEY);
  } catch (err) {
    // ignore storage failures
  }
};

const hasPendingCreateTaskDraftIntent = (pending, draftToken = '') => {
  const token = String(draftToken || '').trim();
  if (!pending || pending.type !== 'create_task') return false;
  const pendingToken = String(pending?.payload?.intakeDraftToken || '').trim();
  if (!pendingToken) return false;
  return token ? pendingToken === token : true;
};

const hasActiveCreateTaskPendingIntent = (pending) =>
  !!pending &&
  pending.type === 'create_task' &&
  ACTIVE_CREATE_TASK_PENDING_STATES.has(String(pending.state || 'pending'));

const isCollisionSpecialistCreateTaskPayload = (payload) =>
  payload?.uiContext?.rideTemplate === COLLISION_SPECIALIST_RIDE_TEMPLATE ||
  payload?.meta?.rideTemplate === COLLISION_SPECIALIST_RIDE_TEMPLATE;

const buildCollisionSpecialistRideLaunchSignature = (queryParams) => {
  if (!queryParams?.get) return '';
  if (
    !isCollisionSpecialistRideRequest({
      queryParams,
      regionSlug: queryParams.get('regionSlug'),
    })
  ) {
    return '';
  }
  return [
    'source',
    'src',
    'intent',
    'regionSlug',
    'marketSlug',
    'rideTemplate',
    'draft',
  ]
    .map((key) => `${key}=${String(queryParams.get(key) || '').trim()}`)
    .join('&');
};

const normalizeIntakeDraftPayload = (payload) =>
  payload?.data?.data || payload?.data || payload || null;

const buildCollisionSpecialistDraftPreset = (draft, draftToken) => {
  const base = buildCollisionSpecialistRidePreset();
  const price = Number(draft?.suggestedPriceUsd);
  const token = String(draft?.intakeDraftToken || draftToken || '').trim();
  const pickupLat = Number(
    draft?.pickupLocation?.lat ??
      draft?.pickupLocation?.latitude ??
      draft?.pickupLocation?.coordinates?.[1],
  );
  const pickupLon = Number(
    draft?.pickupLocation?.lon ??
      draft?.pickupLocation?.lng ??
      draft?.pickupLocation?.longitude ??
      draft?.pickupLocation?.coordinates?.[0],
  );
  const origin =
    Number.isFinite(pickupLat) && Number.isFinite(pickupLon)
      ? { lat: pickupLat, lon: pickupLon }
      : undefined;
  return {
    ...base,
    title: draft?.title || base.title,
    description: draft?.description || base.description,
    pickupAddress: draft?.pickupAddress || base.pickupAddress,
    deliveryAddress: draft?.deliveryAddress || undefined,
    price: Number.isFinite(price) && price > 0 ? price : undefined,
    ...(origin ? { origin } : {}),
    ...(token ? { intakeDraftToken: token } : {}),
  };
};

const hasMeaningfulLocalOpsDraft = (value) => {
  if (!value || typeof value !== 'object') return false;
  const hasTextField = [
    'title',
    'description',
    'pickupAddress',
    'deliveryAddress',
    'destinationAddress',
    'category',
    'availabilityStart',
    'availabilityEnd',
  ].some(
    (key) =>
      typeof value[key] === 'string' && value[key].trim().length > 0,
  );
  if (hasTextField) return true;
  const priceValue = Number(value.price);
  if (Number.isFinite(priceValue) && priceValue > 0) return true;
  const quantityValue = Number(value.quantityAvailable);
  if (Number.isFinite(quantityValue) && quantityValue > 0) return true;
  const lat = Number(value?.location?.lat);
  const lon = Number(value?.location?.lon);
  return Number.isFinite(lat) && Number.isFinite(lon);
};

const parsePlayerFromResponse = (payload) => {
  const playerData =
    payload?.data?.data?.player ||
    payload?.data?.player ||
    payload?.player ||
    payload?.data?.data ||
    payload?.data ||
    payload;
  const jgkTokens = Number(
    payload?.jgkTokens ??
      payload?.data?.jgkTokens ??
      payload?.data?.data?.jgkTokens ??
      playerData?.jgkTokens,
  );
  return {
    player: playerData || null,
    jgkTokens: Number.isFinite(jgkTokens) ? jgkTokens : null,
  };
};

const buildApiUrl = (base, path) => {
  const normalizedBase = (base || '').replace(/\/$/, '');
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${normalizedBase}${normalizedPath}`;
};

const normalizeCoordinates = (item) => {
  if (!item) return null;
  const candidates = [
    item.location,
    item.originLocation,
    item.destinationLocation,
    item.lastKnownLocation,
    item.lastLocation,
    item.position,
    item.center,
  ];

  for (const entry of candidates) {
    if (!entry) continue;
    const coords =
      entry.coordinates ||
      entry.coords ||
      entry.position ||
      entry.center;
    if (Array.isArray(coords) && coords.length === 2) {
      const [lon, lat] = coords;
      if (typeof lon === 'number' && typeof lat === 'number') {
        return [lon, lat];
      }
    }
    const lon = entry.longitude ?? entry.lon ?? entry.lng;
    const lat = entry.latitude ?? entry.lat;
    if (typeof lon === 'number' && typeof lat === 'number') {
      return [lon, lat];
    }
  }

  const lon = item.longitude ?? item.lon ?? item.lng;
  const lat = item.latitude ?? item.lat;
  if (typeof lon === 'number' && typeof lat === 'number') {
    return [lon, lat];
  }
  return null;
};

const isDefaultMapCenter = ({ lat, lon } = {}) =>
  Math.abs(Number(lat) - DEFAULT_MAP_CENTER.lat) < 0.000001 &&
  Math.abs(Number(lon) - DEFAULT_MAP_CENTER.lon) < 0.000001;

const getSavedPlayerLocation = (player) => {
  const coords = normalizeCoordinates(player?.data?.player || player);
  if (!coords) return null;
  const [lon, lat] = coords;
  if (!Number.isFinite(lat) || !Number.isFinite(lon)) return null;
  if (isDefaultMapCenter({ lat, lon })) return null;
  return { lat, lon };
};

const getLocalOpsId = (item, index, prefix) => {
  if (!item) return `${prefix}-${index}`;
  return (
    item.id ||
    item._id ||
    item.taskId ||
    item.offeringId ||
    item.slug ||
    item.handle ||
    `${prefix}-${index}`
  );
};

const parseLocalOpsShareTarget = (shareUrl) => {
  const trimmed = String(shareUrl || '').trim();
  if (!trimmed) return null;
  let path = trimmed;
  if (/^https?:\/\//i.test(trimmed)) {
    try {
      path = new URL(trimmed).pathname;
    } catch (err) {
      return null;
    }
  }
  const match = path.match(/^\/share\/(offering|task)\/([^/?#]+)/i);
  if (!match) return null;
  const type = match[1].toLowerCase();
  const id = decodeURIComponent(match[2]);
  return { type, id };
};

const getLocalOpsNotificationHintType = (payload) => {
  if (!payload || typeof payload !== 'object') return null;
  const notification =
    payload.notification || payload.data?.notification || payload.data || payload;
  const metadata =
    notification?.metadata && typeof notification.metadata === 'object'
      ? notification.metadata
      : {};
  const values = [
    notification?.context,
    notification?.contextType,
    notification?.type,
    notification?.kind,
    notification?.category,
    notification?.ctaUrl,
    notification?.url,
    notification?.link,
    notification?.subject,
    notification?.title,
    notification?.message,
    metadata.context,
    metadata.contextType,
    metadata.entityType,
    metadata.ctaUrl,
    metadata.shareUrl,
    metadata.url,
  ];
  const normalizedValues = values
    .map((value) => String(value || '').toLowerCase())
    .filter(Boolean);
  if (
    normalizedValues.some(
      (value) =>
        value.includes('/share/task/') ||
        value.includes('localops.task') ||
        value.includes('local-ops.task') ||
        value === 'task',
    )
  ) {
    return 'task';
  }
  if (
    normalizedValues.some(
      (value) =>
        value.includes('/share/offering/') ||
        value.includes('localops.offering') ||
        value.includes('local-ops.offering') ||
        value === 'offering',
    )
  ) {
    return 'offering';
  }
  return null;
};

const getLocalOpsCreatedLiveHintType = (payload) => {
  if (!payload || typeof payload !== 'object') return null;
  const eventType = String(
    payload.eventType || payload.event || payload.type || '',
  ).toLowerCase();
  const entityType = String(
    payload.entityType || payload.entity || payload.targetType || '',
  ).toLowerCase();
  const shareTarget = parseLocalOpsShareTarget(
    payload.shareUrl || payload.ctaUrl || payload.url || payload.link || '',
  );
  const isCreated =
    eventType === 'created' ||
    eventType.endsWith('.created') ||
    eventType.endsWith(':created');
  if (!isCreated) return null;
  if (entityType === 'task' || shareTarget?.type === 'task') return 'task';
  if (entityType === 'offering' || shareTarget?.type === 'offering') {
    return 'offering';
  }
  return null;
};

const normalizeLocalOpsCollection = (payload) => {
  if (!payload) return [];
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload.items)) return payload.items;
  if (Array.isArray(payload.data)) return payload.data;
  if (Array.isArray(payload.tasks)) return payload.tasks;
  if (Array.isArray(payload.offerings)) return payload.offerings;
  return [];
};

const normalizeLocalOpsItem = (item) => {
  if (!item || typeof item !== 'object') return null;
  const normalized = { ...item };

  if (!normalized.media && normalized.meta?.media) {
    normalized.media = normalized.meta.media;
  }
  if (
    normalized.coverIndex == null &&
    Number.isInteger(normalized.meta?.coverIndex)
  ) {
    normalized.coverIndex = normalized.meta.coverIndex;
  }

  const applyOwner = (source) => {
    if (!source || typeof source !== 'object') return;
    if (source._id && (!normalized.ownerId || !isMongoId(normalized.ownerId))) {
      normalized.ownerId = source._id;
    }
    if (!normalized.playerId && source.playerId) {
      normalized.playerId = source.playerId;
    }
    if (!normalized.profilePhoto && source.profilePhoto) {
      normalized.profilePhoto = source.profilePhoto;
    }
    if (!normalized.ownerPhoto && source.profilePhoto) {
      normalized.ownerPhoto = source.profilePhoto;
    }
  };

  applyOwner(normalized.owner);
  applyOwner(normalized.creator);
  applyOwner(normalized.ownerPlayerId);

  if (normalized.creator && typeof normalized.creator === 'object') {
    if (
      normalized.creator._id &&
      (!normalized.ownerId || !isMongoId(normalized.ownerId))
    ) {
      normalized.ownerId = normalized.creator._id;
    }
    if (!normalized.playerId && normalized.creator.playerId) {
      normalized.playerId = normalized.creator.playerId;
    }
    if (!normalized.profilePhoto && normalized.creator.profilePhoto) {
      normalized.profilePhoto = normalized.creator.profilePhoto;
    }
  }

  if (typeof normalized.ownerPlayerId === 'string') {
    if (isMongoId(normalized.ownerPlayerId)) {
      if (!normalized.ownerId) normalized.ownerId = normalized.ownerPlayerId;
    } else {
      if (!normalized.playerId) normalized.playerId = normalized.ownerPlayerId;
    }
  }

  if (normalized.price == null && Number.isFinite(normalized.priceUsd)) {
    normalized.price = normalized.priceUsd;
  }
  if (normalized.price == null && Number.isFinite(normalized.priceCents)) {
    normalized.price = normalized.priceCents / 100;
  }

  return normalized;
};

const firstLocalOpsText = (...values) => {
  for (const value of values) {
    if (typeof value !== 'string') continue;
    const trimmed = value.trim();
    if (trimmed) return trimmed;
  }
  return '';
};

const resolveTaskPayloadType = (task) => {
  const explicitType = firstLocalOpsText(
    task?.taskType,
    task?.category,
    task?.meta?.taskType,
  );
  if (explicitType) return explicitType;
  const transportType = firstLocalOpsText(task?.type);
  if (transportType && transportType !== 'task') return transportType;
  if (firstLocalOpsText(task?.meta?.deliveryAddress, task?.deliveryAddress)) {
    return 'delivery';
  }
  return transportType || task?.category;
};

const mergeLocationAddressContext = (previous, next) => {
  if (!previous) return next || previous;
  if (!next) return previous;
  const merged = { ...previous, ...next };
  if (!firstLocalOpsText(merged.address) && firstLocalOpsText(previous.address)) {
    merged.address = previous.address;
  }
  if (!merged.coordinates && previous.coordinates) {
    merged.coordinates = previous.coordinates;
  }
  return merged;
};

const isCompactDescriptionDowngrade = (previous, next) => {
  const previousDescription = firstLocalOpsText(
    previous?.description,
    previous?.meta?.description,
  );
  const nextDescription = firstLocalOpsText(
    next?.description,
    next?.meta?.description,
  );
  if (
    !previousDescription ||
    !nextDescription ||
    previousDescription.length <= nextDescription.length
  ) {
    return false;
  }
  const nextPreview = firstLocalOpsText(
    next?.descriptionPreview,
    next?.summary,
  );
  return !!nextPreview && nextPreview === nextDescription;
};

const mergeTaskPrivateContext = (previous, next) => {
  if (!previous) return next;
  if (!next) return previous;
  const merged = { ...previous, ...next };
  const previousMeta =
    previous.meta && typeof previous.meta === 'object' ? previous.meta : {};
  const nextMeta = next.meta && typeof next.meta === 'object' ? next.meta : {};
  const meta = { ...previousMeta, ...nextMeta };

  if (
    !firstLocalOpsText(meta.pickupAddress) &&
    firstLocalOpsText(previousMeta.pickupAddress)
  ) {
    meta.pickupAddress = previousMeta.pickupAddress;
  }
  if (
    !firstLocalOpsText(meta.deliveryAddress) &&
    firstLocalOpsText(previousMeta.deliveryAddress)
  ) {
    meta.deliveryAddress = previousMeta.deliveryAddress;
  }
  if (Object.keys(meta).length) {
    merged.meta = meta;
  }

  if (isCompactDescriptionDowngrade(previous, next)) {
    merged.description = firstLocalOpsText(
      previous.description,
      previous.meta?.description,
    );
  }

  const incomingTaskType = firstLocalOpsText(next.taskType);
  const previousTaskType = firstLocalOpsText(previous.taskType);
  if (
    (!incomingTaskType || incomingTaskType === 'task') &&
    previousTaskType &&
    previousTaskType !== 'task'
  ) {
    merged.taskType = previousTaskType;
  }

  ['pickupAddress', 'deliveryAddress', 'destinationAddress'].forEach((key) => {
    if (!firstLocalOpsText(merged[key]) && firstLocalOpsText(previous[key])) {
      merged[key] = previous[key];
    }
  });

  merged.originLocation = mergeLocationAddressContext(
    previous.originLocation,
    next.originLocation,
  );
  merged.destinationLocation = mergeLocationAddressContext(
    previous.destinationLocation,
    next.destinationLocation,
  );
  if (String(next.status || merged.status || '') === 'discoverable') {
    delete merged.acceptedPlayerId;
    delete merged.acceptedPlayerHandle;
    delete merged.accepted;
    delete merged.acceptedPlayer;
    delete merged.providerId;
    delete merged.providerHandle;
    delete merged.provider;
    delete merged.acceptedAt;
    delete merged.startedAt;
  }
  return merged;
};

const getTaskFreshnessTimestamp = (task) => {
  const raw = task?.updatedAt || task?.createdAt || '';
  if (!raw) return null;
  const parsed = new Date(raw).getTime();
  return Number.isFinite(parsed) ? parsed : null;
};

const normalizeOfferingPayload = (payload) => {
  if (!payload) return null;
  const offering =
    payload.offering || payload.data || payload.payload || payload;
  return normalizeLocalOpsItem(offering);
};

const parseQuantityValue = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

const getOfferingQuantityValue = (offering) => {
  if (!offering) return null;
  const candidates = [
    offering.quantityAvailable,
    offering.availableQuantity,
    offering.unitsAvailable,
    offering.stock,
    offering.inventory,
    offering.quantity,
    offering.meta?.quantityAvailable,
    offering.meta?.availableQuantity,
    offering.meta?.unitsAvailable,
    offering.meta?.stock,
    offering.meta?.inventory,
    offering.meta?.quantity,
  ];
  for (const value of candidates) {
    const parsed = parseQuantityValue(value);
    if (parsed !== null) return parsed;
  }
  return null;
};

const normalizeTaskPayload = (payload) => {
  if (!payload) return null;
  const task = payload.task || payload.data || payload.payload || payload;
  if (!task || typeof task !== 'object') return null;
  const normalized = normalizeLocalOpsItem(task);
  if (!normalized) return null;
  const creatorId =
    normalized.creator?._id ||
    normalized.creatorId ||
    normalized.creatorPlayerId ||
    normalized.ownerId ||
    null;
  if (creatorId) normalized.creatorPlayerId = creatorId;
  const acceptedId =
    normalized.accepted?._id ||
    normalized.acceptedPlayerId ||
    normalized.providerId ||
    null;
  if (acceptedId) normalized.acceptedPlayerId = acceptedId;
  const taskId = normalized.taskId || normalized.id || normalized._id;
  return {
    ...normalized,
    taskId,
    id: normalized.id || normalized._id || normalized.taskId || taskId,
    taskType: resolveTaskPayloadType(normalized),
    status: normalized.status || payload.status || 'discoverable',
    trustRequirement: normalizeTaskTrustRequirement(normalized.trustRequirement),
  };
};

const normalizeLocalActivityReward = (payload) => {
  const reward =
    payload?.localActivityReward ||
    payload?.data?.localActivityReward ||
    payload?.completion?.localActivityReward ||
    null;
  if (!reward || reward.awarded !== true) return null;
  const amountJGK = Number(reward.amountJGK);
  if (!Number.isFinite(amountJGK) || amountJGK <= 0) return null;
  return {
    awarded: true,
    stage: reward.stage || null,
    amountJGK: Math.round(amountJGK),
    title: reward.title || null,
    message: reward.message || null,
    recognitionLabel: reward.recognitionLabel || null,
  };
};

const normalizeOrderPayload = (payload) => {
  if (!payload) return null;
  const order = payload.order || payload.data || payload.payload || payload;
  if (!order || typeof order !== 'object') return null;
  const orderId = order.orderId || order.id || order._id;
  const offeringId = order.offeringId || order.offering?._id || order.offering;
  if (!orderId) return null;
  return {
    ...order,
    orderId: String(orderId),
    offeringId: offeringId ? String(offeringId) : null,
    buyer: order.buyer || null,
    seller: order.seller || null,
    offering:
      order.offering && typeof order.offering === 'object'
        ? order.offering
        : null,
  };
};

const extractBlockingOrderFromGatePayload = (payload) => {
  if (!payload || typeof payload !== 'object') return null;
  const source =
    payload?.data?.blockingOrder ||
    payload?.blockingOrder ||
    payload?.data?.data?.blockingOrder ||
    null;
  if (!source || typeof source !== 'object') return null;
  const orderId = source?.orderId || source?.id || source?._id || null;
  const offeringId =
    source?.offeringId ||
    source?.offering?._id ||
    (typeof source?.offering === 'string' ? source.offering : null) ||
    null;
  if (!orderId) return null;
  return {
    ...source,
    orderId: String(orderId),
    offeringId: offeringId ? String(offeringId) : null,
  };
};

const getTrustedLabelFromActionCredit = (total) =>
  Number(total || 0) >= 1 ? 'Verified Local' : null;
const normalizeTaskTrustRequirement = (value) =>
  String(value || '').trim().toLowerCase() === 'verified_local'
    ? 'verified_local'
    : 'open';

const resolveCompletionPrimaryLabel = ({
  action,
  landingAmountLabel,
  creatorReservedCount = 0,
}) => {
  if (!action) return 'Continue';
  if (action.type === 'require_auth') return 'Sign in to continue';
  if (action.type === 'use_locally') return 'Browse local offerings';
  if (action.type === 'select_task') {
    if (action.intentType === LANDING_INTENT_TYPES.ACCEPTED_TASK_FOR_USER) {
      return 'Resume accepted task (You accepted)';
    }
    if (action.intentType === LANDING_INTENT_TYPES.CREATOR_TASK_IN_PROGRESS) {
      return 'Resume active task';
    }
    if (
      action.intentType ===
        LANDING_INTENT_TYPES.OWNER_TASK_COMPLETION_NEEDED ||
      action.intentType === LANDING_INTENT_TYPES.OWNER_POSTED_TASK_FOR_USER
    ) {
      return getOwnerTaskLandingLabel(action.task);
    }
    if (action.intentType === LANDING_INTENT_TYPES.BEST_LANDING_TASK) {
      return getLandingEarnTaskLabel(landingAmountLabel);
    }
    return 'Resume task';
  }
  if (action.type === 'select_offering') {
    if (
      action.intentType ===
      LANDING_INTENT_TYPES.CREATOR_RESERVED_OFFERING_UNFULFILLED
    ) {
      return creatorReservedCount > 1
        ? `Resume reservations (${creatorReservedCount})`
        : 'Resume reservation';
    }
    return 'Resume reservation';
  }
  return 'Continue';
};

const normalizeLocalOpsText = (value) => {
  const text = String(value || '').trim();
  return text.length ? text : '';
};

const parseLocalOpsTimestamp = (value) => {
  if (typeof value === 'number') return value;
  const parsed = Date.parse(normalizeLocalOpsText(value));
  return Number.isFinite(parsed) ? parsed : null;
};

const matchesLandingIdentity = ({
  idCandidates = [],
  handleCandidates = [],
  currentPlayerId,
  currentPlayerHandle,
}) => {
  const idSet = new Set(
    idCandidates
      .filter((value) => value !== null && value !== undefined && value !== '')
      .map((value) => String(value)),
  );
  const handleSet = new Set(
    handleCandidates
      .filter((value) => value !== null && value !== undefined && value !== '')
      .map((value) => String(value)),
  );
  const byId = currentPlayerId && idSet.has(String(currentPlayerId));
  const byHandle =
    currentPlayerHandle && handleSet.has(String(currentPlayerHandle));
  return !!(byId || byHandle);
};


const getLocalOpsCreatedAt = (item) =>
  parseLocalOpsTimestamp(item?.createdAt) ||
  parseLocalOpsTimestamp(item?.created_at) ||
  parseLocalOpsTimestamp(item?.created) ||
  parseLocalOpsTimestamp(item?.timestamp) ||
  Date.now();

const buildLocalOpsSeedSummary = (entityType, title, { createdAt } = {}) => {
  const label = entityType === 'task' ? 'Task' : 'Offering';
  const safeTitle = title || label;
  if (entityType === 'offering') {
    const ageMs = Date.now() - Number(createdAt || Date.now());
    if (Number.isFinite(ageMs) && ageMs >= LOCALOPS_STILL_AVAILABLE_OFFER_MS) {
      return `Local offer still available: ${safeTitle}`;
    }
    return `Available offer: ${safeTitle}`;
  }
  return `New ${label.toLowerCase()}: ${safeTitle}`;
};

const buildLocalOpsFeedDedupeKey = ({
  entityType,
  eventType = 'created',
  entityId,
  shareUrl,
  type,
}) => {
  const normalizedEntityType = normalizeLocalOpsText(entityType || type?.split?.('.')?.[0]);
  const normalizedEventType = normalizeLocalOpsText(eventType || type?.split?.('.')?.[1] || 'created');
  const normalizedId = normalizeLocalOpsText(entityId);
  if (normalizedEntityType && normalizedEventType && normalizedId) {
    return `${normalizedEntityType}:${normalizedId}:${normalizedEventType}`;
  }
  const normalizedShare = normalizeLocalOpsText(shareUrl);
  if (normalizedShare && normalizedEventType) {
    return `${normalizedShare}:${normalizedEventType}`;
  }
  return '';
};

const buildLocalOpsSeedEvent = (item, entityType) => {
  if (!item) return null;
  const rawId =
    entityType === 'task'
      ? item.taskId || item.id || item._id
      : item.offeringId || item.id || item._id;
  const resolvedId = rawId != null ? String(rawId).trim() : '';
  if (!resolvedId) return null;
  const shareUrl = getShareUrl(entityType, resolvedId);
  if (!shareUrl) return null;

  const title = normalizeLocalOpsText(
    item.title || item.name || item.headline,
  );
  const regionLabel = normalizeLocalOpsText(
    item.regionLabel || item.region || item.locationLabel,
  );
  const createdAt = getLocalOpsCreatedAt(item);
  const actorId = normalizeLocalOpsText(
    item.playerId || item.creatorPlayerId || item.ownerId || item.createdBy,
  );
  const actorPhoto = normalizeLocalOpsText(
    item.profilePhoto || item.ownerPhoto || item.creator?.profilePhoto,
  );
  const actor =
    actorId || actorPhoto
      ? { playerId: actorId || null, profilePhoto: actorPhoto || null }
      : null;
  const businessName = normalizeLocalOpsText(
    item.business?.name || item.businessName,
  );
  const businessLogo = normalizeLocalOpsText(
    item.business?.logo || item.businessLogo,
  );
  const business =
    businessName || businessLogo
      ? { name: businessName || null, logo: businessLogo || null }
      : null;

  const seedEventType =
    entityType === 'offering' ? 'offering_available' : 'created';
  const seedType =
    entityType === 'offering' ? 'offering.offering_available' : `${entityType}.created`;
  const summaryText = buildLocalOpsSeedSummary(entityType, title, { createdAt });

  return {
    id: `${shareUrl}:${seedEventType}:${createdAt}`,
    type: seedType,
    entityType,
    eventType: seedEventType,
    entityId: resolvedId,
    dedupeKey: buildLocalOpsFeedDedupeKey({
      entityType,
      eventType: 'created',
      entityId: resolvedId,
      shareUrl,
    }),
    createdAt,
    summaryText,
    label:
      entityType === 'offering'
        ? summaryText.replace(/:\s*/, ' - ')
        : null,
    regionLabel: regionLabel || null,
    title: title || null,
    shareUrl,
    actor,
    business,
  };
};

const getRecentLiveFeedEventType = (entityType, eventType) => {
  if (entityType === 'proof') return 'proof.action_credit_earned';
  if (entityType === 'task') return `task.${eventType || 'created'}`;
  if (entityType === 'offering') return `offering.${eventType || 'created'}`;
  return `localops.${eventType || 'updated'}`;
};

const getRecentLiveDedupeKey = ({
  rowId,
  entityType,
  eventType,
  entityId,
  shareUrl,
}) => {
  if (eventType === 'task_posted') {
    return buildLocalOpsFeedDedupeKey({
      entityType: 'task',
      eventType: 'created',
      entityId,
      shareUrl,
    });
  }
  if (eventType === 'offering_available') {
    return buildLocalOpsFeedDedupeKey({
      entityType: 'offering',
      eventType: 'created',
      entityId,
      shareUrl,
    });
  }
  return normalizeLocalOpsText(rowId) ||
    buildLocalOpsFeedDedupeKey({
      entityType,
      eventType,
      entityId,
      shareUrl,
    });
};

const normalizeRecentLiveActor = (actor) => {
  if (!actor || typeof actor !== 'object') return null;
  const playerId = normalizeLocalOpsText(actor.playerId);
  const profilePhoto = normalizeLocalOpsText(actor.profilePhoto);
  if (!playerId && !profilePhoto) return null;
  return {
    playerId: playerId || null,
    profilePhoto: profilePhoto || null,
  };
};

const normalizeRecentLocalOpsLiveEvent = (row) => {
  if (!row || typeof row !== 'object') return null;
  const entityType = normalizeLocalOpsText(row.entityType).toLowerCase();
  const eventType = normalizeLocalOpsText(row.eventType).toLowerCase();
  const entityId = normalizeLocalOpsText(row.entityId);
  const shareUrl = normalizeLocalOpsText(row.clickTarget || row.shareUrl);
  const label = normalizeLocalOpsText(row.label);
  const title = normalizeLocalOpsText(row.title);
  const createdAt =
    parseLocalOpsTimestamp(row.occurredAt) ||
    parseLocalOpsTimestamp(row.createdAt) ||
    Date.now();
  const type = getRecentLiveFeedEventType(entityType, eventType);
  const dedupeKey = getRecentLiveDedupeKey({
    rowId: row.id,
    entityType,
    eventType,
    entityId,
    shareUrl,
  });

  if (!type || (!label && !title)) return null;

  return {
    id:
      normalizeLocalOpsText(row.id) ||
      `${shareUrl || type}:${eventType}:${createdAt}`,
    type,
    entityType,
    eventType,
    entityId: entityId || null,
    dedupeKey,
    createdAt,
    summaryText: label || title,
    label: label || null,
    subtitle: normalizeLocalOpsText(row.subtitle) || null,
    regionLabel: normalizeLocalOpsText(row.regionLabel) || null,
    title: title || label || null,
    shareUrl: shareUrl || null,
    actor: normalizeRecentLiveActor(row.actor),
    isDurable: true,
    source: 'recent',
    availabilityState: normalizeLocalOpsText(row.availabilityState) || null,
    status: normalizeLocalOpsText(row.status) || null,
  };
};

const buildLocalOpsSeedEvents = (
  tasks = [],
  offerings = [],
  limit = LOCALOPS_LIVE_FEED_CAP,
) => {
  const seen = new Set();
  const events = [];
  tasks.forEach((task) => {
    const event = buildLocalOpsSeedEvent(task, 'task');
    if (!event || seen.has(event.id)) return;
    seen.add(event.id);
    events.push(event);
  });
  offerings.forEach((offering) => {
    const event = buildLocalOpsSeedEvent(offering, 'offering');
    if (!event || seen.has(event.id)) return;
    seen.add(event.id);
    events.push(event);
  });
  return events
    .sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0))
    .slice(0, limit);
};

const mergeLocalOpsSeedEvents = (
  previous = [],
  tasks = [],
  offerings = [],
  limit = LOCALOPS_LIVE_FEED_CAP,
) => {
  const seen = new Set();
  const merged = [
    ...buildLocalOpsSeedEvents(tasks, offerings, limit),
    ...(Array.isArray(previous) ? previous : []),
  ];
  return merged
    .filter(Boolean)
    .filter((event) => {
      const id =
        event.id ||
        `${event.shareUrl || event.type || 'event'}:${event.createdAt || ''}`;
      const dedupeKey = event.dedupeKey || id;
      if (seen.has(dedupeKey)) return false;
      seen.add(dedupeKey);
      return true;
    })
    .sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0))
    .slice(0, limit);
};

const normalizeLiveTaskPayload = (payload, previous = null) => {
  if (!payload) return previous;
  const next = normalizeTaskPayload(payload);
  if (!next) return previous;
  return mergeTaskPrivateContext(previous, next);
};

const makeClusterKey = (coords) =>
  `${coords[0].toFixed(5)}|${coords[1].toFixed(5)}`;

const metersPerPixel = (latitude, zoom) => {
  const latRad = (latitude * Math.PI) / 180;
  const scale = Math.pow(2, zoom);
  return (156543.03392 * Math.cos(latRad)) / scale;
};

const buildSpiderCoord = ({ center, index, count, zoom, mobileView }) => {
  if (!center || count <= 1) return center;
  const [lon, lat] = center;
  const basePx = mobileView ? 34 : 28;
  const radiusPx =
    count <= 3
      ? basePx
      : count <= 6
      ? basePx + 8
      : count <= 10
      ? basePx + 14
      : basePx + 20;
  const angle = (2 * Math.PI * index) / count - Math.PI / 2;
  const meters = metersPerPixel(lat, zoom) * radiusPx;
  const latRad = (lat * Math.PI) / 180;
  const safeCos = Math.max(Math.cos(latRad), 0.000001);
  const dx = Math.cos(angle) * meters;
  const dy = Math.sin(angle) * meters;
  const deltaLat = dy / 111320;
  const deltaLon = dx / (111320 * safeCos);
  return [lon + deltaLon, lat + deltaLat];
};

const buildCollisionOffsets = ({ tasks = [], offerings = [], zoom = 13, mobileView = false }) => {
  const buckets = new Map();
  const addItem = (item, type) => {
    const coords = normalizeCoordinates(item);
    if (!coords) return;
    const key = makeClusterKey(coords);
    const id = getLocalOpsId(item, 0, type);
    if (!buckets.has(key)) buckets.set(key, []);
    buckets.get(key).push({ type, id, coords });
  };
  tasks.forEach((task) => addItem(task, 'task'));
  offerings.forEach((offering) => addItem(offering, 'offering'));

  const offsets = new Map();
  buckets.forEach((list) => {
    if (!list || list.length < 2) return;
    const typeSet = new Set(list.map((item) => item.type));
    // Only resolve collisions when different types share a point (task + offering)
    if (typeSet.size < 2) return;
    list.forEach((item, index) => {
      const offsetCoords = buildSpiderCoord({
        center: item.coords,
        index,
        count: list.length,
        zoom,
        mobileView,
      });
      offsets.set(item.id, offsetCoords || item.coords);
    });
  });
  return offsets;
};

const blurActiveElement = () => {
  if (typeof document === 'undefined') return;
  const active = document.activeElement;
  if (active && typeof active.blur === 'function') {
    active.blur();
  }
};

const safeParseNumber = (value) => {
  if (value === null || value === undefined) return null;
  try {
    const parsed = JSON.parse(value);
    return Number.isFinite(parsed) ? parsed : null;
  } catch (err) {
    return null;
  }
};

const buildPresenceIndex = (presenceMap = {}) => {
  const index = new Map();
  Object.values(presenceMap || {}).forEach((entry) => {
    if (!entry) return;
    [
      entry.playerId,
      entry._id,
      entry.mongoId,
      entry.accountId,
      entry.handle,
      entry.id,
    ]
      .filter(Boolean)
      .forEach((key) => index.set(key, entry));
  });
  return index;
};

const getTaskTypeMeta = (taskType) => {
  const normalized = String(taskType || '').trim().toLowerCase();
  const slug = normalized.replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
  const isAssistance = ASSISTANCE_TASK_TYPES.has(normalized);
  const labelBase = normalized.replace(/[_-]+/g, ' ').trim();
  const labelText = labelBase
    ? labelBase.replace(/\b\w/g, (c) => c.toUpperCase())
    : 'Task';
  return {
    badge:
      TASK_TYPE_BADGES[normalized] ||
      (isAssistance ? 'AID' : 'TSK'),
    label: isAssistance ? 'Assistance' : labelText,
    className: slug ? `localops-task--${slug}` : 'localops-task--generic',
    isAssistance,
  };
};

const getOfferingBadge = (category) => {
  if (!category) return 'OPS';
  const normalized = String(category || '').trim().toLowerCase();
  return OFFERING_BADGES[normalized] || normalized.slice(0, 3).toUpperCase();
};

const usePageVisibility = () => {
  const visibilityRef = useRef(
    typeof document === 'undefined'
      ? true
      : document.visibilityState === 'visible',
  );

  useEffect(() => {
    const handler = () => {
      visibilityRef.current = document.visibilityState === 'visible';
    };
    document.addEventListener('visibilitychange', handler);
    return () => document.removeEventListener('visibilitychange', handler);
  }, []);

  return visibilityRef;
};

const useLocalOpsState = ({
  enabled,
  socket,
  seed,
  playerId,
  currentPlayerId,
  currentPlayerHandle,
  onOfferingRemoved,
  onTaskRemoved,
  onTaskCompleted,
}) => {
  const [offerings, setOfferings] = useState(() =>
    normalizeLocalOpsCollection(seed?.offerings)
      .map(normalizeLocalOpsItem)
      .filter(Boolean),
  );
  const [tasks, setTasks] = useState(() =>
    normalizeLocalOpsCollection(seed?.tasks)
      .map(normalizeTaskPayload)
      .filter(Boolean),
  );
  const [liveTask, setLiveTask] = useState(() =>
    seed?.liveTask ? normalizeLiveTaskPayload(seed.liveTask) : null,
  );
  const [presencePlusMap, setPresencePlusMap] = useState(
    () => seed?.presencePlus || {},
  );

  const offeringsRef = useRef(new Map());
  const tasksRef = useRef(new Map());
  const liveTaskRef = useRef(liveTask);
  const liveRouteRef = useRef({ coords: [], lastLocation: null });
  const offeringsRafRef = useRef(null);
  const tasksRafRef = useRef(null);
  const liveTaskRafRef = useRef(null);
  const teardownTaskExecution = useCallback((taskId, reason = 'teardown') => {
    const currentId =
      liveTaskRef.current?.taskId ||
      liveTaskRef.current?.id ||
      liveTaskRef.current?._id;
    if (!currentId || String(currentId) !== String(taskId)) return;
    if (liveTaskRafRef.current) {
      cancelAnimationFrame(liveTaskRafRef.current);
      liveTaskRafRef.current = null;
    }
    liveTaskRef.current = null;
    liveRouteRef.current = { coords: [], lastLocation: null };
    setLiveTask(null);
    if (
      process.env.NODE_ENV === 'development' &&
      liveTaskRef.current !== null
    ) {
      // eslint-disable-next-line no-console
      console.error('[localops][teardown-invariant]', {
        reason,
        taskId,
        liveTaskRef: liveTaskRef.current,
      });
    }
  }, []);

  useEffect(() => {
    liveTaskRef.current = liveTask;
  }, [liveTask]);

  const scheduleOfferingsUpdate = useCallback(() => {
    if (offeringsRafRef.current) return;
    offeringsRafRef.current = requestAnimationFrame(() => {
      offeringsRafRef.current = null;
      const next = Array.from(offeringsRef.current.values()).sort(
        (a, b) =>
          (b.updatedAt || b.createdAt || 0) -
          (a.updatedAt || a.createdAt || 0),
      );
      setOfferings(next);
    });
  }, []);

  const scheduleTasksUpdate = useCallback(() => {
    if (tasksRafRef.current) return;
    tasksRafRef.current = requestAnimationFrame(() => {
      tasksRafRef.current = null;
      const next = Array.from(tasksRef.current.values()).sort(
        (a, b) =>
          (b.updatedAt || b.createdAt || 0) -
          (a.updatedAt || a.createdAt || 0),
      );
      setTasks(next);
    });
  }, []);

  const scheduleLiveTask = useCallback((payload) => {
    const merged = normalizeLiveTaskPayload(payload, liveTaskRef.current);
    if (!merged) return;
    const incomingId = merged.taskId || merged.id || merged._id;
    const currentId =
      liveTaskRef.current?.taskId ||
      liveTaskRef.current?.id ||
      liveTaskRef.current?._id;
    if (incomingId && incomingId !== currentId) {
      liveRouteRef.current = { coords: [], lastLocation: null };
    }
    if (liveRouteRef.current.coords.length) {
      merged.routeCoordinates = [...liveRouteRef.current.coords];
    }
    liveTaskRef.current = merged;
    if (liveTaskRafRef.current) return;
    liveTaskRafRef.current = requestAnimationFrame(() => {
      liveTaskRafRef.current = null;
      setLiveTask(liveTaskRef.current);
    });
  }, []);

  const upsertOffering = useCallback(
    (payload) => {
      const offering = normalizeOfferingPayload(payload);
      if (!offering) return;
      const id = getLocalOpsId(offering, offeringsRef.current.size, 'offering');
      offeringsRef.current.set(id, offering);
      scheduleOfferingsUpdate();
    },
    [scheduleOfferingsUpdate],
  );

  const removeOffering = useCallback(
    (payload) => {
      const id =
        payload?.offeringId || payload?.id || payload?._id || payload;
      if (!id) return;
      offeringsRef.current.delete(id);
      scheduleOfferingsUpdate();
    },
    [scheduleOfferingsUpdate],
  );

  const replaceOfferings = useCallback(
    (payload) => {
      const list = normalizeLocalOpsCollection(payload)
        .map(normalizeLocalOpsItem)
        .filter(Boolean);
      const next = new Map();
      list.forEach((offering, index) => {
        const id = getLocalOpsId(offering, index, 'offering');
        next.set(id, offering);
      });
      offeringsRef.current = next;
      scheduleOfferingsUpdate();
    },
    [scheduleOfferingsUpdate],
  );

  const replaceTasks = useCallback(
    (payload) => {
      const list = normalizeLocalOpsCollection(payload)
        .map(normalizeTaskPayload)
        .filter(Boolean);
      const next = new Map();
      list.forEach((task, index) => {
        const id = task.taskId || task.id || getLocalOpsId(task, index, 'task');
        next.set(id, task);
      });
      tasksRef.current.forEach((task, id) => {
        if (!task?.__liveHydrationBacked || next.has(id)) return;
        if (
          !isOpenPaidLandingTaskForViewer(task, {
            landingAmountLabel: getPlayerMapLandingTaskAmountLabel(task),
            currentPlayerId,
            currentPlayerHandle,
          })
        ) {
          return;
        }
        next.set(id, task);
      });
      tasksRef.current = next;
      scheduleTasksUpdate();
    },
    [currentPlayerHandle, currentPlayerId, scheduleTasksUpdate],
  );

  const shouldKeepTask = useCallback(
    (task) => {
      if (!task) return false;
      const status = task.status || 'discoverable';
      const discoverable =
        status === 'discoverable' ||
        (status === 'created' && task.discoverable);
      const openPaidLandingTask = isOpenPaidLandingTaskForViewer(task, {
        landingAmountLabel: getPlayerMapLandingTaskAmountLabel(task),
        currentPlayerId,
        currentPlayerHandle,
      });
      const creatorId = task.creatorPlayerId || task.creator?._id || null;
      const acceptedId = task.acceptedPlayerId || task.accepted?._id || null;
      const creatorHandle =
        task.creator?.playerId || task.playerId || task.ownerHandle || null;
      const acceptedHandle =
        task.accepted?.playerId || task.providerHandle || null;
      const isCreator =
        (currentPlayerId &&
          creatorId &&
          String(creatorId) === String(currentPlayerId)) ||
        (currentPlayerHandle &&
          creatorHandle &&
          String(creatorHandle) === String(currentPlayerHandle));
      const isAccepted =
        (currentPlayerId &&
          acceptedId &&
          String(acceptedId) === String(currentPlayerId)) ||
        (currentPlayerHandle &&
          acceptedHandle &&
          String(acceptedHandle) === String(currentPlayerHandle));

      if (discoverable) return true;
      if (openPaidLandingTask) return true;
      if (
        isCreator &&
        ['created', 'discoverable', 'accepted', 'started', 'in_progress'].includes(
          status,
        )
      ) {
        return true;
      }
      if (isAccepted && ['accepted', 'started', 'in_progress'].includes(status)) {
        return true;
      }
      return false;
    },
    [currentPlayerId, currentPlayerHandle],
  );

  const upsertTask = useCallback(
    (
      payload,
      { discoverable = false, preserveWhenSnapshotOmitted = false } = {},
    ) => {
      const task = normalizeTaskPayload(payload);
      if (!task) return;
      if (discoverable) task.discoverable = true;
      if (preserveWhenSnapshotOmitted) task.__liveHydrationBacked = true;
      const id = task.taskId || task.id || getLocalOpsId(task, 0, 'task');
      const nextTask = mergeTaskPrivateContext(tasksRef.current.get(id), task);
      if (!shouldKeepTask(nextTask)) {
        tasksRef.current.delete(id);
        scheduleTasksUpdate();
        teardownTaskExecution(id, 'shouldKeepTask:false');
        return;
      }
      tasksRef.current.set(id, nextTask);
      scheduleTasksUpdate();
      if (
        ['accepted', 'in_progress', 'started'].includes(nextTask.status) &&
        (nextTask.liveTrackingEnabled || nextTask.liveTracking)
      ) {
        scheduleLiveTask(nextTask);
      } else {
        teardownTaskExecution(id, 'status_not_live');
      }
    },
    [scheduleTasksUpdate, scheduleLiveTask, shouldKeepTask, teardownTaskExecution],
  );

  const removeTask = useCallback(
    (payload) => {
      const id = payload?.taskId || payload?.id || payload?._id || payload;
      if (!id) return;
      tasksRef.current.delete(id);
      scheduleTasksUpdate();
      teardownTaskExecution(id, 'removeTask');
    },
    [scheduleTasksUpdate, teardownTaskExecution],
  );

  const applyPresencePlus = useCallback((payload) => {
    if (!payload) return;
    const list = Array.isArray(payload)
      ? payload
      : payload.players
      ? Object.values(payload.players)
      : Array.isArray(payload.data)
      ? payload.data
      : payload.data
      ? [payload.data]
      : [payload];

    setPresencePlusMap((prev) => {
      const next = { ...prev };
      list.forEach((entry) => {
        if (!entry || typeof entry !== 'object') return;
        const key =
          entry.playerId ||
          entry.mongoId ||
          entry.id ||
          entry.handle ||
          entry._id;
        if (!key) return;
        next[key] = { ...(next[key] || {}), ...entry };
      });
      return next;
    });
  }, []);

  useEffect(() => {
    if (!enabled || !seed) return;
    replaceOfferings(seed.offerings || []);
    const seedTasks = normalizeLocalOpsCollection(seed.tasks)
      .map(normalizeTaskPayload)
      .filter(Boolean);
    const seededTasks = new Map();
    seedTasks.forEach((task, index) => {
      const id = task.taskId || task.id || getLocalOpsId(task, index, 'task');
      seededTasks.set(id, task);
    });
    tasksRef.current = seededTasks;
    scheduleTasksUpdate();
    if (seed.liveTask) scheduleLiveTask(seed.liveTask);
    if (seed.presencePlus) setPresencePlusMap(seed.presencePlus);
  }, [
    enabled,
    seed,
    replaceOfferings,
    scheduleTasksUpdate,
    scheduleLiveTask,
  ]);

  const requestPresencePlus = useCallback(() => {
    if (!socket || !playerId) return;
    socket.emit('presence:localops:get', { playerId }, (ack) => {
      if (ack?.success === false) return;
      if (ack) applyPresencePlus(ack);
    });
  }, [socket, playerId, applyPresencePlus]);

  useEffect(() => {
    if (!enabled || !socket) return;

    // --- Contract mapping (Phase 2) ---
    // Tasks: task:discoverable, task:created, task:accepted, task:started,
    // task:location_update, task:completed, task:cancelled, task:expired,
    // task:resume; task:sync is client-emitted.
    // Offerings: offering:created, offering:updated, offering:removed,
    // offering:nearby (ack payload shape not defined in provided contracts).
    // Presence++: emit presence:localops:get on mount; listen to presence:localops:update.
    // A/V signals: av:eligible, av:task_context (signals only).
    const handleOfferingCreated = (payload) => {
      upsertOffering(payload);
    };
    const handleOfferingUpdated = (payload) => upsertOffering(payload);
    const handleOfferingRemoved = (payload) => {
      removeOffering(payload);
      const id =
        payload?.offeringId || payload?.id || payload?._id || payload;
      if (id && onOfferingRemoved) {
        onOfferingRemoved(id);
      }
    };

    const handleTaskDiscoverable = (payload) =>
      upsertTask(payload, { discoverable: true });
    const handleTaskLifecycle = (payload) => upsertTask(payload);
    const handleTaskExpired = (payload) => upsertTask(payload);
    const handleTaskRemoved = (payload) => {
      removeTask(payload);
      const id = payload?.taskId || payload?.id || payload?._id || payload;
      if (id && onTaskRemoved) {
        onTaskRemoved(id);
      }
    };

    const handleTaskLocationUpdate = (payload) => {
      if (!payload) return;
      const taskId = payload.taskId || payload.id;
      const location = payload.location || payload.lastLocation;
      const coords =
        location && Number.isFinite(location.lat) && Number.isFinite(location.lng)
          ? [location.lng, location.lat]
          : normalizeCoordinates(location || payload);
      if (!taskId || !coords) return;

      const last = liveRouteRef.current.lastLocation;
      if (
        !last ||
        getDistanceFromLatLonInMeters(last[1], last[0], coords[1], coords[0]) >
          6
      ) {
        liveRouteRef.current.coords = [
          ...liveRouteRef.current.coords,
          coords,
        ];
        liveRouteRef.current.lastLocation = coords;
      }

      const existing = tasksRef.current.get(taskId);
      const nextTask = {
        ...(existing || {}),
        taskId,
        providerId: payload.providerId || existing?.providerId,
        providerLocation: { coordinates: coords },
        lastLocation: { coordinates: coords },
        updatedAt: payload.timestamp || Date.now(),
      };
      if (!shouldKeepTask(nextTask)) {
        tasksRef.current.delete(taskId);
        scheduleTasksUpdate();
        return;
      }
      tasksRef.current.set(taskId, nextTask);
      scheduleTasksUpdate();

      if (
        (liveTaskRef.current?.taskId || liveTaskRef.current?.id) === taskId
      ) {
        scheduleLiveTask({
          ...(existing || {}),
          taskId,
          providerId: payload.providerId || existing?.providerId,
          providerLocation: { coordinates: coords },
          routeCoordinates: [...liveRouteRef.current.coords],
        });
      }
    };

    const handlePresenceUpdate = (payload) => applyPresencePlus(payload);

    const handleAvEligible = (payload) => {
      if (!payload?.taskId) return;
      if (
        (liveTaskRef.current?.taskId || liveTaskRef.current?.id) ===
        payload.taskId
      ) {
        scheduleLiveTask({ avEligible: payload });
      }
    };
    const handleAvContext = (payload) => {
      if (!payload?.taskId) return;
      if (
        (liveTaskRef.current?.taskId || liveTaskRef.current?.id) ===
        payload.taskId
      ) {
        scheduleLiveTask({ avContext: payload });
      }
    };

    socket.on('offering:created', handleOfferingCreated);
    socket.on('offering:updated', handleOfferingUpdated);
    socket.on('offering:removed', handleOfferingRemoved);
    socket.on('localops.offering.created', handleOfferingCreated);
    socket.on('localops.offering.updated', handleOfferingUpdated);
    socket.on('localops.offering.removed', handleOfferingRemoved);

    socket.on('task:discoverable', handleTaskDiscoverable);
    const handleTaskCreated = (payload) => {
      handleTaskLifecycle(payload);
    };
    const handleTaskAccepted = (payload) => {
      handleTaskLifecycle(payload);
    };
    const handleTaskStarted = (payload) => {
      handleTaskLifecycle(payload);
    };
    const handleTaskCompleted = (payload) => {
      const normalized = normalizeTaskPayload(payload);
      if (normalized) {
        upsertTask(normalized);
        const acceptedId =
          normalized.acceptedPlayerId || payload?.acceptedPlayerId;
        const entityId =
          normalized.taskId || normalized.id || normalized._id || payload?.taskId;
        const isTasker =
          entityId &&
          currentPlayerId &&
          acceptedId &&
          String(acceptedId) === String(currentPlayerId);
        if (normalized.status === 'completed' && isTasker) {
          onTaskCompleted?.(normalized, payload?.completion || null);
        }
        return;
      }
      handleTaskLifecycle(payload);
    };

    socket.on('task:created', handleTaskCreated);
    socket.on('task:accepted', handleTaskAccepted);
    socket.on('task:started', handleTaskStarted);
    socket.on('task:completed', handleTaskCompleted);
    socket.on('task:cancelled', handleTaskLifecycle);
    socket.on('task:expired', handleTaskExpired);
    socket.on('task:resume', handleTaskLifecycle);
    socket.on('task:location_update', handleTaskLocationUpdate);
    socket.on('localops.task.created', handleTaskLifecycle);
    socket.on('localops.task.updated', handleTaskLifecycle);
    socket.on('localops.task.accepted', handleTaskLifecycle);
    socket.on('localops.task.started', handleTaskLifecycle);
    socket.on('localops.task.completed', handleTaskCompleted);
    socket.on('localops.task.reopened', handleTaskLifecycle);
    socket.on('localops.task.helper_released', handleTaskLifecycle);
    socket.on('localops.task.raise_pay_renotified', handleTaskLifecycle);
    socket.on('localops.task.cancelled', handleTaskLifecycle);
    socket.on('localops.task.removed', handleTaskRemoved);

    socket.on('presence:localops:update', handlePresenceUpdate);
    socket.on('av:eligible', handleAvEligible);
    socket.on('av:task_context', handleAvContext);

    requestPresencePlus();

    return () => {
      socket.off('offering:created', handleOfferingCreated);
      socket.off('offering:updated', handleOfferingUpdated);
      socket.off('offering:removed', handleOfferingRemoved);
      socket.off('localops.offering.created', handleOfferingCreated);
      socket.off('localops.offering.updated', handleOfferingUpdated);
      socket.off('localops.offering.removed', handleOfferingRemoved);

      socket.off('task:discoverable', handleTaskDiscoverable);
      socket.off('task:created', handleTaskCreated);
      socket.off('task:accepted', handleTaskAccepted);
      socket.off('task:started', handleTaskStarted);
      socket.off('task:completed', handleTaskCompleted);
      socket.off('task:cancelled', handleTaskLifecycle);
      socket.off('task:expired', handleTaskExpired);
      socket.off('task:resume', handleTaskLifecycle);
      socket.off('task:location_update', handleTaskLocationUpdate);
      socket.off('localops.task.created', handleTaskLifecycle);
      socket.off('localops.task.updated', handleTaskLifecycle);
      socket.off('localops.task.accepted', handleTaskLifecycle);
      socket.off('localops.task.started', handleTaskLifecycle);
      socket.off('localops.task.completed', handleTaskCompleted);
      socket.off('localops.task.reopened', handleTaskLifecycle);
      socket.off('localops.task.helper_released', handleTaskLifecycle);
      socket.off('localops.task.raise_pay_renotified', handleTaskLifecycle);
      socket.off('localops.task.cancelled', handleTaskLifecycle);
      socket.off('localops.task.removed', handleTaskRemoved);

      socket.off('presence:localops:update', handlePresenceUpdate);
      socket.off('av:eligible', handleAvEligible);
      socket.off('av:task_context', handleAvContext);
    };
  }, [
    enabled,
    socket,
    playerId,
    upsertOffering,
    removeOffering,
    upsertTask,
    scheduleTasksUpdate,
    scheduleLiveTask,
    applyPresencePlus,
    requestPresencePlus,
    shouldKeepTask,
    onOfferingRemoved,
    onTaskRemoved,
    currentPlayerId,
    onTaskCompleted,
  ]);

  useEffect(() => {
    return () => {
      if (offeringsRafRef.current) {
        cancelAnimationFrame(offeringsRafRef.current);
      }
      if (tasksRafRef.current) {
        cancelAnimationFrame(tasksRafRef.current);
      }
      if (liveTaskRafRef.current) {
        cancelAnimationFrame(liveTaskRafRef.current);
      }
    };
  }, []);

  return {
    offerings,
    tasks,
    liveTask,
    presencePlusMap,
    upsertOffering,
    removeOffering,
    replaceOfferings,
    upsertTask,
    removeTask,
    replaceTasks,
    setLiveTask: scheduleLiveTask,
    requestPresencePlus,
  };
};

const PresenceLayer = React.memo(
  ({
    enabled,
    playersWithin,
    player,
    onSelectPlayer,
    presenceIndex,
    mobileView,
    mapZoom,
  }) => {
    if (!enabled) return null;
    return (
      <PlayerMarkers
        playersWithin={playersWithin}
        player={player}
        handleSelectPlayer={onSelectPlayer}
        presenceIndex={presenceIndex}
        mobileView={mobileView}
        mapZoom={mapZoom}
      />
    );
  },
);

const PostsLayer = React.memo(
  ({
    enabled,
    postItems,
    selectedPost,
    onSelectPost,
    onClosePost,
    mobileView,
  }) => {
    const validPosts = useMemo(() => {
      if (!enabled || !Array.isArray(postItems)) return [];
      return postItems.filter((post) => {
        const coords = post?.location?.coordinates;
        return (
          Array.isArray(coords) &&
          coords.length >= 2 &&
          Number.isFinite(coords[0]) &&
          Number.isFinite(coords[1]) &&
          !String(post.context || '').toLowerCase().startsWith('localops.')
        );
      });
    }, [enabled, postItems]);

    const getOffsetCoordinates = useCallback((latitude, longitude, index) => {
      const offset = 0.0001; // Offset value for staggering markers
      const latOffset =
        latitude + (index % 2 === 0 ? offset : -offset) * (index + 1);
      const lonOffset =
        longitude + (index % 2 === 0 ? -offset : offset) * (index + 1);
      return [latOffset, lonOffset];
    }, []);

    const postMarkers = useMemo(
      () => {
        if (!enabled || validPosts.length === 0) {
          return [];
        }
        return validPosts.map((post, index) => {
          const [latOffset, lonOffset] = getOffsetCoordinates(
            post.location.coordinates[1],
            post.location.coordinates[0],
            index,
          );
          return (
            <Marker
              key={post._id}
              longitude={lonOffset}
              latitude={latOffset}
              className="jg-marker jg-marker--post"
            >
              <button
                className="marker-btn2"
                onClick={(e) => {
                  e.preventDefault();
                  onSelectPost(post);
                }}
                style={{
                  position: 'relative',
                  border: 'none',
                  padding: '0',
                  cursor: 'pointer',
                  background: 'none',
                  width: '50px',
                  height: '70px',
                }}
                aria-label={`Post by ${post.playerId}`}
                title={`Post by ${post.playerId} "${post.desc.trim()}"`}
              >
                {post.img &&
                (post.img.endsWith('.mp4') || post.img.endsWith('.mov')) ? (
                  <video
                    src={post.img}
                    muted
                    loop
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      zIndex: 1,
                    }}
                  />
                ) : (
                  <div
                    style={{
                      backgroundImage: `url(${
                        post.img ||
                        'https://res.cloudinary.com/joegalaxy/image/upload/q_auto/v1656194537/Images/noAvatar_tsgpm9.png'
                      })`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      zIndex: 1,
                    }}
                  />
                )}
              </button>
            </Marker>
          );
        });
      },
      [enabled, postItems, getOffsetCoordinates, onSelectPost],
    );

    if (!enabled) return null;

    return (
      <>
        {postMarkers}
        {selectedPost
          ? (() => {
              const postAvatar =
                selectedPost.author?.profilePhoto ||
                selectedPost.profilePhoto ||
                selectedPost.profilePicture ||
                selectedPost.userId?.profilePhoto ||
                selectedPost.userId?.profilePicture ||
                selectedPost.creator?.profilePhoto ||
                selectedPost.user?.profilePhoto ||
                selectedPost.user?.profilePicture ||
                null;
              const postInitial = String(
                selectedPost.playerId || 'P',
              )
                .trim()
                .charAt(0)
                .toUpperCase();
              const postLocationLabel = selectedPost?.location?.address
                ? selectedPost.location.address
                : selectedPost?.location?.coordinates
                ? 'Location shared'
                : 'Location not available';
              const postMediaIsVideo =
                selectedPost.img &&
                (selectedPost.img.endsWith('.mp4') ||
                  selectedPost.img.endsWith('.mov'));
              return (
                <Popup
                  longitude={selectedPost.location.coordinates[0]}
                  latitude={selectedPost.location.coordinates[1]}
                  onClose={onClosePost}
                  className="jg-map-popup jg-map-popup--post"
                >
                  <div className="jg-map-popup__card">
                    <Link
                      to={`/post/${selectedPost._id}`}
                      className="jg-map-popup__link"
                    >
                      <div className="jg-map-popup__header">
                        <div className="jg-map-popup__avatar">
                          {postAvatar ? (
                            <img src={postAvatar} alt={selectedPost.playerId} />
                          ) : (
                            <span className="jg-map-popup__initial">
                              {postInitial}
                            </span>
                          )}
                        </div>
                        <div className="jg-map-popup__header-text">
                          <div className="jg-map-popup__title">
                            {selectedPost.playerId}
                          </div>
                          <div className="jg-map-popup__subtitle">
                            {preciseFormat(selectedPost?.createdAt)}
                          </div>
                        </div>
                      </div>
                      <div className="jg-map-popup__pill-row">
                        <span className="jg-map-popup__pill">Post</span>
                        {selectedPost?.isPogw ? (
                          <span className="jg-map-popup__pill jg-map-popup__pill--accent">
                            POGW
                          </span>
                        ) : null}
                      </div>
                      {selectedPost.desc ? (
                        <div className="jg-map-popup__summary">
                          "{selectedPost.desc}"
                        </div>
                      ) : null}
                      <div className="jg-map-popup__meta">
                        {postLocationLabel}
                      </div>
                      <div className="jg-map-popup__media">
                        {postMediaIsVideo ? (
                          <video
                            src={selectedPost.img}
                            muted
                            loop
                            playsInline
                            autoPlay
                          />
                        ) : (
                          <img
                            src={
                              selectedPost.img ||
                              'https://res.cloudinary.com/joegalaxy/image/upload/q_auto/v1656194537/Images/noAvatar_tsgpm9.png'
                            }
                            alt={selectedPost.desc || 'Post'}
                          />
                        )}
                      </div>
                    </Link>
                  </div>
                </Popup>
              );
            })()
          : null}
      </>
    );
  },
);

const OfferingsLayer = React.memo(
  ({
    enabled,
    offerings,
    onSelectOffering,
    presenceIndex,
    center,
    radiusMeters,
    mobileView,
    mapZoom,
    collisionOffsets = null,
  }) => {
    const [expandedClusterKey, setExpandedClusterKey] = useState(null);
    const resolvedZoom = Number.isFinite(mapZoom) ? mapZoom : 13;
    const filteredOfferings = useMemo(() => {
      if (!enabled || !Array.isArray(offerings) || offerings.length === 0) {
        return [];
      }
      const candidates = offerings
        .map((offering) => ({
          offering,
          coordinates: normalizeCoordinates(offering),
        }))
        .filter((entry) => entry.coordinates);

      if (center && radiusMeters) {
        return candidates.filter((entry) => {
          const distance = getDistanceFromLatLonInMeters(
            center.lat,
            center.lon,
            entry.coordinates[1],
            entry.coordinates[0],
          );
          return distance <= radiusMeters;
        });
      }

      return candidates;
    }, [enabled, offerings, center, radiusMeters]);

    const markerLimit = mobileView
      ? LOCALOPS_MAX_MARKERS_MOBILE
      : LOCALOPS_MAX_MARKERS_DESKTOP;

    const displayOfferings = useMemo(() => {
      if (filteredOfferings.length === 0) return [];
      const ranked = [...filteredOfferings].sort((a, b) => {
        const aFeatured = a.offering?.featured || a.offering?.isFeatured;
        const bFeatured = b.offering?.featured || b.offering?.isFeatured;
        const aSponsored = a.offering?.sponsored || a.offering?.isSponsored;
        const bSponsored = b.offering?.sponsored || b.offering?.isSponsored;
        if (aFeatured !== bFeatured) return aFeatured ? -1 : 1;
        if (aSponsored !== bSponsored) return aSponsored ? -1 : 1;
        return 0;
      });
      return ranked.slice(0, markerLimit);
    }, [filteredOfferings, markerLimit]);

    const offeringEntries = useMemo(
      () =>
        displayOfferings.map(({ offering, coordinates }, index) => {
          const ownerId =
            offering.ownerId ||
            offering.playerId ||
            offering.providerId ||
            offering.createdBy;
          const presenceEntry = ownerId
            ? presenceIndex?.get(ownerId)
            : null;
          const availability =
            offering.availabilityState ||
            offering.availability ||
            presenceEntry?.availabilityState ||
            presenceEntry?.status;
          const badge = getOfferingBadge(offering.category || offering.type);
          const featured = offering.featured || offering.isFeatured;
          const sponsored = offering.sponsored || offering.isSponsored;
          const supportsDelivery =
            offering.supportsDelivery ||
            offering.delivery?.supported ||
            offering.deliverySupported;
          const mediaList = normalizeMediaList(offering);
          const coverIndex = Number.isInteger(offering.coverIndex)
            ? offering.coverIndex
            : 0;
          const cover = mediaList[coverIndex] || mediaList[0] || null;
          const thumbUrl = getMediaThumbnail(offering, coverIndex);
          const isVideo = cover?.type === 'video';
          const id = getLocalOpsId(offering, index, 'offering');
          const adjustedCoords =
            (collisionOffsets && collisionOffsets.get(id)) || coordinates;
          return {
            offering,
            coordinates: adjustedCoords,
            index,
            availability,
            badge,
            featured,
            sponsored,
            supportsDelivery,
            thumbUrl,
            isVideo,
          };
        }),
      [displayOfferings, presenceIndex, collisionOffsets],
    );

    const clusters = useMemo(() => {
      const map = new Map();
      offeringEntries.forEach((entry) => {
        const key = makeClusterKey(entry.coordinates);
        if (!map.has(key)) {
          map.set(key, { key, center: entry.coordinates, entries: [] });
        }
        map.get(key).entries.push(entry);
      });
      return Array.from(map.values());
    }, [offeringEntries]);

    const toggleCluster = useCallback((key) => {
      setExpandedClusterKey((prev) => (prev === key ? null : key));
    }, []);
    const collapseClusters = useCallback(() => {
      setExpandedClusterKey(null);
    }, []);
    const expandedCluster = useMemo(() => {
      if (!expandedClusterKey) return null;
      return clusters.find((cluster) => cluster.key === expandedClusterKey) || null;
    }, [clusters, expandedClusterKey]);
    const showList =
      expandedCluster && expandedCluster.entries.length >= 6;

    useEffect(() => {
      if (!expandedClusterKey) return;
      const exists = clusters.some(
        (cluster) => cluster.key === expandedClusterKey,
      );
      if (!exists) {
        setExpandedClusterKey(null);
      }
    }, [clusters, expandedClusterKey]);

    useEffect(() => {
      if (!expandedClusterKey) return undefined;
      const handlePointer = (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;
        if (
          target.closest('.localops-cluster') ||
          target.closest('.localops-cluster-list') ||
          target.closest('.localops-spider')
        ) {
          return;
        }
        setExpandedClusterKey(null);
      };
      document.addEventListener('pointerdown', handlePointer, true);
      return () => {
        document.removeEventListener('pointerdown', handlePointer, true);
      };
    }, [expandedClusterKey]);

    const renderOfferingMarker = useCallback(
      (entry, keySuffix = '', coordsOverride = null, extraClass = '', onSelect) => {
        const { offering, coordinates } = entry;
        const id = getLocalOpsId(offering, entry.index, 'offering');
        const markerKey = keySuffix ? `${id}-${keySuffix}` : id;
        const markerCoords = coordsOverride || coordinates;
        if (!markerCoords) return null;
        const markerClassName = [
          'jg-marker',
          'jg-marker--localops',
          'jg-marker--offering',
        ].join(' ');
        return (
          <Marker
            key={markerKey}
            longitude={markerCoords[0]}
            latitude={markerCoords[1]}
            className={markerClassName}
          >
            <button
              type="button"
              className={[
                'localops-pin',
                'localops-pin--offering',
                entry.featured ? 'is-featured' : '',
                entry.sponsored ? 'is-sponsored' : '',
                entry.availability ? `availability-${entry.availability}` : '',
                extraClass,
              ]
                .filter(Boolean)
                .join(' ')}
              onClick={(event) => {
                event.preventDefault();
                onSelectOffering(offering);
                onSelect?.();
              }}
              aria-label={offering.title || offering.name || 'Offering'}
              title={offering.title || offering.name || 'Offering'}
            >
              <span className="localops-pin__badge">{entry.badge}</span>
              {entry.thumbUrl ? (
                <span
                  className="localops-pin__thumb"
                  style={{ backgroundImage: `url(${entry.thumbUrl})` }}
                  aria-hidden="true"
                />
              ) : null}
              {entry.isVideo ? (
                <span className="localops-pin__media" aria-hidden="true">
                  VIDEO
                </span>
              ) : null}
              {entry.availability ? (
                <span
                  className="localops-pin__presence"
                  aria-label={`Availability ${entry.availability}`}
                />
              ) : null}
              {entry.supportsDelivery ? (
                <span
                  className="localops-pin__delivery"
                  aria-label="Delivery available"
                />
              ) : null}
            </button>
          </Marker>
        );
      },
      [onSelectOffering],
    );

    if (!enabled || filteredOfferings.length === 0) {
      return null;
    }

    return (
      <>
        {clusters.map((cluster) => {
          if (cluster.entries.length === 1) {
            return renderOfferingMarker(cluster.entries[0]);
          }
          const expanded = expandedClusterKey === cluster.key;
          const useSpider =
            expanded && cluster.entries.length < 6;
          const stack = cluster.entries.slice(0, 3);
          const countLabel =
            cluster.entries.length > 9 ? '9+' : `${cluster.entries.length}`;
          return (
            <React.Fragment key={`cluster-${cluster.key}`}>
              <Marker
                longitude={cluster.center[0]}
                latitude={cluster.center[1]}
                className="jg-marker jg-marker--localops jg-marker--offering jg-marker--cluster"
              >
                <button
                  type="button"
                  className={[
                    'localops-cluster',
                    'localops-cluster--offering',
                    expanded ? 'is-open' : '',
                  ]
                    .filter(Boolean)
                    .join(' ')}
                  onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    toggleCluster(cluster.key);
                  }}
                  aria-expanded={expanded ? 'true' : 'false'}
                  aria-label={`${cluster.entries.length} offerings here`}
                >
                  <span className="localops-cluster__stack" aria-hidden="true">
                    {stack.map((entry, index) => (
                      <span
                        key={`off-stack-${cluster.key}-${index}`}
                        className={`localops-cluster__thumb is-${index + 1}`}
                        style={
                          entry.thumbUrl
                            ? { backgroundImage: `url(${entry.thumbUrl})` }
                            : undefined
                        }
                      >
                        {!entry.thumbUrl ? entry.badge : null}
                      </span>
                    ))}
                  </span>
                  <span className="localops-cluster__count">{countLabel}</span>
                </button>
              </Marker>
              {useSpider
                ? cluster.entries.map((entry, index) => {
                    const spiderCoords = buildSpiderCoord({
                      center: cluster.center,
                      index,
                      count: cluster.entries.length,
                      zoom: resolvedZoom,
                      mobileView,
                    });
                    return renderOfferingMarker(
                      entry,
                      `spider-${cluster.key}-${index}`,
                      spiderCoords,
                      'localops-spider',
                      collapseClusters,
                    );
                  })
                : null}
            </React.Fragment>
          );
        })}
        {showList ? (
          <div
            className="localops-cluster-list localops-cluster-list--offering"
            role="dialog"
          >
            <div className="localops-cluster-list__header">
              <div>
                <div className="localops-cluster-list__title">
                  Offerings here
                </div>
                <div className="localops-cluster-list__subtitle">
                  {expandedCluster.entries.length} nearby offerings
                </div>
              </div>
              <button
                type="button"
                className="localops-cluster-list__close"
                onClick={collapseClusters}
                aria-label="Close list"
              >
                Close
              </button>
            </div>
            <div className="localops-cluster-list__body">
              {expandedCluster.entries.map((entry) => (
                <button
                  key={`offering-list-${entry.offering._id || entry.index}`}
                  type="button"
                  className="localops-cluster-list__item"
                  onClick={() => {
                    onSelectOffering(entry.offering);
                    collapseClusters();
                  }}
                >
                  <span
                    className="localops-cluster-list__thumb"
                    style={
                      entry.thumbUrl
                        ? { backgroundImage: `url(${entry.thumbUrl})` }
                        : undefined
                    }
                    aria-hidden="true"
                  >
                    {!entry.thumbUrl ? entry.badge : null}
                  </span>
                  <span className="localops-cluster-list__meta">
                    <span className="localops-cluster-list__name">
                      {entry.offering.title ||
                        entry.offering.name ||
                        'Offering'}
                    </span>
                    <span className="localops-cluster-list__sub">
                      {entry.offering.category ||
                        entry.offering.type ||
                        'Local offering'}
                    </span>
                  </span>
                </button>
              ))}
            </div>
          </div>
            ) : null}
      </>
    );
  },
);

const TasksLayer = React.memo(
  ({
    enabled,
    tasks,
    onSelectTask,
    presenceIndex,
    center,
    radiusMeters,
    mobileView,
    activeTaskId,
    mapZoom,
    collisionOffsets = null,
  }) => {
    const [expandedClusterKey, setExpandedClusterKey] = useState(null);
    const resolvedZoom = Number.isFinite(mapZoom) ? mapZoom : 13;
    const filteredTasks = useMemo(() => {
      if (!enabled || !Array.isArray(tasks) || tasks.length === 0) {
        return [];
      }
      const candidates = tasks
        .map((task) => ({
          task,
          coordinates: normalizeCoordinates(task),
        }))
        .filter((entry) => entry.coordinates);

      if (center && radiusMeters) {
        return candidates.filter((entry) => {
          const distance = getDistanceFromLatLonInMeters(
            center.lat,
            center.lon,
            entry.coordinates[1],
            entry.coordinates[0],
          );
          return distance <= radiusMeters;
        });
      }

      return candidates;
    }, [enabled, tasks, center, radiusMeters]);

    const visibleTasks = useMemo(() => {
      if (filteredTasks.length === 0) return [];
      const presenceFiltered = filteredTasks.filter(({ task }) => {
        if (!task) return false;
        if (!task.presenceFiltered && !task.requireAvailability) return true;
        const ownerId =
          task.ownerId || task.playerId || task.requesterId || task.createdBy;
        if (!ownerId) return true;
        const presenceEntry = presenceIndex?.get(ownerId);
        if (!presenceEntry) return true;
        if (
          task.requireAvailability &&
          presenceEntry.availabilityState &&
          presenceEntry.availabilityState !== task.requireAvailability
        ) {
          return false;
        }
        if (task.presenceFiltered && presenceEntry.availabilityState === 'busy') {
          return false;
        }
        return true;
      });

      const markerLimit = mobileView
        ? LOCALOPS_MAX_MARKERS_MOBILE
        : LOCALOPS_MAX_MARKERS_DESKTOP;
      return presenceFiltered.slice(0, markerLimit);
    }, [filteredTasks, presenceIndex, mobileView]);

    const taskEntries = useMemo(
      () =>
        visibleTasks.map(({ task, coordinates }, index) => {
          const taskType = task.taskType || task.type || task.category;
          const meta = getTaskTypeMeta(taskType);
          const sponsored = task.sponsored || task.isSponsored;
          const highlighted =
            activeTaskId && (activeTaskId === task.taskId || activeTaskId === task.id || activeTaskId === task._id);
          const mediaList = normalizeMediaList(task);
          const coverIndex = Number.isInteger(task.coverIndex)
            ? task.coverIndex
            : 0;
          const cover = mediaList[coverIndex] || mediaList[0] || null;
          const thumbUrl = getMediaThumbnail(task, coverIndex);
          const isVideo = cover?.type === 'video';
          const statusClass = task.status ? `status-${task.status}` : '';
          const id = getLocalOpsId(task, index, 'task');
          const adjustedCoords =
            (collisionOffsets && collisionOffsets.get(id)) || coordinates;
          return {
            task,
            coordinates: adjustedCoords,
            index,
            meta,
            sponsored,
            highlighted,
            thumbUrl,
            isVideo,
            statusClass,
          };
        }),
      [visibleTasks, activeTaskId, collisionOffsets],
    );

    const clusters = useMemo(() => {
      const map = new Map();
      taskEntries.forEach((entry) => {
        const key = makeClusterKey(entry.coordinates);
        if (!map.has(key)) {
          map.set(key, { key, center: entry.coordinates, entries: [] });
        }
        map.get(key).entries.push(entry);
      });
      return Array.from(map.values());
    }, [taskEntries]);

    const toggleCluster = useCallback((key) => {
      setExpandedClusterKey((prev) => (prev === key ? null : key));
    }, []);
    const collapseClusters = useCallback(() => {
      setExpandedClusterKey(null);
    }, []);
    const expandedCluster = useMemo(() => {
      if (!expandedClusterKey) return null;
      return clusters.find((cluster) => cluster.key === expandedClusterKey) || null;
    }, [clusters, expandedClusterKey]);
    const showList =
      expandedCluster && expandedCluster.entries.length >= 6;

    useEffect(() => {
      if (!expandedClusterKey) return;
      const exists = clusters.some(
        (cluster) => cluster.key === expandedClusterKey,
      );
      if (!exists) {
        setExpandedClusterKey(null);
      }
    }, [clusters, expandedClusterKey]);

    useEffect(() => {
      if (!expandedClusterKey) return undefined;
      const handlePointer = (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;
        if (
          target.closest('.localops-cluster') ||
          target.closest('.localops-cluster-list') ||
          target.closest('.localops-spider')
        ) {
          return;
        }
        setExpandedClusterKey(null);
      };
      document.addEventListener('pointerdown', handlePointer, true);
      return () => {
        document.removeEventListener('pointerdown', handlePointer, true);
      };
    }, [expandedClusterKey]);

    const renderTaskMarker = useCallback(
      (entry, keySuffix = '', coordsOverride = null, extraClass = '', onSelect) => {
        const { task, coordinates } = entry;
        const id = getLocalOpsId(task, entry.index, 'task');
        const markerKey = keySuffix ? `${id}-${keySuffix}` : id;
        const markerCoords = coordsOverride || coordinates;
        if (!markerCoords) return null;
        const markerClassName = [
          'jg-marker',
          'jg-marker--localops',
          'jg-marker--task',
        ].join(' ');
        return (
          <Marker
            key={markerKey}
            longitude={markerCoords[0]}
            latitude={markerCoords[1]}
            className={markerClassName}
          >
            <button
              type="button"
              className={[
                'localops-pin',
                'localops-pin--task',
                entry.meta.className,
                entry.meta.isAssistance ? 'localops-task--assistance' : '',
                entry.sponsored ? 'is-sponsored' : '',
                entry.highlighted ? 'is-active' : '',
                entry.statusClass,
                extraClass,
              ]
                .filter(Boolean)
                .join(' ')}
              onClick={(event) => {
                event.preventDefault();
                onSelectTask(task);
                onSelect?.();
              }}
              aria-label={task.title || task.name || entry.meta.label}
              title={task.title || task.name || entry.meta.label}
            >
              <span className="localops-pin__badge">{entry.meta.badge}</span>
              {entry.thumbUrl ? (
                <span
                  className="localops-pin__thumb"
                  style={{ backgroundImage: `url(${entry.thumbUrl})` }}
                  aria-hidden="true"
                />
              ) : null}
              {entry.isVideo ? (
                <span className="localops-pin__media" aria-hidden="true">
                  VIDEO
                </span>
              ) : null}
            </button>
          </Marker>
        );
      },
      [onSelectTask],
    );

    if (!enabled || filteredTasks.length === 0) {
      return null;
    }

    return (
      <>
        {clusters.map((cluster) => {
          if (cluster.entries.length === 1) {
            return renderTaskMarker(cluster.entries[0]);
          }
          const expanded = expandedClusterKey === cluster.key;
          const useSpider =
            expanded && cluster.entries.length < 6;
          const stack = cluster.entries.slice(0, 3);
          const countLabel =
            cluster.entries.length > 9 ? '9+' : `${cluster.entries.length}`;
          return (
            <React.Fragment key={`task-cluster-${cluster.key}`}>
              <Marker
                longitude={cluster.center[0]}
                latitude={cluster.center[1]}
                className="jg-marker jg-marker--localops jg-marker--task jg-marker--cluster"
              >
                <button
                  type="button"
                  className={[
                    'localops-cluster',
                    'localops-cluster--task',
                    expanded ? 'is-open' : '',
                  ]
                    .filter(Boolean)
                    .join(' ')}
                  onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    toggleCluster(cluster.key);
                  }}
                  aria-expanded={expanded ? 'true' : 'false'}
                  aria-label={`${cluster.entries.length} tasks here`}
                >
                  <span className="localops-cluster__stack" aria-hidden="true">
                    {stack.map((entry, index) => (
                      <span
                        key={`task-stack-${cluster.key}-${index}`}
                        className={`localops-cluster__thumb is-${index + 1}`}
                        style={
                          entry.thumbUrl
                            ? { backgroundImage: `url(${entry.thumbUrl})` }
                            : undefined
                        }
                      >
                        {!entry.thumbUrl ? entry.meta.badge : null}
                      </span>
                    ))}
                  </span>
                  <span className="localops-cluster__count">{countLabel}</span>
                </button>
              </Marker>
              {useSpider
                ? cluster.entries.map((entry, index) => {
                    const spiderCoords = buildSpiderCoord({
                      center: cluster.center,
                      index,
                      count: cluster.entries.length,
                      zoom: resolvedZoom,
                      mobileView,
                    });
                    return renderTaskMarker(
                      entry,
                      `spider-${cluster.key}-${index}`,
                      spiderCoords,
                      'localops-spider',
                      collapseClusters,
                    );
                  })
                : null}
            </React.Fragment>
          );
        })}
        {showList ? (
          <div
            className="localops-cluster-list localops-cluster-list--task"
            role="dialog"
          >
            <div className="localops-cluster-list__header">
              <div>
                <div className="localops-cluster-list__title">
                  Tasks here
                </div>
                <div className="localops-cluster-list__subtitle">
                  {expandedCluster.entries.length} nearby tasks
                </div>
              </div>
              <button
                type="button"
                className="localops-cluster-list__close"
                onClick={collapseClusters}
                aria-label="Close list"
              >
                Close
              </button>
            </div>
            <div className="localops-cluster-list__body">
              {expandedCluster.entries.map((entry) => (
                <button
                  key={`task-list-${entry.task._id || entry.index}`}
                  type="button"
                  className="localops-cluster-list__item"
                  onClick={() => {
                    onSelectTask(entry.task);
                    collapseClusters();
                  }}
                >
                  <span
                    className="localops-cluster-list__thumb"
                    style={
                      entry.thumbUrl
                        ? { backgroundImage: `url(${entry.thumbUrl})` }
                        : undefined
                    }
                    aria-hidden="true"
                  >
                    {!entry.thumbUrl ? entry.meta.badge : null}
                  </span>
                  <span className="localops-cluster-list__meta">
                    <span className="localops-cluster-list__name">
                      {entry.task.title || entry.task.name || entry.meta.label}
                    </span>
                    <span className="localops-cluster-list__sub">
                      {entry.meta.label}
                    </span>
                  </span>
                </button>
              ))}
            </div>
          </div>
        ) : null}
      </>
    );
  },
);

const LiveTaskOverlay = React.memo(
  ({ activeTask, presenceIndex, motionLevel }) => {
    const [statusFlash, setStatusFlash] = useState(false);
    const lastStatusRef = useRef(activeTask?.status);

    useEffect(() => {
      const status = activeTask?.status;
      if (status && status !== lastStatusRef.current) {
        lastStatusRef.current = status;
        setStatusFlash(true);
        const timeout = setTimeout(() => setStatusFlash(false), 1200);
        return () => clearTimeout(timeout);
      }
    }, [activeTask?.status]);

    if (
      !activeTask ||
      (activeTask?.status &&
        ['completed', 'cancelled', 'expired'].includes(
          String(activeTask.status).toLowerCase(),
        ))
    )
      return null;

    const mediaList = normalizeMediaList(activeTask);
    const coverIndex = Number.isInteger(activeTask?.coverIndex)
      ? activeTask.coverIndex
      : 0;
    const mediaThumb = getMediaThumbnail(activeTask, coverIndex);

    const routeCoordinates =
      activeTask.route?.coordinates ||
      activeTask.route ||
      activeTask.path ||
      activeTask.routeCoordinates ||
      null;
    const routeGeoJson =
      Array.isArray(routeCoordinates) && routeCoordinates.length > 1
        ? {
            type: 'Feature',
            properties: {},
            geometry: {
              type: 'LineString',
              coordinates: routeCoordinates,
            },
          }
        : null;

    const providerLocation = normalizeCoordinates(
      activeTask.providerLocation ||
        activeTask.provider ||
        activeTask.assignee ||
        activeTask.driver,
    );
    const destinationLocation = normalizeCoordinates(
      activeTask.destination || activeTask.dropoff || activeTask.target,
    );

    const taskMeta = getTaskTypeMeta(
      activeTask.taskType || activeTask.type || activeTask.category,
    );
    const providerId =
      activeTask.providerId ||
      activeTask.assigneeId ||
      activeTask.driverId ||
      activeTask.provider?.playerId;
    const providerPresence = providerId
      ? presenceIndex?.get(providerId)
      : null;
    const canRequestAv =
      activeTask.allowAv ||
      activeTask.avEnabled ||
      providerPresence?.availabilityState === 'available';

    const shareCount = Array.isArray(activeTask.shareWith)
      ? activeTask.shareWith.length
      : 0;

    const handleShare = () => {
      if (typeof window === 'undefined') return;
      window.dispatchEvent(
        new CustomEvent('localops:share:open', {
          detail: { taskId: activeTask.id || activeTask.taskId },
        }),
      );
    };

    const handleAvRequest = () => {
      if (typeof window === 'undefined') return;
      window.dispatchEvent(
        new CustomEvent('localops:av:request', {
          detail: {
            taskId: activeTask.id || activeTask.taskId,
            providerId,
          },
        }),
      );
    };

    return (
      <>
        {routeGeoJson ? (
          <Source id="localops-live-route" type="geojson" data={routeGeoJson}>
            <Layer
              id="localops-live-route-outline"
              type="line"
              paint={{
                'line-color': LOCALOPS_ROUTE_OUTLINE,
                'line-width': 6,
                'line-opacity': 0.6,
              }}
            />
            <Layer
              id="localops-live-route"
              type="line"
              paint={{
                'line-color': LOCALOPS_ROUTE_COLOR,
                'line-width': 3,
                'line-opacity': 0.9,
              }}
            />
          </Source>
        ) : null}
        {providerLocation ? (
          <Marker
            longitude={providerLocation[0]}
            latitude={providerLocation[1]}
          >
            <div className="localops-live-marker localops-live-marker--provider" />
          </Marker>
        ) : null}
        {destinationLocation ? (
          <Marker
            longitude={destinationLocation[0]}
            latitude={destinationLocation[1]}
          >
            <div className="localops-live-marker localops-live-marker--target" />
          </Marker>
        ) : null}
        <div
          className={[
            'localops-live-card',
            motionLevel === 'low' ? 'localops-live-card--calm' : '',
            statusFlash ? 'localops-live-card--flash' : '',
          ]
            .filter(Boolean)
            .join(' ')}
          data-motion={motionLevel}
        >
          <div className="localops-live-card__header">
            <span className="localops-pill">
              {taskMeta?.isAssistance ? 'Assistance' : taskMeta?.label}
            </span>
            {activeTask.status ? (
              <span className="localops-pill localops-pill--status">
                {activeTask.status}
              </span>
            ) : null}
          </div>
          {mediaThumb && mediaList.length ? (
            <div className="localops-live-media">
              <img src={mediaThumb} alt="" />
              {mediaList[coverIndex]?.type === 'video' ? (
                <span className="localops-live-media__badge">VIDEO</span>
              ) : null}
            </div>
          ) : null}
          <h3>{activeTask.title || activeTask.name || 'Live task'}</h3>
          {activeTask.etaMinutes ? (
            <p className="localops-meta">ETA: {activeTask.etaMinutes} min</p>
          ) : null}
          {shareCount ? (
            <p className="localops-meta">
              Sharing live route with {shareCount} trusted player
              {shareCount === 1 ? '' : 's'}
            </p>
          ) : (
            <p className="localops-meta">
              Live tracking enabled
            </p>
          )}
          <div className="localops-live-card__actions">
            <button
              type="button"
              className="localops-action"
              onClick={handleShare}
            >
              Share route
            </button>
            {canRequestAv ? (
              <button
                type="button"
                className="localops-action localops-action--primary"
                onClick={handleAvRequest}
              >
                Start A/V
              </button>
            ) : null}
          </div>
        </div>
      </>
    );
  },
);

export default function PlayerMapPage() {
  // console.log('PlayerMapPage re-rendered');
  const { player, updatePlayer } = useContext(AuthContext);
  const mobileView = useMobileView();
  const pageVisibilityRef = usePageVisibility();
  const { presenceMap } = usePresence() || {};
  const playerId =
    player?.data?.player?.playerId ||
    player?.data?.player?._id ||
    player?.playerId ||
    player?._id ||
    null;
  const currentPlayerId =
    player?.data?.player?._id || player?._id || null;
  const currentPlayerHandle =
    player?.data?.player?.playerId || player?.playerId || null;
  const [playerBalance, setPlayerBalance] = useState(
    Number(
      player?.data?.player?.jgkTokens ??
        player?.jgkTokens ??
        0,
    ),
  );
  useEffect(() => {
    const next = Number(
      player?.data?.player?.jgkTokens ??
        player?.jgkTokens ??
        null,
    );
    if (Number.isFinite(next) && next !== playerBalance) {
      setPlayerBalance(next);
    }
  }, [player?.data?.player?.jgkTokens, player?.jgkTokens, playerBalance]);
  const [latitude, SetLatitude] = useState(null);
  const [longitude, SetLongitude] = useState(null);
  const [accuracy, SetAccuracy] = useState(null);
  const [timestamp, SetTimestamp] = useState(null);
  const [radius, setRadius] = useState(25);
  const [initialRadius, setInitialRadius] = useState(radius);
  const [postRadiusSet, setPostRadiusSet] = useState(false);
  const [unit, setUnit] = useState('mi');
  const [playersWithin, setPlayersWithin] = useState({});
  const [selectedPlayer, setSelectedPlayer] = useState(null);
  const [selectedOffering, setSelectedOffering] = useState(null);
  const [offeringQueue, setOfferingQueue] = useState([]);
  const [offeringQueueIndex, setOfferingQueueIndex] = useState(-1);
  const [selectedTask, setSelectedTask] = useState(null);
  const [acceptingTaskId, setAcceptingTaskId] = useState(null);
  const [taskAcceptFeedback, setTaskAcceptFeedback] = useState(null);
  const [publicDetailsEditTarget, setPublicDetailsEditTarget] = useState(null);
  const [isLayersOpen, setIsLayersOpen] = useState(false);
  const [locationHintStatus, setLocationHintStatus] = useState('idle'); // idle|prompt|ready|fallback|denied|waiting
  const [locationHintMessage, setLocationHintMessage] = useState('');
  const locationConsentPrimerDismissedKey = useMemo(() => {
    const scopedPlayerId =
      currentPlayerId || currentPlayerHandle || playerId || 'anonymous';
    return `${LOCALOPS_LOCATION_PRIMER_DISMISSED_KEY}:${scopedPlayerId}`;
  }, [currentPlayerId, currentPlayerHandle, playerId]);
  const [locationConsentPrimerDismissed, setLocationConsentPrimerDismissed] =
    useState(() => {
      try {
        return (
          window.sessionStorage.getItem(
            locationConsentPrimerDismissedKey,
          ) === '1'
        );
      } catch (err) {
        return false;
      }
    });
  const [locationConsentGate, setLocationConsentGate] = useState(null);
  const [locationConsentBusy, setLocationConsentBusy] = useState(false);
  const [locationConsentError, setLocationConsentError] = useState('');
  const [locationRefreshEnabled, setLocationRefreshEnabled] = useState(false);
  const [
    hasPersonalLocationOverride,
    setHasPersonalLocationOverride,
  ] = useState(false);
  const personalLocationReadyRef = useRef(false);
  const locationConsentGateRef = useRef(null);
  const [isCreateOpen, setIsCreateOpen] = useState(false);
  const [isTopUpOpen, setIsTopUpOpen] = useState(false);
  const [topUpPresetUsd, setTopUpPresetUsd] = useState(null);
  const [topUpReturnTo, setTopUpReturnTo] = useState(null);
  const [topUpVariant, setTopUpVariant] = useState(null);
  const [topUpRequiredJGK, setTopUpRequiredJGK] = useState(null);
  const pendingResumeTimerRef = useRef(null);
  const topUpInProgressRef = useRef(false);
  const [pendingIntentState, setPendingIntentState] = useState(() =>
    readPendingIntent(),
  );
  useEffect(() => {
    setPendingIntentState(readPendingIntent());
  }, []);
  const [createPreset, setCreatePreset] = useState(null);
  const [createLaunchTypeHint, setCreateLaunchTypeHint] = useState(null);
  const [createLaunchStepHint, setCreateLaunchStepHint] = useState(null);
  const [createLaunchGroupHint, setCreateLaunchGroupHint] = useState(null);
  const [createLaunchId, setCreateLaunchId] = useState(0);
  const [createIgnitionCandidate, setCreateIgnitionCandidate] = useState(false);
  const [starterIdeasOpen, setStarterIdeasOpen] = useState(false);
  const [starterIdeasIgnitionCandidate, setStarterIdeasIgnitionCandidate] =
    useState(true);
  const [sharePanel, setSharePanel] = useState({
    open: false,
    type: null,
    item: null,
    status: null,
  });
  const [firestarterCreatePending, setFirestarterCreatePending] = useState(false);
  const [firestarterShareTaskId, setFirestarterShareTaskId] = useState(null);
  const firestarterShownRef = useRef(false);
  const firestarterCreateOpenedRef = useRef(false);
  const requesterLandingShownRef = useRef(false);
  const collisionRideCreateOpenedRef = useRef(false);
  const consumedCollisionRideLaunchesRef = useRef(new Set());
  const intakeDraftClaimTokenRef = useRef('');
  const intakeDraftClaimInFlightRef = useRef(false);
  const genericIntakeDraftClaimTokenRef = useRef('');
  const genericIntakeDraftClaimInFlightRef = useRef(false);
  const offeringDraftClaimTokenRef = useRef('');
  const offeringDraftClaimInFlightRef = useRef(false);
  const [localOpsError, setLocalOpsError] = useState('');
  const [localOpsNotice, setLocalOpsNotice] = useState('');
  const [rideReadyRequiredPrompt, setRideReadyRequiredPrompt] = useState(null);
  const resolveRideReadyProfilePath = useCallback(
    (serverPath) => {
      const raw = String(serverPath || '').trim();
      if (/^\/profile\/[^/?#]+(\?|$)/.test(raw)) return raw;
      const handle = String(currentPlayerHandle || '').trim();
      if (handle) {
        return `/profile/${encodeURIComponent(handle)}?focus=localOpsRideReady`;
      }
      return raw || '/profile';
    },
    [currentPlayerHandle],
  );
  const [pendingConfirmationGate, setPendingConfirmationGate] = useState(null);
  const pendingConfirmationGateBusyRef = useRef(false);
  const createTaskInFlightRef = useRef(false);
  const [trustGate, setTrustGate] = useState(null);
  const [postCompletionContext, setPostCompletionContext] = useState(null);
  const [postCompletionOpen, setPostCompletionOpen] = useState(false);
  const landingOverlayRef = useRef(null);
  const landingCardRef = useRef(null);
  const localOpsTickerRef = useRef(null);
  const landingTickerLayoutRef = useRef({
    lift: 0,
    maxHeight: null,
    tickerDrop: 0,
  });
  const landingTickerRafRef = useRef(null);
  const [landingTickerLayout, setLandingTickerLayout] = useState({
    lift: 0,
    maxHeight: null,
    tickerDrop: 0,
  });
  const getLandingViewportSize = useCallback(() => {
    if (typeof window === 'undefined') {
      return { width: 0, height: 0 };
    }
    const visualViewport = window.visualViewport;
    return {
      width: Math.round(visualViewport?.width || window.innerWidth || 0),
      height: Math.round(visualViewport?.height || window.innerHeight || 0),
    };
  }, []);
  const [landingViewportSize, setLandingViewportSize] = useState(() =>
    getLandingViewportSize(),
  );
  const [localOpsLoading, setLocalOpsLoading] = useState(true);
  const [
    hasCompletedInitialLocalOpsSnapshot,
    setHasCompletedInitialLocalOpsSnapshot,
  ] = useState(false);
  const [resumeErrorMessage, setResumeErrorMessage] = useState('');
  const [resumeDebugMessage, setResumeDebugMessage] = useState('');
  const [hasResumeIntent] = useState(() => {
    try {
      return !!localStorage.getItem('jg:resume');
    } catch (err) {
      return false;
    }
  });
  const [landingAuthExpanded, setLandingAuthExpanded] = useState(false);
  const [landingAuthRequired, setLandingAuthRequired] = useState(false);
  const [landingPrimaryBusy, setLandingPrimaryBusy] = useState(false);
  const [landingEmail, setLandingEmail] = useState('');
  const [landingEmailError, setLandingEmailError] = useState('');
  const [landingMagicStatus, setLandingMagicStatus] = useState('idle');
  const [localOpsFeedOpen, setLocalOpsFeedOpen] = useState(false);
  const { events: localOpsLiveEvents } = useLocalOpsLive() || { events: [] };
  const [localOpsSeedEvents, setLocalOpsSeedEvents] = useState([]);
  const [localOpsRecentEvents, setLocalOpsRecentEvents] = useState([]);
  const [localOpsRecentActivitySettled, setLocalOpsRecentActivitySettled] =
    useState(false);
  const [openTaskHydrationSettledIds, setOpenTaskHydrationSettledIds] =
    useState(() => new Set());
  const [zoom, setZoom] = useState(null);
  const [initialZoom, setInitialZoom] = useState(zoom);
  const [getPosition, setGetPosition] = useState(true);
  const [mapBooted, setMapBooted] = useState(false);
  const { socket: socket2 } = useContext(SocketContext);
  const location = useLocation();
  const playerMapRouteKey = `${location.key || ''}:${location.pathname}:${location.search}`;
  const history = useHistory();
  const [lastFetchLocation, setLastFetchLocation] = useState({
    lat: null,
    lon: null,
  });
  const [fetchLat, setFetchLat] = useState(null);
  const [fetchLon, setFetchLon] = useState(null);
  const lastSentLocation = useRef({ lat: null, lon: null });
  const lastMovementTime = useRef(Date.now());
  const resumeBackoffRef = useRef(1000);
  const resumeInFlightRef = useRef(false);
  const viewerActionCreditTotal = useMemo(() => {
    const value = Number(
      player?.data?.player?.actionCreditCount ??
        player?.data?.player?.actionCredit ??
        player?.actionCreditCount ??
        player?.actionCredit ??
        0,
    );
    return Number.isFinite(value) ? value : 0;
  }, [player]);
  const currentPlayerRole = useMemo(
    () =>
      player?.data?.player?.role ||
      player?.player?.role ||
      player?.role ||
      'player',
    [player],
  );
  const currentPlayerRecord = useMemo(
    () => player?.data?.player || player?.player || player || null,
    [player],
  );

  const normalizeCompletionContext = useCallback(
    (rawCompletion, fallback = {}) => {
      const completion =
        rawCompletion && typeof rawCompletion === 'object' ? rawCompletion : {};
      const fallbackEntityId =
        fallback.entityId || fallback.taskId || fallback.offeringId || null;
      const entityId =
        completion.entityId || completion.id || completion.orderId || fallbackEntityId;
      if (!entityId) return null;

      const fallbackAmountUsdRaw = Number(fallback.amountUSD);
      const fallbackAmountJGKRaw = Number(fallback.amountJGK);
      const completionAmountUsdRaw = Number(
        completion.amountUSD ?? completion.localValueCreated?.amountUSD,
      );
      const completionAmountJGKRaw = Number(
        completion.amountJGK ?? completion.localValueCreated?.amountJGK,
      );
      const amountUSD = Number.isFinite(completionAmountUsdRaw)
        ? completionAmountUsdRaw
        : Number.isFinite(fallbackAmountUsdRaw)
        ? fallbackAmountUsdRaw
        : null;
      const amountJGK = Number.isFinite(completionAmountJGKRaw)
        ? Math.round(completionAmountJGKRaw)
        : Number.isFinite(fallbackAmountJGKRaw)
        ? Math.round(fallbackAmountJGKRaw)
        : Number.isFinite(Number(amountUSD))
        ? Math.round(Number(amountUSD) * 1000)
        : null;

      const rawActionCredit =
        completion.actionCredit && typeof completion.actionCredit === 'object'
          ? completion.actionCredit
          : null;
      const actionCreditTotalRaw = Number(rawActionCredit?.total);
      const actionCreditTotal = Number.isFinite(actionCreditTotalRaw)
        ? actionCreditTotalRaw
        : viewerActionCreditTotal;
      const actionCreditEligible =
        rawActionCredit?.eligibleForViewer === true
          ? true
          : rawActionCredit?.eligibleForViewer === false
          ? false
          : fallback.actionCreditEligibleForViewer === true
          ? true
          : fallback.actionCreditEligibleForViewer === false
          ? false
          : null;
      const actionCredit = {
        awarded:
          rawActionCredit?.awarded === true
            ? true
            : rawActionCredit?.awarded === false
            ? false
            : null,
        duplicate:
          rawActionCredit?.duplicate === true
            ? true
            : rawActionCredit?.duplicate === false
            ? false
            : null,
        total: actionCreditTotal,
        trustLabel:
          rawActionCredit?.trustLabel || getTrustedLabelFromActionCredit(actionCreditTotal),
        trustUnlocked: rawActionCredit?.trustUnlocked === true,
        recordId: rawActionCredit?.recordId ? String(rawActionCredit.recordId) : null,
        eligibleForViewer: actionCreditEligible,
      };

      const nextAction =
        completion.nextAction && typeof completion.nextAction === 'object'
          ? {
              kind: completion.nextAction.kind || 'landing_primary',
              label: completion.nextAction.label || null,
            }
          : {
              kind: 'landing_primary',
              label: fallback.nextActionLabel || null,
            };
      const paymentMode =
        completion.paymentMode ||
        completion.sharePayload?.paymentMode ||
        fallback.paymentMode ||
        null;
      const communityTask =
        completion.communityTask === true ||
        fallback.communityTask === true ||
        paymentMode === 'community';

      const sharePayload =
        completion.sharePayload && typeof completion.sharePayload === 'object'
          ? completion.sharePayload
          : {
              entityType: completion.entityType || fallback.entityType || 'task',
              entityId: String(entityId),
              paymentMode,
              amountUSD,
              amountJGK,
              status: completion.kind || fallback.status || 'completed',
            };
      const viewerBalanceRaw = Number(completion.viewerBalanceJGK);
      const viewerBalanceJGK = Number.isFinite(viewerBalanceRaw)
        ? Math.round(viewerBalanceRaw)
        : null;
      const viewerBalanceAuthoritative =
        completion.viewerBalanceAuthoritative === true
          ? true
          : completion.viewerBalanceAuthoritative === false
          ? false
          : viewerBalanceJGK !== null;
      const localActivityReward = normalizeLocalActivityReward(completion);

      return {
        kind: completion.kind || fallback.kind || 'completion',
        entityType: completion.entityType || fallback.entityType || 'task',
        entityId: String(entityId),
        paymentMode,
        communityTask,
        title:
          completion.title ||
          fallback.title ||
          (completion.entityType === 'offering' ? 'Offering completed' : 'Task completed'),
        role: completion.role || fallback.role || 'tasker',
        counterpartyName: completion.counterpartyName || fallback.counterpartyName || null,
        amountUSD,
        amountJGK,
        localValueCreated: communityTask
          ? null
          : {
              amountUSD,
              amountJGK,
            },
        actionCredit,
        trust: {
          total: actionCredit.total,
          label: actionCredit.trustLabel,
          unlocked: actionCredit.trustUnlocked,
        },
        verifiedRecord:
          completion.verifiedRecord && typeof completion.verifiedRecord === 'object'
            ? completion.verifiedRecord
            : {
                added: actionCredit.awarded === true,
                duplicate: actionCredit.duplicate === true,
              },
        localActivityReward,
        nextAction,
        secondaryAction:
          completion.secondaryAction && typeof completion.secondaryAction === 'object'
            ? completion.secondaryAction
            : null,
        sharePayload,
        viewerBalanceJGK,
        viewerBalanceAuthoritative,
      };
    },
    [viewerActionCreditTotal],
  );

  const buildCompletionContext = useCallback(
    (task, role, rawCompletion = null) => {
      if (!task) return null;
      const entityId = task.taskId || task.id || task._id;
      if (!entityId) return null;
      const amountUSD = (() => {
        const candidates = [
          task.price,
          task.providerPayoutAmount,
          task.priceUsd,
          task.price_usd,
        ];
        const found = candidates.find((v) => Number.isFinite(Number(v)));
        if (found == null) {
          if (Number.isFinite(Number(task.requiredJGK))) {
            return Number(task.requiredJGK) / 1000;
          }
          if (Number.isFinite(Number(task.escrowAmountJGK))) {
            return Number(task.escrowAmountJGK) / 1000;
          }
        }
        const value = Number(found ?? 0);
        return Number.isFinite(value) ? value : undefined;
      })();
      const amountJGK = (() => {
        if (Number.isFinite(Number(task.requiredJGK))) return Number(task.requiredJGK);
        if (Number.isFinite(Number(task.escrowAmountJGK))) return Number(task.escrowAmountJGK);
        if (Number.isFinite(Number(amountUSD))) return Math.round(Number(amountUSD) * 1000);
        return undefined;
      })();

      const isTaskExecutor = role === 'tasker' || role === 'provider';
      const communityTask =
        task?.communityTask === true || task?.paymentMode === 'community';
      return normalizeCompletionContext(rawCompletion, {
        kind: 'task_completed',
        entityType: 'task',
        entityId: String(entityId),
        paymentMode: communityTask ? 'community' : 'paid',
        communityTask,
        role,
        title: task?.title || 'Task completed',
        counterpartyName:
          role === 'creator'
            ? task?.accepted?.playerId ||
              task?.accepted?.handle ||
              task?.acceptedPlayerHandle ||
              null
            : task?.creator?.playerId ||
              task?.creator?.handle ||
              task?.playerId ||
              null,
        amountUSD,
        amountJGK,
        actionCreditEligibleForViewer: isTaskExecutor,
      });
    },
    [normalizeCompletionContext],
  );

  const buildOfferingCompletionContext = useCallback(
    (order, role = 'creator', rawCompletion = null) => {
      if (!order) return null;
      const entityId =
        order.offeringId ||
        order.offering?._id ||
        order.offering?.id ||
        order.orderId ||
        order.id ||
        order._id;
      if (!entityId) return null;
      const amountUSD = (() => {
        const candidates = [
          order.subtotalUsd,
          order.subtotal,
          order.totalUsd,
          order.total,
          order.amountUsd,
        ];
        const found = candidates.find((v) => Number.isFinite(Number(v)));
        if (found == null) return undefined;
        const parsed = Number(found);
        return Number.isFinite(parsed) && parsed > 0 ? parsed : undefined;
      })();
      const amountJGK = Number.isFinite(Number(amountUSD))
        ? Math.round(Number(amountUSD) * 1000)
        : undefined;

      return normalizeCompletionContext(rawCompletion, {
        kind: 'offering_fulfilled',
        entityType: 'offering',
        entityId: String(entityId),
        role,
        amountUSD,
        amountJGK,
        title:
          order?.offering?.title ||
          order?.offering?.name ||
          order?.title ||
          'Offering completed',
        counterpartyName:
          order?.buyer?.playerId ||
          order?.buyer?.handle ||
          order?.buyer?.username ||
          null,
        actionCreditEligibleForViewer: role === 'buyer',
      });
    },
    [normalizeCompletionContext],
  );
  const handleRemoteTaskCompleted = useCallback(
    (task, rawCompletion = null) => {
      const ctx = buildCompletionContext(task, 'tasker', rawCompletion);
      if (!ctx) return;
      setSelectedTask(null);
      setPostCompletionContext(ctx);
      setPostCompletionOpen(true);
    },
    [buildCompletionContext],
  );
  const resumeLockIdRef = useRef(null);
  const resumeHasRunInitRef = useRef(false);
  const noIntentLogRef = useRef({ reason: null, ts: 0 });
  const lastBalanceLogRef = useRef({ ts: 0, value: null });
  const refreshInFlightRef = useRef(false);
  const refreshCooldownRef = useRef(0);
  const localOpsSnapshotRef = useRef({
    timer: null,
    lastCenter: null,
    lastDistance: null,
    lastUnit: null,
  });
  const localOpsRealtimeSnapshotRef = useRef({
    task: { timer: null, lastRequestedAt: 0 },
    offering: { timer: null, lastRequestedAt: 0 },
  });
  const hasFiredInitialLocalOpsSnapshotRef = useRef(false);
  const hasSeededLocalOpsFeedRef = useRef(false);
  const hasLoggedLocalOpsSnapshotRef = useRef(false);
  const hasResumedSnapshotRef = useRef(false);
  const viewportUpdateRef = useRef({ rafId: null, next: null });
  const hasSeededViewportRef = useRef(false);
  const playerUpdateQueueRef = useRef([]);
  const playerUpdateTimerRef = useRef(null);
  const mapBootTimerRef = useRef(null);
  const friendProfileCacheRef = useRef(new Map());
  const friendProfilePendingRef = useRef(new Set());
  const presenceIndexRef = useRef(new Map());
  const localOpsOrdersRef = useRef(new Map());
  const [localOpsOrdersVersion, setLocalOpsOrdersVersion] = useState(0);
  const activeOrdersHydratedForRef = useRef(null);
  const [friendProfiles, setFriendProfiles] = useState([]);
  const handleOfferingRemoved = useCallback((id) => {
    setLocalOpsSeedEvents((prev) =>
      Array.isArray(prev)
        ? prev.filter(
            (event) =>
              !event?.shareUrl ||
              !String(event.shareUrl).includes(String(id)),
          )
        : prev,
    );
    setSelectedOffering((prev) => {
      const prevId = prev?.offeringId || prev?.id || prev?._id || null;
      if (prevId && String(prevId) === String(id)) {
        setLocalOpsNotice('This offering was removed.');
        return null;
      }
      return prev;
    });
  }, []);

  const handleTaskRemoved = useCallback((id) => {
    setLocalOpsSeedEvents((prev) =>
      Array.isArray(prev)
        ? prev.filter(
            (event) =>
              !event?.shareUrl ||
              !String(event.shareUrl).includes(String(id)),
          )
        : prev,
    );
    setSelectedTask((prev) => {
      const prevId = prev?.taskId || prev?.id || prev?._id || null;
      if (prevId && String(prevId) === String(id)) {
        setLocalOpsNotice('This task was removed.');
        return null;
      }
      return prev;
    });
  }, []);

  const handleSelectPlayer = useCallback(
    (player) => setSelectedPlayer(player),
    [],
  );
  const refreshPlayerBalance = useCallback(
    async ({ forceNetwork = false } = {}) => {
      if (!player?.token) return null;
      const now = Date.now();
      if (!forceNetwork && refreshInFlightRef.current) return playerBalance;
      if (!forceNetwork && now - refreshCooldownRef.current < 2000) {
        return playerBalance;
      }
      refreshInFlightRef.current = true;
      const headers = {
        Authorization: `Bearer ${player.token}`,
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
      };
      const cacheBust = Date.now();
      const baseUrl = axiosConn.defaults?.baseURL || '';
      const apiUrl = buildApiUrl(baseUrl, '/players/me');
      const params = new URLSearchParams({ cb: cacheBust });
      if (forceNetwork) {
        params.set('fresh', cacheBust);
      }
      const targetUrl = `${apiUrl}?${params.toString()}`;
      let payload = null;
      if (forceNetwork && typeof fetch === 'function') {
        try {
          const res = await fetch(targetUrl, {
            method: 'GET',
            headers,
            cache: 'no-store',
          });
          if (res.ok) {
            payload = await res.json();
          }
        } catch (err) {
          // ignore fetch failure, fallback to axios
        }
      }
      if (!payload) {
        try {
          const res = await axiosConn.get('players/me', {
            headers,
            params: { cb: cacheBust, fresh: cacheBust },
          });
          payload = res?.data;
        } catch (err) {
          // ignore balance fetch errors
        }
      }
      const parsed = parsePlayerFromResponse(payload);
      if (parsed?.jgkTokens !== null) {
        const before = playerBalance;
        setPlayerBalance(parsed.jgkTokens);
        if (updatePlayer) {
          const existingPlayer = player?.data?.player || player?.player || {};
          const nextPlayer = {
            ...existingPlayer,
            ...(parsed.player || {}),
            jgkTokens: parsed.jgkTokens,
          };
          updatePlayer(nextPlayer);
        }
        const lastLog = lastBalanceLogRef.current;
        const changed = before !== parsed.jgkTokens;
        const logAllowed =
          forceNetwork ||
          changed ||
          now - (lastLog?.ts || 0) > 3000 ||
          lastLog?.value !== parsed.jgkTokens;
        if (logAllowed) {
          jgkLog('[jgk-resume] balance refreshed', {
            before,
            after: parsed.jgkTokens,
            force: forceNetwork,
          });
          lastBalanceLogRef.current = { ts: Date.now(), value: parsed.jgkTokens };
        }
        refreshCooldownRef.current = Date.now();
        refreshInFlightRef.current = false;
        return parsed.jgkTokens;
      }
      refreshCooldownRef.current = Date.now();
      refreshInFlightRef.current = false;
      return null;
    },
    [player?.token, player?.data?.player, player?.player, playerBalance, updatePlayer],
  );
  const handleClosePlayer = useCallback(() => {
    blurActiveElement();
    setSelectedPlayer(null);
  }, []);
  const handleSelectOffering = useCallback(
    (offering, queue = null, index = -1) => {
      const pending = readPendingIntent();
      if (pending && pending.state !== 'completed') {
        refreshPlayerBalance({ forceNetwork: true });
      }
      setSelectedTask(null);
      setOfferingQueue(Array.isArray(queue) ? queue : []);
      setOfferingQueueIndex(Array.isArray(queue) ? index : -1);
      setSelectedOffering(offering);
    },
    [refreshPlayerBalance],
  );
  const handleCloseOffering = useCallback(() => {
    blurActiveElement();
    setSelectedOffering(null);
  }, []);
  const handleSelectTask = useCallback((task) => {
    const pending = readPendingIntent();
    if (pending && pending.state !== 'completed') {
      refreshPlayerBalance({ forceNetwork: true });
    }
    setSelectedOffering(null);
    setAcceptingTaskId(null);
    setTaskAcceptFeedback(null);
    setSelectedTask(task);
  }, [refreshPlayerBalance]);

  useEffect(() => {
    if (!localOpsOrdersVersion) return;
    refreshPlayerBalance();
  }, [localOpsOrdersVersion, refreshPlayerBalance]);
  const handleCloseTask = useCallback(() => {
    blurActiveElement();
    setAcceptingTaskId(null);
    setTaskAcceptFeedback(null);
    setSelectedTask(null);
  }, []);
  const handleMessageOwner = useCallback(
    async (entity) => {
      const ownerId =
        entity?.ownerId ||
        entity?.owner?._id ||
        entity?.creator?._id ||
        entity?.ownerPlayerId?._id ||
        entity?.providerId ||
        entity?.createdBy ||
        entity?.creatorPlayerId ||
        entity?.playerId;
      const currentPlayerId = player?.data?.player?._id;
      if (!ownerId || !currentPlayerId || !player?.token) return;
      if (String(ownerId) === String(currentPlayerId)) {
        setLocalOpsNotice('This is yours.');
        return;
      }
      try {
        const created = await axiosConn.post(
          'conversations/get-or-create',
          { senderId: currentPlayerId, receiverId: ownerId },
          { headers: { Authorization: `Bearer ${player.token}` } },
        );
        const convoId =
          created?.data?._id ||
          created?.data?.conversationId ||
          created?.data?.id ||
          null;
        if (convoId) {
          history.push(`/messenger/${convoId}`);
        } else {
          setLocalOpsError('Unable to start a message right now.');
        }
      } catch (err) {
        setLocalOpsError('Unable to start a message right now.');
      }
    },
    [history, player, setLocalOpsError, setLocalOpsNotice],
  );

  const queryParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search],
  );
  const regionBrowseCenter = useMemo(
    () => getLocalOpsBrowseCenterFromParams(queryParams),
    [queryParams],
  );
  const parent = queryParams.get('parent');
  const shareParam = queryParams.get('share');
  const shareFunnelContext = useMemo(
    () => {
      const fromSearch = readShareFunnelContextFromSearch(location.search);
      if (fromSearch) return fromSearch;
      return (
        buildShareFunnelContextFromState(location.state?.resumeLocalOps) ||
        buildShareFunnelContextFromState(location.state?.shareFunnelContext)
      );
    },
    [location.search, location.state],
  );
  const deeplinkTypeParam = queryParams.get('type');
  const deeplinkIdParam = queryParams.get('id');
  const checkoutParam = queryParams.get('checkout');
  const intakeDraftTokenParam = String(queryParams.get('draft') || '').trim();
  const collisionRideLaunchSignature = useMemo(
    () => buildCollisionSpecialistRideLaunchSignature(queryParams),
    [queryParams],
  );
  const resumeLocalOpsState =
    location.state?.resumeLocalOps ||
    location.state?.shareFunnelContext ||
    null;
  const hasResumeLocalOpsState = !!resumeLocalOpsState;
  const localOpsLaunchAttribution = useMemo(
    () =>
      buildClientLaunchAttribution({
        queryParams,
        resumeLocalOps: resumeLocalOpsState,
      }),
    [queryParams, resumeLocalOpsState],
  );
  const proofAttributionHint = useMemo(
    () => readProofAttributionHintFromSearch(location.search),
    [location.search],
  );
  const proofAttributionHintRef = useRef(null);
  useEffect(() => {
    proofAttributionHintRef.current = proofAttributionHint || null;
  }, [proofAttributionHint]);
  const localOpsRegionSlug = useMemo(
    () =>
      normalizeLocalOpsSlug(
        localOpsLaunchAttribution?.regionSlug ||
          queryParams.get('regionSlug') ||
          queryParams.get('region') ||
          'camden',
      ) || 'camden',
    [localOpsLaunchAttribution, queryParams],
  );
  const requesterLandingIntent = useMemo(
    () =>
      isRequesterLandingIntent({
        queryParams,
        launchAttribution: localOpsLaunchAttribution,
        defaultRegionSlug: localOpsRegionSlug,
      }),
    [queryParams, localOpsLaunchAttribution, localOpsRegionSlug],
  );
  const hasRequesterLandingSignal = useMemo(() => {
    const keys = [
      'intent',
      'source',
      'regionSlug',
      'marketSlug',
      'partnerAction',
      'partnerSource',
      'routeKind',
      'parent',
      'type',
      'id',
      'share',
    ];
    return keys.some(
      (key) =>
        String(queryParams.get(key) || '').trim() ||
        String(localOpsLaunchAttribution?.[key] || '').trim(),
    );
  }, [queryParams, localOpsLaunchAttribution]);
  const shareFunnelArrivalRecordedRef = useRef('');
  const shareFunnelSheetRecordedRef = useRef(new Set());
  const firestarterEnabled = queryParams.get('firestarter') === '1';
  const firestarterSurfaceParam =
    queryParams.get('firestarterSurface') || 'playermap_empty';
  const firestarterSource = queryParams.get('source') || '';
  const firestarterRegionSlug = String(queryParams.get('regionSlug') || '').trim();
  const firestarterSrc = String(queryParams.get('src') || '').trim() || null;
  const firestarterIntent = String(queryParams.get('intent') || '').trim() || null;
  const firestarterIsCold = queryParams.get('isCold') === '1';
  const firestarterCreateRaw = String(
    queryParams.get('firestarterCreate') || FIRESTARTER_CREATE_DEFAULT,
  ).trim();
  const firestarterCreateType = firestarterCreateRaw.startsWith('task_')
    ? firestarterCreateRaw
    : FIRESTARTER_CREATE_DEFAULT;
  const firestarterOfflineContext =
    firestarterSource === 'offline_region' && !!firestarterRegionSlug;
  const firestarterContext = firestarterOfflineContext && firestarterIsCold;
  const firestarterLaunchRequested = firestarterEnabled && firestarterContext;
  const collisionSpecialistRideRequested = isCollisionSpecialistRideRequest({
    queryParams,
    regionSlug: queryParams.get('regionSlug'),
  });
  const genericAssistanceTaskRequested = isGenericAssistanceTaskRequest({
    queryParams,
  });
  const offeringDraftReviewRequested = isOfferingDraftReviewRequest({
    queryParams,
  });

  const emitFirestarterTelemetry = useCallback(
    (eventName, extra = {}) => {
      const payload = {
        slug: firestarterRegionSlug || null,
        src: firestarterSrc || null,
        intent: firestarterIntent || null,
        isCold: firestarterIsCold === true,
        surface: extra.surface || firestarterSurfaceParam || 'playermap_empty',
        mode: FIRESTARTER_MODE,
        ...extra,
      };
      try {
        if (window?.dataLayer) {
          window.dataLayer.push({ event: eventName, ...payload });
        }
        if (window?.rudderanalytics?.track) {
          window.rudderanalytics.track(eventName, payload);
        }
        window.dispatchEvent(new CustomEvent(eventName, { detail: payload }));
      } catch (err) {
        // ignore firestarter telemetry errors
      }
    },
    [
      firestarterIntent,
      firestarterIsCold,
      firestarterRegionSlug,
      firestarterSrc,
      firestarterSurfaceParam,
    ],
  );

  const emitLandingTelemetry = useCallback(
    (eventName, extra = {}) => {
      const sourceTag =
        localOpsLaunchAttribution?.src ||
        queryParams.get('src') ||
        localOpsLaunchAttribution?.source ||
        queryParams.get('source') ||
        '';
      const launchIntent =
        localOpsLaunchAttribution?.intent ||
        queryParams.get('intent') ||
        '';
      const routeKind =
        localOpsLaunchAttribution?.routeKind ||
        queryParams.get('routeKind') ||
        PLAYERMAP_LANDING_ROUTE_KIND;
      const starterId =
        extra.selectedStarterId || extra.starterId || extra.starter || '';
      const isRideHelpStarter =
        normalizeRequesterLandingParam(starterId) === 'ride_help';
      const mappedCtaId =
        eventName === 'localops_landing_starter_idea_selected'
          ? isRideHelpStarter
            ? PLAYERMAP_LANDING_CTA_IDS.STARTER_IDEA_SELECTED_RIDE_HELP
            : PLAYERMAP_LANDING_CTA_IDS.STARTER_IDEA_SELECTED
          : LOCALOPS_LANDING_DURABLE_CTA_MAP[eventName];
      const durableEventName =
        mappedCtaId
          ? LAUNCH_VISIT_EVENTS.CTA_CLICKED
          : LOCALOPS_LANDING_DURABLE_EVENT_MAP[eventName];
      const payload = {
        regionSlug: localOpsRegionSlug || null,
        marketSlug:
          localOpsLaunchAttribution?.marketSlug ||
          queryParams.get('marketSlug') ||
          null,
        source:
          localOpsLaunchAttribution?.source ||
          queryParams.get('source') ||
          null,
        src: localOpsLaunchAttribution?.src || queryParams.get('src') || null,
        intent:
          localOpsLaunchAttribution?.intent ||
          queryParams.get('intent') ||
          null,
        partnerAction:
          localOpsLaunchAttribution?.partnerAction ||
          queryParams.get('partnerAction') ||
          null,
        partnerSource:
          localOpsLaunchAttribution?.partnerSource ||
          queryParams.get('partnerSource') ||
          null,
        landingMode: extra.landingMode || 'default',
        authenticated: !!player?.token,
        ...extra,
      };
      try {
        if (window?.dataLayer) {
          window.dataLayer.push({ event: eventName, ...payload });
        }
        if (window?.rudderanalytics?.track) {
          window.rudderanalytics.track(eventName, payload);
        }
        window.dispatchEvent(new CustomEvent(eventName, { detail: payload }));
      } catch (err) {
        // ignore landing telemetry errors
      }
      if (durableEventName) {
        try {
          void trackLocalOpsLaunchEvent({
            slug: localOpsRegionSlug || 'camden',
            eventName: durableEventName,
            sourceTag,
            routeKind,
            intent: launchIntent,
            ctaId: mappedCtaId || extra.ctaId || undefined,
            landingIntentType:
              extra.landingIntentType || extra.intentType || undefined,
            targetKind: extra.targetKind || undefined,
            starterId: starterId || undefined,
          });
        } catch (err) {
          // ignore durable landing telemetry errors
        }
      }
    },
    [
      localOpsRegionSlug,
      localOpsLaunchAttribution,
      queryParams,
      player?.token,
    ],
  );

  const emitLocalOpsShare = useCallback(
    async (payload) => {
      try {
        if (window?.dataLayer) {
          window.dataLayer.push({ event: 'localops:share', ...payload });
        }
        if (window?.rudderanalytics?.track) {
          window.rudderanalytics.track('localops:share', payload);
        }
        window.dispatchEvent(
          new CustomEvent('localops:share', { detail: payload }),
        );
      } catch (err) {
        // ignore share telemetry errors
      }
      if (!player?.token || !payload?.url) return;
      try {
        const headers = { Authorization: `Bearer ${player.token}` };
        // Map platform/contentType to enum-safe values expected by backend
        const platform =
          payload.platform === 'web-share'
            ? 'other'
            : payload.platform || 'other';
        const contentType =
          payload.type === 'task' || payload.type === 'offering'
            ? 'general'
            : payload.type || 'general';
        await axiosConn.post(
          'social-shares',
          {
            platform,
            contentType,
            context: 'localops',
            contextId: payload.id,
            targetUrl: payload.url,
            metadata: {
              source: payload.source,
              visibility: payload.visibility,
            },
            status: 'success',
          },
          { headers },
        );
      } catch (err) {
        // ignore share record failures
      }
    },
    [player?.token],
  );

  const shareLocalOpsLink = useCallback(
    async ({ type, id, visibility = 'nearby', source }) => {
      if (!id) return;
      const link = getShareUrl(type, id);
      if (!link) return;
      const payload = {
        type,
        id,
        visibility,
        url: link,
        source,
      };
      const shareTitle =
        type === 'task' ? 'LocalOps task' : 'LocalOps offering';
      const shareText =
        type === 'task' && source === 'create-success'
          ? 'I thought of you when I saw this. JG LocalOps lets local people post small tasks, offer services, or earn helping nearby.'
          : type === 'task'
          ? 'A local task is available on LocalOps.'
          : 'A local offering is available on LocalOps.';
      let shared = false;
      let platform = 'web';
      try {
        if (navigator.share) {
          const sharePayload = { title: shareTitle, text: shareText, url: link };
          await navigator.share({
            ...sharePayload,
          });
          shared = true;
          platform = 'web-share';
          setLocalOpsNotice('Shared.');
        }
      } catch (err) {
        if (err?.name === 'AbortError') return;
      }
      if (!shared && navigator.clipboard?.writeText) {
        try {
          await navigator.clipboard.writeText(link);
          setLocalOpsNotice('Link copied.');
        } catch (err) {
          setLocalOpsError('Unable to copy link.');
        }
      } else if (!shared) {
        setLocalOpsError('Copy not supported on this device.');
      }
      if (shared) {
        emitLocalOpsShare({ ...payload, platform });
      }
    },
    [emitLocalOpsShare],
  );

  const handleShareOffering = useCallback(
    (offering) => {
      const id = offering?.offeringId || offering?.id || offering?._id;
      shareLocalOpsLink({
        type: 'offering',
        id,
        visibility: offering?.meta?.visibility || 'nearby',
        source: 'offering-detail',
      });
    },
    [shareLocalOpsLink],
  );

  const handleShareTask = useCallback(
    (task) => {
      const id = task?.taskId || task?.id || task?._id;
      shareLocalOpsLink({
        type: 'task',
        id,
        visibility: task?.meta?.visibility || 'nearby',
        source: 'task-detail',
      });
    },
    [shareLocalOpsLink],
  );
  const handleSharePanelShare = useCallback(() => {
    if (!sharePanel?.item || !sharePanel?.type) return;
    const item = sharePanel.item;
    const id =
      sharePanel.type === 'offering'
        ? item?.offeringId || item?.id || item?._id
        : item?.taskId || item?.id || item?._id;
    if (!id) return;
    if (
      sharePanel.type === 'task' &&
      firestarterShareTaskId &&
      String(firestarterShareTaskId) === String(id)
    ) {
      emitFirestarterTelemetry('firestarter_share_used', {
        surface: firestarterSurfaceParam || 'region_landing',
      });
      setFirestarterShareTaskId(null);
      setFirestarterCreatePending(false);
    }
    shareLocalOpsLink({
      type: sharePanel.type,
      id,
      visibility: item?.meta?.visibility || 'nearby',
      source:
        sharePanel.status === 'completed'
          ? 'task-complete'
          : 'create-success',
    });
  }, [
    sharePanel,
    shareLocalOpsLink,
    firestarterShareTaskId,
    emitFirestarterTelemetry,
    firestarterSurfaceParam,
  ]);

  const initialViewport = useRef(null);
  //   const [address, SetAddress] = useState('');
  const [viewport, setViewport] = useState({
    latitude: DEFAULT_MAP_CENTER.lat,
    longitude: DEFAULT_MAP_CENTER.lon,
    zoom: DEFAULT_MAP_CENTER.zoom,
    width: '100vw',
    height: '100vh',
    // center: [longitude, latitude],
  });
  const [calculatedZoom, setCalculatedZoom] = useState(0);
  const localOpsCenter =
    latitude !== null && longitude !== null
      ? { lat: latitude, lon: longitude }
      : null;
  const mapCenter = useMemo(() => {
    const lat = viewport?.latitude;
    const lon = viewport?.longitude;
    if (!Number.isFinite(lat) || !Number.isFinite(lon)) return null;
    return { lat, lon };
  }, [viewport?.latitude, viewport?.longitude]);
  const defaultCenter = localOpsCenter || regionBrowseCenter || mapCenter;
  const isInitialLoad = useRef(true); // Track if this is the initial load

  const handleCreateTaskFromOffering = useCallback(
    (offering, mode) => {
      setCreatePreset(
        buildCreateTaskPresetFromOffering({
          offering,
          mode,
          defaultCenter,
          mapCenter,
          localOpsCenter,
          normalizeCoordinates,
        }),
      );
      setCreateIgnitionCandidate(false);
      setSelectedOffering(null);
      setIsCreateOpen(true);
    },
    [defaultCenter, mapCenter, localOpsCenter],
  );

  const [page, setPage] = useState(1);
  const [postItems, setPostItems] = useState([]);
  const [socketPostIds, setSocketPostIds] = useState([]);
  const [selectedPost, setSelectedPost] = useState(null);
  const handleSelectPost = useCallback((post) => setSelectedPost(post), []);
  const handleClosePost = useCallback(() => {
    blurActiveElement();
    setSelectedPost(null);
  }, []);
  const localOpsFlags = useMemo(() => {
    const baseFromEnv = coerceFlag(process.env.REACT_APP_LOCALOPS_MAP, true);
    const baseEnabled = coerceFlag(queryParams.get('localops'), baseFromEnv);
    const offeringsEnabled = coerceFlag(
      queryParams.get('localopsOfferings'),
      coerceFlag(process.env.REACT_APP_LOCALOPS_OFFERINGS, baseEnabled),
    );
    const tasksEnabled = coerceFlag(
      queryParams.get('localopsTasks'),
      coerceFlag(process.env.REACT_APP_LOCALOPS_TASKS, baseEnabled),
    );
    const liveEnabled = coerceFlag(
      queryParams.get('localopsLive'),
      coerceFlag(process.env.REACT_APP_LOCALOPS_LIVE, baseEnabled),
    );
    return {
      base: baseEnabled || offeringsEnabled || tasksEnabled || liveEnabled,
      offerings: offeringsEnabled,
      tasks: tasksEnabled,
      live: liveEnabled,
    };
  }, [queryParams]);
  const localOpsVerifiedLocalGateEnabled = useMemo(
    () =>
      coerceFlag(
        process.env.REACT_APP_LOCALOPS_VERIFIED_LOCAL_GATE_ENABLED,
        false,
      ),
    [],
  );
  const initialViewportZoom = mobileView
    ? INITIAL_VIEWPORT_ZOOM_MOBILE
    : INITIAL_VIEWPORT_ZOOM_DESKTOP;
  const localOpsMotion = mobileView ? 'low' : 'full';
  const initialLayerPrefs = useMemo(() => {
    const fallback = {
      players: false,
      posts: false,
      offerings: true,
      tasks: true,
    };
    try {
      const stored = secureLocalStorage.getItem(LOCALOPS_LAYER_STORAGE_KEY);
      if (!stored) return fallback;
      const parsed = JSON.parse(stored);
      return { ...fallback, ...(parsed || {}) };
    } catch (err) {
      return fallback;
    }
  }, []);
  const [layerPrefs, setLayerPrefs] = useState(initialLayerPrefs);
  useEffect(() => {
    try {
      secureLocalStorage.setItem(
        LOCALOPS_LAYER_STORAGE_KEY,
        JSON.stringify(layerPrefs),
      );
    } catch (err) {
      // ignore storage failures
    }
  }, [layerPrefs]);
  useEffect(() => {
    if (shareParam && !layerPrefs.players) {
      setLayerPrefs((prev) => ({ ...prev, players: true }));
    }
  }, [shareParam, layerPrefs.players]);
  const initialTravelMode = useMemo(() => {
    try {
      const stored = secureLocalStorage.getItem(LOCALOPS_TRAVEL_STORAGE_KEY);
      return stored ? JSON.parse(stored) === true : false;
    } catch (err) {
      return false;
    }
  }, []);
  const [travelMode, setTravelMode] = useState(initialTravelMode);
  useEffect(() => {
    try {
      secureLocalStorage.setItem(
        LOCALOPS_TRAVEL_STORAGE_KEY,
        JSON.stringify(travelMode),
      );
    } catch (err) {
      // ignore storage failures
    }
  }, [travelMode]);
  const effectiveLayers = useMemo(
    () => ({
      players: layerPrefs.players,
      posts: layerPrefs.posts,
      offerings: layerPrefs.offerings && localOpsFlags.offerings,
      tasks: layerPrefs.tasks && localOpsFlags.tasks,
    }),
    [layerPrefs, localOpsFlags.offerings, localOpsFlags.tasks],
  );
  const allLayersOff = useMemo(
    () =>
      !effectiveLayers.players &&
      !effectiveLayers.posts &&
      !effectiveLayers.offerings &&
      !effectiveLayers.tasks,
    [effectiveLayers],
  );
  const toggleLayer = useCallback((key) => {
    setLayerPrefs((prev) => ({ ...prev, [key]: !prev[key] }));
  }, []);
  const toggleTravelMode = useCallback(
    () => setTravelMode((prev) => !prev),
    [],
  );
  const handleOpenLayers = useCallback(() => setIsLayersOpen(true), []);
  const handleCloseLayers = useCallback(() => setIsLayersOpen(false), []);
  const hasStoredCreateDraftForMode = useCallback(
    (mode) => {
      if (typeof window === 'undefined') return false;
      const candidatePlayerIds = ['anon'];
      if (playerId) candidatePlayerIds.push(String(playerId));
      return candidatePlayerIds.some((candidateId) => {
        const draftKey = `${LOCALOPS_CREATE_DRAFT_PREFIX}:${candidateId}:${mode}`;
        try {
          const raw = window.localStorage.getItem(draftKey);
          if (!raw) return false;
          return hasMeaningfulLocalOpsDraft(JSON.parse(raw));
        } catch (err) {
          return false;
        }
      });
    },
    [playerId],
  );
  const openCreateSheet = useCallback(
    (
      preset = null,
      {
        launchTypeHint = null,
        launchStepHint = null,
        launchGroupHint = null,
        ignitionCandidate = false,
      } = {},
    ) => {
      setCreatePreset(preset);
      setCreateIgnitionCandidate(ignitionCandidate === true);
      setCreateLaunchTypeHint(launchTypeHint || null);
      setCreateLaunchStepHint(
        Number.isInteger(launchStepHint) ? launchStepHint : null,
      );
      setCreateLaunchGroupHint(
        launchGroupHint === 'offerings' || launchGroupHint === 'tasks'
          ? launchGroupHint
          : null,
      );
      setCreateLaunchId(Date.now());
      refreshPlayerBalance({ forceNetwork: true });
      setIsCreateOpen(true);
    },
    [refreshPlayerBalance],
  );
  const handleOpenCreate = useCallback(() => {
    openCreateSheet(null);
  }, [openCreateSheet]);
  const handleOpenStarterIdeas = useCallback(() => {
    setStarterIdeasIgnitionCandidate(true);
    emitLandingTelemetry('localops_landing_starter_ideas_opened', {
      landingMode: 'default',
    });
    setStarterIdeasOpen(true);
  }, [emitLandingTelemetry]);
  const handleCloseStarterIdeas = useCallback(() => {
    setStarterIdeasOpen(false);
  }, []);
  const handleSelectStarterTask = useCallback(
    (preset, template) => {
      setStarterIdeasOpen(false);
      emitLandingTelemetry('localops_landing_starter_idea_selected', {
        landingMode: starterIdeasIgnitionCandidate ? 'default' : 'requester',
        selectedStarterId: template?.id || null,
      });
      if (!preset) {
        openCreateSheet(null, {
          ignitionCandidate: starterIdeasIgnitionCandidate,
        });
        emitLandingTelemetry('localops_landing_create_sheet_opened', {
          landingMode: starterIdeasIgnitionCandidate ? 'default' : 'requester',
          selectedStarterId: template?.id || null,
        });
        return;
      }
      const origin = defaultCenter || mapCenter || localOpsCenter || null;
      openCreateSheet(
        {
          ...preset,
          ...(origin ? { origin: { ...origin } } : {}),
        },
        { ignitionCandidate: starterIdeasIgnitionCandidate },
      );
      emitLandingTelemetry('localops_landing_create_sheet_opened', {
        landingMode: starterIdeasIgnitionCandidate ? 'default' : 'requester',
        selectedStarterId: template?.id || null,
      });
    },
    [
      defaultCenter,
      mapCenter,
      localOpsCenter,
      openCreateSheet,
      starterIdeasIgnitionCandidate,
      emitLandingTelemetry,
    ],
  );
  const resolveRequesterTaskPreset = useCallback(() => {
    const starterId = normalizeRequesterLandingParam(queryParams.get('starter'));
    if (starterId) {
      const template = STARTER_TASK_TEMPLATES.find(
        (item) => normalizeRequesterLandingParam(item.id) === starterId,
      );
      const preset = buildStarterTaskPreset(template);
      if (preset) {
        return {
          preset,
          selectedStarterId: template.id,
        };
      }
    }
    const taskType = normalizeRequesterLandingParam(queryParams.get('taskType'));
    const taskPreset = REQUESTER_TASK_TYPE_PRESETS[taskType];
    if (taskPreset) {
      return {
        preset: { ...taskPreset },
        selectedStarterId: null,
      };
    }
    return null;
  }, [queryParams]);
  const handleOpenRequesterTaskCreate = useCallback(() => {
    const resolved = resolveRequesterTaskPreset();
    emitLandingTelemetry('localops_landing_post_task_clicked', {
      landingMode: 'requester',
      selectedStarterId: resolved?.selectedStarterId || null,
    });
    setStarterIdeasIgnitionCandidate(false);
    if (!resolved?.preset) {
      emitLandingTelemetry('localops_landing_starter_ideas_opened', {
        landingMode: 'requester',
      });
      setStarterIdeasOpen(true);
      return;
    }
    const origin = defaultCenter || mapCenter || localOpsCenter || null;
    openCreateSheet({
      ...resolved.preset,
      ...(origin ? { origin: { ...origin } } : {}),
    });
    emitLandingTelemetry('localops_landing_create_sheet_opened', {
      landingMode: 'requester',
      selectedStarterId: resolved.selectedStarterId || null,
    });
  }, [
    resolveRequesterTaskPreset,
    emitLandingTelemetry,
    defaultCenter,
    mapCenter,
    localOpsCenter,
    openCreateSheet,
  ]);
  const handleOpenFallbackTaskCreate = useCallback(() => {
    const isPendingReplayInProgress =
      hasActiveCreateTaskPendingIntent(pendingIntentState);
    const shouldResumeDraft =
      !checkoutParam &&
      !isTopUpOpen &&
      !isPendingReplayInProgress &&
      hasStoredCreateDraftForMode('task');
    if (shouldResumeDraft) {
      openCreateSheet(null, {
        launchTypeHint: LANDING_FALLBACK_TASK_PRESET,
        launchStepHint: 1,
        ignitionCandidate: true,
      });
      return;
    }
    const origin = defaultCenter || mapCenter || localOpsCenter || null;
    openCreateSheet(
      {
        type: LANDING_FALLBACK_TASK_PRESET,
        ...(origin ? { origin: { ...origin } } : {}),
      },
      { ignitionCandidate: true },
    );
  }, [
    checkoutParam,
    isTopUpOpen,
    pendingIntentState,
    hasStoredCreateDraftForMode,
    defaultCenter,
    mapCenter,
    localOpsCenter,
    openCreateSheet,
  ]);
  const handleOpenFallbackOfferingCreate = useCallback(() => {
    if (!localOpsFlags.offerings) {
      openCreateSheet(null);
      return;
    }
    const isPendingReplayInProgress =
      hasActiveCreateTaskPendingIntent(pendingIntentState);
    const shouldResumeDraft =
      !checkoutParam &&
      !isTopUpOpen &&
      !isPendingReplayInProgress &&
      hasStoredCreateDraftForMode('offering');
    if (shouldResumeDraft) {
      openCreateSheet(null, {
        launchTypeHint: LANDING_FALLBACK_OFFERING_PRESET,
        launchStepHint: 1,
      });
      return;
    }
    openCreateSheet(null, { launchGroupHint: 'offerings' });
  }, [
    localOpsFlags.offerings,
    checkoutParam,
    isTopUpOpen,
    pendingIntentState,
    hasStoredCreateDraftForMode,
    openCreateSheet,
  ]);
  const handleOpenRequesterOfferingCreate = useCallback(() => {
    emitLandingTelemetry('localops_landing_post_offering_clicked', {
      landingMode: 'requester',
    });
    handleOpenFallbackOfferingCreate();
  }, [emitLandingTelemetry, handleOpenFallbackOfferingCreate]);
  const openFirestarterCreate = useCallback(
    (surface = 'playermap_empty') => {
      const origin = defaultCenter || mapCenter || localOpsCenter || null;
      setCreatePreset({
        type: firestarterCreateType,
        ...(origin ? { origin: { ...origin } } : {}),
      });
      setCreateIgnitionCandidate(false);
      setCreateLaunchId(Date.now());
      refreshPlayerBalance({ forceNetwork: true });
      setIsCreateOpen(true);
      setFirestarterCreatePending(true);
      emitFirestarterTelemetry('firestarter_create_opened', { surface });
    },
    [
      defaultCenter,
      mapCenter,
      localOpsCenter,
      firestarterCreateType,
      refreshPlayerBalance,
      emitFirestarterTelemetry,
    ],
  );
  const openCollisionSpecialistRideCreate = useCallback((draft = null) => {
    setCreatePreset(
      draft
        ? buildCollisionSpecialistDraftPreset(
            draft,
            draft?.intakeDraftToken,
          )
        : buildCollisionSpecialistRidePreset(),
    );
    setCreateIgnitionCandidate(false);
    setCreateLaunchId(Date.now());
    refreshPlayerBalance({ forceNetwork: true });
    setIsCreateOpen(true);
  }, [refreshPlayerBalance]);
  const openGenericAssistanceTaskCreate = useCallback((draft = null) => {
    setCreatePreset(
      buildGenericAssistanceTaskPreset(
        draft || {
          intakeType: GENERIC_ASSISTANCE_TASK_INTAKE_TYPE,
        },
        draft?.intakeDraftToken,
      ),
    );
    setCreateIgnitionCandidate(false);
    setCreateLaunchId(Date.now());
    refreshPlayerBalance({ forceNetwork: true });
    setIsCreateOpen(true);
  }, [refreshPlayerBalance]);
  const openOfferingDraftCreate = useCallback((draft = null) => {
    setCreatePreset(
      buildOfferingDraftPreset(
        draft || {
          intakeType: GENERIC_OFFERING_DRAFT_INTAKE_TYPE,
        },
        draft?.offeringDraftToken,
      ),
    );
    setCreateIgnitionCandidate(false);
    setCreateLaunchId(Date.now());
    refreshPlayerBalance({ forceNetwork: true });
    setIsCreateOpen(true);
  }, [refreshPlayerBalance]);
  const handleCloseCreate = useCallback(() => {
    setIsCreateOpen(false);
    setCreateIgnitionCandidate(false);
  }, []);
  const handleOpenTopUp = useCallback(
    ({
      presetUsd = null,
      returnTo = null,
      variant = null,
      requiredTopUpJGK = null,
    } = {}) => {
      const safePreset = Number.isFinite(presetUsd) ? presetUsd : null;
      const parsedRequiredTopUpJGK = Number(requiredTopUpJGK);
      const safeRequiredTopUpJGK =
        Number.isFinite(parsedRequiredTopUpJGK) && parsedRequiredTopUpJGK > 0
          ? Math.round(parsedRequiredTopUpJGK)
          : null;
      const pathWithSearch = `${location.pathname}${location.search || ''}`;
      jgkLog('[jgk-topup] open', {
        presetUsd: safePreset,
        returnTo: returnTo || pathWithSearch,
        variant,
        requiredTopUpJGK: safeRequiredTopUpJGK,
      });
      setTopUpPresetUsd(safePreset);
      setTopUpReturnTo(returnTo || pathWithSearch);
      setTopUpVariant(variant || null);
      setTopUpRequiredJGK(safeRequiredTopUpJGK);
      setIsTopUpOpen(true);
    },
    [location.pathname, location.search],
  );
  const handleCloseTopUp = useCallback(() => {
    jgkLog('[jgk-topup] close', { topUpInProgress: topUpInProgressRef.current });
    setIsTopUpOpen(false);
    setTopUpPresetUsd(null);
    setTopUpReturnTo(null);
    setTopUpVariant(null);
    setTopUpRequiredJGK(null);
    if (!topUpInProgressRef.current) {
      writePendingIntent(null);
      setPendingIntentState(null);
      setLocalOpsNotice('Top up canceled. Action not funded.');
    }
    topUpInProgressRef.current = false;
  }, [setLocalOpsNotice]);
  const lastPendingIntentRef = useRef(null);
  const persistPendingIntent = useCallback(
    (intent) => {
      const normalized = normalizePendingIntent(intent);
      if (!normalized) return null;
      writePendingIntent(normalized);
      setPendingIntentState(normalized);
      lastPendingIntentRef.current = normalized;
      jgkLog('[jgk-intent] written', {
        type: normalized.type,
        requiredJGK: normalized.requiredJGK,
        payload: maskSensitiveLocalOpsPayload(normalized.payload),
      });
      return normalized;
    },
    [],
  );
  const handleTopUpCheckoutStart = useCallback(() => {
    if (topUpInProgressRef.current) return;
    checkoutInjectedRef.current = false;
    topUpInProgressRef.current = true;
    jgkLog('[jgk-topup] checkout start');
    let pending = readPendingIntent() || pendingIntentState;
    if (!pending && lastPendingIntentRef.current) {
      jgkWarn('[jgk-topup] restoring pending intent from ref');
      pending = persistPendingIntent(lastPendingIntentRef.current);
    }
    if (pending) {
      persistPendingIntent({
        ...pending,
        state: 'checkout_started',
        startedAt: Date.now(),
      });
    } else {
      jgkWarn('[jgk-topup] checkout start without pending intent');
    }
  }, [pendingIntentState, persistPendingIntent]);

  const handleLocalOpsInsufficient = useCallback(
    ({ actionType, type, request, topUp, uiContext = {}, requiredJGK }) => {
      const intentType = actionType || type || 'create_task';
      const existing = readPendingIntent();
      if (
        existing &&
        existing.state !== 'completed' &&
        existing.state !== 'canceled'
      ) {
        jgkWarn('[jgk-intent] replacing active pending intent', {
          existingType: existing.type,
          existingState: existing.state,
          nextType: intentType,
        });
      }
      const effectiveUiContext = {
        ...(request?.uiContext || {}),
        ...(uiContext || {}),
      };
      const topUpVariantForIntent =
        intentType === RAISE_PAY_PENDING_INTENT_TYPE
          ? RAISE_PAY_PENDING_INTENT_TYPE
          : effectiveUiContext?.rideTemplate === COLLISION_SPECIALIST_RIDE_TEMPLATE
          ? COLLISION_SPECIALIST_RIDE_TEMPLATE
          : effectiveUiContext?.starterId === 'ride_help' ||
            request?.meta?.starterId === 'ride_help'
          ? 'ride_help'
          : null;
      const neededJGK = Number(topUp?.neededJGK ?? requiredJGK ?? 0);
      const shortfallFromResponse = Number(topUp?.shortfallJGK);
      const currentFromResponse = Number(topUp?.currentJGK);
      const displayRequiredTopUpJGK =
        Number.isFinite(shortfallFromResponse) && shortfallFromResponse > 0
          ? Math.round(shortfallFromResponse)
          : Number.isFinite(currentFromResponse) && neededJGK > 0
          ? Math.max(0, Math.round(neededJGK - currentFromResponse))
          : null;
      const presetBasisJGK =
        Number.isFinite(displayRequiredTopUpJGK) && displayRequiredTopUpJGK > 0
          ? displayRequiredTopUpJGK
          : neededJGK;
      const topUpRate = Number(topUp?.jgkPerUsd);
      const jgkPerUsd =
        Number.isFinite(topUpRate) && topUpRate > 0 ? topUpRate : 1000;
      const topUpPresetUsd = Number(topUp?.topUpPresetUsd);
      const presetUsd = Number.isFinite(topUpPresetUsd)
        ? topUpPresetUsd
        : presetBasisJGK > 0
        ? Math.ceil(presetBasisJGK / jgkPerUsd)
        : null;
      const intent = {
        id: makePendingIntentId(),
        playerId: currentPlayerId || playerId,
        type: intentType,
        payload: request,
        requiredJGK: neededJGK,
        createdAt: Date.now(),
        state: 'pending',
        uiContext: effectiveUiContext,
        topUpPresetUsd: Number.isFinite(presetUsd) ? presetUsd : null,
      };
      const persisted = persistPendingIntent(intent);
      if (!persisted) {
        console.error('[jgk-intent] failed to persist intent', { intent });
        return;
      }
      handleOpenTopUp({
        presetUsd: Number.isFinite(presetUsd) ? presetUsd : null,
        returnTo: `${location.pathname}${location.search || ''}`,
        variant: topUpVariantForIntent,
        requiredTopUpJGK:
          Number.isFinite(displayRequiredTopUpJGK) &&
          displayRequiredTopUpJGK > 0
            ? displayRequiredTopUpJGK
            : null,
      });
      setLocalOpsNotice(
        intentType === RAISE_PAY_PENDING_INTENT_TYPE
          ? 'Top up to raise pay. We will notify helpers after funding.'
          : 'Top up to approve. We will finish this automatically.',
      );
    },
    [
      handleOpenTopUp,
      location.pathname,
      location.search,
      persistPendingIntent,
      setLocalOpsNotice,
      currentPlayerId,
      playerId,
    ],
  );

  const handleCreateOfferingRef = useRef(null);
  const handleCreateTaskRef = useRef(null);
  const handleReserveOfferingRef = useRef(null);
  const handleAcceptTaskRef = useRef(null);
  const handleStartTaskRef = useRef(null);
  const handleRaisePayAndRenotifyRef = useRef(null);
  const localOpsTasksRef = useRef([]);
  const upsertTaskRef = useRef(null);

  const confirmTopupSince = useCallback(
    async (sinceMs) => {
      if (!player?.token) return { confirmed: false };
      try {
        const headers = { Authorization: `Bearer ${player.token}` };
        const res = await axiosConn.get(
          'jgkTokenTransactions/confirm-topup',
          {
            headers,
            params: { since: sinceMs || Date.now() - 60 * 60 * 1000 },
          },
        );
        return res?.data || { confirmed: false };
      } catch (err) {
        return { confirmed: false };
      }
    },
    [player?.token],
  );

  const resumePendingIntent = useCallback(
    async (reason = 'auto') => {
      const pendingRaw = readPendingIntent();
      const pending = normalizePendingIntent(pendingRaw);
      if (!pending || pending.state === 'completed' || pending.state === 'canceled') {
        const now = Date.now();
        if (
          reason &&
          noIntentLogRef.current.reason === reason &&
          now - noIntentLogRef.current.ts < 2000
        ) {
          return;
        }
        noIntentLogRef.current = { reason, ts: now };
        jgkLog('[jgk-resume] no pending intent', {
          reason,
          pendingRaw: maskSensitiveLocalOpsPayload(pendingRaw),
        });
        return;
      }
      jgkLog('[jgk-resume] intent loaded', {
        reason,
        pending: maskSensitiveLocalOpsPayload(pending),
      });
      if (pending.state === 'resuming' && pending.lastAttemptAt) {
        const age = Date.now() - pending.lastAttemptAt;
        const sameLock =
          pending.resumeLockId &&
          resumeLockIdRef.current &&
          pending.resumeLockId === resumeLockIdRef.current;
        if (resumeInFlightRef.current && sameLock && age < RESUME_LOCK_MS) {
          jgkLog('[jgk-resume] locked, skipping', {
            reason,
            age,
            lockId: pending.resumeLockId,
            inFlight: true,
          });
          return;
        }
        if (age < RESUME_STALE_LOCK_MS) {
          jgkLog('[jgk-resume] locked (recent), skipping', {
            reason,
            age,
            lockId: pending.resumeLockId,
            inFlight: resumeInFlightRef.current,
          });
          return;
        }
        jgkLog('[jgk-resume] stale lock, retrying', {
          reason,
          age,
          lockId: pending.resumeLockId,
          inFlight: resumeInFlightRef.current,
        });
      }

      const lockId = makePendingIntentId();
      const nextIntent = {
        ...pending,
        state: 'resuming',
        resumeLockId: lockId,
        lastAttemptAt: Date.now(),
      };
      persistPendingIntent(nextIntent);
      resumeInFlightRef.current = true;
      resumeLockIdRef.current = lockId;
      setResumeErrorMessage('');
      setResumeDebugMessage('');

      try {
        const confirmed = await confirmTopupSince(pending.createdAt || Date.now() - 60 * 60 * 1000);
        if (JGK_DEBUG) {
          jgkLog('[jgk-resume] confirm-topup', { confirmed, pendingCreatedAt: pending.createdAt });
        }
        const refreshed = await refreshPlayerBalance({ forceNetwork: true });
        const balance = Number.isFinite(refreshed)
          ? refreshed
          : Number(playerBalance);
        const required = Number(pending.requiredJGK || 0);
        const confirmedFlag = !!confirmed?.confirmed;
        if (!confirmedFlag && Number.isFinite(required) && balance < required) {
          setLocalOpsNotice('Top-up processing... we will continue automatically.');
          const resetIntent = {
            ...pending,
            state: 'pending',
            resumeLockId: null,
            lastAttemptAt: null,
          };
          persistPendingIntent(resetIntent);
          resumeBackoffRef.current = Math.min(resumeBackoffRef.current * 1.5, 30000);
          resumeInFlightRef.current = false;
          resumeLockIdRef.current = null;
          if (pendingResumeTimerRef.current) clearTimeout(pendingResumeTimerRef.current);
          pendingResumeTimerRef.current = setTimeout(
            () => resumePendingIntent('retry'),
            resumeBackoffRef.current,
          );
          jgkLog('[jgk-resume] retry scheduled (balance low)', {
            required,
            balance,
            confirmed,
            backoffMs: resumeBackoffRef.current,
          });
          return;
        }

        setLocalOpsNotice('JGK added - continuing your task...');
        jgkLog('[jgk-resume] balance refreshed', {
          balance,
          required,
          sufficient: balance >= required,
        });

        const intentType = pending.type;
        let replayResult = null;
        const missingHandlers = [];
        jgkLog('[jgk-resume] replay start', { intentType });
        if (intentType === 'create_task') {
          const fn = handleCreateTaskRef.current;
          if (fn) {
            replayResult = await fn(pending.payload);
          } else {
            missingHandlers.push('create_task');
          }
        } else if (intentType === 'reserve_offering') {
          const fn = handleReserveOfferingRef.current;
          if (fn) {
            replayResult = await fn(pending.payload);
          } else {
            missingHandlers.push('reserve_offering');
          }
        } else if (intentType === 'accept_task') {
          const fn = handleAcceptTaskRef.current;
          if (fn) {
            replayResult = await fn(pending.payload);
          } else {
            missingHandlers.push('accept_task');
          }
        } else if (intentType === RAISE_PAY_PENDING_INTENT_TYPE) {
          const fn = handleRaisePayAndRenotifyRef.current;
          if (fn) {
            replayResult = await fn(pending.payload, { replay: true });
            if (replayResult?.requiresFunding) {
              throw new Error('Top up still required to raise task pay.');
            }
            if (replayResult?.terminal === false) {
              throw new Error('Raise-pay replay did not reach a terminal state.');
            }
          } else {
            missingHandlers.push(RAISE_PAY_PENDING_INTENT_TYPE);
          }
        }
        if (missingHandlers.length) {
          throw new Error(`Replay handler unavailable: ${missingHandlers.join(',')}`);
        }
        let confirmedReplayTask = null;
        let confirmedReplayTaskId = null;
        if (intentType === 'create_task') {
          const normalizedReplayTask = normalizeTaskPayload(replayResult);
          confirmedReplayTask = normalizedReplayTask || replayResult;
          confirmedReplayTaskId = getDurableLocalOpsTaskId(confirmedReplayTask);
          if (!confirmedReplayTaskId) {
            jgkWarn('[jgk-resume] create_task replay not confirmed', {
              replayResult: maskSensitiveLocalOpsPayload(replayResult),
            });
            const replayError = new Error('Continue publishing task');
            replayError.code = 'LOCALOPS_CREATE_TASK_REPLAY_NOT_CONFIRMED';
            throw replayError;
          }
        }
        jgkLog('[jgk-resume] replay success', {
          intentType,
          replayResult,
          taskId: confirmedReplayTaskId,
        });
        if (intentType === 'create_task') {
          const taskId = confirmedReplayTaskId;
          const currentTasks = Array.isArray(localOpsTasksRef.current)
            ? localOpsTasksRef.current
            : [];
          const existsInState = currentTasks.some((t) => {
            const id = getDurableLocalOpsTaskId(t);
            return taskId && id && String(id) === String(taskId);
          });
          if (!existsInState) {
            const upsertTaskFn = upsertTaskRef.current;
            if (confirmedReplayTask && upsertTaskFn) {
              upsertTaskFn(confirmedReplayTask);
              jgkLog('[jgk-resume] task upsert forced', {
                taskId,
                tasksCount: currentTasks.length,
              });
            } else {
              jgkWarn('[jgk-resume] task upsert skipped', {
                taskId,
                reason: confirmedReplayTask
                  ? 'handler_unavailable'
                  : 'normalize_failed',
                replayResult,
              });
            }
          }
          jgkLog('[jgk-resume] task upsert check', {
            taskId,
            existsInState,
            tasksCount: currentTasks.length,
          });
        }
        const successNotice =
          intentType === 'create_task'
            ? 'Task published successfully'
            : intentType === 'reserve_offering'
            ? 'Offering reserved successfully'
            : intentType === RAISE_PAY_PENDING_INTENT_TYPE
            ? replayResult?.message || 'Task pay raise handled.'
            : 'Action completed successfully';
        if (pendingResumeTimerRef.current) {
          clearTimeout(pendingResumeTimerRef.current);
          pendingResumeTimerRef.current = null;
        }
        setLocalOpsNotice(successNotice);
        setResumeErrorMessage('');
        setResumeDebugMessage('');
        if (intentType === 'create_task') {
          const replayDraftToken = String(
            pending?.payload?.intakeDraftToken || '',
          ).trim();
          if (replayDraftToken) {
            intakeDraftClaimTokenRef.current = replayDraftToken;
            intakeDraftClaimInFlightRef.current = false;
          }
        }
        writePendingIntent(null);
        setPendingIntentState(null);
        resumeBackoffRef.current = 1000;
        topUpInProgressRef.current = false;
        resumeInFlightRef.current = false;
        resumeLockIdRef.current = null;
      } catch (err) {
        if (JGK_DEBUG) {
          console.error('[jgk-resume] replay failed', {
            error: err,
          });
        }
        const pausedForLocation =
          err?.code === LOCALOPS_LOCATION_GATE_CODE ||
          err?.cause?.code === LOCALOPS_LOCATION_GATE_CODE;
        const retryIntent = {
          ...pending,
          state: 'pending',
          resumeLockId: null,
          lastAttemptAt: Date.now(),
        };
        persistPendingIntent(retryIntent);
        resumeBackoffRef.current = Math.min(resumeBackoffRef.current * 1.5, 30000);
        const retryMessage =
          pausedForLocation
            ? 'Location required for LocalOps.'
            : pending.type === RAISE_PAY_PENDING_INTENT_TYPE
            ? "We couldn't finish raising pay. Tap to retry."
            : pending.type === 'create_task'
            ? 'Continue publishing task'
            : "We couldn't finish publishing. Tap to retry.";
        setLocalOpsNotice(retryMessage);
        setResumeErrorMessage(retryMessage);
        if (process.env.NODE_ENV === 'development') {
          setResumeDebugMessage(err?.message || 'Replay failed');
        }
        resumeInFlightRef.current = false;
        resumeLockIdRef.current = null;
      }
    },
    [
      confirmTopupSince,
      playerBalance,
      refreshPlayerBalance,
      setLocalOpsNotice,
      persistPendingIntent,
    ],
  );
  const handleOpenSharePanel = useCallback((type, item, status) => {
    setSharePanel({ open: true, type, item, status });
  }, []);
  const handleFirestarterEmptyCta = useCallback(() => {
    emitFirestarterTelemetry('firestarter_clicked', {
      surface: 'playermap_empty',
    });
    openFirestarterCreate('playermap_empty');
  }, [emitFirestarterTelemetry, openFirestarterCreate]);
  const handleCloseSharePanel = useCallback(
    () => setSharePanel((prev) => ({ ...prev, open: false })),
    [],
  );
  const fetchRecentLocalOpsLiveActivity = useCallback(async () => {
    if (!localOpsFlags.base || !player?.token) {
      setLocalOpsRecentEvents([]);
      setLocalOpsRecentActivitySettled(true);
      return;
    }
    setLocalOpsRecentActivitySettled(false);
    try {
      const res = await axiosConn.get('local-ops/live/recent', {
        params: { limit: 50 },
        headers: { Authorization: `Bearer ${player.token}` },
      });
      const rows = normalizeLocalOpsCollection(res?.data)
        .map(normalizeRecentLocalOpsLiveEvent)
        .filter(Boolean);
      setLocalOpsRecentEvents(rows);
    } catch (err) {
      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.log('[localops live recent] fetch failed', err?.message || err);
      }
    } finally {
      setLocalOpsRecentActivitySettled(true);
    }
  }, [localOpsFlags.base, player?.token]);
  const handleOpenFeed = useCallback(() => {
    setLocalOpsFeedOpen(true);
    void fetchRecentLocalOpsLiveActivity();
  }, [fetchRecentLocalOpsLiveActivity]);
  const handleCloseFeed = useCallback(() => setLocalOpsFeedOpen(false), []);
  useEffect(() => {
    if (location.pathname !== '/playermap') return;
    void fetchRecentLocalOpsLiveActivity();
  }, [fetchRecentLocalOpsLiveActivity, location.pathname, playerMapRouteKey]);
  const handleViewShareItem = useCallback(() => {
    if (!sharePanel.item || !sharePanel.type) return;
    if (sharePanel.type === 'offering') {
      setSelectedTask(null);
      setSelectedOffering(sharePanel.item);
    } else {
      setSelectedOffering(null);
      setSelectedTask(sharePanel.item);
    }
    setSharePanel((prev) => ({ ...prev, open: false }));
  }, [sharePanel]);
  useEffect(() => {
    if (!localOpsNotice) return;
    const timer = setTimeout(() => setLocalOpsNotice(''), 3200);
    return () => clearTimeout(timer);
  }, [localOpsNotice]);
  useEffect(() => {
    if (!localOpsError) return;
    const timer = setTimeout(() => setLocalOpsError(''), 3600);
    return () => clearTimeout(timer);
  }, [localOpsError]);
  const radiusMeters = useMemo(() => {
    const numericRadius = Number(radius);
    if (!Number.isFinite(numericRadius) || numericRadius <= 0) return null;
    return unit === 'mi' ? numericRadius * 1609.34 : numericRadius * 1000;
  }, [radius, unit]);
  const discoveryRadiusMeters = useMemo(() => {
    if (!radiusMeters) return null;
    if (!travelMode) return radiusMeters;
    const expanded = radiusMeters * LOCALOPS_TRAVEL_RADIUS_MULTIPLIER;
    const minMeters =
      unit === 'mi'
        ? LOCALOPS_TRAVEL_MIN_RADIUS_MI * 1609.34
        : LOCALOPS_TRAVEL_MIN_RADIUS_KM * 1000;
    return Math.max(expanded, minMeters);
  }, [radiusMeters, travelMode, unit]);
  const travelRadiusLabel = useMemo(() => {
    if (!travelMode) return null;
    if (!discoveryRadiusMeters) return null;
    const expanded =
      unit === 'mi'
        ? Math.round(discoveryRadiusMeters / 1609.34)
        : Math.round(discoveryRadiusMeters / 1000);
    return `${expanded} ${unit}`;
  }, [discoveryRadiusMeters, unit, travelMode]);
  useEffect(() => {
    try {
      secureLocalStorage.setItem(
        'playerMapRadius',
        JSON.stringify({ value: radius, unit }),
      );
    } catch (err) {
      // ignore storage failures
    }
  }, [radius, unit]);

  useEffect(() => {
    if (!resumeHasRunInitRef.current) {
      resumeHasRunInitRef.current = true;
      resumePendingIntent('init');
    }
    const onFocus = () => resumePendingIntent('focus');
    window.addEventListener('focus', onFocus);
    return () => window.removeEventListener('focus', onFocus);
  }, [resumePendingIntent]);
  const storedLocation = useMemo(() => {
    try {
      const storedLat = safeParseNumber(
        secureLocalStorage.getItem('latitude'),
      );
      const storedLon = safeParseNumber(
        secureLocalStorage.getItem('longitude'),
      );
      if (Number.isFinite(storedLat) && Number.isFinite(storedLon)) {
        if (isDefaultMapCenter({ lat: storedLat, lon: storedLon })) {
          return null;
        }
        return { lat: storedLat, lon: storedLon };
      }
    } catch (err) {
      return null;
    }
    return null;
  }, []);
  const storedViewport = useMemo(() => {
    try {
      const raw = secureLocalStorage.getItem('playerMapViewport');
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      const lat = parsed?.latitude;
      const lon = parsed?.longitude;
      const zoom = parsed?.zoom;
      if (Number.isFinite(lat) && Number.isFinite(lon)) {
        return {
          lat,
          lon,
          zoom: Number.isFinite(zoom) ? zoom : null,
        };
      }
    } catch (err) {
      return null;
    }
    return null;
  }, []);
  const playerSavedLocation = useMemo(
    () => getSavedPlayerLocation(player),
    [player],
  );
  const hasSavedPersonalLocation =
    hasPersonalLocationOverride || !!storedLocation || !!playerSavedLocation;

  useEffect(() => {
    personalLocationReadyRef.current = hasSavedPersonalLocation;
  }, [hasSavedPersonalLocation]);

  const emitLocationFunnelEvent = useCallback(
    (eventName, extra = {}, options = {}) => {
      const regionSlug = localOpsRegionSlug || 'camden';
      const payload = {
        regionSlug,
        marketSlug:
          localOpsLaunchAttribution?.marketSlug ||
          queryParams.get('marketSlug') ||
          queryParams.get('market') ||
          null,
        source:
          localOpsLaunchAttribution?.source ||
          queryParams.get('source') ||
          null,
        src: localOpsLaunchAttribution?.src || queryParams.get('src') || null,
        intent:
          localOpsLaunchAttribution?.intent ||
          queryParams.get('intent') ||
          null,
        surface: extra.surface || 'playermap',
        hasExistingSavedLocation:
          extra.hasExistingSavedLocation ?? !!hasSavedPersonalLocation,
        ...extra,
      };
      try {
        void recordLocalOpsFunnelEvent(eventName, payload, {
          transport: 'launch',
          regionSlug,
          ...options,
        }).catch(() => {});
      } catch (err) {
        // ignore telemetry failures
      }
    },
    [
      hasSavedPersonalLocation,
      localOpsLaunchAttribution,
      localOpsRegionSlug,
      queryParams,
    ],
  );

  useEffect(() => {
    locationConsentGateRef.current = locationConsentGate;
  }, [locationConsentGate]);

  useEffect(() => {
    try {
      setLocationConsentPrimerDismissed(
        window.sessionStorage.getItem(locationConsentPrimerDismissedKey) ===
          '1',
      );
    } catch (err) {
      setLocationConsentPrimerDismissed(false);
    }
  }, [locationConsentPrimerDismissedKey]);

  const dismissLocationConsentPrimer = useCallback(() => {
    setLocationConsentPrimerDismissed(true);
    try {
      window.sessionStorage.setItem(
        locationConsentPrimerDismissedKey,
        '1',
      );
    } catch (err) {
      // ignore storage failures
    }
  }, [locationConsentPrimerDismissedKey]);

  const handleBrowseWithoutPersonalLocation = useCallback(() => {
    const gate = locationConsentGateRef.current;
    emitLocationFunnelEvent(LOCALOPS_FUNNEL_EVENTS.LOCATION_BROWSE_FIRST_CLICKED, {
      surface: gate ? 'location_gate' : 'location_primer',
      actionContext: gate?.actionType || 'playermap',
      gateReason: gate ? 'missing_saved_location' : undefined,
    });
    dismissLocationConsentPrimer();
    setLocationConsentGate(null);
    setLocationConsentError('');
    setLocationHintStatus((prev) => (prev === 'ready' ? 'ready' : 'fallback'));
    setLocationHintMessage(
      regionBrowseCenter
        ? `Browsing ${regionBrowseCenter.label || 'LocalOps'} without saving your location.`
        : 'Browsing without saving your location.',
    );
  }, [dismissLocationConsentPrimer, emitLocationFunnelEvent, regionBrowseCenter]);

  const centerMapOnPersonalLocation = useCallback(
    (locationResult) => {
      const coords = locationResult?.coords || locationResult || {};
      const storedLat = safeParseNumber(secureLocalStorage.getItem('latitude'));
      const storedLon = safeParseNumber(secureLocalStorage.getItem('longitude'));
      const resolveCoordinate = (...values) => {
        for (const value of values) {
          if (value === null || value === undefined || value === '') continue;
          const parsed = Number(value);
          if (Number.isFinite(parsed)) return parsed;
        }
        return null;
      };
      const nextLat = resolveCoordinate(coords.latitude, coords.lat, storedLat);
      const nextLon = resolveCoordinate(
        coords.longitude,
        coords.lon,
        coords.lng,
        storedLon,
      );
      if (!Number.isFinite(nextLat) || !Number.isFinite(nextLon)) return;

      const nextZoom = Math.max(
        minZoom,
        Math.min(
          maxZoom,
          regionBrowseCenter?.zoom || initialViewportZoom,
        ),
      );
      const nextViewport = {
        latitude: nextLat,
        longitude: nextLon,
        zoom: nextZoom,
      };

      initialViewport.current = {
        ...(initialViewport.current || {}),
        ...nextViewport,
        width: '100vw',
        height: '100vh',
      };
      setZoom(nextZoom);
      setViewport((prev) => ({
        ...prev,
        ...nextViewport,
      }));
      try {
        secureLocalStorage.setItem(
          'playerMapViewport',
          JSON.stringify(nextViewport),
        );
      } catch (err) {
        // ignore storage failures
      }
    },
    [initialViewportZoom, regionBrowseCenter],
  );

  const requestLocalOpsPersonalLocation = useCallback(
    async ({ replayGate = true } = {}) => {
      if (locationConsentBusy) return null;
      const gate = locationConsentGateRef.current;
      const actionContext = gate?.actionType || 'playermap';
      const wasRetry =
        !!gate || replayGate === false || locationHintStatus === 'denied';
      emitLocationFunnelEvent(
        LOCALOPS_FUNNEL_EVENTS.LOCATION_USE_MY_LOCATION_CLICKED,
        {
          surface: gate ? 'location_gate' : 'location_primer',
          actionContext,
          gateReason: gate ? 'missing_saved_location' : undefined,
          wasRetry,
        },
      );
      if (wasRetry) {
        emitLocationFunnelEvent(LOCALOPS_FUNNEL_EVENTS.LOCATION_RETRY_CLICKED, {
          surface: gate ? 'location_gate' : 'location_recovery',
          actionContext,
          gateReason: gate ? 'missing_saved_location' : undefined,
          wasRetry: true,
        });
      }
      dismissLocationConsentPrimer();
      setLocationConsentBusy(true);
      setLocationConsentError('');
      setLocationHintStatus('prompt');
      setLocationHintMessage('Location required for LocalOps.');

      let position = null;
      try {
        const permissionState = await getBrowserGeolocationPermissionState();
        if (permissionState === 'denied') {
          const deniedError = new Error('Browser geolocation permission denied.');
          deniedError.code = 1;
          throw deniedError;
        }

        position = await getLocationAndSave(
          SetLatitude,
          SetLongitude,
          SetAccuracy,
          SetTimestamp,
          player,
          {
            onPermissionGranted: () => {
              emitLocationFunnelEvent(
                LOCALOPS_FUNNEL_EVENTS.LOCATION_PERMISSION_GRANTED,
                {
                  surface: gate ? 'location_gate' : 'location_primer',
                  actionContext,
                  permissionState: 'granted',
                  wasRetry,
                },
              );
            },
            onSaveAttempted: () => {
              emitLocationFunnelEvent(
                LOCALOPS_FUNNEL_EVENTS.LOCATION_SAVE_ATTEMPTED,
                {
                  surface: gate ? 'location_gate' : 'location_primer',
                  actionContext,
                  permissionState: permissionState || 'unknown',
                  wasRetry,
                },
              );
            },
            onSaved: () => {
              emitLocationFunnelEvent(
                LOCALOPS_FUNNEL_EVENTS.LOCATION_SAVED,
                {
                  surface: gate ? 'location_gate' : 'location_primer',
                  actionContext,
                  wasRetry,
                },
              );
            },
            onSaveFailed: () => {
              emitLocationFunnelEvent(
                LOCALOPS_FUNNEL_EVENTS.LOCATION_SAVE_FAILED,
                {
                  surface: gate ? 'location_gate' : 'location_primer',
                  actionContext,
                  errorCode: 'save_failed',
                  wasRetry,
                },
              );
            },
          },
        );
      } catch (err) {
        const errorCode = getSafeLocationTelemetryErrorCode(err);
        emitLocationFunnelEvent(
          LOCALOPS_FUNNEL_EVENTS.LOCATION_PERMISSION_DENIED,
          {
            surface: gate ? 'location_gate' : 'location_primer',
            actionContext,
            errorCode,
            permissionState:
              errorCode === 'permission_denied' ? 'denied' : 'unknown',
            wasRetry,
          },
        );
        if (errorCode !== 'permission_denied') {
          emitLocationFunnelEvent(
            LOCALOPS_FUNNEL_EVENTS.LOCATION_SAVE_FAILED,
            {
              surface: gate ? 'location_gate' : 'location_primer',
              actionContext,
              errorCode,
              wasRetry,
            },
          );
        }
        setLocationHintStatus('denied');
        setLocationHintMessage('Location required for LocalOps.');
        setLocationConsentError(getLocationConsentErrorCopy(err));
        setLocationConsentBusy(false);
        return null;
      }

      personalLocationReadyRef.current = true;
      setHasPersonalLocationOverride(true);
      setLocationRefreshEnabled(true);
      centerMapOnPersonalLocation(position);
      setLocationHintStatus('ready');
      setLocationHintMessage('');

      if (replayGate && gate?.retry) {
        setLocationConsentGate(null);
        try {
          await gate.retry();
          emitLocationFunnelEvent(
            LOCALOPS_FUNNEL_EVENTS.LOCATION_RETRY_SUCCESS,
            {
              surface: 'location_gate',
              actionContext,
              wasRetry: true,
            },
          );
        } catch (err) {
          if (err?.code !== LOCALOPS_LOCATION_GATE_CODE) {
            setLocationConsentError(
              err?.message || 'Location saved. Try the LocalOps action again.',
            );
          }
        }
      } else {
        setLocationConsentGate(null);
      }

      setLocationConsentBusy(false);
      return position;
    },
    [
      centerMapOnPersonalLocation,
      dismissLocationConsentPrimer,
      emitLocationFunnelEvent,
      locationConsentBusy,
      locationHintStatus,
      player,
    ],
  );

  const openLocationConsentGate = useCallback(
    ({ actionType, retry } = {}) => {
      const actionContext = actionType || 'unknown';
      emitLocationFunnelEvent(
        LOCALOPS_FUNNEL_EVENTS.LOCATION_GATE_OPENED,
        {
          surface: 'location_gate',
          actionContext,
          gateReason: 'missing_saved_location',
        },
        {
          oncePerSession: true,
          dedupeKey: [
            'localops-location-gate',
            localOpsRegionSlug || 'camden',
            currentPlayerId || currentPlayerHandle || playerId || 'anonymous',
            actionContext,
          ].join(':'),
        },
      );
      dismissLocationConsentPrimer();
      setLocationConsentError('');
      setLocationHintStatus('prompt');
      setLocationHintMessage('Location required for LocalOps.');
      setLocationConsentGate({
        id: makePendingIntentId(),
        actionType,
        actionLabel: getLocationConsentActionLabel(actionType),
        retry,
      });
    },
    [
      currentPlayerHandle,
      currentPlayerId,
      dismissLocationConsentPrimer,
      emitLocationFunnelEvent,
      localOpsRegionSlug,
      playerId,
    ],
  );

  const ensurePersonalLocationForAction = useCallback(
    (actionType, retry) => {
      if (personalLocationReadyRef.current || hasSavedPersonalLocation) {
        return true;
      }
      openLocationConsentGate({
        actionType,
        retry: resumeInFlightRef.current
          ? () => resumePendingIntent('location')
          : retry,
      });
      return false;
    },
    [hasSavedPersonalLocation, openLocationConsentGate, resumePendingIntent],
  );

  const shouldShowLocationPrimer =
    !!player?.token &&
    !hasSavedPersonalLocation &&
    !locationConsentPrimerDismissed &&
    !locationConsentGate;

  useEffect(() => {
    if (!shouldShowLocationPrimer) return;
    emitLocationFunnelEvent(
      LOCALOPS_FUNNEL_EVENTS.LOCATION_PRIMER_SHOWN,
      {
        surface: 'location_primer',
        actionContext: 'playermap',
      },
      {
        oncePerSession: true,
        dedupeKey: [
          'localops-location-primer',
          localOpsRegionSlug || 'camden',
          currentPlayerId || currentPlayerHandle || playerId || 'anonymous',
        ].join(':'),
      },
    );
  }, [
    currentPlayerHandle,
    currentPlayerId,
    emitLocationFunnelEvent,
    localOpsRegionSlug,
    playerId,
    shouldShowLocationPrimer,
  ]);

  const initialViewportSeed = useMemo(() => {
    const personalLocationSeed = storedLocation || playerSavedLocation || null;
    const localOpsSeedZoom = regionBrowseCenter?.zoom || initialViewportZoom;

    if (parent === 'post') {
      const lat = parseFloat(queryParams.get('lat'));
      const lon = parseFloat(queryParams.get('lon'));
      if (Number.isFinite(lat) && Number.isFinite(lon)) {
        return {
          lat,
          lon,
          zoom: initialViewportZoom,
          source: 'query',
        };
      }
    }

    if (regionBrowseCenter && personalLocationSeed) {
      return {
        lat: personalLocationSeed.lat,
        lon: personalLocationSeed.lon,
        zoom: localOpsSeedZoom,
        source: storedLocation ? 'storage' : 'player',
      };
    }

    if (storedViewport && personalLocationSeed && radiusMeters) {
      const distance = getDistanceFromLatLonInMeters(
        storedViewport.lat,
        storedViewport.lon,
        personalLocationSeed.lat,
        personalLocationSeed.lon,
      );
      const threshold = Math.max(radiusMeters, 5000);
      if (distance <= threshold) {
        return {
          lat: storedViewport.lat,
          lon: storedViewport.lon,
          zoom:
            storedViewport.zoom && storedViewport.zoom >= minZoom
              ? storedViewport.zoom
              : initialViewportZoom,
          source: 'viewport',
        };
      }
    }

    if (personalLocationSeed) {
      return {
        lat: personalLocationSeed.lat,
        lon: personalLocationSeed.lon,
        zoom: localOpsSeedZoom,
        source: storedLocation ? 'storage' : 'player',
      };
    }

    if (regionBrowseCenter) {
      return {
        lat: regionBrowseCenter.lat,
        lon: regionBrowseCenter.lon,
        zoom: regionBrowseCenter.zoom || initialViewportZoom,
        source: 'region',
      };
    }

    if (storedViewport) {
      return {
        lat: storedViewport.lat,
        lon: storedViewport.lon,
        zoom:
          storedViewport.zoom && storedViewport.zoom >= minZoom
            ? storedViewport.zoom
            : initialViewportZoom,
        source: 'viewport-only',
      };
    }

    return null;
  }, [
    parent,
    queryParams,
    storedLocation,
    playerSavedLocation,
    storedViewport,
    regionBrowseCenter,
    radiusMeters,
    initialViewportZoom,
  ]);
  const localOpsSeed = useMemo(() => {
    if (typeof window === 'undefined') return null;
    if (window.__LOCALOPS__ && typeof window.__LOCALOPS__ === 'object') {
      return window.__LOCALOPS__;
    }
    try {
      const stored = secureLocalStorage.getItem('localopsSeed');
      return stored ? JSON.parse(stored) : null;
    } catch (err) {
      return null;
    }
  }, []);
  const {
    offerings,
    tasks,
    liveTask,
    presencePlusMap,
    replaceOfferings,
    replaceTasks,
    upsertOffering,
    removeOffering,
    upsertTask,
    removeTask,
    requestPresencePlus,
  } = useLocalOpsState({
    enabled: localOpsFlags.base,
    socket: socket2,
    seed: localOpsSeed,
    playerId,
    currentPlayerId,
    currentPlayerHandle,
    onOfferingRemoved: handleOfferingRemoved,
    onTaskRemoved: handleTaskRemoved,
    onTaskCompleted: handleRemoteTaskCompleted,
  });
  localOpsTasksRef.current = Array.isArray(tasks) ? tasks : [];
  upsertTaskRef.current = upsertTask;
  const collisionOffsets = useMemo(
    () =>
      buildCollisionOffsets({
        tasks: effectiveLayers.tasks ? tasks : [],
        offerings: effectiveLayers.offerings ? offerings : [],
        zoom: Number.isFinite(zoom) ? zoom : viewport.zoom,
        mobileView,
      }),
    [
      effectiveLayers.tasks,
      effectiveLayers.offerings,
      tasks,
      offerings,
      zoom,
      viewport.zoom,
      mobileView,
    ],
  );
  const landingWalletLine = useMemo(() => {
    if (!Number.isFinite(Number(playerBalance)) || Number(playerBalance) <= 0) {
      return null;
    }
    const tokens = Number(playerBalance);
    const dollars = (tokens / 1000).toFixed(2);
    return `Balance: ${tokens.toLocaleString('en-US')} JGK ($${dollars})`;
  }, [playerBalance]);

  useEffect(() => {
    if ((tasks && tasks.length) || (offerings && offerings.length)) {
      setLocalOpsLoading(false);
    }
  }, [tasks, offerings]);
  const creatorLandingIntentEnabled = useMemo(
    () =>
      coerceFlag(
        process.env.REACT_APP_LOCALOPS_CREATOR_LANDING_INTENT,
        ENABLE_CREATOR_LANDING_INTENT,
      ),
    [],
  );
  const localOpsOrders = useMemo(
    () => Array.from(localOpsOrdersRef.current.values() || []),
    [localOpsOrdersVersion],
  );
  const landingAvailableOfferings = useMemo(
    () => (Array.isArray(offerings) ? offerings.filter(Boolean) : []),
    [offerings],
  );
  const landingOfferingsById = useMemo(() => {
    const map = new Map();
    landingAvailableOfferings.forEach((offering) => {
      const id = getOfferingIntentId(offering);
      if (id) map.set(id, offering);
    });
    return map;
  }, [landingAvailableOfferings]);
  const reservedOrderForUser = useMemo(() => {
    let bestOrder = null;
    let bestTs = -Infinity;
    localOpsOrders.forEach((order) => {
      const status = getOrderIntentStatus(order);
      if (!LOCALOPS_ACTIVE_ORDER_STATUSES.has(status)) return;
      const buyerId = order?.buyer?._id || order?.buyer;
      const buyerHandle = order?.buyer?.playerId || null;
      const isMine =
        (currentPlayerId &&
          buyerId &&
          String(buyerId) === String(currentPlayerId)) ||
        (currentPlayerHandle &&
          buyerHandle &&
          String(buyerHandle) === String(currentPlayerHandle));
      if (!isMine) return;
      const ts = Date.parse(order?.updatedAt || order?.createdAt) || 0;
      if (ts > bestTs) {
        bestOrder = order;
        bestTs = ts;
      }
    });
    return bestOrder;
  }, [localOpsOrders, currentPlayerId, currentPlayerHandle]);
  const reservedOfferingForUser = useMemo(() => {
    if (!reservedOrderForUser) return null;
    const offeringId = getOrderIntentOfferingId(reservedOrderForUser);
    if (!offeringId) return null;
    const snapshotOffering = landingOfferingsById.get(offeringId) || null;
    return buildOrderBackedOfferingTarget(
      reservedOrderForUser,
      snapshotOffering,
      normalizeLocalOpsItem,
    );
  }, [reservedOrderForUser, landingOfferingsById]);
  const landingOfferingIds = useMemo(
    () => Array.from(landingOfferingsById.keys()),
    [landingOfferingsById],
  );
  const landingFallbackNoOfferings =
    'No local offerings right now. Post one or earn more JGK.';
  const handleUseLocally = useCallback(() => {
    const getOfferingFreshnessTime = (offering) => {
      const raw =
        offering?.publishedAt ||
        offering?.availableAt ||
        offering?.updatedAt ||
        offering?.createdAt;
      const parsed = raw ? Date.parse(raw) : 0;
      return Number.isFinite(parsed) ? parsed : 0;
    };
    const getOfferingAvailabilityRank = (offering) => {
      const status = String(
        offering?.reservationStatus ||
          offering?.availabilityStatus ||
          offering?.status ||
          '',
      ).toLowerCase();
      const unavailable =
        offering?.isReserved === true ||
        ['reserved', 'sold', 'unavailable', 'cancelled', 'canceled', 'deleted', 'expired'].includes(
          status,
        );
      return unavailable ? 1 : 0;
    };
    const sortedQueue = (() => {
      const list = landingAvailableOfferings.slice();
      if (Number.isFinite(latitude) && Number.isFinite(longitude)) {
        return list
          .map((o) => {
            const loc =
              o?.location || o?.originLocation || o?.destinationLocation || {};
            const coords =
              loc.coordinates || loc.coords || loc.position || loc.center || null;
            let lat = null;
            let lon = null;
            if (Array.isArray(coords) && coords.length === 2) {
              [lon, lat] = coords;
            } else {
              lon =
                loc.longitude ??
                loc.lon ??
                loc.lng ??
                o?.longitude ??
                o?.lon ??
                o?.lng;
              lat = loc.latitude ?? loc.lat ?? o?.latitude ?? o?.lat;
            }
            const dist =
              Number.isFinite(lat) && Number.isFinite(lon)
                ? getDistance(latitude, longitude, lat, lon, unit || 'mi')
                : Number.POSITIVE_INFINITY;
            return {
              offering: o,
              availabilityRank: getOfferingAvailabilityRank(o),
              freshnessTime: getOfferingFreshnessTime(o),
              dist,
            };
          })
          .sort((a, b) => {
            if (a.availabilityRank !== b.availabilityRank) {
              return a.availabilityRank - b.availabilityRank;
            }
            if (a.freshnessTime !== b.freshnessTime) {
              return b.freshnessTime - a.freshnessTime;
            }
            return a.dist - b.dist;
          })
          .map((item) => item.offering);
      }
      return list;
    })();
    const bestOffering = sortedQueue[0];
    if (bestOffering) {
      handleSelectOffering(bestOffering, sortedQueue, 0);
    } else {
      setLocalOpsNotice(landingFallbackNoOfferings);
      setTimeout(() => setLocalOpsNotice(''), 4000);
    }
  }, [
    landingAvailableOfferings,
    latitude,
    longitude,
    unit,
    handleSelectOffering,
    landingFallbackNoOfferings,
    setLocalOpsNotice,
  ]);
  const actionableLandingTasks = useMemo(() => {
    const list = Array.isArray(tasks) ? tasks : [];
    const filtered = list.filter((task) => {
      const status = String(task?.status || '').toLowerCase();
      const isMine =
        currentPlayerId &&
        (String(task?.creatorPlayerId?._id || task?.creatorPlayerId) ===
          String(currentPlayerId) ||
          String(task?.ownerId) === String(currentPlayerId) ||
          String(task?.playerId) === String(currentPlayerId));
      if (isMine) return false;
      return !['completed', 'cancelled', 'canceled', 'expired'].includes(status);
    });
    return filtered
      .map((task, index) => ({ task, index }))
      .sort((a, b) => {
        const aLocked =
          localOpsVerifiedLocalGateEnabled &&
          Number(viewerActionCreditTotal || 0) < 1 &&
          normalizeTaskTrustRequirement(a.task?.trustRequirement) ===
          'verified_local';
        const bLocked =
          localOpsVerifiedLocalGateEnabled &&
          Number(viewerActionCreditTotal || 0) < 1 &&
          normalizeTaskTrustRequirement(b.task?.trustRequirement) ===
          'verified_local';
        if (aLocked !== bLocked) return aLocked ? 1 : -1;
        const aPaid = isOpenPaidLandingTaskForViewer(a.task, {
          landingAmountLabel: getPlayerMapLandingTaskAmountLabel(a.task),
          currentPlayerId,
          currentPlayerHandle,
        });
        const bPaid = isOpenPaidLandingTaskForViewer(b.task, {
          landingAmountLabel: getPlayerMapLandingTaskAmountLabel(b.task),
          currentPlayerId,
          currentPlayerHandle,
        });
        if (aPaid !== bPaid) return aPaid ? -1 : 1;
        return a.index - b.index;
      })
      .map((entry) => entry.task);
  }, [
    tasks,
    currentPlayerId,
    currentPlayerHandle,
    localOpsVerifiedLocalGateEnabled,
    viewerActionCreditTotal,
  ]);
  const verifiedLocalUnlockTask = useMemo(() => {
    const list = Array.isArray(tasks) ? tasks : [];
    return (
      list.find((task) => {
        const status = String(task?.status || '').toLowerCase();
        if (status !== 'discoverable') return false;
        if (
          normalizeTaskTrustRequirement(task?.trustRequirement) !==
          'open'
        ) {
          return false;
        }
        const isMine =
          (currentPlayerId || currentPlayerHandle) &&
          (String(task?.creatorPlayerId?._id || task?.creatorPlayerId) ===
            String(currentPlayerId) ||
            String(task?.creatorPlayerId?._id || task?.creatorPlayerId) ===
              String(currentPlayerHandle) ||
            String(task?.ownerId) === String(currentPlayerId) ||
            String(task?.ownerId) === String(currentPlayerHandle) ||
            String(task?.playerId) === String(currentPlayerId) ||
            String(task?.playerId) === String(currentPlayerHandle));
        if (isMine) return false;
        return true;
      }) || null
    );
  }, [tasks, currentPlayerId, currentPlayerHandle]);
  const handleFindVerifiedLocalUnlockTask = useCallback(() => {
    if (verifiedLocalUnlockTask) {
      handleSelectTask(verifiedLocalUnlockTask);
      return;
    }
    handleCloseTask();
  }, [verifiedLocalUnlockTask, handleSelectTask, handleCloseTask]);
  const creatorVisibleLiveTaskCount = useMemo(() => {
    const list = Array.isArray(tasks) ? tasks : [];
    return list.filter((task) => {
      const status = String(task?.status || '').toLowerCase();
      if (!['created', 'discoverable'].includes(status)) return false;
      const creatorPlayerIdRaw = task?.creatorPlayerId;
      const creatorMongo =
        creatorPlayerIdRaw &&
        typeof creatorPlayerIdRaw === 'object' &&
        creatorPlayerIdRaw._id
          ? creatorPlayerIdRaw._id
          : null;
      const creatorHandle =
        creatorPlayerIdRaw &&
        typeof creatorPlayerIdRaw === 'string' &&
        !isMongoId(creatorPlayerIdRaw)
          ? creatorPlayerIdRaw
          : null;
      return matchesLandingIdentity({
        idCandidates: [
          creatorMongo,
          typeof creatorPlayerIdRaw === 'string' && isMongoId(creatorPlayerIdRaw)
            ? creatorPlayerIdRaw
            : null,
          task?.creator?._id,
          task?.ownerId,
          task?.createdBy,
        ],
        handleCandidates: [
          creatorHandle,
          task?.creator?.playerId,
          task?.ownerHandle,
          task?.playerId,
        ],
        currentPlayerId,
        currentPlayerHandle,
      });
    }).length;
  }, [tasks, currentPlayerId, currentPlayerHandle]);
  const acceptedTaskForUser = useMemo(() => {
    const list = Array.isArray(tasks) ? tasks : [];
    let best = null;
    let bestTs = -Infinity;
    list.forEach((task) => {
      if (!task) return;
      const status = String(task.status || '').toLowerCase();
      if (!['accepted', 'started', 'in_progress'].includes(status)) return;
      const acceptedId =
        task.acceptedPlayerId ||
        task.accepted?._id ||
        task.providerId ||
        null;
      const acceptedHandle =
        task.accepted?.playerId || task.providerHandle || null;
      const isMine =
        (currentPlayerId &&
          acceptedId &&
          String(acceptedId) === String(currentPlayerId)) ||
        (currentPlayerHandle &&
          acceptedHandle &&
          String(acceptedHandle) === String(currentPlayerHandle));
      if (!isMine) return;
      const ts =
        Date.parse(task.updatedAt || task.acceptedAt || task.createdAt) || 0;
      if (ts > bestTs) {
        best = task;
        bestTs = ts;
      }
    });
    return best;
  }, [tasks, currentPlayerId, currentPlayerHandle]);
  const creatorReservedOfferings = useMemo(() => {
    if (!creatorLandingIntentEnabled) return [];
    const newestReservedOrderByOfferingId = new Map();
    localOpsOrders.forEach((order) => {
      const status = getOrderIntentStatus(order);
      if (!LOCALOPS_ACTIVE_ORDER_STATUSES.has(status)) return;
      const sellerRaw = typeof order?.seller === 'string' ? order.seller : null;
      const isSeller = matchesLandingIdentity({
        idCandidates: [
          order?.seller?._id,
          order?.seller?.id,
          sellerRaw && isMongoId(sellerRaw) ? sellerRaw : null,
        ],
        handleCandidates: [
          order?.seller?.playerId,
          sellerRaw && !isMongoId(sellerRaw) ? sellerRaw : null,
        ],
        currentPlayerId,
        currentPlayerHandle,
      });
      if (!isSeller) return;
      const offeringId = getOrderIntentOfferingId(order);
      if (!offeringId) return;
      const ts = Date.parse(order?.updatedAt || order?.createdAt) || 0;
      const prev = newestReservedOrderByOfferingId.get(offeringId);
      if (!prev || ts > prev.ts) {
        newestReservedOrderByOfferingId.set(offeringId, { order, ts });
      }
    });
    return Array.from(newestReservedOrderByOfferingId.entries())
      .sort((a, b) => {
        if (b[1].ts !== a[1].ts) return b[1].ts - a[1].ts;
        return a[0].localeCompare(b[0]);
      })
      .map(([offeringId, entry]) =>
        buildOrderBackedOfferingTarget(
          entry.order,
          landingOfferingsById.get(offeringId) || null,
          normalizeLocalOpsItem,
        ),
      )
      .filter(Boolean);
  }, [
    creatorLandingIntentEnabled,
    localOpsOrders,
    landingOfferingsById,
    currentPlayerId,
    currentPlayerHandle,
  ]);
  const creatorOwnedOfferingIds = useMemo(() => {
    if (!creatorLandingIntentEnabled) return [];
    const ids = landingAvailableOfferings
      .filter((offering) =>
        matchesLandingIdentity({
          idCandidates: [
            offering?.ownerId,
            offering?.owner?._id,
            offering?.creator?._id,
            offering?.creator?.id,
            offering?.ownerPlayerId?._id,
          ],
          handleCandidates: [
            offering?.owner?.playerId,
            offering?.creator?.playerId,
            offering?.playerId,
            offering?.handle,
          ],
          currentPlayerId,
          currentPlayerHandle,
        }),
      )
      .map((offering) => getOfferingIntentId(offering))
      .filter(Boolean);
    return Array.from(new Set(ids)).sort();
  }, [
    creatorLandingIntentEnabled,
    landingAvailableOfferings,
    currentPlayerId,
    currentPlayerHandle,
  ]);
  const creatorActiveTasks = useMemo(() => {
    if (!creatorLandingIntentEnabled) return [];
    const list = Array.isArray(tasks) ? tasks : [];
    return list
      .filter((task) => {
        const status = String(task?.status || '').toLowerCase();
        if (!['accepted', 'started', 'in_progress'].includes(status)) {
          return false;
        }
        const creatorPlayerIdRaw = task?.creatorPlayerId;
        const creatorMongo =
          creatorPlayerIdRaw &&
          typeof creatorPlayerIdRaw === 'object' &&
          creatorPlayerIdRaw._id
            ? creatorPlayerIdRaw._id
            : null;
        const creatorHandle =
          creatorPlayerIdRaw &&
          typeof creatorPlayerIdRaw === 'string' &&
          !isMongoId(creatorPlayerIdRaw)
            ? creatorPlayerIdRaw
            : null;
        return matchesLandingIdentity({
          idCandidates: [
            creatorMongo,
            typeof creatorPlayerIdRaw === 'string' && isMongoId(creatorPlayerIdRaw)
              ? creatorPlayerIdRaw
              : null,
            task?.creator?._id,
            task?.ownerId,
            task?.createdBy,
          ],
          handleCandidates: [
            creatorHandle,
            task?.creator?.playerId,
            task?.ownerHandle,
            task?.playerId,
          ],
          currentPlayerId,
          currentPlayerHandle,
        });
      })
      .sort((a, b) => {
        const aTs = Date.parse(a?.updatedAt || a?.acceptedAt || a?.createdAt) || 0;
        const bTs = Date.parse(b?.updatedAt || b?.acceptedAt || b?.createdAt) || 0;
        if (bTs !== aTs) return bTs - aTs;
        return (getTaskIntentId(a) || '').localeCompare(getTaskIntentId(b) || '');
      });
  }, [
    creatorLandingIntentEnabled,
    tasks,
    currentPlayerId,
    currentPlayerHandle,
  ]);
  const ownerTaskForUser = useMemo(
    () =>
      selectOwnerLandingTask({
        tasks,
        currentPlayerId,
        currentPlayerHandle,
      }),
    [tasks, currentPlayerId, currentPlayerHandle],
  );
  const defaultBestLandingTask = actionableLandingTasks[0] || null;
  const defaultLandingAmountLabel = useMemo(
    () => getPlayerMapLandingTaskAmountLabel(defaultBestLandingTask),
    [defaultBestLandingTask],
  );
  const defaultBestLandingTaskLockedForViewer =
    !!defaultBestLandingTask &&
    localOpsVerifiedLocalGateEnabled &&
    Number(viewerActionCreditTotal || 0) < 1 &&
    normalizeTaskTrustRequirement(defaultBestLandingTask?.trustRequirement) ===
      'verified_local';
  const defaultBestLandingTaskHasCashPayout =
    !!defaultBestLandingTask &&
    hasUsableLandingAmountLabel(defaultLandingAmountLabel);
  const defaultBestLandingTaskIsCommunity =
    !!defaultBestLandingTask &&
    (defaultBestLandingTask.communityTask === true ||
      defaultBestLandingTask.money?.communityTask === true ||
      String(
        defaultBestLandingTask.paymentMode ||
          defaultBestLandingTask.money?.paymentMode ||
          '',
      )
        .trim()
        .toLowerCase() === 'community');
  const defaultBestLandingTaskIsCommunityLike =
    !!defaultBestLandingTask &&
    (defaultBestLandingTaskIsCommunity || !defaultBestLandingTaskHasCashPayout);
  const shouldScanRecoveredPaidLandingTask =
    requesterLandingIntent &&
    (hasRequesterLandingSignal ||
      (!!defaultBestLandingTask &&
        !defaultBestLandingTaskLockedForViewer &&
        defaultBestLandingTaskIsCommunityLike));
  const recoveredPaidLandingTask = useMemo(() => {
    if (!shouldScanRecoveredPaidLandingTask) return null;
    return (
      actionableLandingTasks.find((task) =>
        isReleasedOrReopenedPaidLandingTask(task, {
          currentPlayerId,
          currentPlayerHandle,
        }),
      ) || null
    );
  }, [
    actionableLandingTasks,
    shouldScanRecoveredPaidLandingTask,
    currentPlayerId,
    currentPlayerHandle,
  ]);
  const bestLandingTask = shouldScanRecoveredPaidLandingTask
    ? recoveredPaidLandingTask || defaultBestLandingTask
    : defaultBestLandingTask;
  const landingRegisterUrl = useMemo(
    () => {
      const returnTo = buildSafePlayerMapMagicLinkReturnTo({
        pathname: location.pathname,
        search: location.search,
      });
      return `/register?returnTo=${encodeURIComponent(returnTo)}&source=localops_landing&bonus=jgk_100`;
    },
    [location.pathname, location.search],
  );
  const landingAmountLabel = useMemo(
    () => getPlayerMapLandingTaskAmountLabel(bestLandingTask),
    [bestLandingTask],
  );
  const bestLandingTaskLockedForViewer =
    !!bestLandingTask &&
    localOpsVerifiedLocalGateEnabled &&
    Number(viewerActionCreditTotal || 0) < 1 &&
    normalizeTaskTrustRequirement(bestLandingTask?.trustRequirement) ===
      'verified_local';
  const landingEarnAmountLabel = bestLandingTaskLockedForViewer
    ? null
    : landingAmountLabel;
  const bestLandingTaskHasCashPayout =
    !!bestLandingTask && hasUsableLandingAmountLabel(landingAmountLabel);
  const bestLandingTaskIsCommunity =
    !!bestLandingTask &&
    (bestLandingTask.communityTask === true ||
      bestLandingTask.money?.communityTask === true ||
      String(
        bestLandingTask.paymentMode || bestLandingTask.money?.paymentMode || '',
      )
        .trim()
        .toLowerCase() === 'community');
  const bestLandingTaskIsCommunityLike =
    !!bestLandingTask &&
    (bestLandingTaskIsCommunity || !bestLandingTaskHasCashPayout);
  const bestLandingTaskNeedsPaidDiscovery =
    !bestLandingTask || bestLandingTaskIsCommunityLike;
  const landingEarnHeadline = useMemo(
    () =>
      postCompletionContext || postCompletionOpen
        ? 'Earn again'
        : bestLandingTask
        ? getLandingEarnHeadline(landingEarnAmountLabel)
        : 'No open tasks right now',
    [
      postCompletionContext,
      postCompletionOpen,
      bestLandingTask,
      landingEarnAmountLabel,
    ],
  );
  const pendingOpenTaskHydrationIds = useMemo(() => {
    if (!player?.token) return [];
    const existingOpenPaidLandingTaskIds = new Set(
      (Array.isArray(tasks) ? tasks : [])
        .filter((task) =>
          isOpenPaidLandingTaskForViewer(task, {
            landingAmountLabel: getPlayerMapLandingTaskAmountLabel(task),
            currentPlayerId,
            currentPlayerHandle,
          }),
        )
        .map((task) => String(task?.taskId || task?.id || task?._id || ''))
        .filter(Boolean),
    );
    const ids = [];
    const seen = new Set();
    const events = [
      ...(Array.isArray(localOpsSeedEvents) ? localOpsSeedEvents : []),
      ...(Array.isArray(localOpsRecentEvents) ? localOpsRecentEvents : []),
      ...(Array.isArray(localOpsLiveEvents) ? localOpsLiveEvents : []),
    ];
    events.forEach((event) => {
      if (ids.length >= 5) return;
      const entityType = String(event?.entityType || '').toLowerCase();
      const eventType = String(event?.eventType || '').toLowerCase();
      const target = parseLocalOpsShareTarget(event?.shareUrl);
      const taskId = String(event?.entityId || target?.id || '').trim();
      const isOpenTaskEvent =
        entityType === 'task' &&
        ['created', 'task_posted', 'task_reopened_available', 'helper_released_available'].includes(
          eventType,
        );
      if (
        !isOpenTaskEvent ||
        !taskId ||
        seen.has(taskId) ||
        existingOpenPaidLandingTaskIds.has(taskId) ||
        openTaskHydrationSettledIds.has(taskId)
      ) {
        return;
      }
      seen.add(taskId);
      ids.push(taskId);
    });
    return ids;
  }, [
    localOpsLiveEvents,
    localOpsRecentEvents,
    localOpsSeedEvents,
    currentPlayerHandle,
    currentPlayerId,
    openTaskHydrationSettledIds,
    player?.token,
    tasks,
  ]);
  const pendingOpenTaskHydrationKey = pendingOpenTaskHydrationIds.join('|');
  const [landingReady, setLandingReady] = useState(false);
  const [landingLoadingTimeout, setLandingLoadingTimeout] = useState(null);
  const [
    genericRequesterLandingGraceReadyKey,
    setGenericRequesterLandingGraceReadyKey,
  ] = useState('');
  const genericRequesterLandingGraceReady =
    genericRequesterLandingGraceReadyKey === playerMapRouteKey;
  const landingBalanceRefreshRef = useRef(0);
  useEffect(() => {
    if (!mapBooted) return;
    if (
      bestLandingTask ||
      ownerTaskForUser ||
      landingAvailableOfferings.length > 0
    ) {
      setLandingReady(true);
      if (landingLoadingTimeout) {
        clearTimeout(landingLoadingTimeout);
        setLandingLoadingTimeout(null);
      }
      return;
    }
    // Fallback: mark ready shortly after map boots even if no items are present
    const id = setTimeout(() => setLandingReady(true), 800);
    setLandingLoadingTimeout(id);
    return () => {
      clearTimeout(id);
    };
  }, [mapBooted, bestLandingTask, ownerTaskForUser, landingAvailableOfferings]);
  const landingInventorySettled =
    !localOpsFlags.base || hasCompletedInitialLocalOpsSnapshot || !localOpsLoading;
  const landingRecentActivitySettled =
    !localOpsFlags.base || !player?.token || localOpsRecentActivitySettled;
  const hasGenericLegacyArrivalBlocker =
    !!checkoutParam ||
    !!intakeDraftTokenParam ||
    !!shareParam ||
    !!deeplinkTypeParam ||
    !!deeplinkIdParam ||
    firestarterEnabled;
  const shouldHoldReservedOfferingPrimary =
    !!reservedOfferingForUser &&
    !acceptedTaskForUser &&
    !bestLandingTask &&
    !landingInventorySettled;
  const shouldArmGenericRequesterLandingGrace =
    requesterLandingIntent &&
    !hasRequesterLandingSignal &&
    !hasGenericLegacyArrivalBlocker &&
    !acceptedTaskForUser &&
    !reservedOfferingForUser &&
    !ownerTaskForUser &&
    bestLandingTaskNeedsPaidDiscovery &&
    landingInventorySettled &&
    landingRecentActivitySettled &&
    pendingOpenTaskHydrationIds.length === 0;
  useEffect(() => {
    setGenericRequesterLandingGraceReadyKey('');
    if (!shouldArmGenericRequesterLandingGrace) return undefined;
    const timer = setTimeout(
      () => setGenericRequesterLandingGraceReadyKey(playerMapRouteKey),
      900,
    );
    return () => clearTimeout(timer);
  }, [
    currentPlayerHandle,
    currentPlayerId,
    pendingOpenTaskHydrationKey,
    playerMapRouteKey,
    shouldArmGenericRequesterLandingGrace,
  ]);
  const shouldHoldInferredRequesterLanding =
    requesterLandingIntent &&
    !hasRequesterLandingSignal &&
    !hasGenericLegacyArrivalBlocker &&
    !acceptedTaskForUser &&
    !reservedOfferingForUser &&
    !ownerTaskForUser &&
    bestLandingTaskNeedsPaidDiscovery &&
    (!landingInventorySettled ||
      !landingRecentActivitySettled ||
      pendingOpenTaskHydrationIds.length > 0 ||
      !genericRequesterLandingGraceReady);
  const landingInteractionReady =
    landingReady &&
    !shouldHoldReservedOfferingPrimary &&
    !shouldHoldInferredRequesterLanding;
  const landingDisabled = useMemo(
    () => !landingInteractionReady || landingAuthRequired,
    [landingInteractionReady, landingAuthRequired],
  );
  const landingSecondaryDisabled = useMemo(
    () => !landingInteractionReady || landingAuthRequired,
    [landingInteractionReady, landingAuthRequired],
  );
  const noTasksAvailable =
    !bestLandingTask && !ownerTaskForUser && !shouldHoldReservedOfferingPrimary;
  const genericLegacyRequesterLandingMode =
    requesterLandingIntent &&
    !hasRequesterLandingSignal &&
    !hasGenericLegacyArrivalBlocker &&
    noTasksAvailable;
  const requesterLandingMode =
    requesterLandingIntent &&
    (hasRequesterLandingSignal ||
      genericLegacyRequesterLandingMode ||
      (!noTasksAvailable &&
        !bestLandingTaskLockedForViewer &&
        bestLandingTaskIsCommunityLike));
  const legacyLandingPrimaryLabel = useMemo(() => {
    if (!landingInteractionReady) return 'Loading…';
    if (landingAuthRequired) return 'Sign in to continue';
    if (acceptedTaskForUser) return 'Resume accepted task (You accepted)';
    if (reservedOfferingForUser) return 'Resume reservation';
    if (noTasksAvailable) return 'Browse local offerings';
    return getLandingEarnTaskLabel(landingEarnAmountLabel);
  }, [
    landingInteractionReady,
    landingAuthRequired,
    noTasksAvailable,
    landingEarnAmountLabel,
    acceptedTaskForUser,
    reservedOfferingForUser,
  ]);
  const landingIntentState = useMemo(
    () => ({
      landingReady: landingInteractionReady,
      landingAuthRequired,
      acceptedTaskForUser,
      reservedOfferingForUser,
      bestLandingTask,
      landingAmountLabel: landingEarnAmountLabel,
      ownerTaskForUser,
      creatorReservedOfferings,
      creatorActiveTasks,
      requesterLandingIntent: requesterLandingMode,
      currentPlayerId,
      currentPlayerHandle,
    }),
    [
      landingInteractionReady,
      landingAuthRequired,
      acceptedTaskForUser,
      reservedOfferingForUser,
      bestLandingTask,
      landingEarnAmountLabel,
      ownerTaskForUser,
      creatorReservedOfferings,
      creatorActiveTasks,
      requesterLandingMode,
      currentPlayerId,
      currentPlayerHandle,
    ],
  );
  const landingPrimaryIntent = useMemo(
    () =>
      resolveLandingIntent(landingIntentState, {
        // Keep creator-intent phase behind a kill switch.
        enableCreatorIntent: creatorLandingIntentEnabled,
      }),
    [landingIntentState, creatorLandingIntentEnabled],
  );
  const landingPrimaryLabel = landingPrimaryIntent.label;
  useEffect(() => {
    if (process.env.NODE_ENV !== 'development') return;
    // Dev-only parity check: phase-1 baseline should match legacy behavior.
    const legacyLabel = legacyLandingPrimaryLabel;
    const legacyTarget = !landingInteractionReady
      ? { kind: 'use_locally', id: '' }
      : acceptedTaskForUser
      ? { kind: 'task', id: getTaskIntentId(acceptedTaskForUser) || '' }
      : reservedOfferingForUser
      ? { kind: 'offering', id: getOfferingIntentId(reservedOfferingForUser) || '' }
      : bestLandingTask
      ? { kind: 'task', id: getTaskIntentId(bestLandingTask) || '' }
      : { kind: 'use_locally', id: '' };
    const phase1Intent = resolveLandingIntent(
      {
        landingReady: landingInteractionReady,
        landingAuthRequired,
        acceptedTaskForUser,
        reservedOfferingForUser,
        bestLandingTask,
        landingAmountLabel: landingEarnAmountLabel,
        creatorReservedOfferings: [],
        creatorActiveTasks: [],
      },
      { enableCreatorIntent: false },
    );
    const sameLabel = legacyLabel === phase1Intent.label;
    const sameKind = legacyTarget.kind === phase1Intent.target?.kind;
    const sameId =
      String(legacyTarget.id || '') === String(phase1Intent.target?.id || '');
    if (!sameLabel || !sameKind || !sameId) {
      // eslint-disable-next-line no-console
      console.debug('[landing-intent][parity-mismatch]', {
        legacyLabel,
        legacyTarget,
        phase1Intent,
      });
    }
  }, [
    legacyLandingPrimaryLabel,
    landingInteractionReady,
    landingAuthRequired,
    acceptedTaskForUser,
    reservedOfferingForUser,
    bestLandingTask,
    landingEarnAmountLabel,
  ]);
  const showLandingSheet = useMemo(
    () =>
      shouldShowLandingSheet({
        hasResumeIntent,
        postCompletionOpen,
        selectedTask,
        selectedOffering,
        isCreateOpen,
        isTopUpOpen,
        localOpsFeedOpen,
      }),
    [
      hasResumeIntent,
      postCompletionOpen,
      selectedTask,
      selectedOffering,
      isCreateOpen,
      isTopUpOpen,
      localOpsFeedOpen,
    ],
  );
  const layersUiBlocked = localOpsFeedOpen || starterIdeasOpen;
  const createUiBlocked = showLandingSheet || layersUiBlocked;
  useEffect(() => {
    if (!showLandingSheet || !landingReady || !player?.token) return;
    const now = Date.now();
    if (now - landingBalanceRefreshRef.current < 5000) return;
    landingBalanceRefreshRef.current = now;
    refreshPlayerBalance({ forceNetwork: true });
  }, [showLandingSheet, landingReady, player?.token, refreshPlayerBalance]);
  const validateLandingEmail = useCallback((value) => {
    if (!value) return 'Email is required.';
    const re = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
    if (!re.test(value.trim())) return 'Enter a valid email address.';
    return '';
  }, []);
  const handleLandingMagicLink = useCallback(async () => {
    const validation = validateLandingEmail(landingEmail);
    setLandingEmailError(validation);
    if (validation) return;
    setLandingMagicStatus('sending');
    setLandingPrimaryBusy(true);
    try {
      const magicUrl = AUTH_BASE ? `${AUTH_BASE}/auth/magic` : '/auth/magic';
      const returnTo = buildSafePlayerMapMagicLinkReturnTo({
        pathname: location.pathname,
        search: location.search,
      });
      const res = await fetch(magicUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ email: landingEmail, returnTo }),
      });
      if (!res.ok) throw new Error('magic-link-failed');
      setLandingMagicStatus('sent');
    } catch (err) {
      setLandingMagicStatus('error');
    } finally {
      setLandingPrimaryBusy(false);
    }
  }, [landingEmail, location.pathname, location.search, validateLandingEmail]);
  const buildLandingRuntimeState = useCallback(
    (skipTypes = new Set()) => ({
      landingReady: landingInteractionReady,
      landingAuthRequired,
      acceptedTaskForUser,
      reservedOfferingForUser,
      bestLandingTask,
      landingAmountLabel: landingEarnAmountLabel,
      ownerTaskForUser,
      creatorReservedOfferings,
      creatorActiveTasks,
      requesterLandingIntent: requesterLandingMode,
      currentPlayerId,
      currentPlayerHandle,
      skipTypes,
    }),
    [
      landingInteractionReady,
      landingAuthRequired,
      acceptedTaskForUser,
      reservedOfferingForUser,
      bestLandingTask,
      landingEarnAmountLabel,
      ownerTaskForUser,
      creatorReservedOfferings,
      creatorActiveTasks,
      requesterLandingMode,
      currentPlayerId,
      currentPlayerHandle,
    ],
  );
  const resolvePrimaryLandingAction = useCallback(
    () =>
      resolveLandingPrimaryAction({
        runtimeState: buildLandingRuntimeState(),
        featureFlags: {
          enableCreatorIntent: creatorLandingIntentEnabled,
        },
        tasks,
        offerings,
        player,
      }),
    [
      buildLandingRuntimeState,
      creatorLandingIntentEnabled,
      tasks,
      offerings,
      player,
    ],
  );
  const landingPrimaryAction = useMemo(
    () => resolvePrimaryLandingAction(),
    [resolvePrimaryLandingAction],
  );
  const requesterLandingActive =
    landingPrimaryAction?.intentType === LANDING_INTENT_TYPES.REQUESTER_TASK;
  const ownerTaskIntentType = getOwnerTaskLandingIntentType(ownerTaskForUser);
  const landingReservedResumeAction = useMemo(() => {
    if (!landingInteractionReady || landingAuthRequired) return null;
    if (!reservedOfferingForUser) return null;
    if (
      landingPrimaryAction?.intentType !== LANDING_INTENT_TYPES.BEST_LANDING_TASK &&
      landingPrimaryAction?.intentType !==
        LANDING_INTENT_TYPES.OWNER_TASK_COMPLETION_NEEDED
    ) {
      return null;
    }
    return {
      type: 'select_offering',
      intentType: LANDING_INTENT_TYPES.RESERVED_OFFERING_FOR_USER,
      offering: reservedOfferingForUser,
      dismissLanding: true,
    };
  }, [
    landingInteractionReady,
    landingAuthRequired,
    reservedOfferingForUser,
    landingPrimaryAction?.intentType,
  ]);
  const landingOwnerTaskResumeAction = useMemo(() => {
    if (!landingInteractionReady || landingAuthRequired) return null;
    if (!ownerTaskForUser || !ownerTaskIntentType) return null;
    if (landingPrimaryAction?.intentType === ownerTaskIntentType) return null;
    const primaryTaskId =
      landingPrimaryAction?.type === 'select_task'
        ? getTaskIntentId(landingPrimaryAction.task)
        : null;
    const ownerTaskId = getTaskIntentId(ownerTaskForUser);
    if (primaryTaskId && ownerTaskId && primaryTaskId === ownerTaskId) return null;
    return {
      type: 'select_task',
      intentType: ownerTaskIntentType,
      task: ownerTaskForUser,
      dismissLanding: true,
      label: getOwnerTaskLandingLabel(ownerTaskForUser),
    };
  }, [
    landingInteractionReady,
    landingAuthRequired,
    ownerTaskForUser,
    ownerTaskIntentType,
    landingPrimaryAction?.intentType,
    landingPrimaryAction?.type,
    landingPrimaryAction?.task,
  ]);
  const landingAvailableTaskSecondaryAction = useMemo(() => {
    if (!landingInteractionReady || landingAuthRequired) return null;
    if (!bestLandingTask) return null;
    if (requesterLandingActive) {
      if (!bestLandingTaskIsCommunityLike) return null;
      return {
        type: 'select_task',
        intentType: LANDING_INTENT_TYPES.BEST_LANDING_TASK,
        task: bestLandingTask,
        dismissLanding: false,
        label: bestLandingTaskIsCommunityLike
          ? 'Help with Community Task'
          : 'Review local task',
      };
    }
    if (
      landingPrimaryAction?.intentType !==
      LANDING_INTENT_TYPES.OWNER_TASK_COMPLETION_NEEDED
    ) {
      return null;
    }
    const primaryTaskId =
      landingPrimaryAction?.type === 'select_task'
        ? getTaskIntentId(landingPrimaryAction.task)
        : null;
    const availableTaskId = getTaskIntentId(bestLandingTask);
    if (primaryTaskId && availableTaskId && primaryTaskId === availableTaskId) {
      return null;
    }
    return {
      type: 'select_task',
      intentType: LANDING_INTENT_TYPES.BEST_LANDING_TASK,
      task: bestLandingTask,
      dismissLanding: false,
      label: getLandingEarnTaskLabel(landingEarnAmountLabel),
    };
  }, [
    landingInteractionReady,
    landingAuthRequired,
    bestLandingTask,
    requesterLandingActive,
    bestLandingTaskIsCommunity,
    bestLandingTaskIsCommunityLike,
    landingPrimaryAction?.intentType,
    landingPrimaryAction?.type,
    landingPrimaryAction?.task,
    landingEarnAmountLabel,
  ]);
  const hasLandingStackedSecondaryAction =
    !!landingAvailableTaskSecondaryAction ||
    !!landingOwnerTaskResumeAction ||
    !!landingReservedResumeAction;
  const showStarterIdeasAffordance =
    landingInteractionReady &&
    !landingAuthRequired &&
    noTasksAvailable &&
    !acceptedTaskForUser &&
    !reservedOfferingForUser &&
    !hasLandingStackedSecondaryAction &&
    !landingAuthExpanded &&
    !requesterLandingActive;
  const landingPrimaryIsOwnerTask =
    landingPrimaryAction?.intentType ===
      LANDING_INTENT_TYPES.OWNER_TASK_COMPLETION_NEEDED ||
    landingPrimaryAction?.intentType ===
      LANDING_INTENT_TYPES.OWNER_POSTED_TASK_FOR_USER;
  const landingDisplayHeadline = useMemo(() => {
    if (landingPrimaryAction?.intentType === LANDING_INTENT_TYPES.LOADING) {
      return 'Loading LocalOps Live';
    }
    if (postCompletionContext || postCompletionOpen) return 'Earn again';
    if (requesterLandingActive) return 'Need one thing done in Camden?';
    if (
      landingPrimaryAction?.intentType ===
      LANDING_INTENT_TYPES.OWNER_TASK_COMPLETION_NEEDED
    ) {
      return 'Verify completed work';
    }
    if (
      landingPrimaryAction?.intentType ===
      LANDING_INTENT_TYPES.OWNER_POSTED_TASK_FOR_USER
    ) {
      return 'View your task';
    }
    if (
      landingPrimaryAction?.intentType ===
      LANDING_INTENT_TYPES.RESERVED_OFFERING_FOR_USER
    ) {
      return 'Resume reservation';
    }
    if (
      landingPrimaryAction?.intentType === LANDING_INTENT_TYPES.BEST_LANDING_TASK
    ) {
      return landingEarnHeadline;
    }
    if (noTasksAvailable) return 'No open tasks right now';
    return 'Choose your next step';
  }, [
    postCompletionContext,
    postCompletionOpen,
    landingPrimaryAction?.intentType,
    landingEarnHeadline,
    noTasksAvailable,
    requesterLandingActive,
  ]);
  const landingDisplaySubcopy = useMemo(() => {
    if (landingPrimaryAction?.intentType === LANDING_INTENT_TYPES.LOADING) {
      return 'Checking nearby tasks, offerings, and community work before choosing your next step.';
    }
    if (requesterLandingActive) {
      return 'Post a small local task and nearby helpers can see it. You approve payout only after the work is done right.';
    }
    if (
      landingPrimaryAction?.intentType ===
      LANDING_INTENT_TYPES.OWNER_TASK_COMPLETION_NEEDED
    ) {
      return 'A helper is waiting for your verification. Confirm completion to release payout and record the work as verified.';
    }
    if (
      landingPrimaryAction?.intentType ===
      LANDING_INTENT_TYPES.OWNER_POSTED_TASK_FOR_USER
    ) {
      return 'Review your posted task and keep local work moving.';
    }
    if (
      landingPrimaryAction?.intentType ===
      LANDING_INTENT_TYPES.RESERVED_OFFERING_FOR_USER
    ) {
      return 'Return to your reserved LocalOps item.';
    }
    if (
      landingPrimaryAction?.intentType === LANDING_INTENT_TYPES.BEST_LANDING_TASK
    ) {
      return bestLandingTaskLockedForViewer
        ? 'Review the task requirements before taking action.'
        : 'Pick a real task, complete the work, and build trust through verification.';
    }
    if (noTasksAvailable) {
      return 'Local offerings may be available nearby, or you can post a task to create new local work.';
    }
    return 'Choose a path on the local map.';
  }, [
    landingPrimaryAction?.intentType,
    bestLandingTaskLockedForViewer,
    noTasksAvailable,
    requesterLandingActive,
  ]);
  const landingRequesterProofLine = requesterLandingActive
    ? 'Camden helpers are already watching for local tasks. Pickups, deliveries, errands, and small jobs can move fast when helpers are available.'
    : null;
  useEffect(() => {
    if (!showLandingSheet || !landingInteractionReady) return;
    const landingMode = requesterLandingActive
      ? 'requester'
      : landingPrimaryAction?.intentType === LANDING_INTENT_TYPES.LOADING
      ? 'default'
      : landingPrimaryAction?.dismissLanding
      ? 'resume'
      : 'default';
    const eventKey = [
      location.search || '',
      landingMode,
      landingPrimaryAction?.intentType || '',
    ].join('|');
    if (requesterLandingShownRef.current === eventKey) return;
    requesterLandingShownRef.current = eventKey;
    const metadata = {
      landingMode,
      hasTasks: Array.isArray(tasks) && tasks.length > 0,
      hasOfferings: Array.isArray(offerings) && offerings.length > 0,
    };
    emitLandingTelemetry('localops_landing_viewed', metadata);
    if (requesterLandingActive) {
      emitLandingTelemetry('localops_landing_requester_mode_shown', metadata);
    }
    if (
      landingPrimaryAction?.intentType &&
      landingPrimaryAction.intentType !== LANDING_INTENT_TYPES.LOADING
    ) {
      const landingIntentType = landingPrimaryAction.intentType;
      emitLandingTelemetry('localops_landing_primary_action_shown', {
        ...metadata,
        landingIntentType,
        targetKind:
          landingPrimaryAction.type === 'select_task'
            ? 'task'
            : landingPrimaryAction.type === 'select_offering'
            ? 'offering'
            : landingPrimaryAction.type || 'landing_action',
        ctaId: `primary_action_${landingIntentType}`,
      });
    }
  }, [
    showLandingSheet,
    landingInteractionReady,
    requesterLandingActive,
    landingPrimaryAction?.intentType,
    landingPrimaryAction?.type,
    landingPrimaryAction?.dismissLanding,
    location.search,
    tasks,
    offerings,
    emitLandingTelemetry,
  ]);

  const executeLandingPrimaryAction = useCallback(
    (action, { closeCompletion = false } = {}) => {
      if (!action) return;

      if (action.type === 'require_auth') {
        setLandingAuthRequired(true);
        setLandingAuthExpanded(true);
        if (closeCompletion) setPostCompletionOpen(false);
        return;
      }

      if (action.type === 'select_task') {
        handleSelectTask(action.task);
        if (closeCompletion) setPostCompletionOpen(false);
        return;
      }

      if (action.type === 'select_offering') {
        handleSelectOffering(action.offering);
        if (closeCompletion) setPostCompletionOpen(false);
        return;
      }

      if (action.type === 'requester_task') {
        handleOpenRequesterTaskCreate();
        if (closeCompletion) setPostCompletionOpen(false);
        return;
      }

      handleUseLocally();
      if (closeCompletion) setPostCompletionOpen(false);
    },
    [
      handleSelectTask,
      handleSelectOffering,
      handleOpenRequesterTaskCreate,
      handleUseLocally,
    ],
  );

  const handleLandingPrimary = useCallback(() => {
    executeLandingPrimaryAction(landingPrimaryAction);
  }, [landingPrimaryAction, executeLandingPrimaryAction]);

  const handleLandingReservedResume = useCallback(() => {
    executeLandingPrimaryAction(landingReservedResumeAction);
  }, [landingReservedResumeAction, executeLandingPrimaryAction]);

  const handleLandingOwnerTaskResume = useCallback(() => {
    executeLandingPrimaryAction(landingOwnerTaskResumeAction);
  }, [landingOwnerTaskResumeAction, executeLandingPrimaryAction]);

  const handleLandingAvailableTaskSecondary = useCallback(() => {
    if (requesterLandingActive && bestLandingTaskIsCommunityLike) {
      emitLandingTelemetry('localops_landing_help_community_task_clicked', {
        landingMode: 'requester',
        landingIntentType: LANDING_INTENT_TYPES.BEST_LANDING_TASK,
        targetKind: 'community_task',
      });
    }
    executeLandingPrimaryAction(landingAvailableTaskSecondaryAction);
  }, [
    requesterLandingActive,
    bestLandingTaskIsCommunityLike,
    emitLandingTelemetry,
    landingAvailableTaskSecondaryAction,
    executeLandingPrimaryAction,
  ]);
  const handleEnterCamdenLiveFromLanding = useCallback(() => {
    emitLandingTelemetry('localops_landing_camden_live_clicked', {
      landingMode: 'requester',
    });
    history.push(CAMDEN_LIVE_ROUTES.galaxy);
  }, [emitLandingTelemetry, history]);

  const checkoutInjectedRef = useRef(false);
  const deepLinkHandledRef = useRef(false);
  const handledShareRef = useRef(null);
  const resumeHandledRef = useRef(false);
  const taskHandoffFetchesRef = useRef(new Set());
  const liveTaskHydrationFetchesRef = useRef(new Set());
  const liveTaskHydrationCacheRef = useRef(new Map());
  const findLocalOpsTaskById = useCallback(
    (targetId) => {
      if (!targetId) return null;
      const id = String(targetId);
      return (
        (Array.isArray(tasks) ? tasks : []).find(
          (item) => String(item?.taskId || item?.id || item?._id) === id,
        ) || null
      );
    },
    [tasks],
  );
  const openTaskHandoff = useCallback(
    (task) => {
      if (!task) return false;
      setSelectedOffering(null);
      setSelectedTask({
        ...task,
        __directHandoffBacked: true,
      });
      return true;
    },
    [setSelectedOffering, setSelectedTask],
  );
  const hydrateTaskHandoff = useCallback(
    async (targetId, source = 'direct') => {
      if (!targetId || !player?.token) return false;
      const id = String(targetId);
      const key = `${source}:${id}`;
      if (taskHandoffFetchesRef.current.has(key)) return false;
      taskHandoffFetchesRef.current.add(key);
      try {
        const headers = { Authorization: `Bearer ${player.token}` };
        const res = await axiosConn.get(`local-ops/tasks/${id}/state`, {
          headers,
        });
        const task = normalizeTaskPayload(res?.data);
        const taskId = String(task?.taskId || task?.id || task?._id || '');
        if (!task || (taskId && taskId !== id)) return false;
        upsertTask(task, { discoverable: task.status === 'discoverable' });
        openTaskHandoff(task);
        return true;
      } catch (err) {
        return false;
      }
    },
    [openTaskHandoff, player?.token, upsertTask],
  );
  useEffect(() => {
    if (!player?.token) return;
    const ids = pendingOpenTaskHydrationKey
      ? pendingOpenTaskHydrationKey.split('|').filter(Boolean)
      : [];
    if (!ids.length) return;
    const headers = { Authorization: `Bearer ${player.token}` };
    const markSettled = (id) => {
      setOpenTaskHydrationSettledIds((prev) => {
        if (prev.has(id)) return prev;
        const next = new Set(prev);
        next.add(id);
        return next;
      });
    };
    ids.forEach((id) => {
      const cachedTask = liveTaskHydrationCacheRef.current.get(id);
      if (cachedTask) {
        const isOpenPaid = isOpenPaidLandingTaskForViewer(cachedTask, {
          landingAmountLabel: getPlayerMapLandingTaskAmountLabel(cachedTask),
          currentPlayerId,
          currentPlayerHandle,
        });
        const shouldKeep = cachedTask.status === 'discoverable' || isOpenPaid;
        if (!shouldKeep) {
          markSettled(id);
          return;
        }
        upsertTask(cachedTask, {
          discoverable: shouldKeep,
          preserveWhenSnapshotOmitted: isOpenPaid,
        });
        markSettled(id);
        return;
      }
      if (liveTaskHydrationFetchesRef.current.has(id)) return;
      liveTaskHydrationFetchesRef.current.add(id);
      axiosConn
        .get(`local-ops/tasks/${id}/state`, { headers })
        .then((res) => {
          const task = normalizeTaskPayload(res?.data);
          const taskId = String(task?.taskId || task?.id || task?._id || '');
          if (!task || taskId !== id) {
            markSettled(id);
            return;
          }
          const isOpenPaid = isOpenPaidLandingTaskForViewer(task, {
            landingAmountLabel: getPlayerMapLandingTaskAmountLabel(task),
            currentPlayerId,
            currentPlayerHandle,
          });
          const shouldKeep = task.status === 'discoverable' || isOpenPaid;
          liveTaskHydrationCacheRef.current.set(id, task);
          if (!shouldKeep) {
            markSettled(id);
            return;
          }
          upsertTask(task, {
            discoverable: shouldKeep,
            preserveWhenSnapshotOmitted: isOpenPaid,
          });
          markSettled(id);
        })
        .catch(() => {
          markSettled(id);
        });
    });
  }, [
    currentPlayerHandle,
    currentPlayerId,
    pendingOpenTaskHydrationKey,
    player?.token,
    upsertTask,
  ]);
  const markDirectHandoffOffering = useCallback(
    (offering) =>
      offering
        ? {
            ...offering,
            __directHandoffBacked: true,
          }
        : offering,
    [],
  );

  // ResumeGate hands off continuation via location.state.resumeLocalOps (StrictMode safe)
  useEffect(() => {
    if (resumeHandledRef.current) return;
    const resume = location.state?.resumeLocalOps;
    if (!resume || !resume.share) return;

    console.log('[PlayerMap] resumeLocalOps received', resume);

    const target = parseLocalOpsShareTarget(resume.share);
    if (!target) return;
    const retainedShareFunnelContext =
      buildShareFunnelContextFromState(resume) || null;

    if (target.type === 'task') {
      const match = findLocalOpsTaskById(target.id);
      const clearResumeState = () =>
        history.replace({
          pathname: location.pathname,
          search: location.search,
          state: retainedShareFunnelContext
            ? { shareFunnelContext: retainedShareFunnelContext }
            : {},
        });

      if (match) {
        console.log('[PlayerMap] opening task from resume', target.id);
        openTaskHandoff(match);
        resumeHandledRef.current = true;
        clearResumeState();
        return;
      }

      hydrateTaskHandoff(target.id, 'resume').then((opened) => {
        if (!opened || resumeHandledRef.current) return;
        resumeHandledRef.current = true;
        clearResumeState();
      });
      return;
    }

    if (target.type === 'offering') {
      if (!offerings || offerings.length === 0) return;

      const match = offerings.find(
        (item) =>
          String(item?.offeringId || item?.id || item?._id) ===
          String(target.id),
      );

      if (!match) return;

      console.log('[PlayerMap] opening offering from resume', target.id);

      setSelectedTask(null);
      setSelectedOffering(markDirectHandoffOffering(match));
      resumeHandledRef.current = true;

      // Clear resume state to avoid re-open on refresh/back
      history.replace({
        pathname: location.pathname,
        search: location.search,
        state: retainedShareFunnelContext
          ? { shareFunnelContext: retainedShareFunnelContext }
          : {},
      });
      return;
    }

    // Unknown resume type – allow future handlers to manage it
  }, [
    findLocalOpsTaskById,
    hydrateTaskHandoff,
    history,
    location.pathname,
    location.search,
    location.state,
    markDirectHandoffOffering,
    openTaskHandoff,
    offerings,
    setSelectedOffering,
    setSelectedTask,
    tasks,
  ]);

  useEffect(() => {
    const deeplinkType = queryParams.get('type');
    const deeplinkId = queryParams.get('id');
    if (!deeplinkType || !deeplinkId || deepLinkHandledRef.current) return;
    const targetId = String(deeplinkId);
    if (deeplinkType === 'offering') {
      const match = offerings.find(
        (item) =>
          String(item?.offeringId || item?.id || item?._id) === targetId,
      );
      if (match) {
        setSelectedTask(null);
        setSelectedOffering(markDirectHandoffOffering(match));
        deepLinkHandledRef.current = true;
      }
    } else if (deeplinkType === 'task') {
      const match = findLocalOpsTaskById(targetId);
      if (match) {
        openTaskHandoff(match);
        deepLinkHandledRef.current = true;
      } else {
        hydrateTaskHandoff(targetId, 'deeplink').then((opened) => {
          if (opened) deepLinkHandledRef.current = true;
        });
      }
    }
  }, [
    findLocalOpsTaskById,
    hydrateTaskHandoff,
    queryParams,
    offerings,
    tasks,
    markDirectHandoffOffering,
    openTaskHandoff,
    setSelectedOffering,
    setSelectedTask,
  ]);

  useEffect(() => {
    const shareParam = queryParams.get('share');
    if (!shareParam) {
      handledShareRef.current = null;
      return;
    }
    if (handledShareRef.current === shareParam) return;
    const target = parseLocalOpsShareTarget(shareParam);
    if (!target?.id || !target?.type) return;
    const targetId = String(target.id);
    if (target.type === 'offering') {
      const match = offerings.find(
        (item) =>
          String(item?.offeringId || item?.id || item?._id) === targetId,
      );
      if (match) {
        handledShareRef.current = shareParam;
        setSelectedTask(null);
        setSelectedOffering(markDirectHandoffOffering(match));
      }
    } else if (target.type === 'task') {
      const match = findLocalOpsTaskById(targetId);
      if (match) {
        handledShareRef.current = shareParam;
        openTaskHandoff(match);
      } else {
        hydrateTaskHandoff(targetId, 'share').then((opened) => {
          if (opened) handledShareRef.current = shareParam;
        });
      }
    }
  }, [
    findLocalOpsTaskById,
    hydrateTaskHandoff,
    offerings,
    queryParams,
    markDirectHandoffOffering,
    openTaskHandoff,
    setSelectedOffering,
    setSelectedTask,
    tasks,
  ]);

  useEffect(() => {
    if (!shareFunnelContext) {
      shareFunnelArrivalRecordedRef.current = '';
      return;
    }
    const key = `${shareFunnelContext.shareFunnelId}:${shareFunnelContext.share}`;
    if (shareFunnelArrivalRecordedRef.current === key) return;
    shareFunnelArrivalRecordedRef.current = key;
    recordShareFunnelEvent(
      SHARE_FUNNEL_EVENT_NAMES.PLAYERMAP_ARRIVED,
      shareFunnelContext,
      {
        taskId:
          shareFunnelContext.shareType === 'task'
            ? shareFunnelContext.shareId
            : undefined,
      },
    );
  }, [shareFunnelContext]);

  useEffect(() => {
    if (!shareFunnelContext || !selectedTask) return;
    const taskId = String(
      selectedTask?.taskId || selectedTask?.id || selectedTask?._id || '',
    );
    if (!taskId || shareFunnelContext.shareId !== taskId) return;
    const key = `${shareFunnelContext.shareFunnelId}:task:${taskId}`;
    if (shareFunnelSheetRecordedRef.current.has(key)) return;
    shareFunnelSheetRecordedRef.current.add(key);
    recordShareFunnelEvent(
      SHARE_FUNNEL_EVENT_NAMES.TASK_SHEET_OPENED,
      shareFunnelContext,
      { taskId },
    );
  }, [selectedTask, shareFunnelContext]);

  useEffect(() => {
    if (!shareFunnelContext || !selectedOffering) return;
    if (shareFunnelContext.shareType !== 'offering') return;
    const offeringId = String(
      selectedOffering?.offeringId ||
        selectedOffering?.id ||
        selectedOffering?._id ||
        '',
    );
    if (!offeringId || shareFunnelContext.shareId !== offeringId) return;
    const key = `${shareFunnelContext.shareFunnelId}:offering:${offeringId}`;
    if (shareFunnelSheetRecordedRef.current.has(key)) return;
    shareFunnelSheetRecordedRef.current.add(key);
    recordShareFunnelEvent(
      SHARE_FUNNEL_EVENT_NAMES.OFFERING_SHEET_OPENED,
      shareFunnelContext,
      { stage: 'reserve' },
    );
  }, [selectedOffering, shareFunnelContext]);

  useEffect(() => {
    const handleNavigate = (event) => {
      const detail = event?.detail || {};
      const { type, id } = detail;
      if (!type || !id) return;
      if (type === 'offering') {
        const match = offerings.find(
          (item) =>
            String(item?.offeringId || item?.id || item?._id) === String(id),
        );
        if (match) {
          setSelectedTask(null);
          setSelectedOffering(match);
        }
      } else if (type === 'task') {
        const match = tasks.find(
          (item) =>
            String(item?.taskId || item?.id || item?._id) === String(id),
        );
        if (match) {
          setSelectedOffering(null);
          setSelectedTask(match);
        }
      }
    };
    window.addEventListener('localops:navigate', handleNavigate);
    return () => window.removeEventListener('localops:navigate', handleNavigate);
  }, [offerings, tasks]);

  const upsertLocalOpsOrder = useCallback((payload) => {
    const order = normalizeOrderPayload(payload);
    if (!order?.orderId) return;
    localOpsOrdersRef.current.set(order.orderId, order);
    setLocalOpsOrdersVersion((prev) => prev + 1);
  }, []);

  const replaceLocalOpsOrdersForOffering = useCallback((offeringId, orders) => {
    if (!offeringId) return;
    const id = String(offeringId);
    const next = new Map(localOpsOrdersRef.current);
    next.forEach((value, key) => {
      if (String(value?.offeringId || '') === id) {
        next.delete(key);
      }
    });
    (orders || []).forEach((order) => {
      if (order?.orderId) next.set(order.orderId, order);
    });
    localOpsOrdersRef.current = next;
    setLocalOpsOrdersVersion((prev) => prev + 1);
  }, []);

  useEffect(() => {
    if (!socket2) return;
    const handleOrderCreated = (payload) => {
      upsertLocalOpsOrder(payload);
      const order = normalizeOrderPayload(payload);
      const sellerId = order?.seller?._id || order?.seller;
      const sellerHandle = order?.seller?.playerId || null;
      const isSeller =
        (currentPlayerId &&
          sellerId &&
          String(sellerId) === String(currentPlayerId)) ||
        (currentPlayerHandle &&
          sellerHandle &&
          String(sellerHandle) === String(currentPlayerHandle));
      if (!isSeller) return;
      const buyerHandle = order?.buyer?.playerId || 'a buyer';
      const qty = Number.isFinite(order?.quantity) ? order.quantity : 1;
      const title = order?.offering?.title || 'offering';
      setLocalOpsNotice(
        `Hooray — ${buyerHandle} reserved ${qty} × ${title}`,
      );
    };
    const handleOrderUpdated = (payload) => {
      upsertLocalOpsOrder(payload);
      const order = normalizeOrderPayload(payload);
      const buyerId = order?.buyer?._id || order?.buyer;
      const buyerHandle = order?.buyer?.playerId || null;
      const isBuyer =
        (currentPlayerId &&
          buyerId &&
          String(buyerId) === String(currentPlayerId)) ||
        (currentPlayerHandle &&
          buyerHandle &&
          String(buyerHandle) === String(currentPlayerHandle));
      if (isBuyer && String(order?.status || '').toLowerCase() === 'fulfilled') {
        const sellerHandle = order?.seller?.playerId || 'seller';
        setLocalOpsNotice(
          `Order fulfilled. ${sellerHandle} has been paid.`,
        );
      }
    };
    socket2.on('localops.order.created', handleOrderCreated);
    socket2.on('localops.order.updated', handleOrderUpdated);
    return () => {
      socket2.off('localops.order.created', handleOrderCreated);
      socket2.off('localops.order.updated', handleOrderUpdated);
    };
  }, [
    socket2,
    upsertLocalOpsOrder,
    currentPlayerId,
    currentPlayerHandle,
    setLocalOpsNotice,
  ]);

  useEffect(() => {
    if (!player?.token) {
      activeOrdersHydratedForRef.current = null;
      return;
    }
    const playerKey =
      currentPlayerId ||
      currentPlayerHandle ||
      player?.data?.player?.playerId ||
      player?.playerId ||
      'authed';
    const hydrationKey = String(playerKey);
    if (activeOrdersHydratedForRef.current === hydrationKey) return;
    activeOrdersHydratedForRef.current = hydrationKey;
    let cancelled = false;
    const headers = { Authorization: `Bearer ${player.token}` };

    const run = async () => {
      try {
        const res = await axiosConn.get('local-ops/orders/active', {
          params: { limit: 24 },
          headers,
        });
        if (cancelled) return;
        normalizeLocalOpsCollection(res?.data)
          .map(normalizeOrderPayload)
          .filter(Boolean)
          .forEach((order) => upsertLocalOpsOrder(order));
      } catch (err) {
        if (cancelled) return;
        activeOrdersHydratedForRef.current = null;
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.log('[localops orders][active hydrate failed]', {
            message: err?.message || err,
          });
        }
      }
    };

    run();
    return () => {
      cancelled = true;
    };
  }, [
    player?.token,
    player?.data?.player?.playerId,
    player?.playerId,
    currentPlayerId,
    currentPlayerHandle,
    upsertLocalOpsOrder,
  ]);

  const fetchOfferingOrders = useCallback(
    async (offeringId) => {
      if (!offeringId || !player?.token) return;
      try {
        const headers = { Authorization: `Bearer ${player.token}` };
        const res = await axiosConn.get(
          `local-ops/offerings/${offeringId}/orders`,
          { headers },
        );
        const orders = normalizeLocalOpsCollection(res?.data)
          .map(normalizeOrderPayload)
          .filter(Boolean);
        replaceLocalOpsOrdersForOffering(offeringId, orders);
      } catch (err) {
        const status = err?.response?.status;
        if (status === 404) {
          handleOfferingRemoved(String(offeringId));
        } else if (status === 401 || status === 403) {
          setLocalOpsNotice(
            'Log in as the offering seller to view and fulfill orders.',
          );
        }
      }
    },
    [
      player?.token,
      replaceLocalOpsOrdersForOffering,
      handleOfferingRemoved,
      setLocalOpsNotice,
    ],
  );

  useEffect(() => {
    const offeringId =
      selectedOffering?.offeringId ||
      selectedOffering?.id ||
      selectedOffering?._id ||
      null;
    if (!offeringId) return;
    fetchOfferingOrders(offeringId);
  }, [selectedOffering, fetchOfferingOrders]);

  const selectedOfferingOrders = useMemo(() => {
    const offeringId =
      selectedOffering?.offeringId || selectedOffering?.id || selectedOffering?._id || null;
    if (!offeringId) return [];
    const id = String(offeringId);
    return Array.from(localOpsOrdersRef.current.values()).filter(
      (order) => String(order?.offeringId || '') === id,
    );
  }, [selectedOffering, localOpsOrdersVersion]);

  const selectedOfferingOrder = useMemo(() => {
    if (!selectedOfferingOrders.length) return null;
    return (
      selectedOfferingOrders.find((order) => {
        const buyerId = order?.buyer?._id || order?.buyer;
        const buyerHandle = order?.buyer?.playerId || null;
        return (
          (currentPlayerId &&
            buyerId &&
            String(buyerId) === String(currentPlayerId)) ||
          (currentPlayerHandle &&
            buyerHandle &&
            String(buyerHandle) === String(currentPlayerHandle))
        );
      }) || null
    );
  }, [selectedOfferingOrders, currentPlayerId, currentPlayerHandle]);
  const buyerOrderHydratedOfferingIdsRef = useRef(new Set());
  useEffect(() => {
    buyerOrderHydratedOfferingIdsRef.current = new Set();
  }, [currentPlayerId, currentPlayerHandle]);
  useEffect(() => {
    if (!player?.token) return;
    if (reservedOrderForUser) return;
    if (!landingOfferingIds.length) return;
    const pending = landingOfferingIds.filter(
      (id) => !buyerOrderHydratedOfferingIdsRef.current.has(String(id)),
    );
    if (!pending.length) return;
    let cancelled = false;
    const headers = { Authorization: `Bearer ${player.token}` };

    // Buyer-side order hydration: discover existing reserved obligations from visible offerings.
    const run = async () => {
      for (const rawId of pending.slice(0, 24)) {
        if (cancelled) return;
        const offeringId = String(rawId);
        buyerOrderHydratedOfferingIdsRef.current.add(offeringId);
        try {
          const res = await axiosConn.get(
            `local-ops/offerings/${offeringId}/orders`,
            { headers },
          );
          const orders = normalizeLocalOpsCollection(res?.data)
            .map(normalizeOrderPayload)
            .filter(Boolean);
          replaceLocalOpsOrdersForOffering(offeringId, orders);
        } catch (err) {
          const status = err?.response?.status;
          if (status === 404) {
            handleOfferingRemoved(offeringId);
          }
        }
      }
    };

    run();
    return () => {
      cancelled = true;
    };
  }, [
    player?.token,
    reservedOrderForUser,
    landingOfferingIds,
    replaceLocalOpsOrdersForOffering,
    handleOfferingRemoved,
  ]);
  const creatorOrderHydratedOfferingIdsRef = useRef(new Set());
  useEffect(() => {
    creatorOrderHydratedOfferingIdsRef.current = new Set();
  }, [currentPlayerId, currentPlayerHandle, creatorLandingIntentEnabled]);
  useEffect(() => {
    if (!creatorLandingIntentEnabled || !player?.token) return;
    if (!creatorOwnedOfferingIds.length) return;
    const pending = creatorOwnedOfferingIds.filter(
      (id) => !creatorOrderHydratedOfferingIdsRef.current.has(String(id)),
    );
    if (!pending.length) return;
    let cancelled = false;
    const headers = { Authorization: `Bearer ${player.token}` };

    // Hydrate seller order snapshots for creator-owned offerings so landing intent
    // can detect reserved/unfulfilled obligations after direct nav or refresh.
    const run = async () => {
      for (const rawId of pending.slice(0, 16)) {
        if (cancelled) return;
        const offeringId = String(rawId);
        creatorOrderHydratedOfferingIdsRef.current.add(offeringId);
        try {
          const res = await axiosConn.get(
            `local-ops/offerings/${offeringId}/orders`,
            { headers },
          );
          const orders = normalizeLocalOpsCollection(res?.data)
            .map(normalizeOrderPayload)
            .filter(Boolean);
          replaceLocalOpsOrdersForOffering(offeringId, orders);
        } catch (err) {
          const status = err?.response?.status;
          if (status === 404) {
            handleOfferingRemoved(offeringId);
          }
          // 401/403/noise intentionally ignored here; hydration is best-effort.
        }
      }
    };

    run();
    return () => {
      cancelled = true;
    };
  }, [
    creatorLandingIntentEnabled,
    creatorOwnedOfferingIds,
    player?.token,
    replaceLocalOpsOrdersForOffering,
    handleOfferingRemoved,
  ]);

  const offeringSignatureRef = useRef({});
  useEffect(() => {
    if (!selectedOffering) return;
    const id =
      selectedOffering?.offeringId ||
      selectedOffering?.id ||
      selectedOffering?._id ||
      null;
    if (!id) return;
    const next = Array.isArray(offerings)
      ? offerings.find(
          (item) =>
            String(item?.offeringId || item?.id || item?._id || '') ===
            String(id),
        )
      : null;
    if (next) {
      const nextUpdated = next?.updatedAt || next?.createdAt;
      const nextTs = nextUpdated ? new Date(nextUpdated).getTime() : null;
      const signature = [
        nextTs ?? 'n',
        next?.quantityAvailable ?? 'na',
        next?.isOutOfStock ?? 'na',
        next?.status ?? 'na',
        next?.availableUnits ?? 'na',
      ].join('|');
      const lastSig = offeringSignatureRef.current[id];
      if (signature === lastSig) return;
      offeringSignatureRef.current[id] = signature;
      setSelectedOffering((prev) => {
        const merged = { ...(prev || {}), ...next };
        if (
          typeof merged.quantityAvailable !== 'number' &&
          typeof (prev || {}).quantityAvailable === 'number'
        ) {
          merged.quantityAvailable = prev.quantityAvailable;
        }
        return merged;
      });
    } else {
      // Keep order-backed landing targets visible even when not in the live snapshot.
      if (
        selectedOffering?.__landingOrderBacked ||
        selectedOffering?.__directHandoffBacked
      ) {
        return;
      }
      setSelectedOffering(null);
      setLocalOpsNotice('This offering is no longer available.');
    }
  }, [offerings, selectedOffering, setLocalOpsNotice]);

  useEffect(() => {
    if (!selectedTask) return;
    const id = selectedTask?.taskId || selectedTask?.id || selectedTask?._id;
    if (!id) return;
    const next = Array.isArray(tasks)
      ? tasks.find(
          (item) =>
            String(item?.taskId || item?.id || item?._id || '') ===
            String(id),
        )
      : null;
    if (next) {
      const prevTs = getTaskFreshnessTimestamp(selectedTask);
      const nextTs = getTaskFreshnessTimestamp(next);
      if (
        Number.isFinite(prevTs) &&
        Number.isFinite(nextTs) &&
        nextTs < prevTs
      ) {
        return;
      }
      const prevUpdated = selectedTask?.updatedAt || selectedTask?.createdAt;
      const nextUpdated = next?.updatedAt || next?.createdAt;
      const statusChanged = selectedTask?.status !== next?.status;
      if (
        String(
          selectedTask?.taskId || selectedTask?.id || selectedTask?._id || '',
        ) === String(id) &&
        (prevUpdated !== nextUpdated || statusChanged)
      ) {
        setSelectedTask((prev) => mergeTaskPrivateContext(prev, next));
      }
    } else if (!selectedTask?.__directHandoffBacked) {
      setSelectedTask(null);
      setLocalOpsNotice('This task is no longer available.');
    }
  }, [tasks, selectedTask, setLocalOpsNotice]);
  const handleSelectLiveEvent = useCallback(
    (event) => {
      const target = parseLocalOpsShareTarget(event?.shareUrl);
      if (!target?.id || !target?.type) return false;
      if (target.type === 'offering') {
        const match = Array.isArray(offerings)
          ? offerings.find(
              (item) =>
                String(item?.offeringId || item?.id || item?._id) ===
                String(target.id),
            )
          : null;
        if (match) {
          setSelectedTask(null);
          setSelectedOffering(match);
          handleCloseFeed();
          return true;
        }
      }
      if (target.type === 'task') {
        const match = Array.isArray(tasks)
          ? tasks.find(
              (item) =>
                String(item?.taskId || item?.id || item?._id) ===
                String(target.id),
            )
          : null;
        if (match) {
          setSelectedOffering(null);
          setSelectedTask(match);
          handleCloseFeed();
          return true;
        }
      }
      handleCloseFeed();
      if (event?.isDurable === true && event?.shareUrl) {
        return false;
      }
      setLocalOpsNotice('Item not in current map view.');
      return true;
    },
    [offerings, tasks, handleCloseFeed, setLocalOpsNotice],
  );
  const visibleFeedEvents = useMemo(
    () => {
      const seed = Array.isArray(localOpsSeedEvents)
        ? localOpsSeedEvents
        : [];
      const live = Array.isArray(localOpsLiveEvents)
        ? localOpsLiveEvents
        : [];
      const recent = Array.isArray(localOpsRecentEvents)
        ? localOpsRecentEvents
        : [];
      const merged = [...recent, ...seed, ...live]
        .filter(Boolean)
        .filter((event) => {
          if (event?.isDurable === true) return true;
          const target = parseLocalOpsShareTarget(event?.shareUrl);
          if (!target?.id || !target?.type) return true;
          if (target.type === 'offering') {
            return Array.isArray(offerings)
              ? offerings.some(
                  (item) =>
                    String(item?.offeringId || item?.id || item?._id || '') ===
                    String(target.id),
                )
              : true;
          }
          if (target.type === 'task') {
            return Array.isArray(tasks)
              ? tasks.some(
                  (item) =>
                    String(item?.taskId || item?.id || item?._id || '') ===
                    String(target.id),
                )
              : true;
          }
          return true;
        });
      if (!merged.length) return [];
      const seen = new Set();
      return merged
        .sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0))
        .filter((event) => {
          const target = parseLocalOpsShareTarget(event?.shareUrl);
          const dedupeKey =
            event?.dedupeKey ||
            buildLocalOpsFeedDedupeKey({
              entityType: event?.entityType || target?.type,
              eventType: event?.eventType || event?.type?.split?.('.')?.[1],
              entityId: event?.entityId || target?.id,
              shareUrl: event?.shareUrl,
              type: event?.type,
            }) ||
            event?.id;
          if (!dedupeKey) return true;
          if (seen.has(dedupeKey)) return false;
          seen.add(dedupeKey);
          return true;
        })
        .slice(0, LOCALOPS_LIVE_FEED_CAP);
    },
    [localOpsRecentEvents, localOpsSeedEvents, localOpsLiveEvents, offerings, tasks],
  );
  const updateTaskPublicDetailsRemote = useCallback(
    async (task, updates) => {
      if (!task) return null;
      const id = task.taskId || task.id || task._id;
      if (!id) return null;
      if (!player?.token) {
        setLocalOpsNotice('Log in to update this task.');
        return null;
      }
      try {
        const headers = { Authorization: `Bearer ${player.token}` };
        const res = await axiosConn.patch(
          `local-ops/tasks/${id}/public-details`,
          updates,
          { headers },
        );
        const updated = normalizeTaskPayload(res?.data);
        if (updated) {
          upsertTask(updated, { discoverable: updated.status === 'discoverable' });
          setSelectedTask((prev) => {
            const prevId = prev?.taskId || prev?.id || prev?._id || null;
            return prevId && String(prevId) === String(id) ? updated : prev;
          });
        }
        setLocalOpsNotice('Task updated.');
        return updated;
      } catch (err) {
        const message =
          err?.response?.data?.message || 'Unable to update task right now.';
        setLocalOpsError(message);
        throw err;
      }
    },
    [player?.token, setLocalOpsError, setLocalOpsNotice, upsertTask],
  );

  const updateOfferingPublicDetailsRemote = useCallback(
    async (offering, updates) => {
      if (!offering) return null;
      const id = offering.offeringId || offering.id || offering._id;
      if (!id) return null;
      if (!player?.token) {
        setLocalOpsNotice('Log in to update this offering.');
        return null;
      }
      try {
        const headers = { Authorization: `Bearer ${player.token}` };
        const res = await axiosConn.patch(
          `local-ops/offerings/${id}/public-details`,
          updates,
          { headers },
        );
        const updated = normalizeOfferingPayload(res?.data);
        if (updated) {
          upsertOffering(updated);
          setSelectedOffering((prev) => {
            const prevId =
              prev?.offeringId || prev?.id || prev?._id || null;
            return prevId && String(prevId) === String(id) ? updated : prev;
          });
        }
        setLocalOpsNotice('Offering updated.');
        return updated;
      } catch (err) {
        const message =
          err?.response?.data?.message ||
          'Unable to update offering right now.';
        setLocalOpsError(message);
        throw err;
      }
    },
    [player?.token, setLocalOpsError, setLocalOpsNotice, upsertOffering],
  );

  const updateOfferingRemote = useCallback(
    async (offering, updates, successMessage) => {
      if (!offering) return null;
      const id = offering.offeringId || offering.id || offering._id;
      if (!id) return null;
      if (!player?.token) {
        setLocalOpsNotice('Log in to update this offering.');
        return null;
      }
      try {
        const headers = { Authorization: `Bearer ${player.token}` };
        const res = await axiosConn.patch(
          `local-ops/offerings/${id}`,
          updates,
          { headers },
        );
        const updated = normalizeOfferingPayload(res?.data);
        if (updated) {
          upsertOffering(updated);
          setSelectedOffering((prev) => {
            const prevId =
              prev?.offeringId || prev?.id || prev?._id || null;
            if (prevId && String(prevId) === String(id)) {
              return updated;
            }
            return prev;
          });
        }
        if (successMessage) {
          setLocalOpsNotice(successMessage);
        }
        return updated;
      } catch (err) {
        setLocalOpsError('Unable to update offering right now.');
        return null;
      }
    },
    [player?.token, upsertOffering, setLocalOpsNotice, setLocalOpsError],
  );

  const handleEditOffering = useCallback(
    (offering) => {
      if (!offering) return;
      setPublicDetailsEditTarget({ type: 'offering', item: offering });
    },
    [],
  );

  const handleEditTask = useCallback(
    async (task) => {
      if (!task) return;
      const id = task.taskId || task.id || task._id;
      if (id && player?.token) {
        try {
          const headers = { Authorization: `Bearer ${player.token}` };
          const res = await axiosConn.get(`local-ops/tasks/${id}/state`, {
            headers,
          });
          const authoritativeTask = normalizeTaskPayload(res?.data);
          if (authoritativeTask) {
            setPublicDetailsEditTarget({
              type: 'task',
              item: mergeTaskPrivateContext(task, authoritativeTask),
            });
            return;
          }
        } catch (err) {
          // Fall back to the selected task; the backend save endpoint remains authoritative.
        }
      }
      setPublicDetailsEditTarget({ type: 'task', item: task });
    },
    [player?.token],
  );

  const handleClosePublicDetailsEdit = useCallback(() => {
    setPublicDetailsEditTarget(null);
  }, []);

  const handleSavePublicDetailsEdit = useCallback(
    async (updates) => {
      const target = publicDetailsEditTarget;
      if (!target?.item || !target?.type) return null;
      if (target.type === 'task') {
        return updateTaskPublicDetailsRemote(target.item, updates);
      }
      return updateOfferingPublicDetailsRemote(target.item, updates);
    },
    [
      publicDetailsEditTarget,
      updateOfferingPublicDetailsRemote,
      updateTaskPublicDetailsRemote,
    ],
  );

  const handleEditOfferingInventory = useCallback(
    async (offering) => {
      if (!offering) return;
      if (!player?.token) {
        setLocalOpsNotice('Log in to update this offering.');
        return;
      }
      const currentQuantity = getOfferingQuantityValue(offering);
      const promptValue =
        typeof window === 'undefined'
          ? null
          : window.prompt(
              'Update available inventory (leave blank for unlimited)',
              Number.isFinite(currentQuantity) ? String(currentQuantity) : '',
            );
      if (promptValue === null) return;
      const trimmed = String(promptValue).trim();
      let nextQuantity = null;
      if (trimmed.length) {
        const parsed = Number(trimmed);
        if (!Number.isFinite(parsed) || parsed < 0 || !Number.isInteger(parsed)) {
          setLocalOpsError('Inventory must be a whole number.');
          return;
        }
        nextQuantity = parsed;
      }
      await updateOfferingRemote(
        offering,
        { quantityAvailable: nextQuantity },
        'Inventory updated.',
      );
    },
    [player?.token, updateOfferingRemote, setLocalOpsError, setLocalOpsNotice],
  );

  const handlePauseOffering = useCallback(
    async (offering) => {
      if (!offering) return;
      const nextPaused = !offering.isPaused;
      await updateOfferingRemote(
        offering,
        { isPaused: nextPaused },
        nextPaused ? 'Offering paused.' : 'Offering resumed.',
      );
    },
    [updateOfferingRemote],
  );
  const handleRemoveOffering = useCallback(
    async (offering) => {
      if (!offering) return;
      const id = offering.offeringId || offering.id || offering._id;
      if (!id) return;
      if (!player?.token) {
        setLocalOpsNotice('Log in to remove this offering.');
        return;
      }
      try {
        const headers = { Authorization: `Bearer ${player.token}` };
        await axiosConn.delete(`local-ops/offerings/${id}`, { headers });
        removeOffering(id);
        setSelectedOffering(null);
        setLocalOpsNotice('Offering removed.');
      } catch (err) {
        setLocalOpsError('Unable to remove offering right now.');
      }
    },
    [player?.token, removeOffering],
  );
  const handleCancelTask = useCallback(
    async (task) => {
      if (!task) return;
      const id = task.taskId || task.id || task._id;
      if (!id) return;
      if (!player?.token) {
        setLocalOpsNotice('Log in to remove this task.');
        return;
      }
      try {
        const headers = { Authorization: `Bearer ${player.token}` };
        const res = await axiosConn.post(
          `local-ops/tasks/${id}/cancel`,
          {},
          { headers },
        );
        const updated = normalizeTaskPayload(res?.data);
        if (updated) {
          upsertTask(updated);
        }
        removeTask(id);
        setSelectedTask(null);
        setLocalOpsNotice('Task removed.');
      } catch (err) {
        setLocalOpsError('Unable to remove task right now.');
      }
    },
    [player?.token, upsertTask, removeTask],
  );
  const handleReopenTask = useCallback(
    async (task) => {
      if (!task) return;
      const id = task.taskId || task.id || task._id;
      if (!id) return;
      if (!player?.token) {
        setLocalOpsNotice('Log in to reopen this task.');
        return;
      }
      try {
        const headers = { Authorization: `Bearer ${player.token}` };
        const res = await axiosConn.post(
          `local-ops/tasks/${id}/reopen`,
          { reason: 'requester_reopened_before_start' },
          { headers },
        );
        const updated = normalizeTaskPayload(res?.data);
        if (updated) {
          upsertTask(updated);
          setSelectedTask(updated);
        }
        setLocalOpsNotice(
          'Task reopened. Nearby helpers are being notified again.',
        );
      } catch (err) {
        const message =
          err?.response?.data?.message ||
          'Unable to reopen task right now.';
        setLocalOpsError(message);
      }
    },
    [player?.token, upsertTask],
  );
  const handleRenotifyHelpers = useCallback(
    async (task) => {
      if (!task) return;
      const id = task.taskId || task.id || task._id;
      if (!id) return;
      if (!player?.token) {
        setLocalOpsNotice('Log in to notify helpers again.');
        return;
      }
      try {
        const headers = { Authorization: `Bearer ${player.token}` };
        const res = await axiosConn.post(
          `local-ops/tasks/${id}/renotify-helpers`,
          {},
          { headers },
        );
        const updated = normalizeTaskPayload(res?.data);
        if (updated) {
          upsertTask(updated);
          setSelectedTask(updated);
        }
        const status = res?.data?.status || res?.data?.ownerReNotify?.status;
        const message =
          res?.data?.message ||
          (status === 'no_eligible_helpers'
            ? 'No eligible local helpers were available to notify right now.'
            : 'Local helpers were notified again.');
        setLocalOpsNotice(message);
      } catch (err) {
        const status = err?.response?.data?.status;
        const message =
          err?.response?.data?.message ||
          (status === 'rate_limited'
            ? 'Helpers were notified recently. Try again later.'
            : 'Could not notify helpers right now.');
        setLocalOpsError(message);
      }
    },
    [player?.token, upsertTask],
  );
  const handleRaisePayAndRenotify = useCallback(
    async (taskOrRequest, options = {}) => {
      const baseRequest =
        taskOrRequest && typeof taskOrRequest === 'object'
          ? taskOrRequest
          : {};
      const request = {
        ...baseRequest,
        ...(options || {}),
      };
      const id =
        request.taskId ||
        request.id ||
        request._id ||
        request.task?.taskId ||
        request.task?.id ||
        request.task?._id;
      const newPriceUsd = Number(
        request.newPriceUsd ?? request.newPrice ?? request.priceUsd,
      );
      const idempotencyKey =
        String(request.idempotencyKey || '').trim() || makePendingIntentId();
      const makeRequestPayload = () => ({
        taskId: id,
        newPriceUsd,
        idempotencyKey,
      });

      if (!id || !Number.isFinite(newPriceUsd) || newPriceUsd <= 0) {
        const message = getRaisePayTerminalMessage('invalid_amount');
        setLocalOpsError(message);
        return {
          ok: false,
          terminal: true,
          status: 'invalid_amount',
          message,
        };
      }
      if (!player?.token) {
        const error = new Error('Log in to raise task pay.');
        if (options?.replay) throw error;
        setLocalOpsNotice(error.message);
        return {
          ok: false,
          terminal: false,
          status: 'auth_required',
          message: error.message,
        };
      }

      try {
        const headers = { Authorization: `Bearer ${player.token}` };
        const res = await axiosConn.post(
          `local-ops/tasks/${id}/raise-pay-and-renotify`,
          {
            newPriceUsd,
            idempotencyKey,
          },
          { headers },
        );
        const payload = res?.data || {};
        const updated = normalizeTaskPayload(
          payload?.data || payload?.task || payload,
        );
        if (updated) {
          upsertTask(updated);
          setSelectedTask((prev) => mergeTaskPrivateContext(prev, updated));
        }
        const status = normalizeRaisePayStatus(
          payload.status ||
            payload.raisePay?.status ||
            payload.data?.localOpsSupplyProof?.raisePay?.status,
          payload.success === true ? 'sent' : '',
        );
        const message = getRaisePayTerminalMessage(status, payload.message);
        setLocalOpsNotice(message);
        return {
          ok: payload.success !== false,
          terminal: true,
          status: status || 'sent',
          message,
          task: updated || payload.data || null,
        };
      } catch (err) {
        const payload = err?.response?.data || {};
        if (payload?.code === 'INSUFFICIENT_JGK') {
          handleLocalOpsInsufficient({
            actionType: RAISE_PAY_PENDING_INTENT_TYPE,
            request: makeRequestPayload(),
            topUp: payload,
            uiContext: {
              surface: 'localops_task_detail_sheet',
              taskId: id,
            },
            requiredJGK: payload?.neededJGK,
          });
          const message =
            payload?.message ||
            'Top up to raise task pay. We will finish this automatically.';
          setLocalOpsNotice(message);
          return {
            ok: false,
            terminal: false,
            requiresFunding: true,
            status: 'INSUFFICIENT_JGK',
            message,
            request: makeRequestPayload(),
          };
        }

        const responseStatus = Number(err?.response?.status);
        const backendStatus = normalizeRaisePayStatus(
          payload.status || payload.raisePay?.status || payload.code,
        );
        const terminalStatus =
          backendStatus ||
          (responseStatus === 400
            ? 'invalid_amount'
            : responseStatus === 409
            ? 'stale_state'
            : '');
        if (
          RAISE_PAY_HANDLED_TERMINAL_STATUSES.has(terminalStatus) ||
          responseStatus === 400 ||
          responseStatus === 409
        ) {
          const message = getRaisePayTerminalMessage(
            terminalStatus,
            payload.message,
          );
          setLocalOpsError(message);
          return {
            ok: false,
            terminal: true,
            status: terminalStatus || 'stale_state',
            message,
          };
        }

        const message =
          payload?.message || 'Unable to raise task pay right now.';
        setLocalOpsError(message);
        throw new Error(message);
      }
    },
    [
      handleLocalOpsInsufficient,
      player?.token,
      setLocalOpsNotice,
      upsertTask,
    ],
  );
  const handleReleaseTask = useCallback(
    async (task) => {
      if (!task) return;
      const id = task.taskId || task.id || task._id;
      if (!id) return;
      if (!player?.token) {
        setLocalOpsNotice('Log in to release this task.');
        return;
      }
      try {
        const headers = { Authorization: `Bearer ${player.token}` };
        const res = await axiosConn.post(
          `local-ops/tasks/${id}/release`,
          { reason: 'helper_cannot_complete' },
          { headers },
        );
        const updated = normalizeTaskPayload(res?.data);
        if (updated) {
          upsertTask(updated);
          setSelectedTask(updated);
        }
        setLocalOpsNotice(
          'Task released. The requester has been notified and the task is available again.',
        );
      } catch (err) {
        const message =
          err?.response?.data?.message ||
          'Unable to release task right now.';
        setLocalOpsError(message);
      }
    },
    [player?.token, upsertTask],
  );
  const handleMarkOfferingAvailability = useCallback(
    async (offering) => {
      if (!offering) return;
      const offeringType =
        offering.offeringType || offering.type || offering?.meta?.offeringType;
      const isService = offeringType === 'service';
      const flagKey = isService ? 'isBooked' : 'isOutOfStock';
      const nextValue = !offering[flagKey];
      const notice = isService
        ? nextValue
          ? 'Marked booked.'
          : 'Marked available.'
        : nextValue
        ? 'Marked out of stock.'
        : 'Marked in stock.';
      await updateOfferingRemote(offering, { [flagKey]: nextValue }, notice);
    },
    [updateOfferingRemote],
  );
  const combinedPresenceMap = useMemo(() => {
    if (!presencePlusMap) return presenceMap || {};
    const merged = { ...(presenceMap || {}) };
    Object.entries(presencePlusMap).forEach(([key, entry]) => {
      merged[key] = { ...(merged[key] || {}), ...(entry || {}) };
    });
    return merged;
  }, [presenceMap, presencePlusMap]);
  const presenceIndex = useMemo(
    () => buildPresenceIndex(combinedPresenceMap || {}),
    [combinedPresenceMap],
  );
  const presenceSelf = useMemo(() => {
    if (!playerId) return null;
    return (
      presencePlusMap?.[playerId] ||
      presenceIndex.get(playerId) ||
      null
    );
  }, [playerId, presencePlusMap, presenceIndex]);
  useEffect(() => {
    presenceIndexRef.current = presenceIndex;
  }, [presenceIndex]);
  useEffect(() => {
    const rawFriends = Array.isArray(player?.data?.player?.friends)
      ? player.data.player.friends
      : [];
    const friendIds = [];
    rawFriends.forEach((friend) => {
      if (!friend) return;
      if (typeof friend === 'string') {
        friendIds.push(friend);
        return;
      }
      const id =
        friend?._id ||
        friend?.mongoId ||
        friend?.id ||
        friend?.playerId;
      if (!id) return;
      friendIds.push(id);
      if (!friendProfileCacheRef.current.get(id)) {
        friendProfileCacheRef.current.set(id, friend);
      }
    });

    if (!friendIds.length) {
      setFriendProfiles([]);
      return;
    }

    const syncList = () =>
      friendIds
        .map((id) => friendProfileCacheRef.current.get(id))
        .filter(Boolean);

    if (!player?.token) {
      setFriendProfiles(syncList());
      return;
    }

    let active = true;
    const missing = friendIds.filter(
      (id) =>
        !friendProfileCacheRef.current.get(id) &&
        !friendProfilePendingRef.current.has(id),
    );
    if (!missing.length) {
      setFriendProfiles(syncList());
      return;
    }

    Promise.allSettled(
      missing.map(async (id) => {
        friendProfilePendingRef.current.add(id);
        try {
          const res = await axiosConn.get(`players/${id}`, {
            headers: { Authorization: `Bearer ${player.token}` },
          });
          const profile = res?.data?.data?.data || res?.data?.data || res?.data;
          if (profile) {
            friendProfileCacheRef.current.set(id, profile);
          }
        } catch (err) {
          // ignore friend lookup failures
        } finally {
          friendProfilePendingRef.current.delete(id);
        }
      }),
    ).then(() => {
      if (!active) return;
      setFriendProfiles(syncList());
    });

    return () => {
      active = false;
    };
  }, [player?.data?.player?.friends, player?.token]);
  const friendOptions = useMemo(() => {
    return friendProfiles
      .map((friend) => {
        const id =
          friend?._id || friend?.mongoId || friend?.id || friend?.playerId;
        if (!id) return null;
        const presence =
          presenceIndex.get(id) ||
          (friend?.playerId ? presenceIndex.get(friend.playerId) : null);
        const playerIdValue =
          friend?.playerId || friend?.handle || friend?.username || '';
        const displayName =
          friend?.displayName ||
          friend?.fullName ||
          friend?.name ||
          '';
        const label = playerIdValue || displayName || 'JG Player';
        const photo =
          presence?.profilePhoto ||
          friend?.profilePhoto ||
          friend?.profileImg ||
          friend?.avatar ||
          friend?.profilePicture ||
          null;
        const presenceState =
          presence?.availabilityState || presence?.status || null;
        return {
          id,
          label,
          playerId: playerIdValue,
          displayName,
          photo,
          presence: presenceState,
        };
      })
      .filter(Boolean);
  }, [friendProfiles, presenceIndex]);
  const offeringsCenter = useMemo(
    () =>
      travelMode
        ? mapCenter || localOpsCenter || regionBrowseCenter
        : localOpsCenter || regionBrowseCenter,
    [travelMode, mapCenter, localOpsCenter, regionBrowseCenter],
  );
  const tasksCenter = useMemo(
    () =>
      travelMode
        ? mapCenter || localOpsCenter || regionBrowseCenter
        : localOpsCenter || regionBrowseCenter,
    [travelMode, mapCenter, localOpsCenter, regionBrowseCenter],
  );
  const discoveryCenter = useMemo(() => {
    if (travelMode) {
      return (
        mapCenter ||
        localOpsCenter ||
        storedLocation ||
        regionBrowseCenter ||
        storedViewport ||
        null
      );
    }
    return (
      localOpsCenter ||
      storedLocation ||
      regionBrowseCenter ||
      storedViewport ||
      null
    );
  }, [
    travelMode,
    mapCenter,
    localOpsCenter,
    storedViewport,
    storedLocation,
    regionBrowseCenter,
  ]);

  useEffect(() => {
    if (!socket2 || !localOpsFlags.base) return;
    const isNearby = (payload) => {
      if (!discoveryCenter || !discoveryRadiusMeters) return true;
      const coords = normalizeCoordinates(payload);
      if (!coords) return false;
      const distance = getDistanceFromLatLonInMeters(
        discoveryCenter.lat,
        discoveryCenter.lon,
        coords[1],
        coords[0],
      );
      return distance <= discoveryRadiusMeters * 1.05;
    };
    const handleOfferingCreatedToast = (payload) => {
      const ownerHandle =
        payload?.owner?.playerId ||
        payload?.playerId ||
        payload?.creator?.playerId;
      const isOwner =
        currentPlayerHandle &&
        ownerHandle &&
        String(currentPlayerHandle) === String(ownerHandle);
      if (!isOwner && !isNearby(payload)) return;
      const regionLabel = payload?.regionLabel || 'nearby';
      const title = payload?.title || payload?.name || 'Offering';
      setLocalOpsNotice(
        `New LocalOps offering: ${title} · ${regionLabel}`,
      );
    };
    const handleTaskCreatedToast = (payload) => {
      const ownerHandle =
        payload?.creator?.playerId ||
        payload?.playerId ||
        payload?.owner?.playerId;
      const isOwner =
        currentPlayerHandle &&
        ownerHandle &&
        String(currentPlayerHandle) === String(ownerHandle);
      const hasLocation =
        payload?.originLocation?.coordinates ||
        payload?.location?.coordinates ||
        payload?.destinationLocation?.coordinates;
      if (!isOwner && hasLocation && !isNearby(payload)) return;
      const regionLabel = payload?.regionLabel || 'nearby';
      const title = payload?.title || payload?.name || 'Task';
      setLocalOpsNotice(`New LocalOps task: ${title} · ${regionLabel}`);
    };
    socket2.on('localops.offering.created', handleOfferingCreatedToast);
    socket2.on('localops.task.created', handleTaskCreatedToast);
    return () => {
      socket2.off('localops.offering.created', handleOfferingCreatedToast);
      socket2.off('localops.task.created', handleTaskCreatedToast);
    };
  }, [
    socket2,
    localOpsFlags.base,
    discoveryCenter,
    discoveryRadiusMeters,
    currentPlayerHandle,
    setLocalOpsNotice,
  ]);
  const layerCounts = useMemo(() => {
    const markerLimit = mobileView
      ? LOCALOPS_MAX_MARKERS_MOBILE
      : LOCALOPS_MAX_MARKERS_DESKTOP;
    const playersCount = effectiveLayers.players
      ? Object.keys(playersWithin).length
      : 0;
    const postsCount = effectiveLayers.posts ? postItems.length : 0;
    let offeringsCount = 0;
    if (
      effectiveLayers.offerings &&
      Array.isArray(offerings) &&
      offerings.length
    ) {
      offerings.forEach((offering) => {
        const coordinates = normalizeCoordinates(offering);
        if (!coordinates) return;
        if (offeringsCenter && discoveryRadiusMeters) {
          const distance = getDistanceFromLatLonInMeters(
            offeringsCenter.lat,
            offeringsCenter.lon,
            coordinates[1],
            coordinates[0],
          );
          if (distance > discoveryRadiusMeters) return;
        }
        offeringsCount += 1;
      });
    }
    let tasksCount = 0;
    if (effectiveLayers.tasks && Array.isArray(tasks) && tasks.length) {
      tasks.forEach((task) => {
        const coordinates = normalizeCoordinates(task);
        if (!coordinates) return;
        if (tasksCenter && discoveryRadiusMeters) {
          const distance = getDistanceFromLatLonInMeters(
            tasksCenter.lat,
            tasksCenter.lon,
            coordinates[1],
            coordinates[0],
          );
          if (distance > discoveryRadiusMeters) return;
        }
        if (task.presenceFiltered || task.requireAvailability) {
          const ownerId =
            task.ownerId ||
            task.playerId ||
            task.requesterId ||
            task.createdBy;
          const presenceEntry = ownerId ? presenceIndex.get(ownerId) : null;
          if (
            task.requireAvailability &&
            presenceEntry?.availabilityState &&
            presenceEntry.availabilityState !== task.requireAvailability
          ) {
            return;
          }
          if (
            task.presenceFiltered &&
            presenceEntry?.availabilityState === 'busy'
          ) {
            return;
          }
        }
        tasksCount += 1;
      });
    }
    return {
      players: playersCount,
      posts: postsCount,
      offerings: Math.min(offeringsCount, markerLimit),
      tasks: Math.min(tasksCount, markerLimit),
    };
  }, [
    mobileView,
    effectiveLayers,
    playersWithin,
    postItems,
    offerings,
    tasks,
    offeringsCenter,
    tasksCenter,
    discoveryRadiusMeters,
    presenceIndex,
  ]);
  const showDiscoveryEmpty = useMemo(() => {
    if (!localOpsFlags.base) return false;
    if (localOpsLoading && !hasCompletedInitialLocalOpsSnapshot) return false;
    const anyLayerOn = effectiveLayers.offerings || effectiveLayers.tasks;
    if (!anyLayerOn) return false;
    const offeringsEmpty = effectiveLayers.offerings
      ? layerCounts.offerings === 0
      : true;
    const tasksEmpty = effectiveLayers.tasks
      ? layerCounts.tasks === 0
      : true;
    return offeringsEmpty && tasksEmpty;
  }, [
    localOpsFlags.base,
    localOpsLoading,
    hasCompletedInitialLocalOpsSnapshot,
    effectiveLayers.offerings,
    effectiveLayers.tasks,
    layerCounts.offerings,
    layerCounts.tasks,
  ]);
  const showDiscoverySubline =
    showDiscoveryEmpty && effectiveLayers.offerings;
  const showFirestarterEmpty =
    showDiscoveryEmpty && firestarterContext && firestarterIsCold;
  const hasPlainLandingHandoffContext =
    !!shareParam ||
    !!deeplinkTypeParam ||
    !!deeplinkIdParam ||
    hasResumeLocalOpsState ||
    collisionSpecialistRideRequested ||
    genericAssistanceTaskRequested ||
    offeringDraftReviewRequested;
  const pendingReplayInProgress = hasActiveCreateTaskPendingIntent(
    pendingIntentState,
  );
  const showLandingFallbackOverride = useMemo(() => {
    if (!player?.token) return false;
    if (!localOpsFlags.base) return false;
    if (!showLandingSheet) return false;
    if (localOpsLoading) return false;
    if (!hasCompletedInitialLocalOpsSnapshot) return false;
    if (!showDiscoveryEmpty) return false;
    if (landingPrimaryAction?.type !== 'use_locally') return false;
    if (landingPrimaryAction?.intentType === LANDING_INTENT_TYPES.LOADING) {
      return false;
    }
    if (firestarterOfflineContext) return false;
    if (hasPlainLandingHandoffContext) return false;
    if (checkoutParam) return false;
    if (isTopUpOpen) return false;
    if (pendingReplayInProgress) return false;
    if (selectedTask || selectedOffering) return false;
    return true;
  }, [
    player?.token,
    localOpsFlags.base,
    showLandingSheet,
    localOpsLoading,
    hasCompletedInitialLocalOpsSnapshot,
    showDiscoveryEmpty,
    landingPrimaryAction?.type,
    landingPrimaryAction?.intentType,
    firestarterOfflineContext,
    collisionSpecialistRideRequested,
    genericAssistanceTaskRequested,
    hasPlainLandingHandoffContext,
    checkoutParam,
    isTopUpOpen,
    pendingReplayInProgress,
    selectedTask,
    selectedOffering,
  ]);
  const resetLandingTickerLayout = useCallback(() => {
    landingTickerLayoutRef.current = {
      lift: 0,
      maxHeight: null,
      tickerDrop: 0,
    };
    setLandingTickerLayout((prev) =>
      prev.lift === 0 && prev.maxHeight == null && prev.tickerDrop === 0
        ? prev
        : { lift: 0, maxHeight: null, tickerDrop: 0 },
    );
  }, []);
  const recomputeLandingTickerLayout = useCallback(() => {
    if (
      !mobileView ||
      !showLandingSheet ||
      !localOpsFlags.base ||
      localOpsFeedOpen
    ) {
      resetLandingTickerLayout();
      return;
    }

    const card = landingCardRef.current;
    const ticker = localOpsTickerRef.current;
    if (!card || !ticker) {
      resetLandingTickerLayout();
      return;
    }

    const cardRect = card.getBoundingClientRect();
    const tickerRect = ticker.getBoundingClientRect();
    if (
      !cardRect ||
      !tickerRect ||
      cardRect.height <= 0 ||
      tickerRect.height <= 0
    ) {
      resetLandingTickerLayout();
      return;
    }

    const overlayRect = landingOverlayRef.current?.getBoundingClientRect?.();
    const currentLayout = landingTickerLayoutRef.current || {};
    const currentLift = Number(currentLayout.lift) || 0;
    const currentTickerDrop = Number(currentLayout.tickerDrop) || 0;
    const clearance = 12;
    // The landing sheet may cover disabled map controls; only protect the map/app edge.
    const topClearance = 18;
    const topLimit = (overlayRect?.top || 0) + topClearance;
    const bottomLimit =
      (overlayRect?.bottom || window.innerHeight || tickerRect.bottom) - 18;
    const unshiftedCardTop = cardRect.top + currentLift;
    const naturalCardHeight = Math.max(
      cardRect.height,
      Number(card.scrollHeight) || 0,
    );
    const unshiftedCardBottom = unshiftedCardTop + naturalCardHeight;
    const unshiftedTickerTop = tickerRect.top - currentTickerDrop;
    const unshiftedTickerBottom = tickerRect.bottom - currentTickerDrop;
    const initialOverlap = Math.max(
      0,
      unshiftedCardBottom + clearance - unshiftedTickerTop,
    );

    if (initialOverlap <= 0) {
      resetLandingTickerLayout();
      return;
    }

    const tickerDrop = Math.ceil(
      Math.min(
        initialOverlap,
        Math.max(0, bottomLimit - unshiftedTickerBottom),
      ),
    );
    const effectiveTickerTop = unshiftedTickerTop + tickerDrop;
    const neededLift = Math.max(
      0,
      unshiftedCardBottom + clearance - effectiveTickerTop,
    );
    const maxLift = Math.max(0, unshiftedCardTop - topLimit);
    const lift = Math.ceil(Math.min(neededLift, maxLift));
    const needsHeightClamp = neededLift > maxLift + 1;
    const availableHeight = Math.floor(effectiveTickerTop - clearance - topLimit);
    const maxHeight = needsHeightClamp
      ? Math.max(220, availableHeight)
      : null;
    const next = {
      lift,
      maxHeight: maxHeight && Number.isFinite(maxHeight) ? maxHeight : null,
      tickerDrop,
    };

    landingTickerLayoutRef.current = next;
    setLandingTickerLayout((prev) =>
      prev.lift === next.lift &&
      prev.maxHeight === next.maxHeight &&
      prev.tickerDrop === next.tickerDrop
        ? prev
        : next,
    );
  }, [
    localOpsFeedOpen,
    localOpsFlags.base,
    mobileView,
    resetLandingTickerLayout,
    showLandingSheet,
  ]);
  const scheduleLandingTickerLayout = useCallback(() => {
    if (landingTickerRafRef.current) {
      cancelAnimationFrame(landingTickerRafRef.current);
    }
    landingTickerRafRef.current = requestAnimationFrame(() => {
      landingTickerRafRef.current = null;
      recomputeLandingTickerLayout();
    });
  }, [recomputeLandingTickerLayout]);
  const updateLandingViewportSize = useCallback(() => {
    const next = getLandingViewportSize();
    setLandingViewportSize((prev) =>
      prev.width === next.width && prev.height === next.height ? prev : next,
    );
  }, [getLandingViewportSize]);

  useLayoutEffect(() => {
    scheduleLandingTickerLayout();
    return () => {
      if (landingTickerRafRef.current) {
        cancelAnimationFrame(landingTickerRafRef.current);
        landingTickerRafRef.current = null;
      }
    };
  }, [
    scheduleLandingTickerLayout,
    showLandingSheet,
    mobileView,
    localOpsFeedOpen,
    showLandingFallbackOverride,
    requesterLandingActive,
    landingDisplayHeadline,
    landingDisplaySubcopy,
    landingRequesterProofLine,
    landingWalletLine,
    landingPrimaryLabel,
    landingAuthExpanded,
    landingAvailableTaskSecondaryAction?.label,
    landingOwnerTaskResumeAction?.label,
    !!landingReservedResumeAction,
    showStarterIdeasAffordance,
    visibleFeedEvents.length,
    landingViewportSize.width,
    landingViewportSize.height,
  ]);

  useEffect(() => {
    const onLayoutChange = () => {
      updateLandingViewportSize();
      scheduleLandingTickerLayout();
    };
    window.addEventListener('resize', onLayoutChange);
    window.addEventListener('orientationchange', onLayoutChange);
    const visualViewport = window.visualViewport;
    visualViewport?.addEventListener?.('resize', onLayoutChange);

    return () => {
      window.removeEventListener('resize', onLayoutChange);
      window.removeEventListener('orientationchange', onLayoutChange);
      visualViewport?.removeEventListener?.('resize', onLayoutChange);
    };
  }, [scheduleLandingTickerLayout, updateLandingViewportSize]);

  useEffect(() => {
    if (typeof ResizeObserver === 'undefined') return undefined;
    const observer = new ResizeObserver(() => scheduleLandingTickerLayout());
    const card = landingCardRef.current;
    const ticker = localOpsTickerRef.current;
    const overlay = landingOverlayRef.current;
    if (card) observer.observe(card);
    if (ticker) observer.observe(ticker);
    if (overlay) observer.observe(overlay);
    return () => observer.disconnect();
  }, [
    scheduleLandingTickerLayout,
    showLandingSheet,
    localOpsFeedOpen,
    visibleFeedEvents.length,
  ]);

  useEffect(() => {
    if (!showFirestarterEmpty) {
      firestarterShownRef.current = false;
      return;
    }
    if (firestarterShownRef.current) return;
    firestarterShownRef.current = true;
    emitFirestarterTelemetry('firestarter_shown', {
      surface: 'playermap_empty',
    });
  }, [showFirestarterEmpty, emitFirestarterTelemetry]);

  useEffect(() => {
    if (!firestarterLaunchRequested) {
      firestarterCreateOpenedRef.current = false;
      return;
    }
    if (firestarterCreateOpenedRef.current) return;
    firestarterCreateOpenedRef.current = true;
    openFirestarterCreate(firestarterSurfaceParam || 'region_landing');
  }, [
    firestarterLaunchRequested,
    firestarterSurfaceParam,
    openFirestarterCreate,
  ]);

  useEffect(() => {
    if (!intakeDraftTokenParam || !collisionSpecialistRideRequested) {
      intakeDraftClaimTokenRef.current = '';
      intakeDraftClaimInFlightRef.current = false;
      return;
    }
    if (!player?.token) return;
    const pending = readPendingIntent() || pendingIntentState;
    if (
      checkoutParam ||
      isTopUpOpen ||
      hasActiveCreateTaskPendingIntent(pending) ||
      hasPendingCreateTaskDraftIntent(pending, intakeDraftTokenParam)
    ) {
      return;
    }
    if (
      intakeDraftClaimInFlightRef.current ||
      intakeDraftClaimTokenRef.current === intakeDraftTokenParam
    ) {
      return;
    }

    let canceled = false;
    intakeDraftClaimInFlightRef.current = true;
    intakeDraftClaimTokenRef.current = intakeDraftTokenParam;

    const claimDraft = async () => {
      try {
        const headers = { Authorization: `Bearer ${player.token}` };
        const res = await axiosConn.post(
          'local-ops/intake-drafts/claim',
          { draftToken: intakeDraftTokenParam },
          { headers },
        );
        if (canceled) return;
        const draft = normalizeIntakeDraftPayload(res);
        if (!draft?.deliveryAddress) {
          throw new Error('Draft is missing delivery address.');
        }
        setLocalOpsError('');
        openCollisionSpecialistRideCreate({
          ...draft,
          intakeDraftToken: draft?.intakeDraftToken || intakeDraftTokenParam,
        });
      } catch (err) {
        if (canceled) return;
        setLocalOpsError(
          err?.response?.data?.message ||
            err?.message ||
            'Ride draft is unavailable.',
        );
      } finally {
        if (!canceled) {
          intakeDraftClaimInFlightRef.current = false;
        }
      }
    };

    claimDraft();

    return () => {
      canceled = true;
    };
  }, [
    checkoutParam,
    collisionSpecialistRideRequested,
    intakeDraftTokenParam,
    isTopUpOpen,
    openCollisionSpecialistRideCreate,
    pendingIntentState,
    player?.token,
  ]);

  useEffect(() => {
    if (!intakeDraftTokenParam || !genericAssistanceTaskRequested) {
      genericIntakeDraftClaimTokenRef.current = '';
      genericIntakeDraftClaimInFlightRef.current = false;
      return;
    }
    if (!player?.token) return;
    const pending = readPendingIntent() || pendingIntentState;
    if (
      checkoutParam ||
      isTopUpOpen ||
      hasActiveCreateTaskPendingIntent(pending) ||
      hasPendingCreateTaskDraftIntent(pending, intakeDraftTokenParam)
    ) {
      return;
    }
    if (
      genericIntakeDraftClaimInFlightRef.current ||
      genericIntakeDraftClaimTokenRef.current === intakeDraftTokenParam
    ) {
      return;
    }

    let canceled = false;
    genericIntakeDraftClaimInFlightRef.current = true;
    genericIntakeDraftClaimTokenRef.current = intakeDraftTokenParam;

    const claimDraft = async () => {
      try {
        const headers = { Authorization: `Bearer ${player.token}` };
        const res = await axiosConn.post(
          'local-ops/intake-drafts/claim',
          { draftToken: intakeDraftTokenParam },
          { headers },
        );
        if (canceled) return;
        const draft = normalizeIntakeDraftPayload(res);
        if (draft?.intakeType !== GENERIC_ASSISTANCE_TASK_INTAKE_TYPE) {
          throw new Error('Draft is not a generic assistance task.');
        }
        setLocalOpsError('');
        openGenericAssistanceTaskCreate({
          ...draft,
          intakeDraftToken: draft?.intakeDraftToken || intakeDraftTokenParam,
        });
      } catch (err) {
        if (canceled) return;
        setLocalOpsError(
          err?.response?.data?.message ||
            err?.message ||
            'Assistance draft is unavailable.',
        );
      } finally {
        if (!canceled) {
          genericIntakeDraftClaimInFlightRef.current = false;
        }
      }
    };

    claimDraft();

    return () => {
      canceled = true;
    };
  }, [
    checkoutParam,
    genericAssistanceTaskRequested,
    intakeDraftTokenParam,
    isTopUpOpen,
    openGenericAssistanceTaskCreate,
    pendingIntentState,
    player?.token,
  ]);

  useEffect(() => {
    if (!intakeDraftTokenParam || !offeringDraftReviewRequested) {
      offeringDraftClaimTokenRef.current = '';
      offeringDraftClaimInFlightRef.current = false;
      return;
    }
    if (!player?.token) return;
    if (
      offeringDraftClaimInFlightRef.current ||
      offeringDraftClaimTokenRef.current === intakeDraftTokenParam
    ) {
      return;
    }

    let canceled = false;
    offeringDraftClaimInFlightRef.current = true;
    offeringDraftClaimTokenRef.current = intakeDraftTokenParam;

    const claimDraft = async () => {
      try {
        const headers = { Authorization: `Bearer ${player.token}` };
        const res = await axiosConn.post(
          'local-ops/concierge/offering-drafts/claim',
          { draftToken: intakeDraftTokenParam },
          { headers },
        );
        if (canceled) return;
        const draft = normalizeIntakeDraftPayload(res);
        if (draft?.intakeType !== GENERIC_OFFERING_DRAFT_INTAKE_TYPE) {
          throw new Error('Draft is not a LocalOps offering draft.');
        }
        setLocalOpsError('');
        openOfferingDraftCreate({
          ...draft,
          offeringDraftToken: draft?.offeringDraftToken || intakeDraftTokenParam,
        });
      } catch (err) {
        if (canceled) return;
        setLocalOpsError(
          err?.response?.data?.message ||
            err?.message ||
            'Offering draft is unavailable.',
        );
      } finally {
        if (!canceled) {
          offeringDraftClaimInFlightRef.current = false;
        }
      }
    };

    claimDraft();

    return () => {
      canceled = true;
    };
  }, [
    intakeDraftTokenParam,
    offeringDraftReviewRequested,
    openOfferingDraftCreate,
    player?.token,
  ]);

  useEffect(() => {
    if (!collisionSpecialistRideRequested) {
      collisionRideCreateOpenedRef.current = false;
      return;
    }
    if (intakeDraftTokenParam) return;
    const pending = readPendingIntent() || pendingIntentState;
    if (
      checkoutParam ||
      isTopUpOpen ||
      hasActiveCreateTaskPendingIntent(pending) ||
      hasPendingCreateTaskDraftIntent(pending) ||
      (collisionRideLaunchSignature &&
        consumedCollisionRideLaunchesRef.current.has(
          collisionRideLaunchSignature,
        ))
    ) {
      return;
    }
    if (collisionRideCreateOpenedRef.current) return;
    collisionRideCreateOpenedRef.current = true;
    openCollisionSpecialistRideCreate();
  }, [
    checkoutParam,
    collisionSpecialistRideRequested,
    collisionRideLaunchSignature,
    intakeDraftTokenParam,
    isTopUpOpen,
    openCollisionSpecialistRideCreate,
    pendingIntentState,
  ]);

  const buildLocalOpsId = useCallback(
    (prefix) =>
      `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    [],
  );

  const handleCreateOffering = useCallback(
    async (payload) => {
      if (
        !ensurePersonalLocationForAction('create_offering', () =>
          handleCreateOfferingRef.current?.(payload),
        )
      ) {
        throw createLocationConsentGateError();
      }
      const offeringDraftToken = String(payload?.offeringDraftToken || '').trim();
      const offeringDraftId = String(payload?.offeringDraftId || '').trim();
      const tempId = buildLocalOpsId('offering');
      const qty = Number(payload?.quantityAvailable);
      const quantityAvailable =
        Number.isFinite(qty) && qty >= 0 ? Math.floor(qty) : undefined;
      const optimistic = {
        ...payload,
        ...payload.meta,
        id: tempId,
        offeringId: tempId,
        ownerId: playerId,
        createdAt: Date.now(),
        updatedAt: Date.now(),
        quantityAvailable,
      };
      upsertOffering(optimistic);
      setSelectedOffering(optimistic);
      setIsCreateOpen(false);
      const regionLabel = formatCoarseLocationLabel(
        payload?.meta?.locationLabel || payload?.locationLabel || '',
      );
      const hasPrice = Number.isFinite(payload?.price);
      const mediaList = payload?.media || payload?.meta?.media;
      const coverIndex = Number.isInteger(payload?.coverIndex)
        ? payload.coverIndex
        : Number.isInteger(payload?.meta?.coverIndex)
        ? payload.meta.coverIndex
        : undefined;
      const hasMedia = Array.isArray(mediaList) && mediaList.length > 0;
      const locationAddress =
        payload?.location?.address ||
        payload?.pickupAddress ||
        payload?.meta?.pickupAddress;
      const location =
        payload?.location?.coordinates?.length === 2
          ? {
              type: 'Point',
              coordinates: payload.location.coordinates,
              ...(locationAddress ? { address: locationAddress } : {}),
            }
          : payload?.location;
      const restPayload = {
        offeringType: payload?.offeringType,
        category: payload?.category,
        title: payload?.title || payload?.meta?.title || payload?.description,
        description:
          payload?.description ||
          payload?.meta?.description ||
          payload?.meta?.title,
        location,
        pickupAddress: locationAddress,
        price: hasPrice ? payload.price : undefined,
        requestQuote: !hasPrice && payload?.requestQuote ? true : undefined,
        regionLabel: regionLabel || undefined,
        availabilitySchedule: payload?.availabilitySchedule,
        deliverySupported: payload?.deliverySupported,
        featured: payload?.featured,
        businessProfileId: payload?.businessProfileId,
        media: hasMedia ? mediaList : undefined,
        coverIndex:
          hasMedia && Number.isInteger(coverIndex) ? coverIndex : undefined,
        quantityAvailable,
        sellerLaunchAttribution:
          payload?.sellerLaunchAttribution ||
          localOpsLaunchAttribution ||
          undefined,
        offeringDraftToken: offeringDraftToken || undefined,
        meta: {
          ...(payload?.meta || {}),
          ...(locationAddress ? { pickupAddress: locationAddress } : {}),
        },
      };
      Object.keys(restPayload).forEach((key) => {
        if (restPayload[key] === undefined) delete restPayload[key];
      });
      try {
        const headers = player?.token
          ? { Authorization: `Bearer ${player.token}` }
          : undefined;
        if (process.env.NODE_ENV !== 'production') {
          // eslint-disable-next-line no-console
          console.debug('[DEBUG][CLIENT OFFERING CREATE PAYLOAD]', restPayload);
          if (restPayload.location?.coordinates && locationAddress) {
            // eslint-disable-next-line no-console
            console.assert(
              !!restPayload.location.address,
              'INVARIANT VIOLATION: offering create payload missing location.address',
            );
          }
        }
        const res =
          offeringDraftToken && offeringDraftId
            ? await axiosConn.post(
                `local-ops/concierge/offering-drafts/${offeringDraftId}/publish`,
                {
                  ...restPayload,
                  offeringDraftToken,
                },
                { headers },
              )
            : await axiosConn.post(
                'local-ops/offerings',
                restPayload,
                { headers },
              );
        const offering = normalizeOfferingPayload(
          offeringDraftToken && offeringDraftId
            ? res?.data?.data?.offering
            : res?.data,
        );
        if (!offering) {
          removeOffering(tempId);
          setLocalOpsError('Offering publish failed.');
          return;
        }
        removeOffering(tempId);
        upsertOffering(offering);
        setSelectedOffering(offering);
        handleOpenSharePanel('offering', offering, 'created');
      } catch (err) {
        removeOffering(tempId);
        setLocalOpsError(
          isLocalOpsEntityLocationError(err)
            ? LOCALOPS_ENTITY_LOCATION_COPY
            : 'Offering publish failed.',
        );
      }
    },
    [
      player?.token,
      buildLocalOpsId,
      playerId,
      upsertOffering,
      removeOffering,
      handleOpenSharePanel,
      localOpsLaunchAttribution,
      ensurePersonalLocationForAction,
    ],
  );

  const handleResolveVerifiedLocalCreatorReadiness = useCallback(
    async ({ lat, lng, radiusMeters: requestedRadiusMeters } = {}) => {
      if (!player?.token) {
        return { canExposeVerifiedLocalCreatorToggle: false };
      }
      const parsedLat = Number(lat);
      const parsedLng = Number(lng);
      if (!Number.isFinite(parsedLat) || !Number.isFinite(parsedLng)) {
        return { canExposeVerifiedLocalCreatorToggle: false };
      }
      const headers = { Authorization: `Bearer ${player.token}` };
      const res = await axiosConn.get(
        'local-ops/tasks/verified-local-readiness',
        {
          headers,
          params: {
            lat: parsedLat,
            lng: parsedLng,
            radiusMeters: requestedRadiusMeters || radiusMeters,
          },
        },
      );
      return res?.data || { canExposeVerifiedLocalCreatorToggle: false };
    },
    [player?.token, radiusMeters],
  );

  const handleReserveOffering = useCallback(
    async ({
      offeringId,
      quantity,
      idempotencyKey,
      buyerLaunchAttribution,
      reservationLaunchAttribution,
    }) => {
      if (!offeringId) {
        throw new Error('Missing offering.');
      }
      if (!player?.token) {
        setLocalOpsNotice('Log in to reserve.');
        throw new Error('Please log in to reserve.');
      }
      if (
        !ensurePersonalLocationForAction('reserve_offering', () =>
          handleReserveOfferingRef.current?.({
            offeringId,
            quantity,
            idempotencyKey,
            buyerLaunchAttribution,
            reservationLaunchAttribution,
          }),
        )
      ) {
        throw createLocationConsentGateError();
      }
      const trackOfferingShareFunnel =
        shareFunnelContext?.shareType === 'offering' &&
        String(shareFunnelContext.shareId || '') === String(offeringId || '');
      const recordOfferingReserveEvent = (eventName, extra = {}) => {
        if (!trackOfferingShareFunnel) return;
        recordShareFunnelEvent(eventName, shareFunnelContext, {
          stage: 'reserve',
          ...extra,
        });
      };
      try {
        const headers = { Authorization: `Bearer ${player.token}` };
        const reservePayload = {
          quantity,
          idempotencyKey,
        };
        const resolvedBuyerLaunchAttribution =
          buyerLaunchAttribution || localOpsLaunchAttribution || null;
        const resolvedReservationLaunchAttribution =
          reservationLaunchAttribution || localOpsLaunchAttribution || null;
        if (resolvedBuyerLaunchAttribution) {
          reservePayload.buyerLaunchAttribution =
            resolvedBuyerLaunchAttribution;
        }
        if (resolvedReservationLaunchAttribution) {
          reservePayload.reservationLaunchAttribution =
            resolvedReservationLaunchAttribution;
        }
        recordOfferingReserveEvent(
          SHARE_FUNNEL_EVENT_NAMES.OFFERING_RESERVE_CLICKED,
          {
            eventId: [
              'share-offering-reserve-click',
              shareFunnelContext?.shareFunnelId,
              offeringId,
              Math.floor(Date.now() / 2000),
            ].join(':'),
            dedupe: false,
          },
        );
        const res = await axiosConn.post(
          `local-ops/offerings/${offeringId}/accept`,
          reservePayload,
          { headers },
        );
        const payload = res?.data?.data || res?.data || {};
        const orderId =
          payload.orderId ||
          payload?.data?.orderId ||
          payload?._id ||
          null;
        const order = normalizeOrderPayload(payload);
        if (order) upsertLocalOpsOrder(order);
        const updatedOffering =
          res?.data?.offering ||
          res?.data?.data?.offering ||
          res?.data?.payload?.offering ||
          null;
        const normalizedOffering = updatedOffering
          ? normalizeOfferingPayload({ data: updatedOffering })
          : null;
        if (normalizedOffering) {
          upsertOffering(normalizedOffering);
        }
        recordOfferingReserveEvent(
          SHARE_FUNNEL_EVENT_NAMES.OFFERING_RESERVE_SUCCEEDED,
        );
        return { orderId, updatedOffering: normalizedOffering };
      } catch (err) {
        const payload = err?.response?.data;
        const safeFailureReason = (() => {
          if (payload?.code === 'INSUFFICIENT_JGK') return 'insufficient_balance';
          if (err?.response?.status === 409) return 'unavailable';
          if (
            payload?.code === BUYER_PENDING_CONFIRMATION_CODE ||
            err?.response?.status === 400 ||
            err?.response?.status === 422
          ) {
            return 'validation_failed';
          }
          if (!err?.response) return 'network_error';
          return 'unknown';
        })();
        recordOfferingReserveEvent(
          SHARE_FUNNEL_EVENT_NAMES.OFFERING_RESERVE_FAILED,
          { failureReason: safeFailureReason },
        );
        if (payload?.code === BUYER_PENDING_CONFIRMATION_CODE) {
          const blockingOrder = extractBlockingOrderFromGatePayload(payload);
          setPendingConfirmationGate({
            gateId: makePendingIntentId(),
            context: 'reserve',
            intent: {
              type: 'reserve_offering',
              payload: {
                offeringId,
                quantity,
                idempotencyKey,
                buyerLaunchAttribution:
                  buyerLaunchAttribution ||
                  localOpsLaunchAttribution ||
                  undefined,
                reservationLaunchAttribution:
                  reservationLaunchAttribution ||
                  localOpsLaunchAttribution ||
                  undefined,
              },
            },
            blockingOrder,
            busy: false,
            error: '',
          });
          const gateError = new Error(
            'Resolve pending reservation confirmation before reserving another offering.',
          );
          gateError.code = BUYER_PENDING_CONFIRMATION_CODE;
          throw gateError;
        }
        if (isLocalOpsLocationCode(payload?.code)) {
          openLocationConsentGate({
            actionType: 'reserve_offering',
            retry: () =>
              handleReserveOfferingRef.current?.({
                offeringId,
                quantity,
                idempotencyKey,
                buyerLaunchAttribution:
                  buyerLaunchAttribution ||
                  localOpsLaunchAttribution ||
                  undefined,
                reservationLaunchAttribution:
                  reservationLaunchAttribution ||
                  localOpsLaunchAttribution ||
                  undefined,
              }),
          });
          throw createLocationConsentGateError();
        }
        if (payload?.code === 'INSUFFICIENT_JGK') {
          handleLocalOpsInsufficient({
            actionType: 'reserve_offering',
            request: {
              offeringId,
              quantity,
              idempotencyKey,
              buyerLaunchAttribution:
                buyerLaunchAttribution ||
                localOpsLaunchAttribution ||
                undefined,
              reservationLaunchAttribution:
                reservationLaunchAttribution ||
                localOpsLaunchAttribution ||
                undefined,
            },
            topUp: payload,
          });
          throw new Error('Top up required to reserve.');
        }
        if (err?.response?.status === 409) {
          throw new Error('No longer available.');
        }
        throw new Error('Unable to reserve right now.');
      }
    },
    [
      player?.token,
      upsertOffering,
      upsertLocalOpsOrder,
      handleLocalOpsInsufficient,
      setLocalOpsNotice,
      setPendingConfirmationGate,
      localOpsLaunchAttribution,
      shareFunnelContext,
      ensurePersonalLocationForAction,
      openLocationConsentGate,
    ],
  );

  const handleFulfillOrder = useCallback(
    async (order) => {
      const orderId = order?.orderId || order?.id || order?._id;
      if (!orderId) return;
      if (!player?.token) {
        setLocalOpsNotice('Log in to request buyer confirmation.');
        return;
      }
      try {
        const headers = { Authorization: `Bearer ${player.token}` };
        const res = await axiosConn.post(
          `local-ops/orders/${orderId}/fulfill`,
          {},
          { headers },
        );
        const updatedOrder = normalizeOrderPayload(res?.data?.data || res?.data);
        if (updatedOrder) upsertLocalOpsOrder(updatedOrder);
        setLocalOpsNotice('Buyer confirmation requested. Buyer JGK remains held.');
      } catch (err) {
        setLocalOpsError('Unable to request confirmation right now.');
      }
    },
    [
      player?.token,
      upsertLocalOpsOrder,
      setLocalOpsNotice,
      setLocalOpsError,
    ],
  );

  const handleCancelOrder = useCallback(
    async (order) => {
      const orderId = order?.orderId || order?.id || order?._id;
      if (!orderId) return null;
      if (!player?.token) {
        setLocalOpsNotice('Log in to cancel this reservation.');
        return null;
      }
      try {
        const headers = { Authorization: `Bearer ${player.token}` };
        const res = await axiosConn.post(
          `local-ops/orders/${orderId}/cancel`,
          {},
          { headers },
        );
        const updatedOrder = normalizeOrderPayload(res?.data?.data || res?.data);
        if (updatedOrder) upsertLocalOpsOrder(updatedOrder);
        setLocalOpsNotice('Reservation canceled. Held JGK was returned.');
        return updatedOrder || order;
      } catch (err) {
        setLocalOpsError('Unable to cancel this reservation right now.');
        return null;
      }
    },
    [player?.token, upsertLocalOpsOrder, setLocalOpsNotice, setLocalOpsError],
  );

  const handleConfirmOrder = useCallback(
    async (order) => {
      const orderId = order?.orderId || order?.id || order?._id;
      if (!orderId) return null;
      if (!player?.token) {
        setLocalOpsNotice('Log in to confirm this order.');
        return null;
      }
      try {
        const headers = { Authorization: `Bearer ${player.token}` };
        const res = await axiosConn.post(
          `local-ops/orders/${orderId}/confirm`,
          {},
          { headers },
        );
        const completionTruth = res?.data?.completion || null;
        const updatedOrder = normalizeOrderPayload(res?.data?.data || res?.data);
        if (updatedOrder) upsertLocalOpsOrder(updatedOrder);
        const completionContext = buildOfferingCompletionContext(
          updatedOrder || order,
          'buyer',
          completionTruth,
        );
        const amountJGK = Number(completionContext?.amountJGK);
        const amountJGKLabel =
          Number.isFinite(amountJGK) && amountJGK > 0
            ? Math.round(amountJGK).toLocaleString('en-US')
            : '0';
        setLocalOpsNotice(`Payout released. ${amountJGKLabel} JGK transferred.`);
        if (completionContext) {
          setPostCompletionContext(completionContext);
          setPostCompletionOpen(true);
        }
        return updatedOrder || order;
      } catch (err) {
        setLocalOpsError('Unable to confirm this order right now.');
        return null;
      }
    },
    [
      player?.token,
      upsertLocalOpsOrder,
      setLocalOpsNotice,
      setLocalOpsError,
      buildOfferingCompletionContext,
    ],
  );

  const handleDisputeOrder = useCallback(
    async (order) => {
      const orderId = order?.orderId || order?.id || order?._id;
      if (!orderId) return null;
      if (!player?.token) {
        setLocalOpsNotice('Log in to dispute this order.');
        return null;
      }
      try {
        const headers = { Authorization: `Bearer ${player.token}` };
        const res = await axiosConn.post(
          `local-ops/orders/${orderId}/dispute`,
          {},
          { headers },
        );
        const updatedOrder = normalizeOrderPayload(res?.data?.data || res?.data);
        if (updatedOrder) upsertLocalOpsOrder(updatedOrder);
        setLocalOpsNotice('Problem reported. JGK remains held for review.');
        return updatedOrder || order;
      } catch (err) {
        setLocalOpsError('Unable to dispute this order right now.');
        return null;
      }
    },
    [player?.token, upsertLocalOpsOrder, setLocalOpsNotice, setLocalOpsError],
  );

  const handleClosePendingConfirmationGate = useCallback(() => {
    if (pendingConfirmationGateBusyRef.current) return;
    setPendingConfirmationGate(null);
  }, []);

  const handleMessageSellerFromGate = useCallback(
    async (blockingOrder) => {
      const sellerId =
        blockingOrder?.seller?._id ||
        blockingOrder?.sellerId ||
        blockingOrder?.seller ||
        null;
      if (!sellerId) {
        setLocalOpsError('Unable to message the seller right now.');
        return;
      }
      await handleMessageOwner({ ownerId: sellerId });
      setPendingConfirmationGate(null);
    },
    [handleMessageOwner, setLocalOpsError],
  );

  const handleResolvePendingConfirmationGate = useCallback(
    async (action) => {
      const gate = pendingConfirmationGate;
      if (!gate || gate.context !== 'reserve') return;
      if (pendingConfirmationGateBusyRef.current) return;
      const gateId = gate.gateId;
      const blockingOrder = gate.blockingOrder || {};
      if (action === 'message') {
        await handleMessageSellerFromGate(blockingOrder);
        return;
      }

      pendingConfirmationGateBusyRef.current = true;
      setPendingConfirmationGate((prev) =>
        prev && prev.gateId === gateId
          ? { ...prev, busy: true, error: '' }
          : prev,
      );

      try {
        if (!blockingOrder?.orderId) {
          throw new Error('Missing blocking order id.');
        }
        let resolvedOrder = null;
        if (action === 'confirm') {
          resolvedOrder = await handleConfirmOrder(blockingOrder);
        } else if (action === 'dispute') {
          resolvedOrder = await handleDisputeOrder(blockingOrder);
        }
        if (!resolvedOrder) {
          throw new Error('Unable to resolve the pending reservation right now.');
        }

        if (gate?.intent?.type === 'reserve_offering' && gate?.intent?.payload) {
          await handleReserveOffering(gate.intent.payload);
        }

        setPendingConfirmationGate((prev) =>
          prev && prev.gateId === gateId ? null : prev,
        );
      } catch (err) {
        const gateCode =
          err?.code || err?.response?.data?.code || err?.cause?.code || null;
        if (gateCode !== BUYER_PENDING_CONFIRMATION_CODE) {
          setPendingConfirmationGate((prev) =>
            prev && prev.gateId === gateId
              ? {
                  ...prev,
                  error:
                    err?.message ||
                    'Unable to resolve the pending reservation right now.',
                }
              : prev,
          );
        }
      } finally {
        pendingConfirmationGateBusyRef.current = false;
        setPendingConfirmationGate((prev) =>
          prev && prev.gateId === gateId ? { ...prev, busy: false } : prev,
        );
      }
    },
    [
      pendingConfirmationGate,
      handleConfirmOrder,
      handleDisputeOrder,
      handleReserveOffering,
      handleMessageSellerFromGate,
    ],
  );

  const handleCreateTask = useCallback(
    async (payload) => {
      if (createTaskInFlightRef.current) return null;
      if (
        !ensurePersonalLocationForAction('create_task', () =>
          handleCreateTaskRef.current?.(payload),
        )
      ) {
        throw createLocationConsentGateError();
      }
      createTaskInFlightRef.current = true;
      const shouldRequestIgnition =
        createIgnitionCandidate === true ||
        payload?.localEmptyIgnitionCandidate === true;
      const {
        intakeDraftToken: _intakeDraftTokenForOptimistic,
        ...optimisticPayloadBase
      } = payload || {};
      const ignitionPayload = shouldRequestIgnition
        ? {
            localEmptyIgnitionCandidate: true,
            localEmptyIgnitionSource: LOCAL_EMPTY_IGNITION_SOURCE,
            localEmptyRadiusMeters: discoveryRadiusMeters,
          }
        : {};
      const originalPayload = shouldRequestIgnition
        ? { ...payload, ...ignitionPayload }
        : payload;
      const startAtValue = payload?.availabilityWindow?.startAt;
      const startAtMs = startAtValue ? Date.parse(startAtValue) : NaN;
      const fallbackStatus = payload?.status || 'discoverable';
      const desiredStatus =
        fallbackStatus === 'discoverable' &&
        Number.isFinite(startAtMs) &&
        startAtMs > Date.now()
          ? 'created'
          : fallbackStatus;
      const tempId = buildLocalOpsId('task');
      const optimistic = {
        ...optimisticPayloadBase,
        ...optimisticPayloadBase.meta,
        taskId: tempId,
        id: tempId,
        status: desiredStatus,
        creatorPlayerId: playerId,
        createdAt: Date.now(),
        updatedAt: Date.now(),
      };
      upsertTask(optimistic, { discoverable: desiredStatus === 'discoverable' });
      setSelectedTask(optimistic);
      setIsCreateOpen(false);

      const regionLabel = formatCoarseLocationLabel(
        payload?.meta?.locationLabel || payload?.locationLabel || '',
      );
      const hasPrice = Number.isFinite(payload?.price);
      const mediaList = payload?.media || payload?.meta?.media;
      const coverIndex = Number.isInteger(payload?.coverIndex)
        ? payload.coverIndex
        : Number.isInteger(payload?.meta?.coverIndex)
        ? payload.meta.coverIndex
        : undefined;
      const hasMedia = Array.isArray(mediaList) && mediaList.length > 0;
      const originLocation =
        payload?.originLocation?.coordinates?.length === 2
          ? {
              type: 'Point',
              coordinates: payload.originLocation.coordinates,
              ...(payload.originLocation.address
                ? { address: payload.originLocation.address }
                : payload.pickupAddress
                ? { address: payload.pickupAddress }
                : {}),
            }
          : payload?.originLocation;
      const destinationLocation =
        payload?.destinationLocation?.coordinates?.length === 2
          ? {
              type: 'Point',
              coordinates: payload.destinationLocation.coordinates,
              ...(payload.destinationLocation.address
                ? { address: payload.destinationLocation.address }
                : payload.destinationAddress
                ? { address: payload.destinationAddress }
                : {}),
            }
          : payload?.destinationLocation;
      const taskMeta =
        payload?.meta && typeof payload.meta === 'object'
          ? { ...payload.meta }
          : undefined;
      const restPayload = {
        taskType: payload?.taskType,
        paymentMode: payload?.paymentMode,
        title: payload?.title,
        description: payload?.description,
        originLocation,
        availabilityWindow: payload?.availabilityWindow,
        price: hasPrice ? payload.price : undefined,
        quoteRequested: !hasPrice && payload?.quoteRequested ? true : undefined,
        regionLabel: regionLabel || undefined,
        destinationLocation,
        pickupAddress: payload?.pickupAddress,
        deliveryAddress:
          payload?.deliveryAddress || payload?.meta?.deliveryAddress,
        destinationAddress: payload?.destinationAddress,
        presenceRequirements: payload?.presenceRequirements,
        liveTrackingEnabled: payload?.liveTrackingEnabled,
        shareWithTrustedPlayers: payload?.shareWithTrustedPlayers || [],
        trustRequirement: normalizeTaskTrustRequirement(payload?.trustRequirement),
        status: desiredStatus,
        media: hasMedia ? mediaList : undefined,
        coverIndex:
          hasMedia && Number.isInteger(coverIndex) ? coverIndex : undefined,
        creatorLaunchAttribution:
          payload?.creatorLaunchAttribution ||
          localOpsLaunchAttribution ||
          undefined,
        intakeDraftToken: payload?.intakeDraftToken || undefined,
        meta:
          taskMeta && Object.keys(taskMeta).length > 0
            ? taskMeta
            : undefined,
        ...ignitionPayload,
      };
      Object.keys(restPayload).forEach((key) => {
        if (restPayload[key] === undefined) delete restPayload[key];
      });
      const activeProofAttributionHint =
        sanitizeProofAttributionHint(payload?.proofAttributionHint) ||
        proofAttributionHintRef.current;
      const createRequestPayload = attachProofAttributionHintToPendingCreate(
        restPayload,
        activeProofAttributionHint,
      );
      try {
        const headers = player?.token
          ? { Authorization: `Bearer ${player.token}` }
          : undefined;
        const res = await axiosConn.post(
          'local-ops/tasks',
          createRequestPayload,
          { headers },
        );
        const localActivityReward = normalizeLocalActivityReward(res?.data);
        const normalizedTask = normalizeTaskPayload(res?.data);
        const task = normalizedTask && localActivityReward
          ? { ...normalizedTask, localActivityReward }
          : normalizedTask;
        const createdTaskId = getDurableLocalOpsTaskId(task);
        if (!task || !createdTaskId) {
          removeTask(tempId);
          setLocalOpsError('Task publish failed.');
          createTaskInFlightRef.current = false;
          throw new Error('Task publish failed.');
        }
        removeTask(tempId);
        upsertTask(task);
        setSelectedTask(task);
        const shouldConsumeCollisionRideLaunch =
          isCollisionSpecialistCreateTaskPayload(originalPayload) ||
          collisionSpecialistRideRequested;
        if (shouldConsumeCollisionRideLaunch && createdTaskId) {
          if (collisionRideLaunchSignature) {
            consumedCollisionRideLaunchesRef.current.add(
              collisionRideLaunchSignature,
            );
          }
          collisionRideCreateOpenedRef.current = true;
          history.replace({
            pathname: '/playermap',
            search: `?type=task&id=${encodeURIComponent(
              String(createdTaskId),
            )}`,
          });
        }
        if (firestarterCreatePending || firestarterContext) {
          if (createdTaskId) {
            setFirestarterShareTaskId(String(createdTaskId));
          }
          emitFirestarterTelemetry('firestarter_share_prompt_shown', {
            surface: firestarterSurfaceParam || 'region_landing',
          });
          setFirestarterCreatePending(false);
        }
        handleOpenSharePanel('task', task, 'created');
        if (activeProofAttributionHint) {
          proofAttributionHintRef.current = null;
        }
        createTaskInFlightRef.current = false;
        return task;
      } catch (err) {
        const errorPayload = err?.response?.data;
        if (errorPayload?.code === 'INSUFFICIENT_JGK') {
          removeTask(tempId);
          setFirestarterCreatePending(false);
          const pendingCreateRequest = attachProofAttributionHintToPendingCreate(
            {
              ...originalPayload,
              creatorLaunchAttribution:
                originalPayload?.creatorLaunchAttribution ||
                localOpsLaunchAttribution ||
                undefined,
            },
            activeProofAttributionHint,
          );
          handleLocalOpsInsufficient({
            actionType: 'create_task',
            request: pendingCreateRequest,
            topUp: errorPayload,
          });
          createTaskInFlightRef.current = false;
          throw new Error('Top up required to publish task.');
        }
        removeTask(tempId);
        setFirestarterCreatePending(false);
        if (isLocalOpsEntityLocationError(err)) {
          setLocalOpsError(LOCALOPS_ENTITY_LOCATION_COPY);
          createTaskInFlightRef.current = false;
          throw new Error(LOCALOPS_ENTITY_LOCATION_COPY);
        }
        setLocalOpsError('Task publish failed.');
        createTaskInFlightRef.current = false;
        throw err;
      }
    },
    [
      player?.token,
      buildLocalOpsId,
      playerId,
      upsertTask,
      removeTask,
      handleOpenSharePanel,
      handleLocalOpsInsufficient,
      firestarterContext,
      firestarterCreatePending,
      emitFirestarterTelemetry,
      firestarterSurfaceParam,
      createIgnitionCandidate,
      discoveryRadiusMeters,
      localOpsLaunchAttribution,
      collisionSpecialistRideRequested,
      collisionRideLaunchSignature,
      history,
      ensurePersonalLocationForAction,
    ],
  );

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const hasCheckout = params.get('checkout');
    if (hasCheckout) {
      if (hasCheckout !== 'start') {
        checkoutInjectedRef.current = true;
      }
      jgkLog('[jgk-resume] checkout param present', {
        search: location.search,
      });
      return;
    }
    if (checkoutInjectedRef.current) return;
    if (typeof window === 'undefined') return;
    const pending = readPendingIntent();
    const startedAtRaw = window.localStorage.getItem(TOPUP_STARTED_KEY);
    const startedAt = Number(startedAtRaw);
    const returnTo = window.localStorage.getItem(TOPUP_RETURN_KEY);
    if (
      shouldAutoInjectCheckoutSuccess({
        hasCheckoutParam: !!hasCheckout,
        pendingIntent: pending,
        startedAt,
      })
    ) {
      checkoutInjectedRef.current = true;
      params.set('checkout', 'success');
      history.replace({
        pathname: location.pathname,
        search: `?${params.toString()}`,
      });
      jgkLog('[jgk-resume] injected checkout param', {
        pendingId: pending.id,
        startedAt,
        returnTo,
      });
      return;
    }
    jgkLog('[jgk-resume] checkout param missing', {
      pendingId: pending?.id,
      startedAt,
      search: location.search,
    });
  }, [history, location.pathname, location.search]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const checkout = params.get('checkout');
    if (!checkout) return;
    jgkLog('[jgk-resume] checkout param detected', checkout);

    const clearCheckoutParam = () => {
      params.delete('checkout');
      const nextSearch = params.toString();
      history.replace({
        pathname: location.pathname,
        search: nextSearch ? `?${nextSearch}` : '',
      });
    };

    if (checkout === 'cancel') {
      writePendingIntent(null);
      setPendingIntentState(null);
      setLocalOpsNotice('Top up canceled. Action not funded.');
      clearCheckoutParam();
      return;
    }

    if (checkout === 'start') {
      const pending = readPendingIntent();
      const pendingState = String(pending?.state || '').toLowerCase();
      const startedAtRaw =
        typeof window !== 'undefined'
          ? window.localStorage.getItem(TOPUP_STARTED_KEY)
          : null;
      const startedAtFromStorage = Number(startedAtRaw);
      const startedAtFromIntent = Number(pending?.startedAt);
      const startedAt = Number.isFinite(startedAtFromStorage)
        ? startedAtFromStorage
        : startedAtFromIntent;
      const shouldResume =
        !!pending &&
        (pendingState === 'checkout_started' ||
          shouldAutoInjectCheckoutSuccess({
            hasCheckoutParam: false,
            pendingIntent: pending,
            startedAt,
          }));
      if (shouldResume) {
        checkoutInjectedRef.current = true;
        setLocalOpsNotice('JGK added - continuing your task...');
        refreshPlayerBalance({ forceNetwork: true });
        resumePendingIntent('checkout-start');
      }
      clearCheckoutParam();
      return;
    }

    if (checkout === 'success') {
      setLocalOpsNotice('JGK added - continuing your task...');
      refreshPlayerBalance({ forceNetwork: true });
      resumePendingIntent('checkout');
    }

    clearCheckoutParam();
  }, [
    location.search,
    location.pathname,
    history,
    resumePendingIntent,
    refreshPlayerBalance,
  ]);

  const handleAcceptTask = useCallback(
    async (task) => {
      const id = task?.taskId || task?.id || task?._id;
      if (!id) return;
      const taskId = String(id);
      setAcceptingTaskId(taskId);
      setTaskAcceptFeedback(null);
      setRideReadyRequiredPrompt(null);
      if (!player?.token) {
        setAcceptingTaskId(null);
        setTaskAcceptFeedback({
          taskId,
          message: 'Log in to accept this task.',
        });
        setLocalOpsNotice('Log in to accept this task.');
        return;
      }
      if (
        !ensurePersonalLocationForAction('accept_task', () =>
          handleAcceptTaskRef.current?.(task),
        )
      ) {
        setAcceptingTaskId(null);
        return;
      }
      try {
        const headers = { Authorization: `Bearer ${player.token}` };
        if (shareFunnelContext?.shareType === 'task') {
          recordShareFunnelEvent(
            SHARE_FUNNEL_EVENT_NAMES.TASK_ACCEPT_CLICKED,
            shareFunnelContext,
            {
              taskId: id,
              eventId: [
                'share-accept-click',
                shareFunnelContext.shareFunnelId,
                id,
                Math.floor(Date.now() / 2000),
              ].join(':'),
              dedupe: false,
            },
          );
        }
        const acceptPayload = {
          ...(localOpsLaunchAttribution
            ? { acceptLaunchAttribution: localOpsLaunchAttribution }
            : {}),
          ...(shareFunnelContext?.shareType === 'task'
            ? {
                shareFunnelContext: {
                  ...shareFunnelContext,
                  taskId: id,
                },
              }
            : {}),
        };
        const res = await axiosConn.post(
          `local-ops/tasks/${id}/accept`,
          acceptPayload,
          { headers },
        );
        const updated = normalizeTaskPayload(res?.data);
        if (updated) {
          upsertTask(updated);
          setSelectedTask(updated);
        }
        setTaskAcceptFeedback(null);
      } catch (err) {
        const payload = err?.response?.data;
        const feedback = buildLocalOpsAcceptFeedback(payload || {});
        if (payload?.code === 'INSUFFICIENT_JGK') {
          setTaskAcceptFeedback({
            taskId,
            ...feedback,
          });
          setLocalOpsError(feedback.message);
          return;
        }
        if (payload?.code === 'TRUST_GATE_REQUIRED') {
          setTaskAcceptFeedback({
            taskId,
            ...feedback,
          });
          setTrustGate({
            tier: payload?.tier || 'T1',
            required: payload?.required || [],
            task: task,
          });
          try {
            localStorage.setItem(
              TRUST_GATE_RETRY_KEY,
              JSON.stringify({
                taskId: String(id),
                ts: Date.now(),
                ...(shareFunnelContext?.shareType === 'task'
                  ? { shareFunnelContext }
                  : {}),
              }),
            );
          } catch (e) {
            /* ignore */
          }
          return;
        }
        if (payload?.code === 'VERIFIED_LOCAL_REQUIRED') {
          setTaskAcceptFeedback({
            taskId,
            ...feedback,
          });
          setLocalOpsError(feedback.message);
          return;
        }
        if (payload?.code === 'RIDE_READY_REQUIRED') {
          const profilePath = resolveRideReadyProfilePath(feedback.profilePath);
          setLocalOpsError('');
          setTaskAcceptFeedback({
            taskId,
            ...feedback,
            profilePath,
          });
          setRideReadyRequiredPrompt({
            message: feedback.message,
            profilePath,
          });
          return;
        }
        if (
          payload?.code === 'TASK_NOT_SHARED' ||
          payload?.failureReason === 'not_shared'
        ) {
          setTaskAcceptFeedback({ taskId, ...feedback });
          setLocalOpsError(feedback.message);
          return;
        }
        if (isLocalOpsLocationCode(payload?.code)) {
          openLocationConsentGate({
            actionType: 'accept_task',
            retry: () => handleAcceptTaskRef.current?.(task),
          });
          return;
        }
        setTaskAcceptFeedback({
          taskId,
          ...feedback,
        });
        setLocalOpsError(feedback.message);
      } finally {
        setAcceptingTaskId(null);
      }
    },
    [
      player?.token,
      upsertTask,
      localOpsLaunchAttribution,
      shareFunnelContext,
      ensurePersonalLocationForAction,
      openLocationConsentGate,
      resolveRideReadyProfilePath,
    ],
  );

  const handleStartTask = useCallback(
    async (task) => {
      const id = task?.taskId || task?.id || task?._id;
      if (!id) return;
      if (!player?.token) {
        setLocalOpsNotice('Log in to start this task.');
        return;
      }
      if (
        !ensurePersonalLocationForAction('start_task', () =>
          handleStartTaskRef.current?.(task),
        )
      ) {
        return;
      }
      try {
        const headers = { Authorization: `Bearer ${player.token}` };
        const res = await axiosConn.post(
          `local-ops/tasks/${id}/start`,
          {},
          { headers },
        );
        const updated = normalizeTaskPayload(res?.data);
        if (updated) {
          upsertTask(updated);
          setSelectedTask(updated);
        }
      } catch (err) {
        if (isLocalOpsLocationCode(err?.response?.data?.code)) {
          openLocationConsentGate({
            actionType: 'start_task',
            retry: () => handleStartTaskRef.current?.(task),
          });
          return;
        }
        setLocalOpsError('Unable to start task right now.');
      }
    },
    [
      player?.token,
      upsertTask,
      ensurePersonalLocationForAction,
      openLocationConsentGate,
    ],
  );

  const handleTrustGateAction = useCallback(
    (action) => {
      const returnTo = window.location.href;
      if (action === 'google') {
        window.location.href = `/auth/google?returnTo=${encodeURIComponent(
          returnTo,
        )}`;
        return;
      }
      if (action === 'facebook') {
        window.location.href = `/auth/facebook?returnTo=${encodeURIComponent(
          returnTo,
        )}`;
        return;
      }
      if (action === 'payout') {
        history.push('/jgktoken#cashout');
        setTrustGate(null);
      }
    },
    [history],
  );

  const clearCompletionKeys = useCallback(() => {
    try {
      localStorage.removeItem(LAST_COMPLETION_TASK_KEY);
      localStorage.removeItem(LAST_COMPLETION_SEEN_KEY);
      localStorage.removeItem(LAST_COMPLETION_TS_KEY);
    } catch (e) {
      /* ignore */
    }
  }, []);

  const handleClosePostCompletion = useCallback(() => {
    setPostCompletionOpen(false);
    clearCompletionKeys();
  }, [clearCompletionKeys]);

  const handlePostCompletionPrimaryAction = useCallback(() => {
    const action = resolvePrimaryLandingAction();
    executeLandingPrimaryAction(action, { closeCompletion: true });
    clearCompletionKeys();
  }, [resolvePrimaryLandingAction, executeLandingPrimaryAction, clearCompletionKeys]);

  const handlePostCompletionSecondaryAction = useCallback(() => {
    setPostCompletionOpen(false);
    clearCompletionKeys();
    handleUseLocally();
  }, [clearCompletionKeys, handleUseLocally]);

  const handlePostCompletionShare = useCallback(
    (payload) => {
      const type = payload?.entityType === 'offering' ? 'offering' : 'task';
      const id =
        payload?.entityId ||
        payload?.id ||
        (type === 'offering' ? payload?.offeringId : payload?.taskId);
      if (!id) return;
      shareLocalOpsLink({
        type,
        id,
        visibility: payload?.visibility || 'nearby',
        source: 'completion-modal',
      });
    },
    [shareLocalOpsLink],
  );

  const completionPrimaryAction = landingPrimaryAction;
  const creatorReservedCount = creatorReservedOfferings.length;

  const completionPrimaryLabel = useMemo(
    () =>
      resolveCompletionPrimaryLabel({
        action: completionPrimaryAction,
        landingAmountLabel: landingEarnAmountLabel,
        creatorReservedCount,
      }),
    [completionPrimaryAction, landingEarnAmountLabel, creatorReservedCount],
  );

  const completionSecondaryAction = useMemo(() => {
    if (!completionPrimaryAction || completionPrimaryAction.type === 'use_locally') {
      return null;
    }
    return { kind: 'use_locally', label: 'Browse local offerings' };
  }, [completionPrimaryAction]);

  const resolvedPostCompletionContext = useMemo(() => {
    if (!postCompletionContext) return postCompletionContext;
    return {
      ...postCompletionContext,
      nextAction: {
        kind:
          postCompletionContext?.nextAction?.kind ||
          completionPrimaryAction?.type ||
          'landing_primary',
        label: postCompletionContext?.nextAction?.label || completionPrimaryLabel,
      },
      secondaryAction:
        postCompletionContext?.secondaryAction || completionSecondaryAction,
    };
  }, [
    postCompletionContext,
    completionPrimaryAction,
    completionPrimaryLabel,
    completionSecondaryAction,
  ]);
  const completionModalBalance = useMemo(() => {
    const raw = Number(resolvedPostCompletionContext?.viewerBalanceJGK);
    if (!Number.isFinite(raw)) return null;
    const authoritative =
      resolvedPostCompletionContext?.viewerBalanceAuthoritative === true ||
      (resolvedPostCompletionContext?.viewerBalanceAuthoritative == null &&
        Number.isFinite(raw));
    if (!authoritative) return null;
    return Math.round(raw);
  }, [resolvedPostCompletionContext]);

  const handleCompleteTask = useCallback(
    async (task) => {
      const id = task?.taskId || task?.id || task?._id;
      if (!id) return;
      if (!player?.token) {
        setLocalOpsNotice('Log in to complete this task.');
        return;
      }
      try {
        const headers = { Authorization: `Bearer ${player.token}` };
        const res = await axiosConn.post(
          `local-ops/tasks/${id}/complete`,
          { proofMedia: task?.proofMedia || [] },
          { headers },
        );
        const completionTruth = res?.data?.completion || null;
        const completionLocalActivityReward = normalizeLocalActivityReward(completionTruth);
        const normalizedUpdatedTask = normalizeTaskPayload(res?.data);
        const updated = normalizedUpdatedTask && completionLocalActivityReward
          ? { ...normalizedUpdatedTask, localActivityReward: completionLocalActivityReward }
          : normalizedUpdatedTask;
        if (updated) {
          upsertTask(updated);
          setSelectedTask(null);
          if (updated.status === 'completed') {
            try {
              localStorage.setItem(LAST_COMPLETION_TASK_KEY, String(id));
              localStorage.removeItem(LAST_COMPLETION_SEEN_KEY);
              localStorage.setItem(LAST_COMPLETION_TS_KEY, String(Date.now()));
            } catch (e) {
              /* ignore */
            }
            const completionContext = buildCompletionContext(
              updated,
              'creator',
              completionTruth,
            );
            if (completionContext) {
              setPostCompletionContext(completionContext);
              setPostCompletionOpen(true);
            }
          }
          handleOpenSharePanel('task', updated, 'completed');
          return;
        }
        handleOpenSharePanel('task', task, 'completed');
      } catch (err) {
        setLocalOpsError('Unable to complete task right now.');
      }
    },
    [player?.token, upsertTask, handleOpenSharePanel, buildCompletionContext],
  );

  useLayoutEffect(() => {
    handleCreateOfferingRef.current = handleCreateOffering;
    handleCreateTaskRef.current = handleCreateTask;
    handleReserveOfferingRef.current = handleReserveOffering;
    handleAcceptTaskRef.current = handleAcceptTask;
    handleStartTaskRef.current = handleStartTask;
    handleRaisePayAndRenotifyRef.current = handleRaisePayAndRenotify;
  }, [
    handleCreateOffering,
    handleCreateTask,
    handleReserveOffering,
    handleAcceptTask,
    handleStartTask,
    handleRaisePayAndRenotify,
  ]);

  // Retry accept after trust-gate upgrade (OAuth/payout) if pending
  useEffect(() => {
    const payload = (() => {
      try {
        const raw = localStorage.getItem(TRUST_GATE_RETRY_KEY);
        return raw ? JSON.parse(raw) : null;
      } catch (e) {
        return null;
      }
    })();
    const retryAction = getTrustGateRetryAction({
      payload,
      hasPlayerToken: !!player?.token,
    });
    if (retryAction.type === 'skip') return;
    if (retryAction.type === 'clear_expired') {
      try {
        localStorage.removeItem(TRUST_GATE_RETRY_KEY);
      } catch (e) {
        /* ignore */
      }
      return;
    }
    const retry = async () => {
      try {
        const headers = { Authorization: `Bearer ${player.token}` };
        const retryShareFunnelContext =
          retryAction.shareFunnelContext || shareFunnelContext;
        const acceptPayload = {
          ...(localOpsLaunchAttribution
            ? { acceptLaunchAttribution: localOpsLaunchAttribution }
            : {}),
          ...(retryShareFunnelContext?.shareType === 'task'
            ? {
                shareFunnelContext: {
                  ...retryShareFunnelContext,
                  taskId: retryAction.taskId,
                },
              }
            : {}),
        };
        const res = await axiosConn.post(
          `local-ops/tasks/${retryAction.taskId}/accept`,
          acceptPayload,
          { headers },
        );
        const updated = normalizeTaskPayload(res?.data);
        if (updated) {
          upsertTask(updated);
          setSelectedTask(updated);
        }
        localStorage.removeItem(TRUST_GATE_RETRY_KEY);
      } catch (err) {
        const feedback = buildLocalOpsAcceptFeedback(err?.response?.data || {});
        setTaskAcceptFeedback({
          taskId: String(retryAction.taskId),
          ...feedback,
        });
        setLocalOpsError(feedback.message);
        // leave the retry key so user can attempt manually
      }
    };
    retry();
  }, [player?.token, upsertTask, localOpsLaunchAttribution, shareFunnelContext]);

  // Show post-completion modal if a completion was persisted but not yet viewed
  useEffect(() => {
    const taskId = (() => {
      try {
        return localStorage.getItem(LAST_COMPLETION_TASK_KEY);
      } catch (e) {
        return null;
      }
    })();
    const seen = (() => {
      try {
        return localStorage.getItem(LAST_COMPLETION_SEEN_KEY);
      } catch (e) {
        return null;
      }
    })();
    const ts = (() => {
      try {
        return Number(localStorage.getItem(LAST_COMPLETION_TS_KEY));
      } catch (e) {
        return null;
      }
    })();
    const completionAction = getPersistedCompletionAction({
      taskId,
      seen,
      timestamp: ts,
    });
    if (completionAction.type === 'clear_stale') {
      // stale completion; clear and skip
      try {
        localStorage.removeItem(LAST_COMPLETION_TASK_KEY);
        localStorage.removeItem(LAST_COMPLETION_TS_KEY);
        localStorage.removeItem(LAST_COMPLETION_SEEN_KEY);
      } catch (e) {
        /* ignore */
      }
      return;
    }
    if (completionAction.type === 'skip') return;
    // Post-completion screen now opens inline at completion time.
  }, []);

  const buildLocalOpsSnapshotParams = useCallback(
    (center, distance, unitLabel) => {
      if (
        !center ||
        !Number.isFinite(center.lat) ||
        !Number.isFinite(center.lon)
      ) {
        return null;
      }
      const numericDistance = Number(distance);
      if (!Number.isFinite(numericDistance) || numericDistance <= 0) {
        return null;
      }
      return {
        distance: numericDistance,
        unit: unitLabel || 'mi',
        lat: center.lat,
        lng: center.lon,
        limit: 100,
      };
    },
    [],
  );

  const logVisibilityDebug = useCallback(
    async (params) => {
      const debugParams = {
        playerId: currentPlayerId || playerId,
        lng: params?.lng,
        lat: params?.lat,
      };
      if (!debugParams.playerId || debugParams.lng == null || debugParams.lat == null) return;
      const headers = player?.token
        ? { Authorization: `Bearer ${player.token}` }
        : undefined;
      try {
        // Use relative path to avoid double-prefixing with baseURL
        const res = await axiosConn.get('local-ops/debug/visibility', {
          params: debugParams,
          headers,
        });
        console.log('[localops visibility debug]', {
          request: debugParams,
          included: res?.data?.items?.length || res?.data?.length || 0,
          items: res?.data,
        });
        return res?.data;
      } catch (err) {
        console.log(
          '[localops visibility debug] failed',
          err?.message || err,
        );
        return null;
      }
    },
    [currentPlayerId, player?.token, playerId],
  );

  const requestLocalOpsSnapshot = useCallback(
    async (center, distance, unitLabel) => {
      if (!localOpsFlags.base) return;
      const params = buildLocalOpsSnapshotParams(center, distance, unitLabel);
      if (!params) return;
      setLocalOpsLoading(true);
      const headers = player?.token
        ? { Authorization: `Bearer ${player.token}` }
        : undefined;
      try {
        const [tasksRes, offeringsRes, debugRes] = await Promise.all([
          axiosConn.get('local-ops/tasks/snapshot', { params, headers }),
          axiosConn.get('local-ops/offerings/snapshot', { params, headers }),
          logVisibilityDebug(params),
        ]);
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.log('[localops snapshot][tasks-raw]', tasksRes?.data?.slice?.(0, 3) || tasksRes?.data);
        }
        const taskList = normalizeLocalOpsCollection(tasksRes?.data)
          .map(normalizeTaskPayload)
          .filter(Boolean);
        replaceTasks(taskList);
        const offeringList = normalizeLocalOpsCollection(offeringsRes?.data)
          .map(normalizeLocalOpsItem)
          .filter(Boolean);
        replaceOfferings(offeringList);
        console.log('[localops snapshot][apply]', {
          tasks: taskList.length,
          offerings: offeringList.length,
        });
        console.log('[localops visibility client]', {
          request: params,
          fetched: {
            tasks: taskList.length,
            offerings: offeringList.length,
          },
          debug: debugRes,
          filters: {
            layers: effectiveLayers,
            radiusMeters: discoveryRadiusMeters,
            travelMode,
          },
        });
        if (!hasLoggedLocalOpsSnapshotRef.current) {
          console.log('[localops snapshot]', {
            tasks: taskList,
            offerings: offeringList,
          });
          hasLoggedLocalOpsSnapshotRef.current = true;
        }
        const seedEvents = buildLocalOpsSeedEvents(taskList, offeringList);
        setLocalOpsSeedEvents(seedEvents);
        hasSeededLocalOpsFeedRef.current = true;
        setHasCompletedInitialLocalOpsSnapshot(true);
        setLocalOpsLoading(false);
      } catch (err) {
        // keep existing state on snapshot failures
        setLocalOpsLoading(false);
      }
    },
    [
      localOpsFlags.base,
      player?.token,
      buildLocalOpsSnapshotParams,
      replaceTasks,
      replaceOfferings,
      logVisibilityDebug,
      effectiveLayers,
      discoveryRadiusMeters,
      travelMode,
    ],
  );

  const requestRealtimeLocalOpsSnapshot = useCallback(
    async (center, distance, unitLabel, entityType) => {
      if (!localOpsFlags.base) return;
      if (entityType !== 'task' && entityType !== 'offering') return;
      const params = buildLocalOpsSnapshotParams(center, distance, unitLabel);
      if (!params) return;
      const headers = player?.token
        ? { Authorization: `Bearer ${player.token}` }
        : undefined;
      try {
        if (entityType === 'task') {
          const res = await axiosConn.get('local-ops/tasks/snapshot', {
            params,
            headers,
          });
          const taskList = normalizeLocalOpsCollection(res?.data)
            .map(normalizeTaskPayload)
            .filter(Boolean);
          taskList.forEach((task) => upsertTask(task));
          if (taskList.length) {
            setLocalOpsSeedEvents((prev) =>
              mergeLocalOpsSeedEvents(prev, taskList, []),
            );
            hasSeededLocalOpsFeedRef.current = true;
          }
          if (process.env.NODE_ENV === 'development') {
            // eslint-disable-next-line no-console
            console.log('[localops realtime][task snapshot merge]', {
              tasks: taskList.length,
            });
          }
          return;
        }

        const res = await axiosConn.get('local-ops/offerings/snapshot', {
          params,
          headers,
        });
        const offeringList = normalizeLocalOpsCollection(res?.data)
          .map(normalizeLocalOpsItem)
          .filter(Boolean);
        offeringList.forEach((offering) => upsertOffering(offering));
        if (offeringList.length) {
          setLocalOpsSeedEvents((prev) =>
            mergeLocalOpsSeedEvents(prev, [], offeringList),
          );
          hasSeededLocalOpsFeedRef.current = true;
        }
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.log('[localops realtime][offering snapshot merge]', {
            offerings: offeringList.length,
          });
        }
      } catch (err) {
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.log('[localops realtime][snapshot merge failed]', {
            entityType,
            message: err?.message || err,
          });
        }
      }
    },
    [
      localOpsFlags.base,
      buildLocalOpsSnapshotParams,
      player?.token,
      upsertTask,
      upsertOffering,
    ],
  );

  const scheduleLocalOpsSnapshot = useCallback(
    (center, distance, unitLabel, reason) => {
      if (!center || !distance || !localOpsFlags.base) return;
      const numericDistance = Number(distance);
      if (!Number.isFinite(numericDistance) || numericDistance <= 0) return;
      const last = localOpsSnapshotRef.current;
      const lastCenter = last.lastCenter;
      const movedMeters = lastCenter
        ? getDistanceFromLatLonInMeters(
            lastCenter.lat,
            lastCenter.lon,
            center.lat,
            center.lon,
          )
        : Infinity;
      const radiusChanged =
        last.lastDistance == null ||
        Math.abs(last.lastDistance - numericDistance) > 0.05 ||
        last.lastUnit !== unitLabel;
      const distanceMeters =
        unitLabel === 'mi'
          ? numericDistance * 1609.34
          : numericDistance * 1000;
      const moveThreshold = Math.max(
        250,
        Math.min(2500, distanceMeters * 0.12),
      );
      if (!radiusChanged && movedMeters < moveThreshold) return;
      if (last.timer) clearTimeout(last.timer);
      last.timer = setTimeout(() => {
        requestLocalOpsSnapshot(center, numericDistance, unitLabel);
        localOpsSnapshotRef.current.lastCenter = { ...center };
        localOpsSnapshotRef.current.lastDistance = numericDistance;
        localOpsSnapshotRef.current.lastUnit = unitLabel;
      }, OFFERING_NEARBY_DEBOUNCE_MS);
    },
    [localOpsFlags.base, requestLocalOpsSnapshot],
  );

  const isLocalOpsHintNearby = useCallback(
    (payload, { allowMissingCoordinates = false } = {}) => {
      if (
        !discoveryCenter ||
        !Number.isFinite(discoveryCenter.lat) ||
        !Number.isFinite(discoveryCenter.lon)
      ) {
        return false;
      }
      const coords = normalizeCoordinates(payload);
      if (!coords) return allowMissingCoordinates;
      if (!discoveryRadiusMeters) return true;
      const distance = getDistanceFromLatLonInMeters(
        discoveryCenter.lat,
        discoveryCenter.lon,
        coords[1],
        coords[0],
      );
      return distance <= discoveryRadiusMeters * 1.05;
    },
    [discoveryCenter, discoveryRadiusMeters],
  );

  const scheduleRealtimeLocalOpsSnapshot = useCallback(
    (payload, reason, { entityType, allowMissingCoordinates = false } = {}) => {
      if (!localOpsFlags.base) return;
      if (entityType !== 'task' && entityType !== 'offering') return;
      if (!isLocalOpsHintNearby(payload, { allowMissingCoordinates })) return;
      if (
        !discoveryCenter ||
        !Number.isFinite(discoveryCenter.lat) ||
        !Number.isFinite(discoveryCenter.lon)
      ) {
        return;
      }
      const numericDistance = Number(radius);
      if (!Number.isFinite(numericDistance) || numericDistance <= 0) return;
      const ref = localOpsRealtimeSnapshotRef.current[entityType];
      if (!ref) return;
      if (ref.timer) clearTimeout(ref.timer);
      const now = Date.now();
      const cooldownRemaining = Math.max(
        0,
        LOCALOPS_REALTIME_SNAPSHOT_COOLDOWN_MS -
          (now - (ref.lastRequestedAt || 0)),
      );
      const delay = Math.max(
        LOCALOPS_REALTIME_SNAPSHOT_DEBOUNCE_MS,
        cooldownRemaining,
      );
      const center = { lat: discoveryCenter.lat, lon: discoveryCenter.lon };
      ref.timer = setTimeout(() => {
        ref.timer = null;
        ref.lastRequestedAt = Date.now();
        requestRealtimeLocalOpsSnapshot(
          center,
          numericDistance,
          unit,
          entityType,
        );
        localOpsSnapshotRef.current.lastCenter = { ...center };
        localOpsSnapshotRef.current.lastDistance = numericDistance;
        localOpsSnapshotRef.current.lastUnit = unit;
      }, delay);
      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.log('[localops realtime][snapshot scheduled]', {
          reason,
          entityType,
          delay,
        });
      }
    },
    [
      localOpsFlags.base,
      isLocalOpsHintNearby,
      discoveryCenter,
      radius,
      unit,
      requestRealtimeLocalOpsSnapshot,
    ],
  );

  useEffect(() => {
    if (!socket2 || !localOpsFlags.base) return;
    const handleTaskCreatedEntity = (payload) => {
      scheduleRealtimeLocalOpsSnapshot(payload, 'socket:task_created', {
        entityType: 'task',
        allowMissingCoordinates: false,
      });
    };
    const handleOfferingCreatedEntity = (payload) => {
      scheduleRealtimeLocalOpsSnapshot(payload, 'socket:offering_created', {
        entityType: 'offering',
        allowMissingCoordinates: false,
      });
    };
    const handleLiveHint = (payload) => {
      const entityType = getLocalOpsCreatedLiveHintType(payload);
      if (!entityType) return;
      scheduleRealtimeLocalOpsSnapshot(payload, 'live:created', {
        entityType,
        allowMissingCoordinates: false,
      });
    };
    const handleNotificationHint = (payload) => {
      const entityType = getLocalOpsNotificationHintType(payload);
      if (!entityType) return;
      scheduleRealtimeLocalOpsSnapshot(payload, 'notification:localops', {
        entityType,
        allowMissingCoordinates: true,
      });
    };

    socket2.on('task:created', handleTaskCreatedEntity);
    socket2.on('offering:created', handleOfferingCreatedEntity);
    socket2.on('localops.task.created', handleTaskCreatedEntity);
    socket2.on('localops.offering.created', handleOfferingCreatedEntity);
    socket2.on('localops:live', handleLiveHint);
    socket2.on('localops.live.event', handleLiveHint);
    socket2.on('notification:new', handleNotificationHint);

    return () => {
      socket2.off('task:created', handleTaskCreatedEntity);
      socket2.off('offering:created', handleOfferingCreatedEntity);
      socket2.off('localops.task.created', handleTaskCreatedEntity);
      socket2.off('localops.offering.created', handleOfferingCreatedEntity);
      socket2.off('localops:live', handleLiveHint);
      socket2.off('localops.live.event', handleLiveHint);
      socket2.off('notification:new', handleNotificationHint);
    };
  }, [
    socket2,
    localOpsFlags.base,
    scheduleRealtimeLocalOpsSnapshot,
  ]);

  useEffect(() => {
    if (!localOpsFlags.base) return;
    if (hasFiredInitialLocalOpsSnapshotRef.current) return;
    if (
      !discoveryCenter ||
      !Number.isFinite(discoveryCenter.lat) ||
      !Number.isFinite(discoveryCenter.lon)
    ) {
      return;
    }
    const center = { lat: discoveryCenter.lat, lon: discoveryCenter.lon };
    const params = buildLocalOpsSnapshotParams(center, radius, unit);
    if (!params) return;

    localOpsSnapshotRef.current.lastCenter = { ...center };
    localOpsSnapshotRef.current.lastDistance = params.distance;
    localOpsSnapshotRef.current.lastUnit = params.unit;
    hasFiredInitialLocalOpsSnapshotRef.current = true;
    requestLocalOpsSnapshot(center, radius, unit);
  }, [
    localOpsFlags.base,
    discoveryCenter,
    radius,
    unit,
    buildLocalOpsSnapshotParams,
    requestLocalOpsSnapshot,
  ]);

  useEffect(() => {
    if (!localOpsFlags.base) return;
    if (
      !discoveryCenter ||
      !Number.isFinite(discoveryCenter.lat) ||
      !Number.isFinite(discoveryCenter.lon)
    ) {
      return;
    }
    scheduleLocalOpsSnapshot(
      { lat: discoveryCenter.lat, lon: discoveryCenter.lon },
      radius,
      unit,
      'radius',
    );
  }, [
    localOpsFlags.base,
    discoveryCenter,
    radius,
    unit,
    scheduleLocalOpsSnapshot,
  ]);

  useEffect(() => {
    if (!localOpsFlags.base || !radiusMeters) return;
    requestPresencePlus();
  }, [localOpsFlags.base, radiusMeters, requestPresencePlus]);

  useEffect(() => {
    if (!Array.isArray(offerings)) return;
    try {
      secureLocalStorage.setItem(
        LOCALOPS_OFFERINGS_CACHE_KEY,
        JSON.stringify({ updatedAt: Date.now(), offerings }),
      );
    } catch (err) {
      // ignore storage failures
    }
  }, [offerings]);

  useEffect(() => {
    if (!Array.isArray(tasks)) return;
    try {
      secureLocalStorage.setItem(
        LOCALOPS_TASKS_CACHE_KEY,
        JSON.stringify({ updatedAt: Date.now(), tasks }),
      );
    } catch (err) {
      // ignore storage failures
    }
  }, [tasks]);

  useEffect(() => {
    const shareParam = queryParams.get('share');
    if (!shareParam) return;
    if (!player || !localOpsFlags.base) return;
    if (hasResumedSnapshotRef.current) return;
    if (tasks.length > 0 || offerings.length > 0) return;

    const fallbackCenter =
      discoveryCenter || storedLocation || mapCenter || storedViewport || null;

    if (!fallbackCenter || !fallbackCenter.lat || !fallbackCenter.lon) {
      console.log('[LocalOps][resume] snapshot deferred — no center yet');
      return;
    }

    console.log('[LocalOps][resume] forcing snapshot after magic link', {
      center: fallbackCenter,
      radius,
      unit,
      tasks: tasks.length,
      offerings: offerings.length,
    });

    requestLocalOpsSnapshot(
      { lat: fallbackCenter.lat, lon: fallbackCenter.lon },
      radius,
      unit,
    );
    hasResumedSnapshotRef.current = true;
  }, [
    player,
    localOpsFlags.base,
    tasks.length,
    offerings.length,
    queryParams,
    discoveryCenter,
    storedLocation,
    mapCenter,
    storedViewport,
    radius,
    unit,
    requestLocalOpsSnapshot,
  ]);

  useEffect(() => {
    return () => {
      if (localOpsSnapshotRef.current.timer) {
        clearTimeout(localOpsSnapshotRef.current.timer);
      }
      Object.values(localOpsRealtimeSnapshotRef.current || {}).forEach(
        (entry) => {
          if (entry?.timer) clearTimeout(entry.timer);
        },
      );
    };
  }, []);

  const calculateBoundingBox = (posts) => {
    if (!posts || posts.length === 0) return null;

    // Filter out posts without valid location or coordinates
    const validPosts = posts.filter(
      (post) =>
        post.location &&
        Array.isArray(post.location.coordinates) &&
        post.location.coordinates.length === 2 &&
        typeof post.location.coordinates[0] === 'number' &&
        typeof post.location.coordinates[1] === 'number',
    );

    if (validPosts.length === 0) return null; // Return null if no valid posts

    const lats = validPosts.map((post) => post.location.coordinates[1]); // Latitude
    const lons = validPosts.map((post) => post.location.coordinates[0]); // Longitude

    const minLat = Math.min(...lats);
    const maxLat = Math.max(...lats);
    const minLon = Math.min(...lons);
    const maxLon = Math.max(...lons);

    return [
      [minLon, minLat],
      [maxLon, maxLat],
    ]; // Southwest and Northeast corners
  };

  const radiusPaddingFactor = 3; // Try 1.1-1.2 for a comfortable fit
  const MOVEMENT_THRESHOLD_METERS = 1;
  const calculateViewport = (
    boundingBox,
    mapWidth,
    mapHeight,
    radius,
    centerLat,
  ) => {
    const viewport = new WebMercatorViewport({
      width: mapWidth,
      height: mapHeight,
    }).fitBounds(boundingBox, { padding: 50 });

    // Convert radius to meters if needed
    const radiusInMeters = unit === 'mi' ? radius * 1609.34 : radius * 1000;

    // Calculate zoom so that the diameter (2*radius) fits in the map width
    const zoomForRadius = Math.log2(
      (156543.03392 *
        Math.cos((viewport.latitude * Math.PI) / 180) *
        mapWidth) /
        (radiusInMeters * 2 * radiusPaddingFactor),
    );

    // Clamp zoom
    const clampedZoom = Math.max(minZoom, Math.min(maxZoom, zoomForRadius));

    setCalculatedZoom(clampedZoom);

    return {
      latitude: viewport.latitude,
      longitude: viewport.longitude,
      zoom:
        zoom !== initialZoom && radius === initialRadius ? zoom : clampedZoom,
    };
  };
  // Use RAF to keep map interactions responsive without flooding state updates.
  const scheduleViewportUpdate = useCallback((nextViewport) => {
    if (!nextViewport) return;
    viewportUpdateRef.current.next = nextViewport;
    if (viewportUpdateRef.current.rafId) return;
    viewportUpdateRef.current.rafId = requestAnimationFrame(() => {
      const pending = viewportUpdateRef.current.next;
      viewportUpdateRef.current.rafId = null;
      if (!pending) return;
      setZoom(pending.zoom);
      setViewport((prev) => ({ ...prev, ...pending }));
    });
  }, []);

  const handleViewportChange = useCallback(
    (event) => {
      const nextViewport = event?.viewState || event?.viewport || event;
      if (!nextViewport) return;
      scheduleViewportUpdate(nextViewport);
    },
    [scheduleViewportUpdate],
  );

  const handleViewportCommit = useCallback(
    (event) => {
      const nextViewport = event?.viewState || event?.viewport || event;
      if (
        !nextViewport ||
        !Number.isFinite(nextViewport.latitude) ||
        !Number.isFinite(nextViewport.longitude)
      ) {
        return;
      }
      secureLocalStorage.setItem(
        'playerMapViewport',
        JSON.stringify({
          latitude: nextViewport.latitude,
          longitude: nextViewport.longitude,
          zoom: nextViewport.zoom,
        }),
      );
      if (travelMode) {
        scheduleLocalOpsSnapshot(
          { lat: nextViewport.latitude, lon: nextViewport.longitude },
          radius,
          unit,
          'viewport',
        );
      }
    },
    [travelMode, radius, unit, scheduleLocalOpsSnapshot],
  );

  useLayoutEffect(() => {
    if (!initialViewportSeed || hasSeededViewportRef.current) return;
    hasSeededViewportRef.current = true;
    setViewport((prev) => {
      const shouldOverrideZoom = !prev.zoom || prev.zoom <= 4;
      const nextViewport = {
        ...prev,
        latitude: initialViewportSeed.lat,
        longitude: initialViewportSeed.lon,
        zoom: shouldOverrideZoom
          ? initialViewportSeed.zoom || initialViewportZoom
          : prev.zoom,
      };
      initialViewport.current = nextViewport;
      return nextViewport;
    });
    if (initialViewportSeed.source !== 'region') {
      if (latitude === null) SetLatitude(initialViewportSeed.lat);
      if (longitude === null) SetLongitude(initialViewportSeed.lon);
    }
  }, [
    initialViewportSeed,
    initialViewportZoom,
    latitude,
    longitude,
    SetLatitude,
    SetLongitude,
  ]);

  useEffect(() => {
    return () => {
      if (viewportUpdateRef.current.rafId) {
        cancelAnimationFrame(viewportUpdateRef.current.rafId);
      }
    };
  }, []);

  const playersWithinCount = useMemo(
    () => Object.keys(playersWithin).length,
    [playersWithin],
  );

  useEffect(() => {
    if (mapBooted) return;
    const hasSeed = !!initialViewportSeed;
    const hasCoords =
      Number.isFinite(latitude) && Number.isFinite(longitude);
    const hasData = postItems.length > 0 || playersWithinCount > 0;
    const delayMs = hasSeed || hasCoords || hasData ? 160 : 520;
    if (mapBootTimerRef.current) {
      clearTimeout(mapBootTimerRef.current);
    }
    mapBootTimerRef.current = setTimeout(() => {
      setMapBooted(true);
    }, delayMs);
    return () => {
      if (mapBootTimerRef.current) {
        clearTimeout(mapBootTimerRef.current);
      }
    };
  }, [
    mapBooted,
    initialViewportSeed,
    latitude,
    longitude,
    postItems.length,
    playersWithinCount,
  ]);
  // const handlePlayerLocationUpdate = (updatedPlayer) => {
  //   console.log(
  //     'Received location update for:',
  //     updatedPlayer.playerId,
  //     updatedPlayer.lastLocation.coordinates[0],
  //     updatedPlayer.lastLocation.coordinates[1],
  //   );

  //   setPlayersWithin((prevPlayers) => {
  //     console.log('Previous playersWithin:', prevPlayers);

  //     // Find the existing player in the array
  //     const existingPlayer = prevPlayers?.find(
  //       (player) => player.playerId === updatedPlayer.playerId,
  //     );

  //     if (existingPlayer) {
  //       console.log(
  //         'Existing player found:',
  //         existingPlayer.playerId,
  //         'Existing coordinates:',
  //         existingPlayer.lastLocation.coordinates,
  //       );

  //       // Only update if the player's location has changed
  //       if (
  //         existingPlayer.lastLocation.coordinates[0] ===
  //           updatedPlayer.lastLocation.coordinates[0] &&
  //         existingPlayer.lastLocation.coordinates[1] ===
  //           updatedPlayer.lastLocation.coordinates[1]
  //       ) {
  //         console.log(
  //           'No location change detected for:',
  //           updatedPlayer.playerId,
  //         );
  //         return prevPlayers; // No changes, return the previous state
  //       } else {
  //         console.log(
  //           'Location change detected for:',
  //           updatedPlayer.playerId,
  //           'New coordinates:',
  //           updatedPlayer.lastLocation.coordinates,
  //         );
  //       }
  //     } else {
  //       console.log(
  //         'Player not found in playersWithin, adding new player:',
  //         updatedPlayer.playerId,
  //       );
  //     }

  //     // Update the player or add a new one
  //     const updatedPlayers = existingPlayer
  //       ? prevPlayers.map((player) =>
  //           player.playerId === updatedPlayer.playerId
  //             ? {
  //                 ...player, // Preserve existing player data
  //                 lastLocation: updatedPlayer.lastLocation, // Update only the lastLocation
  //               }
  //             : player,
  //         )
  //       : [
  //           ...prevPlayers,
  //           {
  //             ...updatedPlayer, // Add the new player
  //           },
  //         ];

  //     console.log('Updated playersWithin:', updatedPlayers);
  //     return updatedPlayers; // Return the updated state
  //   });
  // };

  useEffect(() => {
    const handleUnload = () => {
      if (
        personalLocationReadyRef.current &&
        latitude &&
        longitude &&
        player?.token
      ) {
        const data = {
          latitude,
          longitude,
          accuracy,
          timestamp,
          token: player.token, // Include token in body for backend auth
        };
        const result = navigator.sendBeacon(
          '/api/v1/players/lastLocation',
          JSON.stringify(data),
        );
        if (result) {
          console.log('[sendBeacon] Location beacon queued for sending.');
        } else {
          console.log('[sendBeacon] Failed to queue location beacon.');
        }
      }
    };
    window.addEventListener('beforeunload', handleUnload);
    return () => window.removeEventListener('beforeunload', handleUnload);
  }, [latitude, longitude, accuracy, timestamp, player?.token]);

  useEffect(() => {
    if (!locationRefreshEnabled || !personalLocationReadyRef.current) {
      return undefined;
    }
    let heartbeatId;
    let mounted = true;

    async function sendHeartbeat() {
      if (!mounted) return;
      try {
        await getLocationAndSave(
          SetLatitude,
          SetLongitude,
          SetAccuracy,
          SetTimestamp,
          player,
        );
        // Optionally, you can log or handle success here
        console.log('Heartbeat location sent to backend');
      } catch (err) {
        console.log('Heartbeat location update failed:', err);
      }
      if (!mounted) return;
      heartbeatId = setTimeout(sendHeartbeat, 30000); // 30 seconds
    }

    sendHeartbeat();

    return () => {
      mounted = false;
      clearTimeout(heartbeatId);
    };
  }, [player, locationRefreshEnabled]);

  const applyPlayerLocationUpdate = useCallback((prevPlayers, updatedPlayer) => {
    // console.log(
    //   'Received location update for:',
    //   updatedPlayer.playerId,
    //   updatedPlayer.lastLocation.coordinates[0],
    //   updatedPlayer.lastLocation.coordinates[1],
    // );

    // console.log('Previous playersWithin:', prevPlayers);

    const existingPlayer = prevPlayers[updatedPlayer.playerId];
    let newLastMovementTime = existingPlayer?.lastMovementTime || Date.now();

    if (existingPlayer) {
      // console.log(
      //   'Existing player found:',
      //   existingPlayer.playerId,
      //   'Existing coordinates:',
      //   existingPlayer.lastLocation.coordinates,
      // );

      // Calculate distance between previous and new location
      const [prevLon, prevLat] = existingPlayer.lastLocation.coordinates;
      const [newLon, newLat] = updatedPlayer.lastLocation.coordinates;
      const distance = getDistanceFromLatLonInMeters(
        prevLat,
        prevLon,
        newLat,
        newLon,
      );

      if (distance < MOVEMENT_THRESHOLD_METERS) {
        console.log(
          `Movement (${distance.toFixed(2)}m) below threshold for:`,
          updatedPlayer.playerId,
        );
        // Not enough movement, ignore
        return prevPlayers;
      }

      if (prevLon === newLon && prevLat === newLat) {
        // console.log(
        //   'No location change detected for:',
        //   updatedPlayer.playerId,
        // );
        return prevPlayers;
      } else {
        // Location changed, update lastMovementTime
        newLastMovementTime = Date.now();
        console.log(
          'Location change detected for:',
          updatedPlayer.playerId,
          'New coordinates:',
          updatedPlayer.lastLocation.coordinates,
          `Distance moved: ${distance.toFixed(2)}m`,
        );
      }
    } else {
      newLastMovementTime = Date.now();
      console.log(
        'Player not found in playersWithin, adding new player:',
        updatedPlayer.playerId,
      );
    }

    const updatedPlayers = {
      ...prevPlayers,
      [updatedPlayer.playerId]: {
        ...existingPlayer,
        ...updatedPlayer,
        lastLocation: updatedPlayer.lastLocation,
        lastMovementTime: newLastMovementTime,
      },
    };

    // console.log('Updated playersWithin:', updatedPlayers);
    return updatedPlayers;
  }, []);

  const flushPlayerUpdates = useCallback(() => {
    const queued = playerUpdateQueueRef.current;
    if (!queued.length) {
      playerUpdateTimerRef.current = null;
      return;
    }
    playerUpdateQueueRef.current = [];
    playerUpdateTimerRef.current = null;
    setPlayersWithin((prevPlayers) => {
      let nextPlayers = prevPlayers;
      queued.forEach((updatedPlayer) => {
        nextPlayers = applyPlayerLocationUpdate(nextPlayers, updatedPlayer);
      });
      return nextPlayers;
    });
  }, [applyPlayerLocationUpdate]);

  // Buffer socket deltas to avoid per-event re-renders on mobile.
  const enqueuePlayerLocationUpdate = useCallback(
    (updatedPlayer) => {
      playerUpdateQueueRef.current.push(updatedPlayer);
      if (playerUpdateTimerRef.current) return;
      const intervalMs = pageVisibilityRef.current
        ? mobileView
          ? 250
          : 120
        : 1000;
      playerUpdateTimerRef.current = setTimeout(
        flushPlayerUpdates,
        intervalMs,
      );
    },
    [flushPlayerUpdates, mobileView, pageVisibilityRef],
  );

  useEffect(() => {
    return () => {
      if (playerUpdateTimerRef.current) {
        clearTimeout(playerUpdateTimerRef.current);
      }
      if (pendingResumeTimerRef.current) {
        clearTimeout(pendingResumeTimerRef.current);
      }
    };
  }, []);

  const handlePlayerLocationUpdate = useCallback(
    (updatedPlayer) => {
      enqueuePlayerLocationUpdate(updatedPlayer);
    },
    [enqueuePlayerLocationUpdate],
  );

  useEffect(() => {
    if (!effectiveLayers.posts) return;
    let mounted = true;
    if (latitude && longitude) {
      const distance = getDistance(
        lastFetchLocation.lat,
        lastFetchLocation.lon,
        latitude,
        longitude,
        unit, // 'mi' or 'km'
      );
      // Only trigger if threshold is crossed
      if (!mounted) return;
      if (
        lastFetchLocation.lat === null ||
        lastFetchLocation.lon === null ||
        distance > 1 // 1 mile or your chosen threshold
      ) {
        setLastFetchLocation({ lat: latitude, lon: longitude });
        setFetchLat(latitude); // This triggers useGetPosts
        setFetchLon(longitude);
      }
    }
    return () => {
      mounted = false; // Cleanup function to prevent memory leaks
      // Cleanup function to prevent memory leaks
    };
    // Only depend on latitude, longitude, unit, and lastFetchLocation
    // Do NOT include lastFetchLocation.lat/lon in the dependency array, or you'll get stuck in a loop!
  }, [latitude, longitude, unit, effectiveLayers.posts]);

  // Set up socket listeners
  useEffect(() => {
    if (!effectiveLayers.players) return;
    const handlePlayerLocationUpdateWrapper = (updatedPlayer) => {
      // console.log('updatedPlayer:', updatedPlayer);
      handlePlayerLocationUpdate(updatedPlayer);
    };

    socket2.on('getPlayerLocationUpdate', handlePlayerLocationUpdateWrapper);

    return () => {
      socket2.off('getPlayerLocationUpdate', handlePlayerLocationUpdateWrapper);
    };
  }, [socket2, handlePlayerLocationUpdate, effectiveLayers.players]);

  // useEffect(() => {
  //   let mounted = true;

  //   // Function to update the current player's location
  //   const updateCurrentPlayerLocation = async () => {
  //     if (!mounted) return;

  //     await getLocationAndSave(
  //       SetLatitude,
  //       SetLongitude,
  //       SetAccuracy,
  //       SetTimestamp,
  //       player,
  //     ).then(() => {
  //       const latitude = JSON.parse(secureLocalStorage.getItem('latitude'));
  //       const longitude = JSON.parse(secureLocalStorage.getItem('longitude'));

  //       if (latitude && longitude) {
  //         // Emit the updated location to the server
  //         socket2.emit('updatePlayerLocation', {
  //           playerId: player.data.player.playerId,
  //           _id: player.data.player._id,
  //           location: {
  //             coordinates: [longitude, latitude],
  //           },
  //         });
  //       }
  //     });
  //   };

  useEffect(() => {
    if (!locationRefreshEnabled || !personalLocationReadyRef.current) {
      return undefined;
    }
    if (!navigator.geolocation?.getCurrentPosition) {
      setLocationHintStatus('denied');
      setLocationHintMessage('Location is not available in this browser.');
      return undefined;
    }
    let mounted = true;
    let timeoutId;

    const updateCurrentPlayerLocation = () => {
      if (!mounted) return;
      setLocationHintStatus((prev) =>
        prev === 'ready' ? 'ready' : 'prompt',
      );
      setLocationHintMessage('Allow location to see activity near you');
      console.log('[Location] Updating current player location');
      navigator.geolocation.getCurrentPosition(
        (position) => {
          if (!mounted) return;
          console.log('Accuracy (meters):', position.coords.accuracy);

          const newLat = position.coords.latitude;
          const newLon = position.coords.longitude;

          console.log('New location:', newLat, newLon);

          // Calculate distance between previous and new location
          const prevLat = lastSentLocation.current.lat;
          const prevLon = lastSentLocation.current.lon;
          let distance = 0;
          if (prevLat !== null && prevLon !== null) {
            distance = getDistanceFromLatLonInMeters(
              prevLat,
              prevLon,
              newLat,
              newLon,
            );
            console.log(
              `[Location] Distance from last sent: ${distance.toFixed(2)}m`,
            );
          }

          // Only emit if significant movement occurred
          if (
            prevLat === null ||
            prevLon === null ||
            distance >= MOVEMENT_THRESHOLD_METERS
          ) {
            console.log(
              '[Location] Moved More Than THRESHOLD:',
              newLat,
              newLon,
              'emitting update',
            );
            socket2.emit('updatePlayerLocation', {
              playerId: player.data.player.playerId,
              _id: player.data.player._id,
              location: {
                coordinates: [newLon, newLat],
              },
            });
            lastSentLocation.current = { lat: newLat, lon: newLon };
            lastMovementTime.current = Date.now();
            console.log(
              `[Location] Moved: sent update at ${newLat}, ${newLon} (interval will be 5s if moving), distance: ${distance.toFixed(
                2,
              )}m`,
            );
            setLocationHintStatus('ready');
            setLocationHintMessage('');
          } else {
            console.log('[Location] No significant movement detected');
            // No significant movement, but check if it's been more than 30s since last movement
            const now = Date.now();
            if (now - lastMovementTime.current >= 30000) {
              console.log(
                `[Location] No movement detected for >30s, interval now 15s`,
              );
            } else {
              console.log(
                `[Location] No movement detected, interval remains 5s`,
              );
            }
          }
        },
        (error) => {
          if (!mounted) return;
          console.error('Geolocation error:', error);
          setLocationHintStatus('denied');
          setLocationHintMessage(
            'Location denied. Using last known area. Retry from your browser bar.',
          );
        },
        { enableHighAccuracy: true },
      );
    };
    // Adaptive interval: 5s if moved in last 30s, else 15s
    const adaptiveInterval = () => {
      console.log('[Adaptive] Calculating adaptive interval');
      const now = Date.now();
      if (!pageVisibilityRef.current) {
        return 30000;
      }
      const interval = now - lastMovementTime.current < 30000 ? 5000 : 15000;
      // Debug: show which interval is being used
      if (interval === 5000) {
        console.log('[Adaptive] Using 5s interval (recent movement)');
      } else {
        console.log('[Adaptive] Using 15s interval (no recent movement)');
      }
      return interval;
    };

    function scheduleNext() {
      console.log('[Location] Scheduling next update');
      updateCurrentPlayerLocation();
      timeoutId = setTimeout(scheduleNext, adaptiveInterval());
    }

    scheduleNext();

    return () => {
      mounted = false;
      clearTimeout(timeoutId);
    };
  }, [
    socket2,
    player.data.player.playerId,
    player.data.player._id,
    locationRefreshEnabled,
  ]);

  useEffect(() => {
    const lat = parseFloat(queryParams.get('lat'));
    const lon = parseFloat(queryParams.get('lon'));
    const parent = queryParams.get('parent');

    if (parent === 'post' && !isNaN(lat) && !isNaN(lon)) {
      SetLatitude(lat);
      SetLongitude(lon);
    }
  }, [location.search, queryParams]);

  const error = () => {
    console.log('error geolocation called.');
    setGetPosition(false);
  };

  const onSuccess = (data) => {
    // console.log('data: ', data);
  };

  const onError = (err) => {
    // console.log('err: ', err);
  };

  const { isLoading, data, status } = useGetPosts(
    onSuccess,
    onError,
    player,
    null,
    page,
    'posts',
    null,
    // trigger,
    effectiveLayers.posts, // fetchAll only when posts layer enabled
    radius,
    unit,
    fetchLat,
    fetchLon,
  );

  // console.log(data?.length);
  const processedPosts = useMemo(() => {
    if (status === 'success' && data) {
      const newPosts = data.filter(
        (post) =>
          !socketPostIds.includes(post._id) &&
          String(post.context || '').toLowerCase() !== 'localops', // Exclude LocalOps-derived posts from map pins
      );

      // Sort the posts by date
      return newPosts.sort((a, b) => {
        const dateA = a.repostedAt
          ? new Date(a.repostedAt)
          : new Date(a.createdAt);
        const dateB = b.repostedAt
          ? new Date(b.repostedAt)
          : new Date(b.createdAt);
        return dateB - dateA;
      });
    }
    return [];
  }, [status, data, socketPostIds]);

  useEffect(() => {
    if (!effectiveLayers.posts) return;
    if (processedPosts.length > 0) {
      setPostItems((prevPostItems) => {
        const isDifferent =
          processedPosts.length !== prevPostItems.length ||
          !processedPosts.every(
            (post, index) => post._id === prevPostItems[index]._id,
          );

        if (isDifferent) {
          console.log('Updating postItems with new posts.');
          return processedPosts;
        }

        return prevPostItems; // No update needed
      });
    } else if (status === 'success' && processedPosts.length === 0) {
      console.log('No posts found within the radius.');
      setPostItems([]); // Clear postItems if no posts are found
    }
  }, [processedPosts, status, effectiveLayers.posts]);

  useEffect(() => {
    if (initialViewport.current) {
      isInitialLoad.current = false;
      return;
    }
    if (isInitialLoad.current || radius || unit) {
      isInitialLoad.current = false; // Mark as no longer the initial load

      if (postItems && postItems.length > 0) {
        const boundingBox = calculateBoundingBox(postItems);
        if (boundingBox) {
          const { latitude, longitude, zoom } = calculateViewport(
            boundingBox,
            window.innerWidth, // Map width
            window.innerHeight, // Map height
            radius, // Pass radius to adjust zoom dynamically
          );

          // Prevent overriding zoom if the player is zooming in
          setViewport((prevViewport) => {
            // console.log('zoom:', zoom, 'Calculated Zoom:', calculatedZoom);

            if (zoom > calculatedZoom) {
              return prevViewport; // Skip updating if zoom is greater than calculatedZoom
            }

            return {
              ...prevViewport,
              latitude,
              longitude,
              zoom: Math.max(minZoom, Math.min(maxZoom, zoom)), // Clamp zoom between minZoom and maxZoom
            };
          });
        }
      }
    }
  }, [postItems, radius, unit, calculatedZoom]);

  // useEffect(() => {
  //   // Combine posts and players for bounding box calculation
  //   const playerArray = Object.values(playersWithin);
  //   // console.log('playerArray:', playerArray);
  //   // console.log('postItems:', postItems);
  //   const allMapItems = [
  //     ...postItems.filter(
  //       (post) =>
  //         post.location &&
  //         Array.isArray(post.location.coordinates) &&
  //         post.location.coordinates.length === 2,
  //     ),
  //     ...playerArray
  //       .filter(
  //         (player) =>
  //           player.lastLocation &&
  //           Array.isArray(player.lastLocation.coordinates) &&
  //           player.lastLocation.coordinates.length === 2,
  //       )
  //       .map((player) => ({
  //         location: { coordinates: player.lastLocation.coordinates },
  //       })),
  //   ];

  //   // console.log('allMapItems:', allMapItems);
  //   if (allMapItems.length === 0) {
  //     console.log('No posts or players to calculate bounding box.');
  //     return;
  //   }

  //   try {
  //     const boundingBox = calculateBoundingBox(allMapItems);
  //     // console.log('Combined bounding box:', boundingBox);

  //     if (boundingBox) {
  //       const { latitude, longitude, zoom } = calculateViewport(
  //         boundingBox,
  //         window.innerWidth,
  //         window.innerHeight,
  //         radius,
  //       );

  //       // Prevent overriding zoom if the player is zooming in
  //       setViewport((prevViewport) => {
  //         // console.log('zoom:', zoom, 'Calculated Zoom:', calculatedZoom);
  //         if (zoom > calculatedZoom) {
  //           return prevViewport; // Skip updating if zoom is greater than calculatedZoom
  //         }
  //         return {
  //           ...prevViewport,
  //           latitude,
  //           longitude,
  //           zoom: Math.max(minZoom, Math.min(maxZoom, zoom)), // Clamp zoom between minZoom and maxZoom
  //         };
  //       });
  //     } else {
  //       console.log('No valid bounding box could be calculated.');
  //     }
  //   } catch (err) {
  //     console.log('Error calculating combined bounding box or viewport:', err);
  //   }
  // }, [postItems, playersWithin, radius, unit, calculatedZoom]);

  // console.log('Post items:', postItems.length);
  useEffect(() => {
    let mounted = true;
    const options = {
      enableHighAccuracy: true,
    };

    const fetchPlayersWithin = async (centerLat, centerLon, useSnapshot) => {
      try {
        if (!getPosition || radius < 0 || radius === '') {
          console.log('Location not shared or radius not positive');
          return;
        }

        const res = await axiosConn.get(
          `players/players-within/${radius}/center/${centerLat},${centerLon}/unit/${
            unit ? unit : 'mi'
          }`,
          {
            headers: {
              Authorization: `Bearer ${player.token}`,
            },
          },
        );

        if (!mounted) return;

        if (useSnapshot) {
          const playersObj = {};
          for (const player of res.data.data.data) {
            const prevPlayer = playersWithin[player.playerId];
            playersObj[player.playerId] = {
              ...player,
              lastMovementTime: prevPlayer?.lastMovementTime || Date.now(),
            };
          }
          setPlayersWithin(playersObj);
        } else {
          setPlayersWithin((prevPlayers) => {
            const playersObj = {};
            for (const player of res.data.data.data) {
              const prevPlayer = prevPlayers[player.playerId];
              if (
                prevPlayer &&
                prevPlayer.lastLocation.coordinates[0] ===
                  player.lastLocation.coordinates[0] &&
                prevPlayer.lastLocation.coordinates[1] ===
                  player.lastLocation.coordinates[1] &&
                prevPlayer.profilePhoto === player.profilePhoto
              ) {
                playersObj[player.playerId] = prevPlayer; // Reuse previous object
              } else {
                playersObj[player.playerId] = player; // Use new/changed object
              }
            }
            return playersObj;
          });
        }

        secureLocalStorage.setItem(
          'playersWithin',
          JSON.stringify(res.data.data.data),
        );

        const boundingBox = calculateBoundingBox(res.data.data.data);
        if (!initialViewport.current && boundingBox) {
          console.log('Setting initial viewport using calculateViewport');
          const {
            latitude: latViewport,
            longitude: lonViewport,
            zoom,
          } = calculateViewport(
            boundingBox,
            window.innerWidth, // Map width
            window.innerHeight, // Map height
            radius, // Pass radius to adjust zoom dynamically
          );

          const newViewport = {
            latitude: latViewport,
            longitude: lonViewport,
            zoom,
            width: '100vw',
            height: '100vh',
          };

          initialViewport.current = newViewport;
          setViewport(newViewport);
        }
      } catch (err) {
        console.log(err);
      }
    };

    const getData = async () => {
      if (!mounted) return;

      const lat = parseFloat(queryParams.get('lat'));
      const lon = parseFloat(queryParams.get('lon'));

      // If lat, lon, and parent query parameters are present, skip getLocationAndSave
      if (parent === 'post' && Number.isFinite(lat) && Number.isFinite(lon)) {
        console.log('Using queryParams for latitude and longitude');
        if (!postRadiusSet) {
          setRadius(25);
          setPostRadiusSet(true);
        }
        await fetchPlayersWithin(lat, lon, true);
        return; // Exit early since we handled the queryParams case
      }

      const personalSeed = storedLocation || playerSavedLocation || null;
      const seedCenter = personalSeed || regionBrowseCenter || null;
      const seedLat = seedCenter?.lat ?? null;
      const seedLon = seedCenter?.lon ?? null;
      let didWarmFetch = false;
      if (Number.isFinite(seedLat) && Number.isFinite(seedLon)) {
        await fetchPlayersWithin(seedLat, seedLon, false);
        didWarmFetch = true;
      }

      const resolvedLat = Number.isFinite(seedLat) ? seedLat : latitude;
      const resolvedLon = Number.isFinite(seedLon) ? seedLon : longitude;

      if (
        personalSeed &&
        Number.isFinite(resolvedLat) &&
        Number.isFinite(resolvedLon)
      ) {
        if (resolvedLat !== latitude) SetLatitude(resolvedLat);
        if (resolvedLon !== longitude) SetLongitude(resolvedLon);
      }

      if (
        !Number.isFinite(resolvedLat) ||
        !Number.isFinite(resolvedLon) ||
        !getPosition ||
        radius < 0 ||
        radius === ''
      ) {
        console.log(
          'null latitude and longitude or location not shared or radius not positive',
        );
        setLocationHintStatus((prev) =>
          prev === 'ready' ? 'ready' : 'waiting',
        );
        setLocationHintMessage('Use your location to show nearby activity.');
        return;
      }

      if (personalSeed) {
        setLocationHintStatus('ready');
        setLocationHintMessage('');
      } else if (regionBrowseCenter) {
        setLocationHintStatus((prev) =>
          prev === 'ready' ? 'ready' : 'fallback',
        );
        setLocationHintMessage(
          `Browsing ${regionBrowseCenter.label || 'LocalOps'} without saving your location.`,
        );
      }

      const shouldRefetch =
        !didWarmFetch ||
        !Number.isFinite(seedLat) ||
        !Number.isFinite(seedLon) ||
        getDistanceFromLatLonInMeters(
          seedLat,
          seedLon,
          resolvedLat,
          resolvedLon,
        ) >= FETCH_REFRESH_THRESHOLD_METERS;

      if (shouldRefetch) {
        await fetchPlayersWithin(resolvedLat, resolvedLon, false);
      }
    };

    getData();

    return () => {
      mounted = false;
      secureLocalStorage.removeItem('playersWithin');
    };
  }, [
    queryParams,
    player.token,
    radius,
    unit,
    getPosition,
    parent,
    storedLocation,
    playerSavedLocation,
    regionBrowseCenter,
  ]);
  // //   console.log(latitude, longitude, accuracy, timestamp);

  // useEffect(() => {
  //   let mounted = true;
  //   const options = {
  //     enableHighAccuracy: true,
  //   };

  //   const getData = async () => {
  //     if (!mounted) return;

  //     const lat = parseFloat(queryParams.get('lat'));
  //     const lon = parseFloat(queryParams.get('lon'));

  //     // If lat, lon, and parent query parameters are present, skip getLocationAndSave
  //     if (parent === 'post' && !isNaN(lat) && !isNaN(lon)) {
  //       console.log('Using queryParams for latitude and longitude');
  //       if (!postRadiusSet) {
  //         setRadius(20);
  //         setPostRadiusSet(true);
  //       }
  //       try {
  //         if (!getPosition || radius < 0 || radius === '') {
  //           console.log('Location not shared or radius not positive');
  //           return;
  //         }

  //         const res = await axiosConn.get(
  //           `/players/players-within/${radius}/center/${lat},${lon}/unit/${
  //             unit ? unit : 'mi'
  //           }`,
  //           {
  //             headers: {
  //               Authorization: `Bearer ${player.token}`,
  //             },
  //           },
  //         );

  //         if (!mounted) return;

  //         // Convert array to object
  //         const playersObj = {};
  //         for (const player of res.data.data.data) {
  //           playersObj[player.playerId] = player;
  //         }
  //         // console.log('playersObj:', playersObj);
  //         setPlayersWithin(playersObj);
  //         // secureLocalStorage.setItem(
  //         //   'playersWithin',
  //         //   JSON.stringify(res.data.data.data),
  //         // );
  //       } catch (err) {
  //         console.log(err);
  //       }
  //       return; // Exit early since we handled the queryParams case
  //     }

  //     // If no queryParams, proceed with getLocationAndSave
  //     await getLocationAndSave(
  //       SetLatitude,
  //       SetLongitude,
  //       SetAccuracy,
  //       SetTimestamp,
  //       player,
  //     ).then(async () => {
  //       const latitude = JSON.parse(secureLocalStorage.getItem('latitude'));
  //       const longitude = JSON.parse(secureLocalStorage.getItem('longitude'));

  //       try {
  //         if (
  //           !latitude ||
  //           !longitude ||
  //           !getPosition ||
  //           radius < 0 ||
  //           radius === ''
  //         ) {
  //           console.log(
  //             'null latitude and longitude or location not shared or radius not positive',
  //           );
  //           return;
  //         }

  //         const res = await axiosConn.get(
  //           `/players/players-within/${radius}/center/${latitude},${longitude}/unit/${
  //             unit ? unit : 'mi'
  //           }`,
  //           {
  //             headers: {
  //               Authorization: `Bearer ${player.token}`,
  //             },
  //           },
  //         );

  //         if (!mounted) return;

  //         // Convert array to object
  //         const playersObj = {};
  //         for (const player of res.data.data.data) {
  //           playersObj[player.playerId] = player;
  //         }
  //         // console.log('playersObj:', playersObj);
  //         setPlayersWithin(playersObj);
  //         // secureLocalStorage.setItem(
  //         //   'playersWithin',
  //         //   JSON.stringify(res.data.data.data),
  //         // );
  //       } catch (err) {
  //         console.log(err);
  //       }
  //     });
  //   };

  //   getData();

  //   return () => {
  //     mounted = false;
  //     secureLocalStorage.removeItem('playersWithin');
  //   };
  // }, [queryParams, player.token, radius, unit, getPosition, parent]);

  // const playersWithin2 = JSON.parse(
  //   secureLocalStorage.getItem('playersWithin'),
  // );
  // // console.log(playersWithin2);

  useEffect(() => {
    const listener = (e) => {
      if (e.key === 'Escape') {
        setSelectedPlayer(null);
      }
    };
    window.addEventListener('keydown', listener);
    return () => {
      window.removeEventListener('keydown', listener);
    };
  }, []);

  const selectedPlayerPresence = useMemo(() => {
    if (!selectedPlayer) return null;
    return (
      presenceIndex.get(selectedPlayer.playerId) ||
      presenceIndex.get(selectedPlayer._id) ||
      null
    );
  }, [selectedPlayer, presenceIndex]);

  const selectedOfferingPresence = useMemo(() => {
    if (!selectedOffering) return null;
    const ownerId =
      selectedOffering.ownerId ||
      selectedOffering.playerId ||
      selectedOffering.providerId ||
      selectedOffering.createdBy;
    if (!ownerId) return null;
    return presenceIndex.get(ownerId) || null;
  }, [selectedOffering, presenceIndex]);

  const localOpsTaskActorById = useMemo(() => {
    const map = new Map();
    const events = [
      ...(Array.isArray(localOpsSeedEvents) ? localOpsSeedEvents : []),
      ...(Array.isArray(localOpsRecentEvents) ? localOpsRecentEvents : []),
      ...(Array.isArray(localOpsLiveEvents) ? localOpsLiveEvents : []),
    ];
    events.forEach((event) => {
      if (!event || String(event.entityType || '').toLowerCase() !== 'task') {
        return;
      }
      const target = parseLocalOpsShareTarget(event.shareUrl);
      const taskId = String(event.entityId || target?.id || '').trim();
      const actor = event.actor || null;
      if (!taskId || !actor || typeof actor !== 'object') return;
      if (!actor.playerId && !actor.profilePhoto) return;
      map.set(taskId, {
        playerId: actor.playerId || null,
        profilePhoto: actor.profilePhoto || null,
      });
    });
    return map;
  }, [localOpsLiveEvents, localOpsRecentEvents, localOpsSeedEvents]);

  const selectedTaskForDetail = useMemo(() => {
    if (!selectedTask) return null;
    const taskId = String(
      selectedTask.taskId || selectedTask.id || selectedTask._id || '',
    );
    const actor = taskId ? localOpsTaskActorById.get(taskId) : null;
    if (!actor) return selectedTask;
    const creator =
      selectedTask.creator && typeof selectedTask.creator === 'object'
        ? selectedTask.creator
        : {};
    const requester =
      selectedTask.requester && typeof selectedTask.requester === 'object'
        ? selectedTask.requester
        : {};
    return {
      ...selectedTask,
      creator: {
        ...creator,
        playerId: creator.playerId || actor.playerId || undefined,
        profilePhoto: creator.profilePhoto || actor.profilePhoto || undefined,
      },
      requester: {
        ...requester,
        playerId: requester.playerId || actor.playerId || undefined,
        profilePhoto: requester.profilePhoto || actor.profilePhoto || undefined,
      },
      profilePhoto: selectedTask.profilePhoto || actor.profilePhoto || undefined,
    };
  }, [localOpsTaskActorById, selectedTask]);

  const selectedTaskIdForAccept = useMemo(() => {
    const task = selectedTaskForDetail || selectedTask;
    if (!task) return '';
    return String(
      getDurableLocalOpsTaskId(task) ||
        task.taskId ||
        task.id ||
        task._id ||
        '',
    );
  }, [selectedTask, selectedTaskForDetail]);
  const selectedTaskAcceptPending =
    !!selectedTaskIdForAccept &&
    String(acceptingTaskId || '') === selectedTaskIdForAccept;
  const selectedTaskAcceptFeedback =
    taskAcceptFeedback &&
    String(taskAcceptFeedback.taskId || '') === selectedTaskIdForAccept
      ? taskAcceptFeedback
      : null;
  const handleSelectedTaskAcceptAction = useCallback(() => {
    if (selectedTaskAcceptFeedback?.action === 'ride_ready') {
      const nextPath =
        selectedTaskAcceptFeedback.profilePath ||
        resolveRideReadyProfilePath();
      setRideReadyRequiredPrompt(null);
      setTaskAcceptFeedback(null);
      history.push(nextPath);
    }
  }, [
    history,
    resolveRideReadyProfilePath,
    selectedTaskAcceptFeedback,
  ]);

  const selectedTaskPresence = useMemo(() => {
    const task = selectedTaskForDetail || selectedTask;
    if (!task) return null;
    const ownerId =
      task.creator?.playerId ||
      task.requester?.playerId ||
      task.creatorPlayerId ||
      task.ownerId ||
      task.playerId ||
      task.requesterId ||
      task.createdBy;
    if (!ownerId) return null;
    return presenceIndex.get(ownerId) || null;
  }, [selectedTask, selectedTaskForDetail, presenceIndex]);
  const showLocalOpsLoadingOverlay =
    localOpsLoading && !selectedTask && !selectedOffering;

  const activeTaskId = useMemo(() => {
    if (!liveTask) return null;
    return liveTask.id || liveTask._id || liveTask.taskId || null;
  }, [liveTask]);

  // console.log(filteredPostItems);
  // useEffect(() => {
  //   console.log('Updated playersWithin state:', playersWithin);
  // }, [playersWithin]);

  // console.log('PlayerMapPage re-rendered');
  // console.log('playersWithin:', playersWithin);
  // console.log('player:', player);

  const landingShortViewportCompact =
    mobileView &&
    !showLandingFallbackOverride &&
    landingViewportSize.width > 0 &&
    landingViewportSize.width <= 340 &&
    landingViewportSize.height > 0 &&
    landingViewportSize.height <= 700;

  return (
    <>
      <div className="full" data-motion={localOpsMotion}>
        <div
          className={`map-fade-mask ${mapBooted ? 'is-hidden' : ''}`}
          aria-hidden="true"
        />
        {showLocalOpsLoadingOverlay && (
          <>
            <div className="localops-live-pill" aria-live="polite">
              <span className="localops-live-dot" />
              Loading LocalOps Live…
            </div>
            <div className="localops-live-scrim" />
          </>
        )}
        <ReactMapGL
          {...viewport}
          mapboxAccessToken={process.env.REACT_APP_MAPBOX_TOKEN}
          mapStyle="mapbox://styles/joegalaxydotnet/clmquop4a04vw01phe5fi2sdq"
          onMove={handleViewportChange}
          onMoveEnd={handleViewportCommit}
          // zoom={zoom}
        >
          {/* {parent !== 'post' && (
            <Link
              to={`/profile/${player.data.player?.playerId}`}
              className="mmenu_header hover3"
            >
              <Marker latitude={latitude} longitude={longitude}>
                <button className="marker-btn2">
                  <img
                    // src="https://res.cloudinary.com/joegalaxy/image/upload/v1695177384/Map_marker_fymyi0.svg"
                    src={
                      player.data.player?.profilePhoto
                        ? player.data.player?.profilePhoto
                        : 'https://res.cloudinary.com/joegalaxy/image/upload/q_auto/v1656194537/Images/noAvatar_tsgpm9.png'
                    }
                    alt={player.data.player?.playerId}
                    title={player.data.player?.playerId}
                  />
                </button>
              </Marker>
            </Link>
          )} */}
          {/* SetMyOnlineFriends(myFriends.filter((f) =>
          onlinePlayers.includes(f._id))); */}
          {/* playersWithin2.map((player) => ( */}
          <PresenceLayer
            enabled={getPosition && effectiveLayers.players}
            playersWithin={playersWithin}
            player={player}
            onSelectPlayer={handleSelectPlayer}
            presenceIndex={presenceIndex}
            mobileView={mobileView}
            mapZoom={Number.isFinite(zoom) ? zoom : viewport.zoom}
          />
          <PostsLayer
            enabled={effectiveLayers.posts}
            postItems={postItems}
            selectedPost={selectedPost}
            onSelectPost={handleSelectPost}
            onClosePost={handleClosePost}
            mobileView={mobileView}
          />
          <OfferingsLayer
            enabled={effectiveLayers.offerings}
            offerings={offerings}
            onSelectOffering={handleSelectOffering}
            presenceIndex={presenceIndex}
            center={offeringsCenter}
            radiusMeters={discoveryRadiusMeters}
            mobileView={mobileView}
            mapZoom={Number.isFinite(zoom) ? zoom : viewport.zoom}
            collisionOffsets={collisionOffsets}
          />
          <TasksLayer
            enabled={effectiveLayers.tasks}
            tasks={tasks}
            onSelectTask={handleSelectTask}
            presenceIndex={presenceIndex}
            center={tasksCenter}
            radiusMeters={discoveryRadiusMeters}
            mobileView={mobileView}
            activeTaskId={activeTaskId}
            mapZoom={Number.isFinite(zoom) ? zoom : viewport.zoom}
            collisionOffsets={collisionOffsets}
          />
          {localOpsFlags.live ? (
            <LiveTaskOverlay
              activeTask={liveTask}
              presenceIndex={presenceIndex}
              motionLevel={localOpsMotion}
            />
          ) : null}
          {selectedPlayer
            ? (() => {
                const playerAvatar =
                  selectedPlayer.profilePhoto ||
                  selectedPlayer.profilePicture ||
                  selectedPlayer.avatar ||
                  null;
                const playerInitial = String(
                  selectedPlayer.playerId || 'P',
                )
                  .trim()
                  .charAt(0)
                  .toUpperCase();
                const coverPhoto = selectedPlayer.coverPhoto;
                const coverIsVideo =
                  coverPhoto &&
                  (coverPhoto.endsWith('.mp4') ||
                    coverPhoto.endsWith('.mov'));
                return (
                  <Popup
                    longitude={selectedPlayer.lastLocation.coordinates[0]}
                    latitude={selectedPlayer.lastLocation.coordinates[1]}
                    onClose={handleClosePlayer}
                    className="jg-map-popup jg-map-popup--player"
                  >
                    <div className="jg-map-popup__card">
                      <Link
                        to={`/profile/${selectedPlayer?.playerId}`}
                        className="jg-map-popup__link"
                      >
                        <div className="jg-map-popup__header">
                          <div className="jg-map-popup__avatar">
                            {playerAvatar ? (
                              <img
                                src={playerAvatar}
                                alt={selectedPlayer.playerId}
                              />
                            ) : (
                              <span className="jg-map-popup__initial">
                                {playerInitial}
                              </span>
                            )}
                          </div>
                          <div className="jg-map-popup__header-text">
                            <div className="jg-map-popup__title">
                              {selectedPlayer.playerId}
                            </div>
                            <div className="jg-map-popup__subtitle">
                              Player profile
                            </div>
                          </div>
                        </div>
                        {selectedPlayer.desc ? (
                          <div className="jg-map-popup__summary">
                            {selectedPlayer.desc}
                          </div>
                        ) : null}
                        <div className="jg-map-popup__pill-row">
                          {selectedPlayerPresence?.availabilityState ? (
                            <span className="jg-map-popup__pill jg-map-popup__pill--success">
                              {selectedPlayerPresence.availabilityState}
                            </span>
                          ) : null}
                          {selectedPlayerPresence?.movementState ? (
                            <span className="jg-map-popup__pill jg-map-popup__pill--info">
                              {selectedPlayerPresence.movementState}
                            </span>
                          ) : null}
                          {selectedPlayerPresence?.taskEligibility ? (
                            <span className="jg-map-popup__pill jg-map-popup__pill--accent">
                              LocalOps eligible
                            </span>
                          ) : null}
                        </div>
                        {coverPhoto ? (
                          <div className="jg-map-popup__media">
                            {coverIsVideo ? (
                              <video
                                src={coverPhoto}
                                muted
                                loop
                                playsInline
                                autoPlay
                              />
                            ) : (
                              <img
                                src={coverPhoto}
                                alt={selectedPlayer.playerId}
                              />
                            )}
                          </div>
                        ) : null}
                      </Link>
                    </div>
                  </Popup>
                );
              })()
            : null}
        </ReactMapGL>
        {localOpsFlags.base ? (
          <div className="localops-map-controls">
            <button
              type="button"
              className="localops-layers-btn"
              onClick={handleOpenLayers}
              style={{
                opacity: layersUiBlocked ? 0.4 : 1,
                pointerEvents: layersUiBlocked ? 'none' : 'auto',
              }}
            >
              <span className="localops-btn-icon">
                <LayersOutlinedIcon fontSize="small" />
              </span>
              Layers
            </button>
            <button
              type="button"
              className="localops-fab"
              onClick={handleOpenCreate}
              style={{
                opacity: createUiBlocked ? 0.4 : 1,
                pointerEvents: createUiBlocked ? 'none' : 'auto',
              }}
            >
              <span className="localops-btn-icon">
                <AddRoundedIcon fontSize="small" />
              </span>
              Create JG LocalOps here
            </button>
          </div>
        ) : null}
        {localOpsFlags.base && !localOpsFeedOpen ? (
          <LocalOpsFeedTicker
            events={visibleFeedEvents}
            onOpen={handleOpenFeed}
            compact={mobileView}
            wrapperRef={localOpsTickerRef}
            wrapperTestId="playermap-localops-live-ticker"
            wrapperStyle={
              landingTickerLayout.tickerDrop
                ? {
                    transform: `translate3d(0, ${landingTickerLayout.tickerDrop}px, 0)`,
                  }
                : undefined
            }
          />
        ) : null}
        {showFirestarterEmpty ? (
          <div className="localops-layer-hint" data-testid="firestarter-playermap-empty">
            <div>
              Start with a small task: a pickup, errand, cleaning help, home
              help, or food run. For paid tasks, you approve completion only
              when satisfied.
            </div>
            <div style={{ marginTop: 6 }}>
              <button
                type="button"
                className="localops-btn"
                data-testid="firestarter-playermap-cta"
                onClick={handleFirestarterEmptyCta}
              >
                Create the first task here
              </button>
            </div>
          </div>
        ) : showDiscoveryEmpty && !showLandingFallbackOverride ? (
          <div className="localops-layer-hint">
            <div>What's already here just hasn't been surfaced yet.</div>
            {showDiscoverySubline ? (
              <div>Create an offering to make local value visible.</div>
            ) : null}
          </div>
        ) : null}
        {allLayersOff ? (
          <div className="localops-layer-hint">
            Turn a layer on to see what&apos;s nearby
          </div>
        ) : null}
        {resumeErrorMessage ? (
          <div
            className="localops-toast localops-toast--error"
            role="button"
            tabIndex={0}
            onClick={() => resumePendingIntent('manual')}
            onKeyDown={(event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                resumePendingIntent('manual');
              }
            }}
          >
            {resumeErrorMessage}
            {process.env.NODE_ENV === 'development' && resumeDebugMessage ? (
              <div className="localops-helper">[jgk-resume] {resumeDebugMessage}</div>
            ) : null}
          </div>
        ) : rideReadyRequiredPrompt ? (
          <div className="localops-toast localops-toast--error localops-toast--action">
            <span>{rideReadyRequiredPrompt.message}</span>
            <button
              type="button"
              onClick={() => {
                const nextPath =
                  rideReadyRequiredPrompt.profilePath ||
                  resolveRideReadyProfilePath();
                setRideReadyRequiredPrompt(null);
                history.push(nextPath);
              }}
            >
              Complete Ride Ready
            </button>
          </div>
        ) : localOpsError ? (
          <div className="localops-toast localops-toast--error">
            {localOpsError}
          </div>
        ) : localOpsNotice ? (
          <div className="localops-toast">{localOpsNotice}</div>
        ) : null}
        {showLandingSheet ? (
          <div
            ref={landingOverlayRef}
            style={{
              position: 'absolute',
              inset: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              paddingTop:
                showLandingFallbackOverride && mobileView ? 96 : 0,
              paddingBottom:
                showLandingFallbackOverride && mobileView ? 18 : 0,
              pointerEvents: 'none',
              zIndex: 18,
            }}
          >
            <div
              ref={landingCardRef}
              data-testid={
                showLandingFallbackOverride
                  ? 'playermap-local-empty-fallback-card'
                  : 'playermap-landing-card'
              }
              style={{
                width:
                  showLandingFallbackOverride && mobileView
                    ? 'min(440px, calc(100vw - 20px))'
                    : 'min(420px, 94vw)',
                background: 'rgba(10,14,24,0.94)',
                border: showLandingFallbackOverride
                  ? '1px solid rgba(138,177,225,0.28)'
                  : '1px solid rgba(255,255,255,0.08)',
                boxShadow: showLandingFallbackOverride
                  ? '0 28px 52px rgba(0,0,0,0.5)'
                  : '0 24px 48px rgba(0,0,0,0.45)',
                borderRadius: showLandingFallbackOverride ? 20 : 18,
                padding:
                  showLandingFallbackOverride && mobileView
                    ? '18px 16px 16px'
                    : landingShortViewportCompact
                    ? '14px 14px 12px'
                    : 20,
                color: '#e8edf7',
                pointerEvents: 'auto',
                transform: landingTickerLayout.lift
                  ? `translate3d(0, -${landingTickerLayout.lift}px, 0)`
                  : undefined,
                maxHeight: landingTickerLayout.maxHeight
                  ? `${landingTickerLayout.maxHeight}px`
                  : undefined,
                overflowY: landingTickerLayout.maxHeight ? 'auto' : undefined,
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: landingShortViewportCompact ? 8 : 10,
                  marginBottom: landingShortViewportCompact ? 4 : 6,
                }}
              >
                <JGLocalOpsMark />
                <div
                  data-testid="playermap-landing-headline"
                  style={{
                    fontSize: landingShortViewportCompact ? 17 : 18,
                    fontWeight: 800,
                    lineHeight: landingShortViewportCompact ? 1.15 : undefined,
                  }}
                >
                  {showLandingFallbackOverride
                    ? 'Nothing nearby yet'
                    : landingDisplayHeadline}
                </div>
              </div>
              <div
                data-testid="playermap-landing-subcopy"
                style={{
                  fontSize: landingShortViewportCompact ? '0.9em' : '0.95em',
                  color: '#9fb6d1',
                  marginBottom: landingShortViewportCompact ? 8 : 12,
                  lineHeight: landingShortViewportCompact ? 1.32 : 1.4,
                }}
              >
                {showLandingFallbackOverride
                  ? 'Start with a small task: a pickup, errand, cleaning help, home help, or food run.'
                  : landingDisplaySubcopy}
              </div>
              {landingRequesterProofLine ? (
                <div
                  data-testid="playermap-requester-proof-line"
                  style={{
                    color: '#bcd4f6',
                    opacity: 0.9,
                    marginBottom: landingShortViewportCompact ? 8 : 12,
                    fontSize: landingShortViewportCompact ? '0.8em' : '0.84em',
                    lineHeight: landingShortViewportCompact ? 1.32 : 1.45,
                  }}
                >
                  {landingRequesterProofLine}
                </div>
              ) : null}
              {landingWalletLine ? (
                <div
                  style={{
                    fontSize: landingShortViewportCompact ? '0.8em' : '0.85em',
                    fontWeight: 400,
                    opacity: 0.6,
                    color: '#9fb6d1',
                    marginBottom: landingShortViewportCompact ? 8 : 12,
                  }}
                >
                  {landingWalletLine}
                </div>
              ) : null}
              {showLandingFallbackOverride ? (
                <div
                  data-testid="playermap-local-empty-fallback-override"
                  style={{
                    color: '#9fb6d1',
                    opacity: 0.86,
                    marginBottom: 12,
                    fontSize: '0.84em',
                    lineHeight: 1.45,
                  }}
                >
                  For paid tasks, you approve completion only when satisfied.
                </div>
              ) : null}

              <button
                type="button"
                className="loc-btn"
                disabled={landingDisabled}
                onClick={
                  showLandingFallbackOverride
                    ? handleOpenFallbackTaskCreate
                    : handleLandingPrimary
                }
                data-testid={
                  showLandingFallbackOverride
                    ? 'playermap-local-empty-primary-cta'
                    : 'playermap-landing-primary-cta'
                }
                style={{
                  width: '100%',
                  marginBottom: landingShortViewportCompact ? 8 : 10,
                  padding: showLandingFallbackOverride
                    ? '13px 14px'
                    : landingShortViewportCompact
                    ? '10px 12px'
                    : '12px 14px',
                  borderRadius: 12,
                  background:
                    'linear-gradient(135deg, rgba(25,147,255,0.9), rgba(79,106,255,0.9))',
                  color: '#fff',
                  fontWeight: 800,
                  fontSize: showLandingFallbackOverride ? '0.99rem' : undefined,
                  border: 'none',
                  opacity: landingDisabled ? 0.6 : 1,
                  cursor: landingDisabled ? 'not-allowed' : 'pointer',
                  boxShadow: landingDisabled
                    ? 'none'
                    : showLandingFallbackOverride
                    ? '0 14px 28px rgba(24,116,255,0.35)'
                    : undefined,
                  transition: 'opacity 0.15s ease',
                }}
              >
                {showLandingFallbackOverride
                  ? 'Create a task here'
                  : landingPrimaryLabel}
              </button>

              {landingAvailableTaskSecondaryAction ? (
                <button
                  type="button"
                  disabled={landingSecondaryDisabled}
                  onClick={handleLandingAvailableTaskSecondary}
                  data-testid="playermap-available-task-secondary-cta"
                  style={{
                    width: '100%',
                    marginBottom: landingShortViewportCompact ? 8 : 10,
                    padding: landingShortViewportCompact ? '8px 10px' : '10px 12px',
                    borderRadius: 12,
                    background: 'rgba(255,255,255,0.08)',
                    color: '#dce5f5',
                    border: '1px solid rgba(255,255,255,0.12)',
                    fontWeight: 700,
                    opacity: landingSecondaryDisabled ? 0.5 : 1,
                    cursor: landingSecondaryDisabled ? 'not-allowed' : 'pointer',
                  }}
                >
                  {landingAvailableTaskSecondaryAction.label}
                </button>
              ) : null}

              {landingOwnerTaskResumeAction ? (
                <button
                  type="button"
                  disabled={landingSecondaryDisabled}
                  onClick={handleLandingOwnerTaskResume}
                  data-testid="playermap-owner-task-resume-cta"
                  style={{
                    width: '100%',
                    marginBottom: landingShortViewportCompact ? 8 : 10,
                    padding: landingShortViewportCompact ? '8px 10px' : '10px 12px',
                    borderRadius: 12,
                    background: 'rgba(255,255,255,0.08)',
                    color: '#dce5f5',
                    border: '1px solid rgba(255,255,255,0.12)',
                    fontWeight: 700,
                    opacity: landingSecondaryDisabled ? 0.5 : 1,
                    cursor: landingSecondaryDisabled ? 'not-allowed' : 'pointer',
                  }}
                >
                  {landingOwnerTaskResumeAction.label}
                </button>
              ) : null}

              {landingReservedResumeAction ? (
                <button
                  type="button"
                  disabled={landingSecondaryDisabled}
                  onClick={handleLandingReservedResume}
                  data-testid="playermap-reserved-offering-resume-cta"
                  style={{
                    width: '100%',
                    marginBottom: landingShortViewportCompact ? 8 : 10,
                    padding: landingShortViewportCompact ? '8px 10px' : '10px 12px',
                    borderRadius: 12,
                    background: 'rgba(255,255,255,0.08)',
                    color: '#dce5f5',
                    border: '1px solid rgba(255,255,255,0.12)',
                    fontWeight: 700,
                    opacity: landingSecondaryDisabled ? 0.5 : 1,
                    cursor: landingSecondaryDisabled ? 'not-allowed' : 'pointer',
                  }}
                >
                  Resume reservation
                </button>
              ) : null}

              <div
                style={{
                  display: 'flex',
                  gap: landingShortViewportCompact ? 8 : 10,
                  marginBottom: landingAuthExpanded
                    ? landingShortViewportCompact
                      ? 8
                      : 10
                    : 0,
                  flexWrap: 'wrap',
                }}
              >
                {!showLandingFallbackOverride &&
                !noTasksAvailable &&
                !hasLandingStackedSecondaryAction &&
                !landingPrimaryIsOwnerTask &&
                !requesterLandingActive ? (
                  <button
                    type="button"
                    disabled={landingSecondaryDisabled}
                    onClick={handleUseLocally}
                    style={{
                      flex: 1,
                      minWidth: 140,
                      padding: landingShortViewportCompact ? '8px 10px' : '10px 12px',
                      borderRadius: 12,
                      background: 'rgba(255,255,255,0.06)',
                      color: '#dce5f5',
                      border: '1px solid rgba(255,255,255,0.08)',
                      fontWeight: 600,
                      opacity: landingSecondaryDisabled ? 0.5 : 1,
                      cursor: landingSecondaryDisabled ? 'not-allowed' : 'pointer',
                    }}
                  >
                    Browse local offerings
                  </button>
                ) : null}
                <button
                  type="button"
                  disabled={landingSecondaryDisabled}
                  onClick={
                    requesterLandingActive
                      ? handleOpenRequesterOfferingCreate
                      : showLandingFallbackOverride
                      ? handleOpenFallbackOfferingCreate
                      : handleOpenCreate
                  }
                  data-testid={
                    requesterLandingActive
                      ? 'playermap-requester-offering-cta'
                      : showLandingFallbackOverride
                      ? 'playermap-local-empty-secondary-cta'
                      : undefined
                  }
                  style={{
                    flex:
                      showLandingFallbackOverride || requesterLandingActive
                        ? '0 0 100%'
                        : 1,
                    minWidth:
                      showLandingFallbackOverride || requesterLandingActive
                        ? 0
                        : 140,
                    padding:
                      showLandingFallbackOverride || requesterLandingActive
                        ? landingShortViewportCompact
                          ? '8px 10px'
                          : '9px 12px'
                        : '10px 12px',
                    borderRadius: 12,
                    background:
                      showLandingFallbackOverride || requesterLandingActive
                      ? requesterLandingActive
                        ? 'rgba(255,255,255,0.08)'
                        : 'rgba(148,163,184,0.08)'
                      : 'rgba(255,255,255,0.06)',
                    color:
                      showLandingFallbackOverride || requesterLandingActive
                      ? '#dce5f5'
                      : '#dce5f5',
                    border:
                      showLandingFallbackOverride || requesterLandingActive
                      ? requesterLandingActive
                        ? '1px solid rgba(148,163,184,0.56)'
                        : '1px solid rgba(148,163,184,0.42)'
                      : '1px solid rgba(255,255,255,0.08)',
                    fontWeight:
                      showLandingFallbackOverride || requesterLandingActive
                        ? 500
                        : 600,
                    opacity: landingSecondaryDisabled
                      ? 0.5
                      : showLandingFallbackOverride
                      ? 0.86
                      : 1,
                    cursor: landingSecondaryDisabled ? 'not-allowed' : 'pointer',
                  }}
                >
                  {requesterLandingActive || showLandingFallbackOverride
                    ? 'Offer something locally'
                    : 'Post a task or offering'}
                </button>
              </div>

              {requesterLandingActive ? (
                <button
                  type="button"
                  disabled={landingSecondaryDisabled}
                  onClick={handleEnterCamdenLiveFromLanding}
                  data-testid="playermap-requester-camden-live-cta"
                  style={{
                    width: '100%',
                    marginBottom: landingAuthExpanded
                      ? landingShortViewportCompact
                        ? 8
                        : 10
                      : 0,
                    padding: landingShortViewportCompact ? '7px 10px' : '8px 10px',
                    borderRadius: 12,
                    background: 'transparent',
                    color: 'rgba(188,212,246,0.86)',
                    border: '1px solid rgba(148,163,184,0.22)',
                    fontWeight: 500,
                    opacity: landingSecondaryDisabled ? 0.5 : 0.86,
                    cursor: landingSecondaryDisabled ? 'not-allowed' : 'pointer',
                  }}
                >
                  Enter Camden Live
                </button>
              ) : null}

              {showStarterIdeasAffordance ? (
                <button
                  type="button"
                  className="localops-starter-affordance"
                  data-testid="playermap-starter-ideas-affordance"
                  onClick={handleOpenStarterIdeas}
                >
                  <strong>Need an idea?</strong> Food pickup · Grocery pickup ·
                  Cleaning · Home Help
                </button>
              ) : null}

              {landingAuthExpanded ? (
                <div style={{ marginTop: 6 }}>
                  <AuthChooser
                    headerText="Sign in to review local tasks"
                    subText="We'll bring you back to the map."
                    onPrimaryStart={() => setLandingPrimaryBusy(true)}
                    onPrimary={() => {
                      try {
                        localStorage.setItem('localops:signup_bonus_intent', 'JGK_100');
                      } catch (err) {
                        // ignore
                      }
                      history.replace(landingRegisterUrl);
                    }}
                    primaryDisabled={landingPrimaryBusy}
                    email={landingEmail}
                    onEmailChange={setLandingEmail}
                    emailError={landingEmailError}
                    onEmailErrorClear={() => setLandingEmailError('')}
                    onSendMagicLink={handleLandingMagicLink}
                    magicStatus={landingMagicStatus}
                  />
                </div>
              ) : null}
            </div>
          </div>
        ) : null}
        <PostCompletionScreen
          open={postCompletionOpen}
          context={resolvedPostCompletionContext}
          playerBalance={completionModalBalance}
          onPrimaryAction={handlePostCompletionPrimaryAction}
          onSecondaryAction={completionSecondaryAction ? handlePostCompletionSecondaryAction : null}
          onShare={handlePostCompletionShare}
          onClose={handleClosePostCompletion}
        />
        {trustGate ? (
          <div
            style={{
              position: 'absolute',
              inset: 0,
              background: 'rgba(9,12,20,0.52)',
              backdropFilter: 'blur(6px)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 30,
            }}
          >
            <div
              style={{
                background: '#0b1424',
                color: '#e2e8f0',
                padding: '20px 24px',
                borderRadius: 14,
                minWidth: 320,
                maxWidth: 420,
                boxShadow: '0 18px 48px rgba(0,0,0,0.35)',
                border: '1px solid rgba(148,163,184,0.25)',
              }}
            >
              <div
                style={{
                  fontWeight: 700,
                  fontSize: 18,
                  marginBottom: 6,
                }}
              >
                Higher trust required
              </div>
              <div style={{ fontSize: 14, opacity: 0.9, marginBottom: 12 }}>
                This task needs additional verification before you can accept it.
              </div>
              <div style={{ fontSize: 13, marginBottom: 12 }}>
                Tier: {trustGate.tier || 'T1'}
                {trustGate.required?.length ? (
                  <div style={{ marginTop: 6 }}>
                    Required:{' '}
                    {trustGate.required.map((item) => (
                      <span
                        key={item}
                        style={{
                          display: 'inline-block',
                          padding: '2px 8px',
                          marginRight: 6,
                          marginTop: 4,
                          borderRadius: 999,
                          background: 'rgba(59,130,246,0.15)',
                          color: '#bfdbfe',
                          fontSize: 12,
                        }}
                      >
                        {item}
                      </span>
                    ))}
                  </div>
                ) : null}
              </div>
              <div style={{ display: 'flex', gap: 8, marginBottom: 10 }}>
                <button
                  type="button"
                  style={{
                    flex: 1,
                    background: '#2563eb',
                    color: '#f8fafc',
                    border: 'none',
                    borderRadius: 10,
                    padding: '10px 12px',
                    fontWeight: 600,
                    cursor: 'pointer',
                  }}
                  onClick={() => handleTrustGateAction('google')}
                >
                  Continue with Google
                </button>
                <button
                  type="button"
                  style={{
                    flex: 1,
                    background: '#111827',
                    color: '#e5e7eb',
                    border: '1px solid rgba(148,163,184,0.35)',
                    borderRadius: 10,
                    padding: '10px 12px',
                    fontWeight: 600,
                    cursor: 'pointer',
                  }}
                  onClick={() => handleTrustGateAction('payout')}
                >
                  Enable payouts
                </button>
              </div>
              <button
                type="button"
                style={{
                  width: '100%',
                  background: 'transparent',
                  color: '#94a3b8',
                  border: 'none',
                  padding: '6px 8px',
                  cursor: 'pointer',
                  fontSize: 13,
                }}
                onClick={() => setTrustGate(null)}
              >
                Maybe later
              </button>
            </div>
          </div>
        ) : null}
        <BuyerPendingConfirmationGateModal
          open={!!pendingConfirmationGate}
          contextLabel="Before reserving another offering"
          blockingOrder={pendingConfirmationGate?.blockingOrder || null}
          busy={pendingConfirmationGate?.busy === true}
          error={pendingConfirmationGate?.error || ''}
          onClose={handleClosePendingConfirmationGate}
          onConfirm={() => handleResolvePendingConfirmationGate('confirm')}
          onDispute={() => handleResolvePendingConfirmationGate('dispute')}
          onMessage={() => handleResolvePendingConfirmationGate('message')}
        />
        {shouldShowLocationPrimer ? (
          <div
            data-testid="localops-location-primer"
            style={{
              position: 'absolute',
              left: 16,
              right: mobileView ? 16 : 'auto',
              bottom: mobileView ? 88 : 24,
              width: mobileView ? 'auto' : 360,
              background: 'rgba(15,23,42,0.92)',
              color: '#e2e8f0',
              border: '1px solid rgba(148,163,184,0.35)',
              borderRadius: 12,
              padding: 16,
              boxShadow: '0 18px 42px rgba(0,0,0,0.32)',
              backdropFilter: 'blur(8px)',
              zIndex: 6,
              fontSize: 14,
              lineHeight: 1.45,
            }}
          >
            <div style={{ fontWeight: 700, marginBottom: 6 }}>
              Location required for LocalOps
            </div>
            <div style={{ color: '#cbd5e1', marginBottom: 12 }}>
              {LOCALOPS_USER_LOCATION_COPY}
            </div>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              <button
                type="button"
                onClick={() => requestLocalOpsPersonalLocation()}
                disabled={locationConsentBusy}
                style={{
                  background: '#22c55e',
                  color: '#06220f',
                  border: 'none',
                  borderRadius: 8,
                  padding: '9px 12px',
                  fontWeight: 700,
                  cursor: locationConsentBusy ? 'default' : 'pointer',
                }}
              >
                {locationConsentBusy ? 'Requesting...' : 'Use my location'}
              </button>
              <button
                type="button"
                onClick={handleBrowseWithoutPersonalLocation}
                style={{
                  background: 'transparent',
                  color: '#e2e8f0',
                  border: '1px solid rgba(148,163,184,0.45)',
                  borderRadius: 8,
                  padding: '9px 12px',
                  fontWeight: 650,
                  cursor: 'pointer',
                }}
              >
                Browse first
              </button>
            </div>
            {locationConsentError ? (
              <div style={{ color: '#fecaca', marginTop: 10 }}>
                {locationConsentError}
              </div>
            ) : null}
          </div>
        ) : null}
        {locationConsentGate ? (
          <div
            data-testid="localops-location-gate"
            role="dialog"
            aria-modal="true"
            aria-label="Location required for LocalOps"
            style={{
              position: 'fixed',
              inset: 0,
              background: 'rgba(15,23,42,0.42)',
              display: 'flex',
              alignItems: mobileView ? 'flex-end' : 'center',
              justifyContent: 'center',
              padding: 16,
              zIndex: 7600,
            }}
          >
            <div
              style={{
                width: 'min(420px, 100%)',
                background: '#0f172a',
                color: '#e2e8f0',
                border: '1px solid rgba(148,163,184,0.35)',
                borderRadius: 12,
                padding: 18,
                boxShadow: '0 22px 58px rgba(0,0,0,0.38)',
              }}
            >
              <div style={{ fontWeight: 750, fontSize: 16, marginBottom: 8 }}>
                Location required for LocalOps
              </div>
              <div style={{ color: '#cbd5e1', marginBottom: 10 }}>
                To {locationConsentGate.actionLabel}, JG LocalOps uses your
                current location to keep activity local.
              </div>
              <div style={{ color: '#94a3b8', marginBottom: 14 }}>
                Your exact location is not posted publicly.
              </div>
              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                <button
                  type="button"
                  onClick={() => requestLocalOpsPersonalLocation()}
                  disabled={locationConsentBusy}
                  style={{
                    background: '#22c55e',
                    color: '#06220f',
                    border: 'none',
                    borderRadius: 8,
                    padding: '10px 14px',
                    fontWeight: 750,
                    cursor: locationConsentBusy ? 'default' : 'pointer',
                  }}
                >
                  {locationConsentBusy ? 'Requesting...' : 'Allow location'}
                </button>
                <button
                  type="button"
                  onClick={handleBrowseWithoutPersonalLocation}
                  disabled={locationConsentBusy}
                  style={{
                    background: 'transparent',
                    color: '#e2e8f0',
                    border: '1px solid rgba(148,163,184,0.45)',
                    borderRadius: 8,
                    padding: '10px 14px',
                    fontWeight: 650,
                    cursor: locationConsentBusy ? 'default' : 'pointer',
                  }}
                >
                  Not now
                </button>
              </div>
              {locationConsentError ? (
                <div style={{ color: '#fecaca', marginTop: 12 }}>
                  {locationConsentError}
                </div>
              ) : null}
            </div>
          </div>
        ) : null}
        {locationHintStatus !== 'idle' &&
        locationHintStatus !== 'ready' &&
        !shouldShowLocationPrimer &&
        !locationConsentGate ? (
          <div
            className={`localops-location-chip localops-location-chip--${locationHintStatus}`}
            style={{
              position: 'absolute',
              left: 16,
              right: mobileView ? 16 : 'auto',
              bottom: mobileView ? 88 : 24,
              width: mobileView ? 'auto' : 360,
              maxWidth: mobileView ? 'none' : 360,
              background:
                locationHintStatus === 'denied'
                  ? 'rgba(255,84,84,0.12)'
                  : 'rgba(15,23,42,0.92)',
              color: '#e2e8f0',
              border:
                locationHintStatus === 'denied'
                  ? '1px solid rgba(255,84,84,0.5)'
                  : '1px solid rgba(148,163,184,0.35)',
              borderRadius: 12,
              padding: 16,
              boxShadow: '0 18px 42px rgba(0,0,0,0.32)',
              backdropFilter: 'blur(8px)',
              zIndex: 7,
              fontSize: 14,
              lineHeight: 1.45,
              pointerEvents: 'auto',
            }}
          >
            <div style={{ fontWeight: 700, marginBottom: 6 }}>
              {locationHintMessage || 'Getting your location...'}
            </div>
            {locationConsentError ? (
              <div style={{ color: '#fecaca', marginBottom: 8 }}>
                {locationConsentError}
              </div>
            ) : null}
            {!hasSavedPersonalLocation ? (
              <button
                type="button"
                onClick={() =>
                  requestLocalOpsPersonalLocation({ replayGate: false })
                }
                disabled={locationConsentBusy}
                style={{
                  marginTop: 6,
                  background: 'rgba(34,197,94,0.18)',
                  color: '#bbf7d0',
                  border: '1px solid rgba(34,197,94,0.45)',
                  borderRadius: 8,
                  padding: '6px 9px',
                  fontWeight: 650,
                  cursor: locationConsentBusy ? 'default' : 'pointer',
                }}
              >
                {locationConsentBusy ? 'Requesting...' : 'Use my location'}
              </button>
            ) : null}
          </div>
        ) : null}
      </div>
      <LocalOpsLayersSheet
        open={isLayersOpen}
        onClose={handleCloseLayers}
        layers={layerPrefs}
        onToggle={toggleLayer}
        counts={layerCounts}
        travelMode={travelMode}
        onToggleTravel={toggleTravelMode}
        travelLabel={travelRadiusLabel}
        radius={radius}
        unit={unit}
        onRadiusChange={setRadius}
        onUnitChange={setUnit}
        disabled={{
          offerings: !localOpsFlags.offerings,
          tasks: !localOpsFlags.tasks,
        }}
      />
      <LocalOpsCreateSheet
        open={isCreateOpen}
        onClose={handleCloseCreate}
        launchId={createLaunchId}
        launchTypeHint={createLaunchTypeHint}
        launchStepHint={createLaunchStepHint}
        launchGroupHint={createLaunchGroupHint}
        defaultCenter={defaultCenter}
        radiusMeters={radiusMeters}
        onCreateOffering={handleCreateOffering}
        onCreateTask={handleCreateTask}
        presenceSelf={presenceSelf}
        currentPlayer={currentPlayerRecord}
        currentPlayerRole={currentPlayerRole}
        localOpsRegionSlug={localOpsRegionSlug}
        onResolveVerifiedLocalCreatorReadiness={
          handleResolveVerifiedLocalCreatorReadiness
        }
        playerBalance={playerBalance}
        onRequestTopUp={handleOpenTopUp}
        onInsufficientBalance={handleLocalOpsInsufficient}
        pendingIntent={pendingIntentState}
        onRetryPendingIntent={() => resumePendingIntent('manual')}
        friendOptions={friendOptions}
        disabledOfferings={!localOpsFlags.offerings}
        disabledTasks={!localOpsFlags.tasks}
        preset={createPreset}
      />
      <LocalOpsStarterTaskIdeas
        open={starterIdeasOpen}
        onClose={handleCloseStarterIdeas}
        onSelect={handleSelectStarterTask}
      />
      <LocalOpsOfferingDetailSheet
        open={!!selectedOffering}
        offering={selectedOffering}
        onClose={handleCloseOffering}
        onReserve={handleReserveOffering}
        onMessage={handleMessageOwner}
        onCreateTask={handleCreateTaskFromOffering}
        onShare={handleShareOffering}
        onEdit={handleEditOffering}
        onEditInventory={handleEditOfferingInventory}
        onPause={handlePauseOffering}
        onMarkAvailability={handleMarkOfferingAvailability}
        onRemove={handleRemoveOffering}
        order={selectedOfferingOrder}
        orders={selectedOfferingOrders}
        onFulfillOrder={handleFulfillOrder}
        onConfirmOrder={handleConfirmOrder}
        onDisputeOrder={handleDisputeOrder}
        onCancelOrder={handleCancelOrder}
        presenceEntry={selectedOfferingPresence}
        currentPlayerId={currentPlayerId}
        currentPlayerHandle={currentPlayerHandle}
        navContext={
          Array.isArray(offeringQueue) && offeringQueue.length > 1
            ? {
                total: offeringQueue.length,
                index: offeringQueueIndex,
                onPrev: () => {
                  if (!Array.isArray(offeringQueue) || offeringQueue.length < 2) return;
                  const nextIndex =
                    offeringQueueIndex > 0
                      ? offeringQueueIndex - 1
                      : offeringQueue.length - 1;
                  const nextOffering = offeringQueue[nextIndex];
                  if (nextOffering) {
                    handleSelectOffering(nextOffering, offeringQueue, nextIndex);
                  }
                },
                onNext: () => {
                  if (!Array.isArray(offeringQueue) || offeringQueue.length < 2) return;
                  const nextIndex =
                    offeringQueueIndex < offeringQueue.length - 1
                      ? offeringQueueIndex + 1
                      : 0;
                  const nextOffering = offeringQueue[nextIndex];
                  if (nextOffering) {
                    handleSelectOffering(nextOffering, offeringQueue, nextIndex);
                  }
                },
              }
            : null
        }
      />
      <LocalOpsTaskDetailSheet
        open={!!selectedTask}
        task={selectedTaskForDetail || selectedTask}
        onClose={handleCloseTask}
        onAccept={handleAcceptTask}
        onStart={handleStartTask}
        onComplete={handleCompleteTask}
        onShare={handleShareTask}
        onEdit={handleEditTask}
        onMessage={handleMessageOwner}
        onCancel={handleCancelTask}
        onReopen={handleReopenTask}
        onRenotifyHelpers={handleRenotifyHelpers}
        onRaisePayAndRenotify={handleRaisePayAndRenotify}
        onRelease={handleReleaseTask}
        presenceEntry={selectedTaskPresence}
        currentPlayerId={currentPlayerId}
        currentPlayerHandle={currentPlayerHandle}
        currentPlayerRole={currentPlayerRole}
        currentPlayerActionCreditCount={viewerActionCreditTotal}
        verifiedLocalGateEnabled={localOpsVerifiedLocalGateEnabled}
        hasOpenUnlockTask={!!verifiedLocalUnlockTask}
        onFindOpenTask={handleFindVerifiedLocalUnlockTask}
        currentPlayerToken={player?.token || null}
        acceptPending={selectedTaskAcceptPending}
        acceptError={selectedTaskAcceptFeedback?.message || ''}
        acceptActionLabel={selectedTaskAcceptFeedback?.actionLabel || ''}
        onAcceptAction={handleSelectedTaskAcceptAction}
      />
      <LocalOpsPublicDetailsEditSheet
        open={!!publicDetailsEditTarget}
        type={publicDetailsEditTarget?.type}
        item={publicDetailsEditTarget?.item}
        onClose={handleClosePublicDetailsEdit}
        onSave={handleSavePublicDetailsEdit}
      />
      <LocalOpsShareSheet
        open={sharePanel.open}
        type={sharePanel.type}
        item={sharePanel.item}
        status={sharePanel.status}
        onClose={handleCloseSharePanel}
        onShare={handleSharePanelShare}
        onView={handleViewShareItem}
      />
      <LocalOpsTopUpSheet
        open={isTopUpOpen}
        onClose={handleCloseTopUp}
        presetAmount={topUpPresetUsd}
        returnTo={topUpReturnTo}
        onCheckoutStart={handleTopUpCheckoutStart}
        variant={topUpVariant}
        requiredTopUpJGK={topUpRequiredJGK}
      />
      <LocalOpsFeed
        open={localOpsFeedOpen}
        onClose={handleCloseFeed}
        events={visibleFeedEvents}
        description="Live activity across LocalOps."
        variant="peek"
        onSelectEvent={handleSelectLiveEvent}
      />
    </>
  );
}

